window.slate = window.slate || {};
window.theme = window.theme || {};
window.timber = window.timber || {};
window.utm = '';
window.referer = '';
try {
  const params = new URL(window.location.href).searchParams;
  window.referer = params.get('referer') || '';
} catch (e) {
  let match = window.location.href.match(/[?&]referer=([^&#]+)/);
  window.referer = match ? decodeURIComponent(match[1].split('&')[0]) : '';
}
window.translationSets = translations ? translations.translations : translations;
window.nonEnglish = window.location.href.includes('/fr/') || window.location.href.includes('/de/') ? true : false;
if (window.nonEnglish) {
  window.lang = window.location.href.includes('/fr/') ? 'french' : 'deutsch';
  window.langCode = window.location.href.includes('/fr/') ? 'fr' : 'de';
} else {
  window.langCode = '';
  window.lang = 'english';
}
let singleVariantWithSlash = ['slim-wallet-pro'];
let sizeSwatchCodes = [ 
      {value : 'Set of Four',
        code : '4'},
      {value : 'Ensemble de quatre',
        code : '4'},
      {value: 'Set aus vier',
        code: '4'},
      {value : 'Set aus sechs',
        code : '6'},
      {value : 'Ensemble de six',
        code : '6'},
      {value : 'Set of Six',
        code : '6'},
      {value : '500 mL',
        code : window.langCode == 'fr' ? 'P' : window.langCode == 'de' ? 'K' : 'S' },
      {value : '750 mL',
        code : window.langCode == 'fr' ? 'G' : window.langCode == 'de' ? 'G' : 'L' },
      {value : 'Large',
        code : 'L'},
      {value : 'Grand',
        code : 'G'},
      {value : 'Petit',
        code : 'P'},
      {value : 'Small',
        code : 'S'},
      {value : '14-inch',
        code : 'S'},
      {value : '16-inch',
        code : 'L'},
      {value : '14 pouces',
        code : 'P'},
      {value : '16 pouces',
        code : 'G'},
      {value : '14 Zoll',
        code : 'K'},
      {value : '16 Zoll',
        code : 'G'},
      {value : 'Klein',
        code : 'K'},
      {value : 'Groß',
        code : 'G'},
      {value : 'Carry-On',
        code : window.langCode == 'fr' ? 'P' : 'S' },
      {value : 'Check-In',
        code : window.langCode == 'fr' ? 'G' : 'L' }
    ];
/*!
Waypoints - 4.0.1
Copyright © 2011-2016 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!function(){"use strict";function t(o){if(!o)throw new Error("No options passed to Waypoint constructor");if(!o.element)throw new Error("No element option passed to Waypoint constructor");if(!o.handler)throw new Error("No handler option passed to Waypoint constructor");this.key="waypoint-"+e,this.options=t.Adapter.extend({},t.defaults,o),this.element=this.options.element,this.adapter=new t.Adapter(this.element),this.callback=o.handler,this.axis=this.options.horizontal?"horizontal":"vertical",this.enabled=this.options.enabled,this.triggerPoint=null,this.group=t.Group.findOrCreate({name:this.options.group,axis:this.axis}),this.context=t.Context.findOrCreateByElement(this.options.context),t.offsetAliases[this.options.offset]&&(this.options.offset=t.offsetAliases[this.options.offset]),this.group.add(this),this.context.add(this),i[this.key]=this,e+=1}var e=0,i={};t.prototype.queueTrigger=function(t){this.group.queueTrigger(this,t)},t.prototype.trigger=function(t){this.enabled&&this.callback&&this.callback.apply(this,t)},t.prototype.destroy=function(){this.context.remove(this),this.group.remove(this),delete i[this.key]},t.prototype.disable=function(){return this.enabled=!1,this},t.prototype.enable=function(){return this.context.refresh(),this.enabled=!0,this},t.prototype.next=function(){return this.group.next(this)},t.prototype.previous=function(){return this.group.previous(this)},t.invokeAll=function(t){var e=[];for(var o in i)e.push(i[o]);for(var n=0,r=e.length;r>n;n++)e[n][t]()},t.destroyAll=function(){t.invokeAll("destroy")},t.disableAll=function(){t.invokeAll("disable")},t.enableAll=function(){t.Context.refreshAll();for(var e in i)i[e].enabled=!0;return this},t.refreshAll=function(){t.Context.refreshAll()},t.viewportHeight=function(){return window.innerHeight||document.documentElement.clientHeight},t.viewportWidth=function(){return document.documentElement.clientWidth},t.adapters=[],t.defaults={context:window,continuous:!0,enabled:!0,group:"default",horizontal:!1,offset:0},t.offsetAliases={"bottom-in-view":function(){return this.context.innerHeight()-this.adapter.outerHeight()},"right-in-view":function(){return this.context.innerWidth()-this.adapter.outerWidth()}},window.Waypoint=t}(),function(){"use strict";function t(t){window.setTimeout(t,1e3/60)}function e(t){this.element=t,this.Adapter=n.Adapter,this.adapter=new this.Adapter(t),this.key="waypoint-context-"+i,this.didScroll=!1,this.didResize=!1,this.oldScroll={x:this.adapter.scrollLeft(),y:this.adapter.scrollTop()},this.waypoints={vertical:{},horizontal:{}},t.waypointContextKey=this.key,o[t.waypointContextKey]=this,i+=1,n.windowContext||(n.windowContext=!0,n.windowContext=new e(window)),this.createThrottledScrollHandler(),this.createThrottledResizeHandler()}var i=0,o={},n=window.Waypoint,r=window.onload;e.prototype.add=function(t){var e=t.options.horizontal?"horizontal":"vertical";this.waypoints[e][t.key]=t,this.refresh()},e.prototype.checkEmpty=function(){var t=this.Adapter.isEmptyObject(this.waypoints.horizontal),e=this.Adapter.isEmptyObject(this.waypoints.vertical),i=this.element==this.element.window;t&&e&&!i&&(this.adapter.off(".waypoints"),delete o[this.key])},e.prototype.createThrottledResizeHandler=function(){function t(){e.handleResize(),e.didResize=!1}var e=this;this.adapter.on("resize.waypoints",function(){e.didResize||(e.didResize=!0,n.requestAnimationFrame(t))})},e.prototype.createThrottledScrollHandler=function(){function t(){e.handleScroll(),e.didScroll=!1}var e=this;this.adapter.on("scroll.waypoints",function(){(!e.didScroll||n.isTouch)&&(e.didScroll=!0,n.requestAnimationFrame(t))})},e.prototype.handleResize=function(){n.Context.refreshAll()},e.prototype.handleScroll=function(){var t={},e={horizontal:{newScroll:this.adapter.scrollLeft(),oldScroll:this.oldScroll.x,forward:"right",backward:"left"},vertical:{newScroll:this.adapter.scrollTop(),oldScroll:this.oldScroll.y,forward:"down",backward:"up"}};for(var i in e){var o=e[i],n=o.newScroll>o.oldScroll,r=n?o.forward:o.backward;for(var s in this.waypoints[i]){var a=this.waypoints[i][s];if(null!==a.triggerPoint){var l=o.oldScroll<a.triggerPoint,h=o.newScroll>=a.triggerPoint,p=l&&h,u=!l&&!h;(p||u)&&(a.queueTrigger(r),t[a.group.id]=a.group)}}}for(var c in t)t[c].flushTriggers();this.oldScroll={x:e.horizontal.newScroll,y:e.vertical.newScroll}},e.prototype.innerHeight=function(){return this.element==this.element.window?n.viewportHeight():this.adapter.innerHeight()},e.prototype.remove=function(t){delete this.waypoints[t.axis][t.key],this.checkEmpty()},e.prototype.innerWidth=function(){return this.element==this.element.window?n.viewportWidth():this.adapter.innerWidth()},e.prototype.destroy=function(){var t=[];for(var e in this.waypoints)for(var i in this.waypoints[e])t.push(this.waypoints[e][i]);for(var o=0,n=t.length;n>o;o++)t[o].destroy()},e.prototype.refresh=function(){var t,e=this.element==this.element.window,i=e?void 0:this.adapter.offset(),o={};this.handleScroll(),t={horizontal:{contextOffset:e?0:i.left,contextScroll:e?0:this.oldScroll.x,contextDimension:this.innerWidth(),oldScroll:this.oldScroll.x,forward:"right",backward:"left",offsetProp:"left"},vertical:{contextOffset:e?0:i.top,contextScroll:e?0:this.oldScroll.y,contextDimension:this.innerHeight(),oldScroll:this.oldScroll.y,forward:"down",backward:"up",offsetProp:"top"}};for(var r in t){var s=t[r];for(var a in this.waypoints[r]){var l,h,p,u,c,d=this.waypoints[r][a],f=d.options.offset,w=d.triggerPoint,y=0,g=null==w;d.element!==d.element.window&&(y=d.adapter.offset()[s.offsetProp]),"function"==typeof f?f=f.apply(d):"string"==typeof f&&(f=parseFloat(f),d.options.offset.indexOf("%")>-1&&(f=Math.ceil(s.contextDimension*f/100))),l=s.contextScroll-s.contextOffset,d.triggerPoint=Math.floor(y+l-f),h=w<s.oldScroll,p=d.triggerPoint>=s.oldScroll,u=h&&p,c=!h&&!p,!g&&u?(d.queueTrigger(s.backward),o[d.group.id]=d.group):!g&&c?(d.queueTrigger(s.forward),o[d.group.id]=d.group):g&&s.oldScroll>=d.triggerPoint&&(d.queueTrigger(s.forward),o[d.group.id]=d.group)}}return n.requestAnimationFrame(function(){for(var t in o)o[t].flushTriggers()}),this},e.findOrCreateByElement=function(t){return e.findByElement(t)||new e(t)},e.refreshAll=function(){for(var t in o)o[t].refresh()},e.findByElement=function(t){return o[t.waypointContextKey]},window.onload=function(){r&&r(),e.refreshAll()},n.requestAnimationFrame=function(e){var i=window.requestAnimationFrame||window.mozRequestAnimationFrame||window.webkitRequestAnimationFrame||t;i.call(window,e)},n.Context=e}(),function(){"use strict";function t(t,e){return t.triggerPoint-e.triggerPoint}function e(t,e){return e.triggerPoint-t.triggerPoint}function i(t){this.name=t.name,this.axis=t.axis,this.id=this.name+"-"+this.axis,this.waypoints=[],this.clearTriggerQueues(),o[this.axis][this.name]=this}var o={vertical:{},horizontal:{}},n=window.Waypoint;i.prototype.add=function(t){this.waypoints.push(t)},i.prototype.clearTriggerQueues=function(){this.triggerQueues={up:[],down:[],left:[],right:[]}},i.prototype.flushTriggers=function(){for(var i in this.triggerQueues){var o=this.triggerQueues[i],n="up"===i||"left"===i;o.sort(n?e:t);for(var r=0,s=o.length;s>r;r+=1){var a=o[r];(a.options.continuous||r===o.length-1)&&a.trigger([i])}}this.clearTriggerQueues()},i.prototype.next=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints),o=i===this.waypoints.length-1;return o?null:this.waypoints[i+1]},i.prototype.previous=function(e){this.waypoints.sort(t);var i=n.Adapter.inArray(e,this.waypoints);return i?this.waypoints[i-1]:null},i.prototype.queueTrigger=function(t,e){this.triggerQueues[e].push(t)},i.prototype.remove=function(t){var e=n.Adapter.inArray(t,this.waypoints);e>-1&&this.waypoints.splice(e,1)},i.prototype.first=function(){return this.waypoints[0]},i.prototype.last=function(){return this.waypoints[this.waypoints.length-1]},i.findOrCreate=function(t){return o[t.axis][t.name]||new i(t)},n.Group=i}(),function(){"use strict";function t(t){this.$element=e(t)}var e=window.jQuery,i=window.Waypoint;e.each(["innerHeight","innerWidth","off","offset","on","outerHeight","outerWidth","scrollLeft","scrollTop"],function(e,i){t.prototype[i]=function(){var t=Array.prototype.slice.call(arguments);return this.$element[i].apply(this.$element,t)}}),e.each(["extend","inArray","isEmptyObject"],function(i,o){t[o]=e[o]}),i.adapters.push({name:"jquery",Adapter:t}),i.Adapter=t}(),function(){"use strict";function t(t){return function(){var i=[],o=arguments[0];return t.isFunction(arguments[0])&&(o=t.extend({},arguments[1]),o.handler=arguments[0]),this.each(function(){var n=t.extend({},o,{element:this});"string"==typeof n.context&&(n.context=t(this).closest(n.context)[0]),i.push(new e(n))}),i}}var e=window.Waypoint;window.jQuery&&(window.jQuery.fn.waypoint=t(window.jQuery)),window.Zepto&&(window.Zepto.fn.waypoint=t(window.Zepto))}();
/*
 Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
*/
(function(){var b,f;b=this.jQuery||window.jQuery;f=b(window);b.fn.stick_in_parent=function(d){var A,w,J,n,B,K,p,q,k,E,t;null==d&&(d={});t=d.sticky_class;B=d.inner_scrolling;E=d.recalc_every;k=d.parent;q=d.offset_top;p=d.spacer;w=d.bottoming;null==q&&(q=0);null==k&&(k=void 0);null==B&&(B=!0);null==t&&(t="is_stuck");A=b(document);null==w&&(w=!0);J=function(a,d,n,C,F,u,r,G){var v,H,m,D,I,c,g,x,y,z,h,l;if(!a.data("sticky_kit")){a.data("sticky_kit",!0);I=A.height();g=a.parent();null!=k&&(g=g.closest(k));
if(!g.length)throw"failed to find stick parent";v=m=!1;(h=null!=p?p&&a.closest(p):b("<div />"))&&h.css("position",a.css("position"));x=function(){var c,f,e;if(!G&&(I=A.height(),c=parseInt(g.css("border-top-width"),10),f=parseInt(g.css("padding-top"),10),d=parseInt(g.css("padding-bottom"),10),n=g.offset().top+c+f,C=g.height(),m&&(v=m=!1,null==p&&(a.insertAfter(h),h.detach()),a.css({position:"",top:"",width:"",bottom:""}).removeClass(t),e=!0),F=a.offset().top-(parseInt(a.css("margin-top"),10)||0)-q,
u=a.outerHeight(!0),r=a.css("float"),h&&h.css({width:a.outerWidth(!0),height:u,display:a.css("display"),"vertical-align":a.css("vertical-align"),"float":r}),e))return l()};x();if(u!==C)return D=void 0,c=q,z=E,l=function(){var b,l,e,k;if(!G&&(e=!1,null!=z&&(--z,0>=z&&(z=E,x(),e=!0)),e||A.height()===I||x(),e=f.scrollTop(),null!=D&&(l=e-D),D=e,m?(w&&(k=e+u+c>C+n,v&&!k&&(v=!1,a.css({position:"fixed",bottom:"",top:c}).trigger("sticky_kit:unbottom"))),e<F&&(m=!1,c=q,null==p&&("left"!==r&&"right"!==r||a.insertAfter(h),
h.detach()),b={position:"",width:"",top:""},a.css(b).removeClass(t).trigger("sticky_kit:unstick")),B&&(b=f.height(),u+q>b&&!v&&(c-=l,c=Math.max(b-u,c),c=Math.min(q,c),m&&a.css({top:c+"px"})))):e>F&&(m=!0,b={position:"fixed",top:c},b.width="border-box"===a.css("box-sizing")?a.outerWidth()+"px":a.width()+"px",a.css(b).addClass(t),null==p&&(a.after(h),"left"!==r&&"right"!==r||h.append(a)),a.trigger("sticky_kit:stick")),m&&w&&(null==k&&(k=e+u+c>C+n),!v&&k)))return v=!0,"static"===g.css("position")&&g.css({position:"relative"}),
a.css({position:"absolute",bottom:d,top:"auto"}).trigger("sticky_kit:bottom")},y=function(){x();return l()},H=function(){G=!0;f.off("touchmove",l);f.off("scroll",l);f.off("resize",y);b(document.body).off("sticky_kit:recalc",y);a.off("sticky_kit:detach",H);a.removeData("sticky_kit");a.css({position:"",bottom:"",top:"",width:""});g.position("position","");if(m)return null==p&&("left"!==r&&"right"!==r||a.insertAfter(h),h.remove()),a.removeClass(t)},f.on("touchmove",l),f.on("scroll",l),f.on("resize",
y),b(document.body).on("sticky_kit:recalc",y),a.on("sticky_kit:detach",H),setTimeout(l,0)}};n=0;for(K=this.length;n<K;n++)d=this[n],J(b(d));return this}}).call(this);
/*  jQuery Nice Select - v1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */
!function(e){e.fn.niceSelect=function(t){function s(t){t.after(e("<div></div>").addClass("nice-select").addClass(t.attr("class")||"").addClass(t.attr("disabled")?"disabled":"").attr("tabindex",t.attr("disabled")?null:"0").html('<span class="current"></span><ul class="list"></ul>'));var s=t.next(),n=t.find("option"),i=t.find("option:selected");s.find(".current").html(i.data("display")||i.text()),n.each(function(t){var n=e(this),i=n.data("display");s.find("ul").append(e("<li></li>").attr("data-value",n.val()).attr("data-display",i||null).addClass("option"+(n.is(":selected")?" selected":"")+(n.is(":disabled")?" disabled":"")).html(n.text()))})}if("string"==typeof t)return"update"==t?this.each(function(){var t=e(this),n=e(this).next(".nice-select"),i=n.hasClass("open");n.length&&(n.remove(),s(t),i&&t.next().trigger("click"))}):"destroy"==t?(this.each(function(){var t=e(this),s=e(this).next(".nice-select");s.length&&(s.remove(),t.css("display",""))}),0==e(".nice-select").length&&e(document).off(".nice_select")):console.log('Method "'+t+'" does not exist.'),this;this.hide(),this.each(function(){var t=e(this);t.next().hasClass("nice-select")||s(t)}),e(document).off(".nice_select"),e(document).on("click.nice_select",".nice-select",function(t){var s=e(this);e(".nice-select").not(s).removeClass("open"),s.toggleClass("open"),s.hasClass("open")?(s.find(".option"),s.find(".focus").removeClass("focus"),s.find(".selected").addClass("focus")):s.focus()}),e(document).on("click.nice_select",function(t){0===e(t.target).closest(".nice-select").length&&e(".nice-select").removeClass("open").find(".option")}),e(document).on("click.nice_select",".nice-select .option:not(.disabled)",function(t){var s=e(this),n=s.closest(".nice-select");n.find(".selected").removeClass("selected"),s.addClass("selected");var i=s.data("display")||s.text();n.find(".current").text(i),n.prev("select").val(s.data("value")).trigger("change")}),e(document).on("keydown.nice_select",".nice-select",function(t){var s=e(this),n=e(s.find(".focus")||s.find(".list .option.selected"));if(32==t.keyCode||13==t.keyCode)return s.hasClass("open")?n.trigger("click"):s.trigger("click"),!1;if(40==t.keyCode){if(s.hasClass("open")){var i=n.nextAll(".option:not(.disabled)").first();i.length>0&&(s.find(".focus").removeClass("focus"),i.addClass("focus"))}else s.trigger("click");return!1}if(38==t.keyCode){if(s.hasClass("open")){var l=n.prevAll(".option:not(.disabled)").first();l.length>0&&(s.find(".focus").removeClass("focus"),l.addClass("focus"))}else s.trigger("click");return!1}if(27==t.keyCode)s.hasClass("open")&&s.trigger("click");else if(9==t.keyCode&&s.hasClass("open"))return!1});var n=document.createElement("a").style;return n.cssText="pointer-events:auto","auto"!==n.pointerEvents&&e("html").addClass("no-csspointerevents"),this}}(jQuery);

!function(a){function b(b,c,d){b.on("mousedown.ba-events touchstart.ba-events",function(e){b.addClass("ba-draggable"),c.addClass("ba-resizable");var f=e.pageX?e.pageX:e.originalEvent.touches[0].pageX,g=b.outerWidth(),h=b.offset().left+g-f,i=d.offset().left,j=d.outerWidth();minLeft=i+10,maxLeft=i+j-g-10,b.parents().on("mousemove.ba-events touchmove.ba-events",function(b){var c=b.pageX?b.pageX:b.originalEvent.touches[0].pageX;leftValue=c+h-g,leftValue<minLeft?leftValue=minLeft:leftValue>maxLeft&&(leftValue=maxLeft),widthValue=100*(leftValue+g/2-i)/j+"%",a(".ba-draggable").css("left",widthValue),a(".ba-resizable").css("width",widthValue)}).on("mouseup.ba-events touchend.ba-events touchcancel.ba-events",function(){b.removeClass("ba-draggable"),c.removeClass("ba-resizable"),a(this).off(".ba-events")}),e.preventDefault()})}a.fn.beforeAfter=function(){var c=this,d=c.width()+"px";c.find(".resize img").css("width",d),b(c.find(".handle"),c.find(".resize"),c),a(window).resize(function(){var a=c.width()+"px";c.find(".resize img").css("width",a)});return this}}(jQuery);

/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
//
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
//
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
//
// About: Release History
//
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
//
// Topic: Note for non-jQuery users
//
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
//
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

/**
 * Swiper 11.0.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: November 22, 2023
 */

 var Swiper=function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,a){void 0===s&&(s={}),void 0===a&&(a={}),Object.keys(a).forEach((i=>{void 0===s[i]?s[i]=a[i]:e(a[i])&&e(s[i])&&Object.keys(a[i]).length>0&&t(s[i],a[i])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function a(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const i={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function r(){const e="undefined"!=typeof window?window:{};return t(e,i),e}function n(e){return void 0===e&&(e=""),e.trim().split(" ").filter((e=>!!e.trim()))}function l(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function o(){return Date.now()}function d(e,t){void 0===t&&(t="x");const s=r();let a,i,n;const l=function(e){const t=r();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(i=l.transform||l.webkitTransform,i.split(",").length>6&&(i=i.split(", ").map((e=>e.replace(",","."))).join(", ")),n=new s.WebKitCSSMatrix("none"===i?"":i)):(n=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),a=n.toString().split(",")),"x"===t&&(i=s.WebKitCSSMatrix?n.m41:16===a.length?parseFloat(a[12]):parseFloat(a[4])),"y"===t&&(i=s.WebKitCSSMatrix?n.m42:16===a.length?parseFloat(a[13]):parseFloat(a[5])),i||0}function c(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function p(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let a=1;a<arguments.length;a+=1){const i=a<0||arguments.length<=a?void 0:arguments[a];if(null!=i&&(s=i,!("undefined"!=typeof window&&void 0!==window.HTMLElement?s instanceof HTMLElement:s&&(1===s.nodeType||11===s.nodeType)))){const s=Object.keys(Object(i)).filter((e=>t.indexOf(e)<0));for(let t=0,a=s.length;t<a;t+=1){const a=s[t],r=Object.getOwnPropertyDescriptor(i,a);void 0!==r&&r.enumerable&&(c(e[a])&&c(i[a])?i[a].__swiper__?e[a]=i[a]:p(e[a],i[a]):!c(e[a])&&c(i[a])?(e[a]={},i[a].__swiper__?e[a]=i[a]:p(e[a],i[a])):e[a]=i[a])}}}var s;return e}function u(e,t,s){e.style.setProperty(t,s)}function m(e){let{swiper:t,targetPosition:s,side:a}=e;const i=r(),n=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",i.cancelAnimationFrame(t.cssModeFrameID);const c=s>n?"next":"prev",p=(e,t)=>"next"===c&&e>=t||"prev"===c&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),r=.5-Math.cos(e*Math.PI)/2;let c=n+r*(s-n);if(p(c,s)&&(c=s),t.wrapperEl.scrollTo({[a]:c}),p(c,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[a]:c})})),void i.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=i.requestAnimationFrame(u)};u()}function h(e){return e.querySelector(".swiper-slide-transform")||e.shadowRoot&&e.shadowRoot.querySelector(".swiper-slide-transform")||e}function f(e,t){return void 0===t&&(t=""),[...e.children].filter((e=>e.matches(t)))}function g(e){try{return void console.warn(e)}catch(e){}}function v(e,t){void 0===t&&(t=[]);const s=document.createElement(e);return s.classList.add(...Array.isArray(t)?t:n(t)),s}function w(e){const t=r(),s=a(),i=e.getBoundingClientRect(),n=s.body,l=e.clientTop||n.clientTop||0,o=e.clientLeft||n.clientLeft||0,d=e===t?t.scrollY:e.scrollTop,c=e===t?t.scrollX:e.scrollLeft;return{top:i.top+d-l,left:i.left+c-o}}function b(e,t){return r().getComputedStyle(e,null).getPropertyValue(t)}function y(e){let t,s=e;if(s){for(t=0;null!==(s=s.previousSibling);)1===s.nodeType&&(t+=1);return t}}function E(e,t){const s=[];let a=e.parentElement;for(;a;)t?a.matches(t)&&s.push(a):s.push(a),a=a.parentElement;return s}function x(e,t){t&&e.addEventListener("transitionend",(function s(a){a.target===e&&(t.call(e,a),e.removeEventListener("transitionend",s))}))}function S(e,t,s){const a=r();return s?e["width"===t?"offsetWidth":"offsetHeight"]+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-right":"margin-top"))+parseFloat(a.getComputedStyle(e,null).getPropertyValue("width"===t?"margin-left":"margin-bottom")):e.offsetWidth}let T,M,C;function P(){return T||(T=function(){const e=r(),t=a();return{smoothScroll:t.documentElement&&t.documentElement.style&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch)}}()),T}function L(e){return void 0===e&&(e={}),M||(M=function(e){let{userAgent:t}=void 0===e?{}:e;const s=P(),a=r(),i=a.navigator.platform,n=t||a.navigator.userAgent,l={ios:!1,android:!1},o=a.screen.width,d=a.screen.height,c=n.match(/(Android);?[\s\/]+([\d.]+)?/);let p=n.match(/(iPad).*OS\s([\d_]+)/);const u=n.match(/(iPod)(.*OS\s([\d_]+))?/),m=!p&&n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),h="Win32"===i;let f="MacIntel"===i;return!p&&f&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(p=n.match(/(Version)\/([\d.]+)/),p||(p=[0,1,"13_0_0"]),f=!1),c&&!h&&(l.os="android",l.android=!0),(p||m||u)&&(l.os="ios",l.ios=!0),l}(e)),M}function A(){return C||(C=function(){const e=r();let t=!1;function s(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}if(s()){const s=String(e.navigator.userAgent);if(s.includes("Version/")){const[e,a]=s.split("Version/")[1].split(" ")[0].split(".").map((e=>Number(e)));t=e<16||16===e&&a<2}}return{isSafari:t||s(),needPerspectiveFix:t,isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)}}()),C}var I={on(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;const i=s?"unshift":"push";return e.split(" ").forEach((e=>{a.eventsListeners[e]||(a.eventsListeners[e]=[]),a.eventsListeners[e][i](t)})),a},once(e,t,s){const a=this;if(!a.eventsListeners||a.destroyed)return a;if("function"!=typeof t)return a;function i(){a.off(e,i),i.__emitterProxy&&delete i.__emitterProxy;for(var s=arguments.length,r=new Array(s),n=0;n<s;n++)r[n]=arguments[n];t.apply(a,r)}return i.__emitterProxy=t,a.on(e,i,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const a=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[a](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((a,i)=>{(a===t||a.__emitterProxy&&a.__emitterProxy===t)&&s.eventsListeners[e].splice(i,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,a;for(var i=arguments.length,r=new Array(i),n=0;n<i;n++)r[n]=arguments[n];"string"==typeof r[0]||Array.isArray(r[0])?(t=r[0],s=r.slice(1,r.length),a=e):(t=r[0].events,s=r[0].data,a=r[0].context||e),s.unshift(a);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(a,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(a,s)}))})),e}};const z=(e,t)=>{if(!e||e.destroyed||!e.params)return;const s=t.closest(e.isElement?"swiper-slide":`.${e.params.slideClass}`);if(s){let t=s.querySelector(`.${e.params.lazyPreloaderClass}`);!t&&e.isElement&&(s.shadowRoot?t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`):requestAnimationFrame((()=>{s.shadowRoot&&(t=s.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`),t&&t.remove())}))),t&&t.remove()}},$=(e,t)=>{if(!e.slides[t])return;const s=e.slides[t].querySelector('[loading="lazy"]');s&&s.removeAttribute("loading")},k=e=>{if(!e||e.destroyed||!e.params)return;let t=e.params.lazyPreloadPrevNext;const s=e.slides.length;if(!s||!t||t<0)return;t=Math.min(t,s);const a="auto"===e.params.slidesPerView?e.slidesPerViewDynamic():Math.ceil(e.params.slidesPerView),i=e.activeIndex;if(e.params.grid&&e.params.grid.rows>1){const s=i,r=[s-t];return r.push(...Array.from({length:t}).map(((e,t)=>s+a+t))),void e.slides.forEach(((t,s)=>{r.includes(t.column)&&$(e,s)}))}const r=i+a-1;if(e.params.rewind||e.params.loop)for(let a=i-t;a<=r+t;a+=1){const t=(a%s+s)%s;(t<i||t>r)&&$(e,t)}else for(let a=Math.max(i-t,0);a<=Math.min(r+t,s-1);a+=1)a!==i&&(a>r||a<i)&&$(e,a)};var O={updateSize:function(){const e=this;let t,s;const a=e.el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:a.clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:a.clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(b(a,"padding-left")||0,10)-parseInt(b(a,"padding-right")||0,10),s=s-parseInt(b(a,"padding-top")||0,10)-parseInt(b(a,"padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t,s){return parseFloat(t.getPropertyValue(e.getDirectionLabel(s))||0)}const s=e.params,{wrapperEl:a,slidesEl:i,size:r,rtlTranslate:n,wrongRTL:l}=e,o=e.virtual&&s.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,c=f(i,`.${e.params.slideClass}, swiper-slide`),p=o?e.virtual.slides.length:c.length;let m=[];const h=[],g=[];let v=s.slidesOffsetBefore;"function"==typeof v&&(v=s.slidesOffsetBefore.call(e));let w=s.slidesOffsetAfter;"function"==typeof w&&(w=s.slidesOffsetAfter.call(e));const y=e.snapGrid.length,E=e.slidesGrid.length;let x=s.spaceBetween,T=-v,M=0,C=0;if(void 0===r)return;"string"==typeof x&&x.indexOf("%")>=0?x=parseFloat(x.replace("%",""))/100*r:"string"==typeof x&&(x=parseFloat(x)),e.virtualSize=-x,c.forEach((e=>{n?e.style.marginLeft="":e.style.marginRight="",e.style.marginBottom="",e.style.marginTop=""})),s.centeredSlides&&s.cssMode&&(u(a,"--swiper-centered-offset-before",""),u(a,"--swiper-centered-offset-after",""));const P=s.grid&&s.grid.rows>1&&e.grid;let L;P?e.grid.initSlides(c):e.grid&&e.grid.unsetSlides();const A="auto"===s.slidesPerView&&s.breakpoints&&Object.keys(s.breakpoints).filter((e=>void 0!==s.breakpoints[e].slidesPerView)).length>0;for(let a=0;a<p;a+=1){let i;if(L=0,c[a]&&(i=c[a]),P&&e.grid.updateSlide(a,i,c),!c[a]||"none"!==b(i,"display")){if("auto"===s.slidesPerView){A&&(c[a].style[e.getDirectionLabel("width")]="");const r=getComputedStyle(i),n=i.style.transform,l=i.style.webkitTransform;if(n&&(i.style.transform="none"),l&&(i.style.webkitTransform="none"),s.roundLengths)L=e.isHorizontal()?S(i,"width",!0):S(i,"height",!0);else{const e=t(r,"width"),s=t(r,"padding-left"),a=t(r,"padding-right"),n=t(r,"margin-left"),l=t(r,"margin-right"),o=r.getPropertyValue("box-sizing");if(o&&"border-box"===o)L=e+n+l;else{const{clientWidth:t,offsetWidth:r}=i;L=e+s+a+n+l+(r-t)}}n&&(i.style.transform=n),l&&(i.style.webkitTransform=l),s.roundLengths&&(L=Math.floor(L))}else L=(r-(s.slidesPerView-1)*x)/s.slidesPerView,s.roundLengths&&(L=Math.floor(L)),c[a]&&(c[a].style[e.getDirectionLabel("width")]=`${L}px`);c[a]&&(c[a].swiperSlideSize=L),g.push(L),s.centeredSlides?(T=T+L/2+M/2+x,0===M&&0!==a&&(T=T-r/2-x),0===a&&(T=T-r/2-x),Math.abs(T)<.001&&(T=0),s.roundLengths&&(T=Math.floor(T)),C%s.slidesPerGroup==0&&m.push(T),h.push(T)):(s.roundLengths&&(T=Math.floor(T)),(C-Math.min(e.params.slidesPerGroupSkip,C))%e.params.slidesPerGroup==0&&m.push(T),h.push(T),T=T+L+x),e.virtualSize+=L+x,M=L,C+=1}}if(e.virtualSize=Math.max(e.virtualSize,r)+w,n&&l&&("slide"===s.effect||"coverflow"===s.effect)&&(a.style.width=`${e.virtualSize+x}px`),s.setWrapperSize&&(a.style[e.getDirectionLabel("width")]=`${e.virtualSize+x}px`),P&&e.grid.updateWrapperSize(L,m),!s.centeredSlides){const t=[];for(let a=0;a<m.length;a+=1){let i=m[a];s.roundLengths&&(i=Math.floor(i)),m[a]<=e.virtualSize-r&&t.push(i)}m=t,Math.floor(e.virtualSize-r)-Math.floor(m[m.length-1])>1&&m.push(e.virtualSize-r)}if(o&&s.loop){const t=g[0]+x;if(s.slidesPerGroup>1){const a=Math.ceil((e.virtual.slidesBefore+e.virtual.slidesAfter)/s.slidesPerGroup),i=t*s.slidesPerGroup;for(let e=0;e<a;e+=1)m.push(m[m.length-1]+i)}for(let a=0;a<e.virtual.slidesBefore+e.virtual.slidesAfter;a+=1)1===s.slidesPerGroup&&m.push(m[m.length-1]+t),h.push(h[h.length-1]+t),e.virtualSize+=t}if(0===m.length&&(m=[0]),0!==x){const t=e.isHorizontal()&&n?"marginLeft":e.getDirectionLabel("marginRight");c.filter(((e,t)=>!(s.cssMode&&!s.loop)||t!==c.length-1)).forEach((e=>{e.style[t]=`${x}px`}))}if(s.centeredSlides&&s.centeredSlidesBounds){let e=0;g.forEach((t=>{e+=t+(x||0)})),e-=x;const t=e-r;m=m.map((e=>e<=0?-v:e>t?t+w:e))}if(s.centerInsufficientSlides){let e=0;if(g.forEach((t=>{e+=t+(x||0)})),e-=x,e<r){const t=(r-e)/2;m.forEach(((e,s)=>{m[s]=e-t})),h.forEach(((e,s)=>{h[s]=e+t}))}}if(Object.assign(e,{slides:c,snapGrid:m,slidesGrid:h,slidesSizesGrid:g}),s.centeredSlides&&s.cssMode&&!s.centeredSlidesBounds){u(a,"--swiper-centered-offset-before",-m[0]+"px"),u(a,"--swiper-centered-offset-after",e.size/2-g[g.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(p!==d&&e.emit("slidesLengthChange"),m.length!==y&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==E&&e.emit("slidesGridLengthChange"),s.watchSlidesProgress&&e.updateSlidesOffset(),e.emit("slidesUpdated"),!(o||s.cssMode||"slide"!==s.effect&&"fade"!==s.effect)){const t=`${s.containerModifierClass}backface-hidden`,a=e.el.classList.contains(t);p<=s.maxBackfaceHiddenSlides?a||e.el.classList.add(t):a&&e.el.classList.remove(t)}},updateAutoHeight:function(e){const t=this,s=[],a=t.virtual&&t.params.virtual.enabled;let i,r=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const n=e=>a?t.slides[t.getSlideIndexByData(e)]:t.slides[e];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||[]).forEach((e=>{s.push(e)}));else for(i=0;i<Math.ceil(t.params.slidesPerView);i+=1){const e=t.activeIndex+i;if(e>t.slides.length&&!a)break;s.push(n(e))}else s.push(n(t.activeIndex));for(i=0;i<s.length;i+=1)if(void 0!==s[i]){const e=s[i].offsetHeight;r=e>r?e:r}(r||0===r)&&(t.wrapperEl.style.height=`${r}px`)},updateSlidesOffset:function(){const e=this,t=e.slides,s=e.isElement?e.isHorizontal()?e.wrapperEl.offsetLeft:e.wrapperEl.offsetTop:0;for(let a=0;a<t.length;a+=1)t[a].swiperSlideOffset=(e.isHorizontal()?t[a].offsetLeft:t[a].offsetTop)-s-e.cssOverflowAdjustment()},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:a,rtlTranslate:i,snapGrid:r}=t;if(0===a.length)return;void 0===a[0].swiperSlideOffset&&t.updateSlidesOffset();let n=-e;i&&(n=e),a.forEach((e=>{e.classList.remove(s.slideVisibleClass,s.slideFullyVisibleClass)})),t.visibleSlidesIndexes=[],t.visibleSlides=[];let l=s.spaceBetween;"string"==typeof l&&l.indexOf("%")>=0?l=parseFloat(l.replace("%",""))/100*t.size:"string"==typeof l&&(l=parseFloat(l));for(let e=0;e<a.length;e+=1){const o=a[e];let d=o.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(d-=a[0].swiperSlideOffset);const c=(n+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),p=(n-r[0]+(s.centeredSlides?t.minTranslate():0)-d)/(o.swiperSlideSize+l),u=-(n-d),m=u+t.slidesSizesGrid[e],h=u>=0&&u<=t.size-t.slidesSizesGrid[e];(u>=0&&u<t.size-1||m>1&&m<=t.size||u<=0&&m>=t.size)&&(t.visibleSlides.push(o),t.visibleSlidesIndexes.push(e),a[e].classList.add(s.slideVisibleClass)),h&&a[e].classList.add(s.slideFullyVisibleClass),o.progress=i?-c:c,o.originalProgress=i?-p:p}},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,a=t.maxTranslate()-t.minTranslate();let{progress:i,isBeginning:r,isEnd:n,progressLoop:l}=t;const o=r,d=n;if(0===a)i=0,r=!0,n=!0;else{i=(e-t.minTranslate())/a;const s=Math.abs(e-t.minTranslate())<1,l=Math.abs(e-t.maxTranslate())<1;r=s||i<=0,n=l||i>=1,s&&(i=0),l&&(i=1)}if(s.loop){const s=t.getSlideIndexByData(0),a=t.getSlideIndexByData(t.slides.length-1),i=t.slidesGrid[s],r=t.slidesGrid[a],n=t.slidesGrid[t.slidesGrid.length-1],o=Math.abs(e);l=o>=i?(o-i)/n:(o+n-r)/n,l>1&&(l-=1)}Object.assign(t,{progress:i,progressLoop:l,isBeginning:r,isEnd:n}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),r&&!o&&t.emit("reachBeginning toEdge"),n&&!d&&t.emit("reachEnd toEdge"),(o&&!r||d&&!n)&&t.emit("fromEdge"),t.emit("progress",i)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,slidesEl:a,activeIndex:i}=e,r=e.virtual&&s.virtual.enabled,n=e.grid&&s.grid&&s.grid.rows>1,l=e=>f(a,`.${s.slideClass}${e}, swiper-slide${e}`)[0];let o,d,c;if(t.forEach((e=>{e.classList.remove(s.slideActiveClass,s.slideNextClass,s.slidePrevClass)})),r)if(s.loop){let t=i-e.virtual.slidesBefore;t<0&&(t=e.virtual.slides.length+t),t>=e.virtual.slides.length&&(t-=e.virtual.slides.length),o=l(`[data-swiper-slide-index="${t}"]`)}else o=l(`[data-swiper-slide-index="${i}"]`);else n?(o=t.filter((e=>e.column===i))[0],c=t.filter((e=>e.column===i+1))[0],d=t.filter((e=>e.column===i-1))[0]):o=t[i];o&&(o.classList.add(s.slideActiveClass),n?(c&&c.classList.add(s.slideNextClass),d&&d.classList.add(s.slidePrevClass)):(c=function(e,t){const s=[];for(;e.nextElementSibling;){const a=e.nextElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&!c&&(c=t[0]),c&&c.classList.add(s.slideNextClass),d=function(e,t){const s=[];for(;e.previousElementSibling;){const a=e.previousElementSibling;t?a.matches(t)&&s.push(a):s.push(a),e=a}return s}(o,`.${s.slideClass}, swiper-slide`)[0],s.loop&&0===!d&&(d=t[t.length-1]),d&&d.classList.add(s.slidePrevClass))),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{snapGrid:a,params:i,activeIndex:r,realIndex:n,snapIndex:l}=t;let o,d=e;const c=e=>{let s=e-t.virtual.slidesBefore;return s<0&&(s=t.virtual.slides.length+s),s>=t.virtual.slides.length&&(s-=t.virtual.slides.length),s};if(void 0===d&&(d=function(e){const{slidesGrid:t,params:s}=e,a=e.rtlTranslate?e.translate:-e.translate;let i;for(let e=0;e<t.length;e+=1)void 0!==t[e+1]?a>=t[e]&&a<t[e+1]-(t[e+1]-t[e])/2?i=e:a>=t[e]&&a<t[e+1]&&(i=e+1):a>=t[e]&&(i=e);return s.normalizeSlideIndex&&(i<0||void 0===i)&&(i=0),i}(t)),a.indexOf(s)>=0)o=a.indexOf(s);else{const e=Math.min(i.slidesPerGroupSkip,d);o=e+Math.floor((d-e)/i.slidesPerGroup)}if(o>=a.length&&(o=a.length-1),d===r&&!t.params.loop)return void(o!==l&&(t.snapIndex=o,t.emit("snapIndexChange")));if(d===r&&t.params.loop&&t.virtual&&t.params.virtual.enabled)return void(t.realIndex=c(d));const p=t.grid&&i.grid&&i.grid.rows>1;let u;if(t.virtual&&i.virtual.enabled&&i.loop)u=c(d);else if(p){const e=t.slides.filter((e=>e.column===d))[0];let s=parseInt(e.getAttribute("data-swiper-slide-index"),10);Number.isNaN(s)&&(s=Math.max(t.slides.indexOf(e),0)),u=Math.floor(s/i.grid.rows)}else if(t.slides[d]){const e=t.slides[d].getAttribute("data-swiper-slide-index");u=e?parseInt(e,10):d}else u=d;Object.assign(t,{previousSnapIndex:l,snapIndex:o,previousRealIndex:n,realIndex:u,previousIndex:r,activeIndex:d}),t.initialized&&k(t),t.emit("activeIndexChange"),t.emit("snapIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&(n!==u&&t.emit("realIndexChange"),t.emit("slideChange"))},updateClickedSlide:function(e,t){const s=this,a=s.params;let i=e.closest(`.${a.slideClass}, swiper-slide`);!i&&s.isElement&&t&&t.length>1&&t.includes(e)&&[...t.slice(t.indexOf(e)+1,t.length)].forEach((e=>{!i&&e.matches&&e.matches(`.${a.slideClass}, swiper-slide`)&&(i=e)}));let r,n=!1;if(i)for(let e=0;e<s.slides.length;e+=1)if(s.slides[e]===i){n=!0,r=e;break}if(!i||!n)return s.clickedSlide=void 0,void(s.clickedIndex=void 0);s.clickedSlide=i,s.virtual&&s.params.virtual.enabled?s.clickedIndex=parseInt(i.getAttribute("data-swiper-slide-index"),10):s.clickedIndex=r,a.slideToClickedSlide&&void 0!==s.clickedIndex&&s.clickedIndex!==s.activeIndex&&s.slideToClickedSlide()}};var D={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:a,wrapperEl:i}=this;if(t.virtualTranslate)return s?-a:a;if(t.cssMode)return a;let r=d(i,e);return r+=this.cssOverflowAdjustment(),s&&(r=-r),r||0},setTranslate:function(e,t){const s=this,{rtlTranslate:a,params:i,wrapperEl:r,progress:n}=s;let l,o=0,d=0;s.isHorizontal()?o=a?-e:e:d=e,i.roundLengths&&(o=Math.floor(o),d=Math.floor(d)),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?o:d,i.cssMode?r[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-o:-d:i.virtualTranslate||(s.isHorizontal()?o-=s.cssOverflowAdjustment():d-=s.cssOverflowAdjustment(),r.style.transform=`translate3d(${o}px, ${d}px, 0px)`);const c=s.maxTranslate()-s.minTranslate();l=0===c?0:(e-s.minTranslate())/c,l!==n&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===a&&(a=!0);const r=this,{params:n,wrapperEl:l}=r;if(r.animating&&n.preventInteractionOnTransition)return!1;const o=r.minTranslate(),d=r.maxTranslate();let c;if(c=a&&e>o?o:a&&e<d?d:e,r.updateProgress(c),n.cssMode){const e=r.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-c;else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:-c,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-c,behavior:"smooth"})}return!0}return 0===t?(r.setTransition(0),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionEnd"))):(r.setTransition(t),r.setTranslate(c),s&&(r.emit("beforeTransitionStart",t,i),r.emit("transitionStart")),r.animating||(r.animating=!0,r.onTranslateToWrapperTransitionEnd||(r.onTranslateToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onTranslateToWrapperTransitionEnd),r.onTranslateToWrapperTransitionEnd=null,delete r.onTranslateToWrapperTransitionEnd,s&&r.emit("transitionEnd"))}),r.wrapperEl.addEventListener("transitionend",r.onTranslateToWrapperTransitionEnd))),!0}};function G(e){let{swiper:t,runCallbacks:s,direction:a,step:i}=e;const{activeIndex:r,previousIndex:n}=t;let l=a;if(l||(l=r>n?"next":r<n?"prev":"reset"),t.emit(`transition${i}`),s&&r!==n){if("reset"===l)return void t.emit(`slideResetTransition${i}`);t.emit(`slideChangeTransition${i}`),"next"===l?t.emit(`slideNextTransition${i}`):t.emit(`slidePrevTransition${i}`)}}var X={slideTo:function(e,t,s,a,i){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e&&(e=parseInt(e,10));const r=this;let n=e;n<0&&(n=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:c,activeIndex:p,rtlTranslate:u,wrapperEl:h,enabled:f}=r;if(r.animating&&l.preventInteractionOnTransition||!f&&!a&&!i)return!1;const g=Math.min(r.params.slidesPerGroupSkip,n);let v=g+Math.floor((n-g)/r.params.slidesPerGroup);v>=o.length&&(v=o.length-1);const w=-o[v];if(l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*w),s=Math.floor(100*d[e]),a=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<a-(a-s)/2?n=e:t>=s&&t<a&&(n=e+1):t>=s&&(n=e)}if(r.initialized&&n!==p){if(!r.allowSlideNext&&(u?w>r.translate&&w>r.minTranslate():w<r.translate&&w<r.minTranslate()))return!1;if(!r.allowSlidePrev&&w>r.translate&&w>r.maxTranslate()&&(p||0)!==n)return!1}let b;if(n!==(c||0)&&s&&r.emit("beforeSlideChangeStart"),r.updateProgress(w),b=n>p?"next":n<p?"prev":"reset",u&&-w===r.translate||!u&&w===r.translate)return r.updateActiveIndex(n),l.autoHeight&&r.updateAutoHeight(),r.updateSlidesClasses(),"slide"!==l.effect&&r.setTranslate(w),"reset"!==b&&(r.transitionStart(s,b),r.transitionEnd(s,b)),!1;if(l.cssMode){const e=r.isHorizontal(),s=u?w:-w;if(0===t){const t=r.virtual&&r.params.virtual.enabled;t&&(r.wrapperEl.style.scrollSnapType="none",r._immediateVirtual=!0),t&&!r._cssModeVirtualInitialSet&&r.params.initialSlide>0?(r._cssModeVirtualInitialSet=!0,requestAnimationFrame((()=>{h[e?"scrollLeft":"scrollTop"]=s}))):h[e?"scrollLeft":"scrollTop"]=s,t&&requestAnimationFrame((()=>{r.wrapperEl.style.scrollSnapType="",r._immediateVirtual=!1}))}else{if(!r.support.smoothScroll)return m({swiper:r,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}return r.setTransition(t),r.setTranslate(w),r.updateActiveIndex(n),r.updateSlidesClasses(),r.emit("beforeTransitionStart",t,a),r.transitionStart(s,b),0===t?r.transitionEnd(s,b):r.animating||(r.animating=!0,r.onSlideToWrapperTransitionEnd||(r.onSlideToWrapperTransitionEnd=function(e){r&&!r.destroyed&&e.target===this&&(r.wrapperEl.removeEventListener("transitionend",r.onSlideToWrapperTransitionEnd),r.onSlideToWrapperTransitionEnd=null,delete r.onSlideToWrapperTransitionEnd,r.transitionEnd(s,b))}),r.wrapperEl.addEventListener("transitionend",r.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,a){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e){e=parseInt(e,10)}const i=this,r=i.grid&&i.params.grid&&i.params.grid.rows>1;let n=e;if(i.params.loop)if(i.virtual&&i.params.virtual.enabled)n+=i.virtual.slidesBefore;else{let e;if(r){const t=n*i.params.grid.rows;e=i.slides.filter((e=>1*e.getAttribute("data-swiper-slide-index")===t))[0].column}else e=i.getSlideIndexByData(n);const t=r?Math.ceil(i.slides.length/i.params.grid.rows):i.slides.length,{centeredSlides:s}=i.params;let a=i.params.slidesPerView;"auto"===a?a=i.slidesPerViewDynamic():(a=Math.ceil(parseFloat(i.params.slidesPerView,10)),s&&a%2==0&&(a+=1));let l=t-e<a;if(s&&(l=l||e<Math.ceil(a/2)),l){const a=s?e<i.activeIndex?"prev":"next":e-i.activeIndex-1<i.params.slidesPerView?"next":"prev";i.loopFix({direction:a,slideTo:!0,activeSlideIndex:"next"===a?e+1:e-t+1,slideRealIndex:"next"===a?i.realIndex:void 0})}if(r){const e=n*i.params.grid.rows;n=i.slides.filter((t=>1*t.getAttribute("data-swiper-slide-index")===e))[0].column}else n=i.getSlideIndexByData(n)}return requestAnimationFrame((()=>{i.slideTo(n,t,s,a)})),i},slideNext:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{enabled:i,params:r,animating:n}=a;if(!i)return a;let l=r.slidesPerGroup;"auto"===r.slidesPerView&&1===r.slidesPerGroup&&r.slidesPerGroupAuto&&(l=Math.max(a.slidesPerViewDynamic("current",!0),1));const o=a.activeIndex<r.slidesPerGroupSkip?1:l,d=a.virtual&&r.virtual.enabled;if(r.loop){if(n&&!d&&r.loopPreventsSliding)return!1;if(a.loopFix({direction:"next"}),a._clientLeft=a.wrapperEl.clientLeft,a.activeIndex===a.slides.length-1&&r.cssMode)return requestAnimationFrame((()=>{a.slideTo(a.activeIndex+o,e,t,s)})),!0}return r.rewind&&a.isEnd?a.slideTo(0,e,t,s):a.slideTo(a.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const a=this,{params:i,snapGrid:r,slidesGrid:n,rtlTranslate:l,enabled:o,animating:d}=a;if(!o)return a;const c=a.virtual&&i.virtual.enabled;if(i.loop){if(d&&!c&&i.loopPreventsSliding)return!1;a.loopFix({direction:"prev"}),a._clientLeft=a.wrapperEl.clientLeft}function p(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const u=p(l?a.translate:-a.translate),m=r.map((e=>p(e)));let h=r[m.indexOf(u)-1];if(void 0===h&&i.cssMode){let e;r.forEach(((t,s)=>{u>=t&&(e=s)})),void 0!==e&&(h=r[e>0?e-1:e])}let f=0;if(void 0!==h&&(f=n.indexOf(h),f<0&&(f=a.activeIndex-1),"auto"===i.slidesPerView&&1===i.slidesPerGroup&&i.slidesPerGroupAuto&&(f=f-a.slidesPerViewDynamic("previous",!0)+1,f=Math.max(f,0))),i.rewind&&a.isBeginning){const i=a.params.virtual&&a.params.virtual.enabled&&a.virtual?a.virtual.slides.length-1:a.slides.length-1;return a.slideTo(i,e,t,s)}return i.loop&&0===a.activeIndex&&i.cssMode?(requestAnimationFrame((()=>{a.slideTo(f,e,t,s)})),!0):a.slideTo(f,e,t,s)},slideReset:function(e,t,s){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,s)},slideToClosest:function(e,t,s,a){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===a&&(a=.5);const i=this;let r=i.activeIndex;const n=Math.min(i.params.slidesPerGroupSkip,r),l=n+Math.floor((r-n)/i.params.slidesPerGroup),o=i.rtlTranslate?i.translate:-i.translate;if(o>=i.snapGrid[l]){const e=i.snapGrid[l];o-e>(i.snapGrid[l+1]-e)*a&&(r+=i.params.slidesPerGroup)}else{const e=i.snapGrid[l-1];o-e<=(i.snapGrid[l]-e)*a&&(r-=i.params.slidesPerGroup)}return r=Math.max(r,0),r=Math.min(r,i.slidesGrid.length-1),i.slideTo(r,e,t,s)},slideToClickedSlide:function(){const e=this,{params:t,slidesEl:s}=e,a="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let i,r=e.clickedIndex;const n=e.isElement?"swiper-slide":`.${t.slideClass}`;if(t.loop){if(e.animating)return;i=parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10),t.centeredSlides?r<e.loopedSlides-a/2||r>e.slides.length-e.loopedSlides+a/2?(e.loopFix(),r=e.getSlideIndex(f(s,`${n}[data-swiper-slide-index="${i}"]`)[0]),l((()=>{e.slideTo(r)}))):e.slideTo(r):r>e.slides.length-a?(e.loopFix(),r=e.getSlideIndex(f(s,`${n}[data-swiper-slide-index="${i}"]`)[0]),l((()=>{e.slideTo(r)}))):e.slideTo(r)}else e.slideTo(r)}};var H={loopCreate:function(e){const t=this,{params:s,slidesEl:a}=t;if(!s.loop||t.virtual&&t.params.virtual.enabled)return;const i=()=>{f(a,`.${s.slideClass}, swiper-slide`).forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t)}))},r=t.grid&&s.grid&&s.grid.rows>1,n=s.slidesPerGroup*(r?s.grid.rows:1),l=t.slides.length%n!=0,o=r&&t.slides.length%s.grid.rows!=0,d=e=>{for(let a=0;a<e;a+=1){const e=t.isElement?v("swiper-slide",[s.slideBlankClass]):v("div",[s.slideClass,s.slideBlankClass]);t.slidesEl.append(e)}};if(l){if(s.loopAddBlankSlides){d(n-t.slides.length%n),t.recalcSlides(),t.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");i()}else if(o){if(s.loopAddBlankSlides){d(s.grid.rows-t.slides.length%s.grid.rows),t.recalcSlides(),t.updateSlides()}else g("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");i()}else i();t.loopFix({slideRealIndex:e,direction:s.centeredSlides?void 0:"next"})},loopFix:function(e){let{slideRealIndex:t,slideTo:s=!0,direction:a,setTranslate:i,activeSlideIndex:r,byController:n,byMousewheel:l}=void 0===e?{}:e;const o=this;if(!o.params.loop)return;o.emit("beforeLoopFix");const{slides:d,allowSlidePrev:c,allowSlideNext:p,slidesEl:u,params:m}=o,{centeredSlides:h}=m;if(o.allowSlidePrev=!0,o.allowSlideNext=!0,o.virtual&&m.virtual.enabled)return s&&(m.centeredSlides||0!==o.snapIndex?m.centeredSlides&&o.snapIndex<m.slidesPerView?o.slideTo(o.virtual.slides.length+o.snapIndex,0,!1,!0):o.snapIndex===o.snapGrid.length-1&&o.slideTo(o.virtual.slidesBefore,0,!1,!0):o.slideTo(o.virtual.slides.length,0,!1,!0)),o.allowSlidePrev=c,o.allowSlideNext=p,void o.emit("loopFix");let f=m.slidesPerView;"auto"===f?f=o.slidesPerViewDynamic():(f=Math.ceil(parseFloat(m.slidesPerView,10)),h&&f%2==0&&(f+=1));const v=m.slidesPerGroupAuto?f:m.slidesPerGroup;let w=v;w%v!=0&&(w+=v-w%v),w+=m.loopAdditionalSlides,o.loopedSlides=w;const b=o.grid&&m.grid&&m.grid.rows>1;d.length<f+w?g("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters"):b&&"row"===m.grid.fill&&g("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");const y=[],E=[];let x=o.activeIndex;void 0===r?r=o.getSlideIndex(d.filter((e=>e.classList.contains(m.slideActiveClass)))[0]):x=r;const S="next"===a||!a,T="prev"===a||!a;let M=0,C=0;const P=b?Math.ceil(d.length/m.grid.rows):d.length,L=(b?d[r].column:r)+(h&&void 0===i?-f/2+.5:0);if(L<w){M=Math.max(w-L,v);for(let e=0;e<w-L;e+=1){const t=e-Math.floor(e/P)*P;if(b){const e=P-t-1;for(let t=d.length-1;t>=0;t-=1)d[t].column===e&&y.push(t)}else y.push(P-t-1)}}else if(L+f>P-w){C=Math.max(L-(P-2*w),v);for(let e=0;e<C;e+=1){const t=e-Math.floor(e/P)*P;b?d.forEach(((e,s)=>{e.column===t&&E.push(s)})):E.push(t)}}if(o.__preventObserver__=!0,requestAnimationFrame((()=>{o.__preventObserver__=!1})),T&&y.forEach((e=>{d[e].swiperLoopMoveDOM=!0,u.prepend(d[e]),d[e].swiperLoopMoveDOM=!1})),S&&E.forEach((e=>{d[e].swiperLoopMoveDOM=!0,u.append(d[e]),d[e].swiperLoopMoveDOM=!1})),o.recalcSlides(),"auto"===m.slidesPerView?o.updateSlides():b&&(y.length>0&&T||E.length>0&&S)&&o.slides.forEach(((e,t)=>{o.grid.updateSlide(t,e,o.slides)})),m.watchSlidesProgress&&o.updateSlidesOffset(),s)if(y.length>0&&T){if(void 0===t){const e=o.slidesGrid[x],t=o.slidesGrid[x+M]-e;l?o.setTranslate(o.translate-t):(o.slideTo(x+M,0,!1,!0),i&&(o.touchEventsData.startTranslate=o.touchEventsData.startTranslate-t,o.touchEventsData.currentTranslate=o.touchEventsData.currentTranslate-t))}else if(i){const e=b?y.length/m.grid.rows:y.length;o.slideTo(o.activeIndex+e,0,!1,!0),o.touchEventsData.currentTranslate=o.translate}}else if(E.length>0&&S)if(void 0===t){const e=o.slidesGrid[x],t=o.slidesGrid[x-C]-e;l?o.setTranslate(o.translate-t):(o.slideTo(x-C,0,!1,!0),i&&(o.touchEventsData.startTranslate=o.touchEventsData.startTranslate-t,o.touchEventsData.currentTranslate=o.touchEventsData.currentTranslate-t))}else{const e=b?E.length/m.grid.rows:E.length;o.slideTo(o.activeIndex-e,0,!1,!0)}if(o.allowSlidePrev=c,o.allowSlideNext=p,o.controller&&o.controller.control&&!n){const e={slideRealIndex:t,direction:a,setTranslate:i,activeSlideIndex:r,byController:!0};Array.isArray(o.controller.control)?o.controller.control.forEach((t=>{!t.destroyed&&t.params.loop&&t.loopFix({...e,slideTo:t.params.slidesPerView===m.slidesPerView&&s})})):o.controller.control instanceof o.constructor&&o.controller.control.params.loop&&o.controller.control.loopFix({...e,slideTo:o.controller.control.params.slidesPerView===m.slidesPerView&&s})}o.emit("loopFix")},loopDestroy:function(){const e=this,{params:t,slidesEl:s}=e;if(!t.loop||e.virtual&&e.params.virtual.enabled)return;e.recalcSlides();const a=[];e.slides.forEach((e=>{const t=void 0===e.swiperSlideIndex?1*e.getAttribute("data-swiper-slide-index"):e.swiperSlideIndex;a[t]=e})),e.slides.forEach((e=>{e.removeAttribute("data-swiper-slide-index")})),a.forEach((e=>{s.append(e)})),e.recalcSlides(),e.slideTo(e.realIndex,0)}};function N(e,t,s){const a=r(),{params:i}=e,n=i.edgeSwipeDetection,l=i.edgeSwipeThreshold;return!n||!(s<=l||s>=a.innerWidth-l)||"prevent"===n&&(t.preventDefault(),!0)}function Y(e){const t=this,s=a();let i=e;i.originalEvent&&(i=i.originalEvent);const n=t.touchEventsData;if("pointerdown"===i.type){if(null!==n.pointerId&&n.pointerId!==i.pointerId)return;n.pointerId=i.pointerId}else"touchstart"===i.type&&1===i.targetTouches.length&&(n.touchId=i.targetTouches[0].identifier);if("touchstart"===i.type)return void N(t,i,i.targetTouches[0].pageX);const{params:l,touches:d,enabled:c}=t;if(!c)return;if(!l.simulateTouch&&"mouse"===i.pointerType)return;if(t.animating&&l.preventInteractionOnTransition)return;!t.animating&&l.cssMode&&l.loop&&t.loopFix();let p=i.target;if("wrapper"===l.touchEventsTarget&&!t.wrapperEl.contains(p))return;if("which"in i&&3===i.which)return;if("button"in i&&i.button>0)return;if(n.isTouched&&n.isMoved)return;const u=!!l.noSwipingClass&&""!==l.noSwipingClass,m=i.composedPath?i.composedPath():i.path;u&&i.target&&i.target.shadowRoot&&m&&(p=m[0]);const h=l.noSwipingSelector?l.noSwipingSelector:`.${l.noSwipingClass}`,f=!(!i.target||!i.target.shadowRoot);if(l.noSwiping&&(f?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===a()||s===r())return null;s.assignedSlot&&(s=s.assignedSlot);const i=s.closest(e);return i||s.getRootNode?i||t(s.getRootNode().host):null}(t)}(h,p):p.closest(h)))return void(t.allowClick=!0);if(l.swipeHandler&&!p.closest(l.swipeHandler))return;d.currentX=i.pageX,d.currentY=i.pageY;const g=d.currentX,v=d.currentY;if(!N(t,i,g))return;Object.assign(n,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),d.startX=g,d.startY=v,n.touchStartTime=o(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,l.threshold>0&&(n.allowThresholdMove=!1);let w=!0;p.matches(n.focusableElements)&&(w=!1,"SELECT"===p.nodeName&&(n.isTouched=!1)),s.activeElement&&s.activeElement.matches(n.focusableElements)&&s.activeElement!==p&&s.activeElement.blur();const b=w&&t.allowTouchMove&&l.touchStartPreventDefault;!l.touchStartForcePreventDefault&&!b||p.isContentEditable||i.preventDefault(),l.freeMode&&l.freeMode.enabled&&t.freeMode&&t.animating&&!l.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",i)}function B(e){const t=a(),s=this,i=s.touchEventsData,{params:r,touches:n,rtlTranslate:l,enabled:d}=s;if(!d)return;if(!r.simulateTouch&&"mouse"===e.pointerType)return;let c,p=e;if(p.originalEvent&&(p=p.originalEvent),"pointermove"===p.type){if(null!==i.touchId)return;if(p.pointerId!==i.pointerId)return}if("touchmove"===p.type){if(c=[...p.changedTouches].filter((e=>e.identifier===i.touchId))[0],!c||c.identifier!==i.touchId)return}else c=p;if(!i.isTouched)return void(i.startMoving&&i.isScrolling&&s.emit("touchMoveOpposite",p));const u=c.pageX,m=c.pageY;if(p.preventedByNestedSwiper)return n.startX=u,void(n.startY=m);if(!s.allowTouchMove)return p.target.matches(i.focusableElements)||(s.allowClick=!1),void(i.isTouched&&(Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m}),i.touchStartTime=o()));if(r.touchReleaseOnEdges&&!r.loop)if(s.isVertical()){if(m<n.startY&&s.translate<=s.maxTranslate()||m>n.startY&&s.translate>=s.minTranslate())return i.isTouched=!1,void(i.isMoved=!1)}else if(u<n.startX&&s.translate<=s.maxTranslate()||u>n.startX&&s.translate>=s.minTranslate())return;if(t.activeElement&&p.target===t.activeElement&&p.target.matches(i.focusableElements))return i.isMoved=!0,void(s.allowClick=!1);i.allowTouchCallbacks&&s.emit("touchMove",p),n.previousX=n.currentX,n.previousY=n.currentY,n.currentX=u,n.currentY=m;const h=n.currentX-n.startX,f=n.currentY-n.startY;if(s.params.threshold&&Math.sqrt(h**2+f**2)<s.params.threshold)return;if(void 0===i.isScrolling){let e;s.isHorizontal()&&n.currentY===n.startY||s.isVertical()&&n.currentX===n.startX?i.isScrolling=!1:h*h+f*f>=25&&(e=180*Math.atan2(Math.abs(f),Math.abs(h))/Math.PI,i.isScrolling=s.isHorizontal()?e>r.touchAngle:90-e>r.touchAngle)}if(i.isScrolling&&s.emit("touchMoveOpposite",p),void 0===i.startMoving&&(n.currentX===n.startX&&n.currentY===n.startY||(i.startMoving=!0)),i.isScrolling)return void(i.isTouched=!1);if(!i.startMoving)return;s.allowClick=!1,!r.cssMode&&p.cancelable&&p.preventDefault(),r.touchMoveStopPropagation&&!r.nested&&p.stopPropagation();let g=s.isHorizontal()?h:f,v=s.isHorizontal()?n.currentX-n.previousX:n.currentY-n.previousY;r.oneWayMovement&&(g=Math.abs(g)*(l?1:-1),v=Math.abs(v)*(l?1:-1)),n.diff=g,g*=r.touchRatio,l&&(g=-g,v=-v);const w=s.touchesDirection;s.swipeDirection=g>0?"prev":"next",s.touchesDirection=v>0?"prev":"next";const b=s.params.loop&&!r.cssMode,y="next"===s.touchesDirection&&s.allowSlideNext||"prev"===s.touchesDirection&&s.allowSlidePrev;if(!i.isMoved){if(b&&y&&s.loopFix({direction:s.swipeDirection}),i.startTranslate=s.getTranslate(),s.setTransition(0),s.animating){const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});s.wrapperEl.dispatchEvent(e)}i.allowMomentumBounce=!1,!r.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",p)}if((new Date).getTime(),i.isMoved&&i.allowThresholdMove&&w!==s.touchesDirection&&b&&y&&Math.abs(g)>=1)return Object.assign(n,{startX:u,startY:m,currentX:u,currentY:m,startTranslate:i.currentTranslate}),i.loopSwapReset=!0,void(i.startTranslate=i.currentTranslate);s.emit("sliderMove",p),i.isMoved=!0,i.currentTranslate=g+i.startTranslate;let E=!0,x=r.resistanceRatio;if(r.touchReleaseOnEdges&&(x=0),g>0?(b&&y&&i.allowThresholdMove&&i.currentTranslate>(r.centeredSlides?s.minTranslate()-s.slidesSizesGrid[s.activeIndex+1]:s.minTranslate())&&s.loopFix({direction:"prev",setTranslate:!0,activeSlideIndex:0}),i.currentTranslate>s.minTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+i.startTranslate+g)**x))):g<0&&(b&&y&&i.allowThresholdMove&&i.currentTranslate<(r.centeredSlides?s.maxTranslate()+s.slidesSizesGrid[s.slidesSizesGrid.length-1]:s.maxTranslate())&&s.loopFix({direction:"next",setTranslate:!0,activeSlideIndex:s.slides.length-("auto"===r.slidesPerView?s.slidesPerViewDynamic():Math.ceil(parseFloat(r.slidesPerView,10)))}),i.currentTranslate<s.maxTranslate()&&(E=!1,r.resistance&&(i.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-i.startTranslate-g)**x))),E&&(p.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&i.currentTranslate<i.startTranslate&&(i.currentTranslate=i.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&i.currentTranslate>i.startTranslate&&(i.currentTranslate=i.startTranslate),s.allowSlidePrev||s.allowSlideNext||(i.currentTranslate=i.startTranslate),r.threshold>0){if(!(Math.abs(g)>r.threshold||i.allowThresholdMove))return void(i.currentTranslate=i.startTranslate);if(!i.allowThresholdMove)return i.allowThresholdMove=!0,n.startX=n.currentX,n.startY=n.currentY,i.currentTranslate=i.startTranslate,void(n.diff=s.isHorizontal()?n.currentX-n.startX:n.currentY-n.startY)}r.followFinger&&!r.cssMode&&((r.freeMode&&r.freeMode.enabled&&s.freeMode||r.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),r.freeMode&&r.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(i.currentTranslate),s.setTranslate(i.currentTranslate))}function R(e){const t=this,s=t.touchEventsData;let a,i=e;i.originalEvent&&(i=i.originalEvent);if("touchend"===i.type||"touchcancel"===i.type){if(a=[...i.changedTouches].filter((e=>e.identifier===s.touchId))[0],!a||a.identifier!==s.touchId)return}else{if(null!==s.touchId)return;if(i.pointerId!==s.pointerId)return;a=i}if(["pointercancel","pointerout","pointerleave","contextmenu"].includes(i.type)){if(!(["pointercancel","contextmenu"].includes(i.type)&&(t.browser.isSafari||t.browser.isWebView)))return}s.pointerId=null,s.touchId=null;const{params:r,touches:n,rtlTranslate:d,slidesGrid:c,enabled:p}=t;if(!p)return;if(!r.simulateTouch&&"mouse"===i.pointerType)return;if(s.allowTouchCallbacks&&t.emit("touchEnd",i),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&r.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);r.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const u=o(),m=u-s.touchStartTime;if(t.allowClick){const e=i.path||i.composedPath&&i.composedPath();t.updateClickedSlide(e&&e[0]||i.target,e),t.emit("tap click",i),m<300&&u-s.lastClickTime<300&&t.emit("doubleTap doubleClick",i)}if(s.lastClickTime=o(),l((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===n.diff&&!s.loopSwapReset||s.currentTranslate===s.startTranslate&&!s.loopSwapReset)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=r.followFinger?d?t.translate:-t.translate:-s.currentTranslate,r.cssMode)return;if(r.freeMode&&r.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});const f=h>=-t.maxTranslate()&&!t.params.loop;let g=0,v=t.slidesSizesGrid[0];for(let e=0;e<c.length;e+=e<r.slidesPerGroupSkip?1:r.slidesPerGroup){const t=e<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;void 0!==c[e+t]?(f||h>=c[e]&&h<c[e+t])&&(g=e,v=c[e+t]-c[e]):(f||h>=c[e])&&(g=e,v=c[c.length-1]-c[c.length-2])}let w=null,b=null;r.rewind&&(t.isBeginning?b=r.virtual&&r.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(w=0));const y=(h-c[g])/v,E=g<r.slidesPerGroupSkip-1?1:r.slidesPerGroup;if(m>r.longSwipesMs){if(!r.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(y>=r.longSwipesRatio?t.slideTo(r.rewind&&t.isEnd?w:g+E):t.slideTo(g)),"prev"===t.swipeDirection&&(y>1-r.longSwipesRatio?t.slideTo(g+E):null!==b&&y<0&&Math.abs(y)>r.longSwipesRatio?t.slideTo(b):t.slideTo(g))}else{if(!r.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(i.target===t.navigation.nextEl||i.target===t.navigation.prevEl)?i.target===t.navigation.nextEl?t.slideTo(g+E):t.slideTo(g):("next"===t.swipeDirection&&t.slideTo(null!==w?w:g+E),"prev"===t.swipeDirection&&t.slideTo(null!==b?b:g))}}function q(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:a,allowSlidePrev:i,snapGrid:r}=e,n=e.virtual&&e.params.virtual.enabled;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses();const l=n&&t.loop;!("auto"===t.slidesPerView||t.slidesPerView>1)||!e.isEnd||e.isBeginning||e.params.centeredSlides||l?e.params.loop&&!n?e.slideToLoop(e.realIndex,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0):e.slideTo(e.slides.length-1,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&(clearTimeout(e.autoplay.resizeTimeout),e.autoplay.resizeTimeout=setTimeout((()=>{e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.resume()}),500)),e.allowSlidePrev=i,e.allowSlideNext=a,e.params.watchOverflow&&r!==e.snapGrid&&e.checkOverflow()}function V(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function _(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:a}=e;if(!a)return;let i;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const r=e.maxTranslate()-e.minTranslate();i=0===r?0:(e.translate-e.minTranslate())/r,i!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}function F(e){const t=this;z(t,e.target),t.params.cssMode||"auto"!==t.params.slidesPerView&&!t.params.autoHeight||t.update()}function j(){const e=this;e.documentTouchHandlerProceeded||(e.documentTouchHandlerProceeded=!0,e.params.touchReleaseOnEdges&&(e.el.style.touchAction="auto"))}const W=(e,t)=>{const s=a(),{params:i,el:r,wrapperEl:n,device:l}=e,o=!!i.nested,d="on"===t?"addEventListener":"removeEventListener",c=t;s[d]("touchstart",e.onDocumentTouchStart,{passive:!1,capture:o}),r[d]("touchstart",e.onTouchStart,{passive:!1}),r[d]("pointerdown",e.onTouchStart,{passive:!1}),s[d]("touchmove",e.onTouchMove,{passive:!1,capture:o}),s[d]("pointermove",e.onTouchMove,{passive:!1,capture:o}),s[d]("touchend",e.onTouchEnd,{passive:!0}),s[d]("pointerup",e.onTouchEnd,{passive:!0}),s[d]("pointercancel",e.onTouchEnd,{passive:!0}),s[d]("touchcancel",e.onTouchEnd,{passive:!0}),s[d]("pointerout",e.onTouchEnd,{passive:!0}),s[d]("pointerleave",e.onTouchEnd,{passive:!0}),s[d]("contextmenu",e.onTouchEnd,{passive:!0}),(i.preventClicks||i.preventClicksPropagation)&&r[d]("click",e.onClick,!0),i.cssMode&&n[d]("scroll",e.onScroll),i.updateOnWindowResize?e[c](l.ios||l.android?"resize orientationchange observerUpdate":"resize observerUpdate",q,!0):e[c]("observerUpdate",q,!0),r[d]("load",e.onLoad,{capture:!0})};const U=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var K={init:!0,direction:"horizontal",oneWayMovement:!1,touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,eventsPrefix:"swiper",enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:5,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,loop:!1,loopAddBlankSlides:!0,loopAdditionalSlides:0,loopPreventsSliding:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-blank",slideActiveClass:"swiper-slide-active",slideVisibleClass:"swiper-slide-visible",slideFullyVisibleClass:"swiper-slide-fully-visible",slideNextClass:"swiper-slide-next",slidePrevClass:"swiper-slide-prev",wrapperClass:"swiper-wrapper",lazyPreloaderClass:"swiper-lazy-preloader",lazyPreloadPrevNext:0,runCallbacksOnInit:!0,_emitClasses:!1};function Z(e,t){return function(s){void 0===s&&(s={});const a=Object.keys(s)[0],i=s[a];"object"==typeof i&&null!==i?(!0===e[a]&&(e[a]={enabled:!0}),"navigation"===a&&e[a]&&e[a].enabled&&!e[a].prevEl&&!e[a].nextEl&&(e[a].auto=!0),["pagination","scrollbar"].indexOf(a)>=0&&e[a]&&e[a].enabled&&!e[a].el&&(e[a].auto=!0),a in e&&"enabled"in i?("object"!=typeof e[a]||"enabled"in e[a]||(e[a].enabled=!0),e[a]||(e[a]={enabled:!1}),p(t,s)):p(t,s)):p(t,s)}}const Q={eventsEmitter:I,update:O,translate:D,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||(s.wrapperEl.style.transitionDuration=`${e}ms`,s.wrapperEl.style.transitionDelay=0===e?"0ms":""),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;a.cssMode||(a.autoHeight&&s.updateAutoHeight(),G({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:a}=s;s.animating=!1,a.cssMode||(s.setTransition(0),G({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:X,loop:H,grabCursor:{setGrabCursor:function(e){const t=this;if(!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;t.isElement&&(t.__preventObserver__=!0),s.style.cursor="move",s.style.cursor=e?"grabbing":"grab",t.isElement&&requestAnimationFrame((()=>{t.__preventObserver__=!1}))},unsetGrabCursor:function(){const e=this;e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e.isElement&&(e.__preventObserver__=!0),e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="",e.isElement&&requestAnimationFrame((()=>{e.__preventObserver__=!1})))}},events:{attachEvents:function(){const e=this,{params:t}=e;e.onTouchStart=Y.bind(e),e.onTouchMove=B.bind(e),e.onTouchEnd=R.bind(e),e.onDocumentTouchStart=j.bind(e),t.cssMode&&(e.onScroll=_.bind(e)),e.onClick=V.bind(e),e.onLoad=F.bind(e),W(e,"on")},detachEvents:function(){W(this,"off")}},breakpoints:{setBreakpoint:function(){const e=this,{realIndex:t,initialized:s,params:a,el:i}=e,r=a.breakpoints;if(!r||r&&0===Object.keys(r).length)return;const n=e.getBreakpoint(r,e.params.breakpointsBase,e.el);if(!n||e.currentBreakpoint===n)return;const l=(n in r?r[n]:void 0)||e.originalParams,o=U(e,a),d=U(e,l),c=a.enabled;o&&!d?(i.classList.remove(`${a.containerModifierClass}grid`,`${a.containerModifierClass}grid-column`),e.emitContainerClasses()):!o&&d&&(i.classList.add(`${a.containerModifierClass}grid`),(l.grid.fill&&"column"===l.grid.fill||!l.grid.fill&&"column"===a.grid.fill)&&i.classList.add(`${a.containerModifierClass}grid-column`),e.emitContainerClasses()),["navigation","pagination","scrollbar"].forEach((t=>{if(void 0===l[t])return;const s=a[t]&&a[t].enabled,i=l[t]&&l[t].enabled;s&&!i&&e[t].disable(),!s&&i&&e[t].enable()}));const u=l.direction&&l.direction!==a.direction,m=a.loop&&(l.slidesPerView!==a.slidesPerView||u),h=a.loop;u&&s&&e.changeDirection(),p(e.params,l);const f=e.params.enabled,g=e.params.loop;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),c&&!f?e.disable():!c&&f&&e.enable(),e.currentBreakpoint=n,e.emit("_beforeBreakpoint",l),s&&(m?(e.loopDestroy(),e.loopCreate(t),e.updateSlides()):!h&&g?(e.loopCreate(t),e.updateSlides()):h&&!g&&e.loopDestroy()),e.emit("breakpoint",l)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let a=!1;const i=r(),n="window"===t?i.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:n*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:r,value:n}=l[e];"window"===t?i.matchMedia(`(min-width: ${n}px)`).matches&&(a=r):n<=s.clientWidth&&(a=r)}return a||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:a}=s;if(a){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*a;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:{addClasses:function(){const e=this,{classNames:t,params:s,rtl:a,el:i,device:r}=e,n=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((a=>{e[a]&&s.push(t+a)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:a},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:r.android},{ios:r.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...n),i.classList.add(...t),e.emitContainerClasses()},removeClasses:function(){const{el:e,classNames:t}=this;e.classList.remove(...t),this.emitContainerClasses()}}},J={};class ee{constructor(){let e,t;for(var s=arguments.length,i=new Array(s),r=0;r<s;r++)i[r]=arguments[r];1===i.length&&i[0].constructor&&"Object"===Object.prototype.toString.call(i[0]).slice(8,-1)?t=i[0]:[e,t]=i,t||(t={}),t=p({},t),e&&!t.el&&(t.el=e);const n=a();if(t.el&&"string"==typeof t.el&&n.querySelectorAll(t.el).length>1){const e=[];return n.querySelectorAll(t.el).forEach((s=>{const a=p({},t,{el:s});e.push(new ee(a))})),e}const l=this;l.__swiper__=!0,l.support=P(),l.device=L({userAgent:t.userAgent}),l.browser=A(),l.eventsListeners={},l.eventsAnyListeners=[],l.modules=[...l.__modules__],t.modules&&Array.isArray(t.modules)&&l.modules.push(...t.modules);const o={};l.modules.forEach((e=>{e({params:t,swiper:l,extendParams:Z(t,o),on:l.on.bind(l),once:l.once.bind(l),off:l.off.bind(l),emit:l.emit.bind(l)})}));const d=p({},K,o);return l.params=p({},d,J,t),l.originalParams=p({},l.params),l.passedParams=p({},t),l.params&&l.params.on&&Object.keys(l.params.on).forEach((e=>{l.on(e,l.params.on[e])})),l.params&&l.params.onAny&&l.onAny(l.params.onAny),Object.assign(l,{enabled:l.params.enabled,el:e,classNames:[],slides:[],slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===l.params.direction,isVertical:()=>"vertical"===l.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,cssOverflowAdjustment(){return Math.trunc(this.translate/2**23)*2**23},allowSlideNext:l.params.allowSlideNext,allowSlidePrev:l.params.allowSlidePrev,touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:l.params.focusableElements,lastClickTime:0,clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,startMoving:void 0,pointerId:null,touchId:null},allowClick:!0,allowTouchMove:l.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),l.emit("_swiper"),l.params.init&&l.init(),l}getDirectionLabel(e){return this.isHorizontal()?e:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[e]}getSlideIndex(e){const{slidesEl:t,params:s}=this,a=y(f(t,`.${s.slideClass}, swiper-slide`)[0]);return y(e)-a}getSlideIndexByData(e){return this.getSlideIndex(this.slides.filter((t=>1*t.getAttribute("data-swiper-slide-index")===e))[0])}recalcSlides(){const{slidesEl:e,params:t}=this;this.slides=f(e,`.${t.slideClass}, swiper-slide`)}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const a=s.minTranslate(),i=(s.maxTranslate()-a)*e+a;s.translateTo(i,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.forEach((s=>{const a=e.getSlideClasses(s);t.push({slideEl:s,classNames:a}),e.emit("_slideClass",s,a)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:a,slidesGrid:i,slidesSizesGrid:r,size:n,activeIndex:l}=this;let o=1;if("number"==typeof s.slidesPerView)return s.slidesPerView;if(s.centeredSlides){let e,t=a[l]?a[l].swiperSlideSize:0;for(let s=l+1;s<a.length;s+=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0));for(let s=l-1;s>=0;s-=1)a[s]&&!e&&(t+=a[s].swiperSlideSize,o+=1,t>n&&(e=!0))}else if("current"===e)for(let e=l+1;e<a.length;e+=1){(t?i[e]+r[e]-i[l]<n:i[e]-i[l]<n)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){i[l]-i[e]<n&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function a(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let i;if(s.breakpoints&&e.setBreakpoint(),[...e.el.querySelectorAll('[loading="lazy"]')].forEach((t=>{t.complete&&z(e,t)})),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),s.freeMode&&s.freeMode.enabled&&!s.cssMode)a(),s.autoHeight&&e.updateAutoHeight();else{if(("auto"===s.slidesPerView||s.slidesPerView>1)&&e.isEnd&&!s.centeredSlides){const t=e.virtual&&s.virtual.enabled?e.virtual.slides:e.slides;i=e.slideTo(t.length-1,0,!1,!0)}else i=e.slideTo(e.activeIndex,0,!1,!0);i||a()}s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,a=s.params.direction;return e||(e="horizontal"===a?"vertical":"horizontal"),e===a||"horizontal"!==e&&"vertical"!==e||(s.el.classList.remove(`${s.params.containerModifierClass}${a}`),s.el.classList.add(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.forEach((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.el.classList.add(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.el.classList.remove(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;let s=e||t.params.el;if("string"==typeof s&&(s=document.querySelector(s)),!s)return!1;s.swiper=t,s.parentNode&&s.parentNode.host&&"SWIPER-CONTAINER"===s.parentNode.host.nodeName&&(t.isElement=!0);const a=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let i=(()=>{if(s&&s.shadowRoot&&s.shadowRoot.querySelector){return s.shadowRoot.querySelector(a())}return f(s,a())[0]})();return!i&&t.params.createElements&&(i=v("div",t.params.wrapperClass),s.append(i),f(s,`.${t.params.slideClass}`).forEach((e=>{i.append(e)}))),Object.assign(t,{el:s,wrapperEl:i,slidesEl:t.isElement&&!s.parentNode.host.slideSlots?s.parentNode.host:i,hostEl:t.isElement?s.parentNode.host:s,mounted:!0,rtl:"rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===s.dir.toLowerCase()||"rtl"===b(s,"direction")),wrongRTL:"-webkit-box"===b(i,"display")}),!0}init(e){const t=this;if(t.initialized)return t;if(!1===t.mount(e))return t;t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.loop&&t.virtual&&t.params.virtual.enabled?t.slideTo(t.params.initialSlide+t.virtual.slidesBefore,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.params.loop&&t.loopCreate(),t.attachEvents();const s=[...t.el.querySelectorAll('[loading="lazy"]')];return t.isElement&&s.push(...t.hostEl.querySelectorAll('[loading="lazy"]')),s.forEach((e=>{e.complete?z(t,e):e.addEventListener("load",(e=>{z(t,e.target)}))})),k(t),t.initialized=!0,k(t),t.emit("init"),t.emit("afterInit"),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:a,el:i,wrapperEl:r,slides:n}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),a.loop&&s.loopDestroy(),t&&(s.removeClasses(),i.removeAttribute("style"),r.removeAttribute("style"),n&&n.length&&n.forEach((e=>{e.classList.remove(a.slideVisibleClass,a.slideFullyVisibleClass,a.slideActiveClass,a.slideNextClass,a.slidePrevClass),e.removeAttribute("style"),e.removeAttribute("data-swiper-slide-index")}))),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.el.swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){p(J,e)}static get extendedDefaults(){return J}static get defaults(){return K}static installModule(e){ee.prototype.__modules__||(ee.prototype.__modules__=[]);const t=ee.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>ee.installModule(e))),ee):(ee.installModule(e),ee)}}function te(e,t,s,a){return e.params.createElements&&Object.keys(a).forEach((i=>{if(!s[i]&&!0===s.auto){let r=f(e.el,`.${a[i]}`)[0];r||(r=v("div",a[i]),r.className=a[i],e.el.append(r)),s[i]=r,t[i]=r}})),s}function se(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!+\/])/g,"\\$1").replace(/ /g,".")}`}function ae(e){const t=this,{params:s,slidesEl:a}=t;s.loop&&t.loopDestroy();const i=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,a.append(t.children[0]),t.innerHTML=""}else a.append(e)};if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&i(e[t]);else i(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update()}function ie(e){const t=this,{params:s,activeIndex:a,slidesEl:i}=t;s.loop&&t.loopDestroy();let r=a+1;const n=e=>{if("string"==typeof e){const t=document.createElement("div");t.innerHTML=e,i.prepend(t.children[0]),t.innerHTML=""}else i.prepend(e)};if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&n(e[t]);r=a+e.length}else n(e);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),t.slideTo(r,0,!1)}function re(e,t){const s=this,{params:a,activeIndex:i,slidesEl:r}=s;let n=i;a.loop&&(n-=s.loopedSlides,s.loopDestroy(),s.recalcSlides());const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=n>e?n+1:n;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides[t];e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&r.append(t[e]);o=n>e?n+t.length:n}else r.append(t);for(let e=0;e<d.length;e+=1)r.append(d[e]);s.recalcSlides(),a.loop&&s.loopCreate(),a.observer&&!s.isElement||s.update(),a.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function ne(e){const t=this,{params:s,activeIndex:a}=t;let i=a;s.loop&&(i-=t.loopedSlides,t.loopDestroy());let r,n=i;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)r=e[s],t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1);n=Math.max(n,0)}else r=e,t.slides[r]&&t.slides[r].remove(),r<n&&(n-=1),n=Math.max(n,0);t.recalcSlides(),s.loop&&t.loopCreate(),s.observer&&!t.isElement||t.update(),s.loop?t.slideTo(n+t.loopedSlides,0,!1):t.slideTo(n,0,!1)}function le(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function oe(e){const{effect:t,swiper:s,on:a,setTranslate:i,setTransition:r,overwriteParams:n,perspective:l,recreateShadows:o,getEffectParams:d}=e;let c;a("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=n?n():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),a("setTranslate",(()=>{s.params.effect===t&&i()})),a("setTransition",((e,a)=>{s.params.effect===t&&r(a)})),a("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.forEach((e=>{e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e=>e.remove()))})),o()}})),a("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(c=!0),requestAnimationFrame((()=>{c&&s.slides&&s.slides.length&&(i(),c=!1)})))}))}function de(e,t){const s=h(t);return s!==t&&(s.style.backfaceVisibility="hidden",s.style["-webkit-backface-visibility"]="hidden"),s}function ce(e){let{swiper:t,duration:s,transformElements:a,allSlides:i}=e;const{activeIndex:r}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=i?a:a.filter((e=>{const s=e.classList.contains("swiper-slide-transform")?(e=>{if(!e.parentElement)return t.slides.filter((t=>t.shadowRoot&&t.shadowRoot===e.parentNode))[0];return e.parentElement})(e):e;return t.getSlideIndex(s)===r})),e.forEach((e=>{x(e,(()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=new window.CustomEvent("transitionend",{bubbles:!0,cancelable:!0});t.wrapperEl.dispatchEvent(e)}))}))}}function pe(e,t,s){const a=`swiper-slide-shadow${s?`-${s}`:""}${e?` swiper-slide-shadow-${e}`:""}`,i=h(t);let r=i.querySelector(`.${a.split(" ").join(".")}`);return r||(r=v("div",a.split(" ")),i.append(r)),r}Object.keys(Q).forEach((e=>{Object.keys(Q[e]).forEach((t=>{ee.prototype[t]=Q[e][t]}))})),ee.use([function(e){let{swiper:t,on:s,emit:a}=e;const i=r();let n=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(a("beforeResize"),a("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&a("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==i.ResizeObserver?t&&!t.destroyed&&t.initialized&&(n=new ResizeObserver((e=>{l=i.requestAnimationFrame((()=>{const{width:s,height:a}=t;let i=s,r=a;e.forEach((e=>{let{contentBoxSize:s,contentRect:a,target:n}=e;n&&n!==t.el||(i=a?a.width:(s[0]||s).inlineSize,r=a?a.height:(s[0]||s).blockSize)})),i===s&&r===a||o()}))})),n.observe(t.el)):(i.addEventListener("resize",o),i.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&i.cancelAnimationFrame(l),n&&n.unobserve&&t.el&&(n.unobserve(t.el),n=null),i.removeEventListener("resize",o),i.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=[],l=r(),o=function(e,s){void 0===s&&(s={});const a=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(t.__preventObserver__)return;if(1===e.length)return void i("observerUpdate",e[0]);const s=function(){i("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(s):l.setTimeout(s,0)}));a.observe(e,{attributes:void 0===s.attributes||s.attributes,childList:void 0===s.childList||s.childList,characterData:void 0===s.characterData||s.characterData}),n.push(a)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),a("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=E(t.hostEl);for(let t=0;t<e.length;t+=1)o(e[t])}o(t.hostEl,{childList:t.params.observeSlideChildren}),o(t.wrapperEl,{attributes:!1})}})),a("destroy",(()=>{n.forEach((e=>{e.disconnect()})),n.splice(0,n.length)}))}]);const ue=[function(e){let t,{swiper:s,extendParams:i,on:r,emit:n}=e;i({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}});const l=a();s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]};const o=l.createElement("div");function d(e,t){const a=s.params.virtual;if(a.cache&&s.virtual.cache[t])return s.virtual.cache[t];let i;return a.renderSlide?(i=a.renderSlide.call(s,e,t),"string"==typeof i&&(o.innerHTML=i,i=o.children[0])):i=s.isElement?v("swiper-slide"):v("div",s.params.slideClass),i.setAttribute("data-swiper-slide-index",t),a.renderSlide||(i.innerHTML=e),a.cache&&(s.virtual.cache[t]=i),i}function c(e){const{slidesPerView:t,slidesPerGroup:a,centeredSlides:i,loop:r}=s.params,{addSlidesBefore:l,addSlidesAfter:o}=s.params.virtual,{from:c,to:p,slides:u,slidesGrid:m,offset:h}=s.virtual;s.params.cssMode||s.updateActiveIndex();const g=s.activeIndex||0;let v,w,b;v=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",i?(w=Math.floor(t/2)+a+o,b=Math.floor(t/2)+a+l):(w=t+(a-1)+o,b=(r?t:a)+l);let y=g-b,E=g+w;r||(y=Math.max(y,0),E=Math.min(E,u.length-1));let x=(s.slidesGrid[y]||0)-(s.slidesGrid[0]||0);function S(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),n("virtualUpdate")}if(r&&g>=b?(y-=b,i||(x+=s.slidesGrid[0])):r&&g<b&&(y=-b,i&&(x+=s.slidesGrid[0])),Object.assign(s.virtual,{from:y,to:E,offset:x,slidesGrid:s.slidesGrid,slidesBefore:b,slidesAfter:w}),c===y&&p===E&&!e)return s.slidesGrid!==m&&x!==h&&s.slides.forEach((e=>{e.style[v]=x-Math.abs(s.cssOverflowAdjustment())+"px"})),s.updateProgress(),void n("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:x,from:y,to:E,slides:function(){const e=[];for(let t=y;t<=E;t+=1)e.push(u[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?S():n("virtualUpdate"));const T=[],M=[],C=e=>{let t=e;return e<0?t=u.length+e:t>=u.length&&(t-=u.length),t};if(e)s.slides.filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`))).forEach((e=>{e.remove()}));else for(let e=c;e<=p;e+=1)if(e<y||e>E){const t=C(e);s.slides.filter((e=>e.matches(`.${s.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`))).forEach((e=>{e.remove()}))}const P=r?-u.length:0,L=r?2*u.length:u.length;for(let t=P;t<L;t+=1)if(t>=y&&t<=E){const s=C(t);void 0===p||e?M.push(s):(t>p&&M.push(s),t<c&&T.push(s))}if(M.forEach((e=>{s.slidesEl.append(d(u[e],e))})),r)for(let e=T.length-1;e>=0;e-=1){const t=T[e];s.slidesEl.prepend(d(u[t],t))}else T.sort(((e,t)=>t-e)),T.forEach((e=>{s.slidesEl.prepend(d(u[e],e))}));f(s.slidesEl,".swiper-slide, swiper-slide").forEach((e=>{e.style[v]=x-Math.abs(s.cssOverflowAdjustment())+"px"})),S()}r("beforeInit",(()=>{if(!s.params.virtual.enabled)return;let e;if(void 0===s.passedParams.virtual.slides){const t=[...s.slidesEl.children].filter((e=>e.matches(`.${s.params.slideClass}, swiper-slide`)));t&&t.length&&(s.virtual.slides=[...t],e=!0,t.forEach(((e,t)=>{e.setAttribute("data-swiper-slide-index",t),s.virtual.cache[t]=e,e.remove()})))}e||(s.virtual.slides=s.params.virtual.slides),s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,c()})),r("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{c()}),100)):c())})),r("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&u(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);c(!0)},prependSlide:function(e){const t=s.activeIndex;let a=t+1,i=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);a=t+e.length,i=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const a=e[s],r=a.getAttribute("data-swiper-slide-index");r&&a.setAttribute("data-swiper-slide-index",parseInt(r,10)+i),t[parseInt(s,10)+i]=a})),s.virtual.cache=t}c(!0),s.slideTo(a,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let a=e.length-1;a>=0;a-=1)s.params.virtual.cache&&(delete s.virtual.cache[e[a]],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e[a],1),e[a]<t&&(t-=1),t=Math.max(t,0);else s.params.virtual.cache&&(delete s.virtual.cache[e],Object.keys(s.virtual.cache).forEach((t=>{t>e&&(s.virtual.cache[t-1]=s.virtual.cache[t],s.virtual.cache[t-1].setAttribute("data-swiper-slide-index",t-1),delete s.virtual.cache[t])}))),s.virtual.slides.splice(e,1),e<t&&(t-=1),t=Math.max(t,0);c(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),c(!0),s.slideTo(0,0)},update:c})},function(e){let{swiper:t,extendParams:s,on:i,emit:n}=e;const l=a(),o=r();function d(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let a=e;a.originalEvent&&(a=a.originalEvent);const i=a.keyCode||a.charCode,r=t.params.keyboard.pageUpDown,d=r&&33===i,c=r&&34===i,p=37===i,u=39===i,m=38===i,h=40===i;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&h||c))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&p||t.isVertical()&&m||d))return!1;if(!(a.shiftKey||a.altKey||a.ctrlKey||a.metaKey||l.activeElement&&l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(d||c||p||u||m||h)){let e=!1;if(E(t.el,`.${t.params.slideClass}, swiper-slide`).length>0&&0===E(t.el,`.${t.params.slideActiveClass}`).length)return;const a=t.el,i=a.clientWidth,r=a.clientHeight,n=o.innerWidth,l=o.innerHeight,d=w(a);s&&(d.left-=a.scrollLeft);const c=[[d.left,d.top],[d.left+i,d.top],[d.left,d.top+r],[d.left+i,d.top+r]];for(let t=0;t<c.length;t+=1){const s=c[t];if(s[0]>=0&&s[0]<=n&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||c||p||u)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),((c||u)&&!s||(d||p)&&s)&&t.slideNext(),((d||p)&&!s||(c||u)&&s)&&t.slidePrev()):((d||c||m||h)&&(a.preventDefault?a.preventDefault():a.returnValue=!1),(c||h)&&t.slideNext(),(d||m)&&t.slidePrev()),n("keyPress",i)}}function c(){t.keyboard.enabled||(l.addEventListener("keydown",d),t.keyboard.enabled=!0)}function p(){t.keyboard.enabled&&(l.removeEventListener("keydown",d),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),i("init",(()=>{t.params.keyboard.enabled&&c()})),i("destroy",(()=>{t.keyboard.enabled&&p()})),Object.assign(t.keyboard,{enable:c,disable:p})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();let d;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null,noMousewheelClass:"swiper-no-mousewheel"}}),t.mousewheel={enabled:!1};let c,p=o();const u=[];function m(){t.enabled&&(t.mouseEntered=!0)}function h(){t.enabled&&(t.mouseEntered=!1)}function f(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&o()-p<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&o()-p<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),i("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),i("scroll",e.raw)),p=(new n.Date).getTime(),!1)))}function g(e){let s=e,a=!0;if(!t.enabled)return;if(e.target.closest(`.${t.params.mousewheel.noMousewheelClass}`))return;const r=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let n=t.el;"container"!==t.params.mousewheel.eventsTarget&&(n=document.querySelector(t.params.mousewheel.eventsTarget));const p=n&&n.contains(s.target);if(!t.mouseEntered&&!p&&!r.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let m=0;const h=t.rtlTranslate?-1:1,g=function(e){let t=0,s=0,a=0,i=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),a=10*t,i=10*s,"deltaY"in e&&(i=e.deltaY),"deltaX"in e&&(a=e.deltaX),e.shiftKey&&!a&&(a=i,i=0),(a||i)&&e.deltaMode&&(1===e.deltaMode?(a*=40,i*=40):(a*=800,i*=800)),a&&!t&&(t=a<1?-1:1),i&&!s&&(s=i<1?-1:1),{spinX:t,spinY:s,pixelX:a,pixelY:i}}(s);if(r.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(g.pixelX)>Math.abs(g.pixelY)))return!0;m=-g.pixelX*h}else{if(!(Math.abs(g.pixelY)>Math.abs(g.pixelX)))return!0;m=-g.pixelY}else m=Math.abs(g.pixelX)>Math.abs(g.pixelY)?-g.pixelX*h:-g.pixelY;if(0===m)return!0;r.invert&&(m=-m);let v=t.getTranslate()+m*r.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),a=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),a&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:o(),delta:Math.abs(m),direction:Math.sign(m)},a=c&&e.time<c.time+500&&e.delta<=c.delta&&e.direction===c.direction;if(!a){c=void 0;let n=t.getTranslate()+m*r.sensitivity;const o=t.isBeginning,p=t.isEnd;if(n>=t.minTranslate()&&(n=t.minTranslate()),n<=t.maxTranslate()&&(n=t.maxTranslate()),t.setTransition(0),t.setTranslate(n),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!o&&t.isBeginning||!p&&t.isEnd)&&t.updateSlidesClasses(),t.params.loop&&t.loopFix({direction:e.direction<0?"next":"prev",byMousewheel:!0}),t.params.freeMode.sticky){clearTimeout(d),d=void 0,u.length>=15&&u.shift();const s=u.length?u[u.length-1]:void 0,a=u[0];if(u.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))u.splice(0);else if(u.length>=15&&e.time-a.time<500&&a.delta-e.delta>=1&&e.delta<=6){const s=m>0?.8:.2;c=e,u.splice(0),d=l((()=>{t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}d||(d=l((()=>{c=e,u.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(a||i("scroll",s),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),r.releaseOnEdges&&(n===t.minTranslate()||n===t.maxTranslate()))return!0}}else{const s={time:o(),delta:Math.abs(m),direction:Math.sign(m),raw:e};u.length>=2&&u.shift();const a=u.length?u[u.length-1]:void 0;if(u.push(s),a?(s.direction!==a.direction||s.delta>a.delta||s.time>a.time+150)&&f(s):f(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function v(e){let s=t.el;"container"!==t.params.mousewheel.eventsTarget&&(s=document.querySelector(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",m),s[e]("mouseleave",h),s[e]("wheel",g)}function w(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",g),!0):!t.mousewheel.enabled&&(v("addEventListener"),t.mousewheel.enabled=!0,!0)}function b(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,g),!0):!!t.mousewheel.enabled&&(v("removeEventListener"),t.mousewheel.enabled=!1,!0)}a("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&b(),t.params.mousewheel.enabled&&w()})),a("destroy",(()=>{t.params.cssMode&&w(),t.mousewheel.enabled&&b()})),Object.assign(t.mousewheel,{enable:w,disable:b})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,prevEl:null};const r=e=>(Array.isArray(e)?e:[e]).filter((e=>!!e));function n(e){let s;return e&&"string"==typeof e&&t.isElement&&(s=t.el.querySelector(e),s)?s:(e&&("string"==typeof e&&(s=[...document.querySelectorAll(e)]),t.params.uniqueNavElements&&"string"==typeof e&&s.length>1&&1===t.el.querySelectorAll(e).length&&(s=t.el.querySelector(e))),e&&!s?e:s)}function l(e,s){const a=t.params.navigation;(e=r(e)).forEach((e=>{e&&(e.classList[s?"add":"remove"](...a.disabledClass.split(" ")),"BUTTON"===e.tagName&&(e.disabled=s),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](a.lockClass))}))}function o(){const{nextEl:e,prevEl:s}=t.navigation;if(t.params.loop)return l(s,!1),void l(e,!1);l(s,t.isBeginning&&!t.params.rewind),l(e,t.isEnd&&!t.params.rewind)}function d(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),i("navigationPrev"))}function c(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),i("navigationNext"))}function p(){const e=t.params.navigation;if(t.params.navigation=te(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;let s=n(e.nextEl),a=n(e.prevEl);Object.assign(t.navigation,{nextEl:s,prevEl:a}),s=r(s),a=r(a);const i=(s,a)=>{s&&s.addEventListener("click","next"===a?c:d),!t.enabled&&s&&s.classList.add(...e.lockClass.split(" "))};s.forEach((e=>i(e,"next"))),a.forEach((e=>i(e,"prev")))}function u(){let{nextEl:e,prevEl:s}=t.navigation;e=r(e),s=r(s);const a=(e,s)=>{e.removeEventListener("click","next"===s?c:d),e.classList.remove(...t.params.navigation.disabledClass.split(" "))};e.forEach((e=>a(e,"next"))),s.forEach((e=>a(e,"prev")))}a("init",(()=>{!1===t.params.navigation.enabled?m():(p(),o())})),a("toEdge fromEdge lock unlock",(()=>{o()})),a("destroy",(()=>{u()})),a("enable disable",(()=>{let{nextEl:e,prevEl:s}=t.navigation;e=r(e),s=r(s),t.enabled?o():[...e,...s].filter((e=>!!e)).forEach((e=>e.classList.add(t.params.navigation.lockClass)))})),a("click",((e,s)=>{let{nextEl:a,prevEl:n}=t.navigation;a=r(a),n=r(n);const l=s.target;if(t.params.navigation.hideOnClick&&!n.includes(l)&&!a.includes(l)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===l||t.pagination.el.contains(l)))return;let e;a.length?e=a[0].classList.contains(t.params.navigation.hiddenClass):n.length&&(e=n[0].classList.contains(t.params.navigation.hiddenClass)),i(!0===e?"navigationShow":"navigationHide"),[...a,...n].filter((e=>!!e)).forEach((e=>e.classList.toggle(t.params.navigation.hiddenClass)))}}));const m=()=>{t.el.classList.add(...t.params.navigation.navigationDisabledClass.split(" ")),u()};Object.assign(t.navigation,{enable:()=>{t.el.classList.remove(...t.params.navigation.navigationDisabledClass.split(" ")),p(),o()},disable:m,update:o,init:p,destroy:u})},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const r="swiper-pagination";let n;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${r}-bullet`,bulletActiveClass:`${r}-bullet-active`,modifierClass:`${r}-`,currentClass:`${r}-current`,totalClass:`${r}-total`,hiddenClass:`${r}-hidden`,progressbarFillClass:`${r}-progressbar-fill`,progressbarOppositeClass:`${r}-progressbar-opposite`,clickableClass:`${r}-clickable`,lockClass:`${r}-lock`,horizontalClass:`${r}-horizontal`,verticalClass:`${r}-vertical`,paginationDisabledClass:`${r}-disabled`}}),t.pagination={el:null,bullets:[]};let l=0;const o=e=>(Array.isArray(e)?e:[e]).filter((e=>!!e));function d(){return!t.params.pagination.el||!t.pagination.el||Array.isArray(t.pagination.el)&&0===t.pagination.el.length}function c(e,s){const{bulletActiveClass:a}=t.params.pagination;e&&(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&(e.classList.add(`${a}-${s}`),(e=e[("prev"===s?"previous":"next")+"ElementSibling"])&&e.classList.add(`${a}-${s}-${s}`))}function p(e){const s=e.target.closest(se(t.params.pagination.bulletClass));if(!s)return;e.preventDefault();const a=y(s)*t.params.slidesPerGroup;if(t.params.loop){if(t.realIndex===a)return;t.slideToLoop(a)}else t.slideTo(a)}function u(){const e=t.rtl,s=t.params.pagination;if(d())return;let a,r,p=t.pagination.el;p=o(p);const u=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,m=t.params.loop?Math.ceil(u/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(r=t.previousRealIndex||0,a=t.params.slidesPerGroup>1?Math.floor(t.realIndex/t.params.slidesPerGroup):t.realIndex):void 0!==t.snapIndex?(a=t.snapIndex,r=t.previousSnapIndex):(r=t.previousIndex||0,a=t.activeIndex||0),"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const i=t.pagination.bullets;let o,d,u;if(s.dynamicBullets&&(n=S(i[0],t.isHorizontal()?"width":"height",!0),p.forEach((e=>{e.style[t.isHorizontal()?"width":"height"]=n*(s.dynamicMainBullets+4)+"px"})),s.dynamicMainBullets>1&&void 0!==r&&(l+=a-(r||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),o=Math.max(a-l,0),d=o+(Math.min(i.length,s.dynamicMainBullets)-1),u=(d+o)/2),i.forEach((e=>{const t=[...["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`))].map((e=>"string"==typeof e&&e.includes(" ")?e.split(" "):e)).flat();e.classList.remove(...t)})),p.length>1)i.forEach((e=>{const i=y(e);i===a?e.classList.add(...s.bulletActiveClass.split(" ")):t.isElement&&e.setAttribute("part","bullet"),s.dynamicBullets&&(i>=o&&i<=d&&e.classList.add(...`${s.bulletActiveClass}-main`.split(" ")),i===o&&c(e,"prev"),i===d&&c(e,"next"))}));else{const e=i[a];if(e&&e.classList.add(...s.bulletActiveClass.split(" ")),t.isElement&&i.forEach(((e,t)=>{e.setAttribute("part",t===a?"bullet-active":"bullet")})),s.dynamicBullets){const e=i[o],t=i[d];for(let e=o;e<=d;e+=1)i[e]&&i[e].classList.add(...`${s.bulletActiveClass}-main`.split(" "));c(e,"prev"),c(t,"next")}}if(s.dynamicBullets){const a=Math.min(i.length,s.dynamicMainBullets+4),r=(n*a-n)/2-u*n,l=e?"right":"left";i.forEach((e=>{e.style[t.isHorizontal()?l:"top"]=`${r}px`}))}}p.forEach(((e,r)=>{if("fraction"===s.type&&(e.querySelectorAll(se(s.currentClass)).forEach((e=>{e.textContent=s.formatFractionCurrent(a+1)})),e.querySelectorAll(se(s.totalClass)).forEach((e=>{e.textContent=s.formatFractionTotal(m)}))),"progressbar"===s.type){let i;i=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const r=(a+1)/m;let n=1,l=1;"horizontal"===i?n=r:l=r,e.querySelectorAll(se(s.progressbarFillClass)).forEach((e=>{e.style.transform=`translate3d(0,0,0) scaleX(${n}) scaleY(${l})`,e.style.transitionDuration=`${t.params.speed}ms`}))}"custom"===s.type&&s.renderCustom?(e.innerHTML=s.renderCustom(t,a+1,m),0===r&&i("paginationRender",e)):(0===r&&i("paginationRender",e),i("paginationUpdate",e)),t.params.watchOverflow&&t.enabled&&e.classList[t.isLocked?"add":"remove"](s.lockClass)}))}function m(){const e=t.params.pagination;if(d())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.grid&&t.params.grid.rows>1?t.slides.length/Math.ceil(t.params.grid.rows):t.slides.length;let a=t.pagination.el;a=o(a);let r="";if("bullets"===e.type){let a=t.params.loop?Math.ceil(s/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&a>s&&(a=s);for(let s=0;s<a;s+=1)e.renderBullet?r+=e.renderBullet.call(t,s,e.bulletClass):r+=`<${e.bulletElement} ${t.isElement?'part="bullet"':""} class="${e.bulletClass}"></${e.bulletElement}>`}"fraction"===e.type&&(r=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),"progressbar"===e.type&&(r=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`),t.pagination.bullets=[],a.forEach((s=>{"custom"!==e.type&&(s.innerHTML=r||""),"bullets"===e.type&&t.pagination.bullets.push(...s.querySelectorAll(se(e.bulletClass)))})),"custom"!==e.type&&i("paginationRender",a[0])}function h(){t.params.pagination=te(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s;"string"==typeof e.el&&t.isElement&&(s=t.el.querySelector(e.el)),s||"string"!=typeof e.el||(s=[...document.querySelectorAll(e.el)]),s||(s=e.el),s&&0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&Array.isArray(s)&&s.length>1&&(s=[...t.el.querySelectorAll(e.el)],s.length>1&&(s=s.filter((e=>E(e,".swiper")[0]===t.el))[0])),Array.isArray(s)&&1===s.length&&(s=s[0]),Object.assign(t.pagination,{el:s}),s=o(s),s.forEach((s=>{"bullets"===e.type&&e.clickable&&s.classList.add(...(e.clickableClass||"").split(" ")),s.classList.add(e.modifierClass+e.type),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.classList.add(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.classList.add(e.progressbarOppositeClass),e.clickable&&s.addEventListener("click",p),t.enabled||s.classList.add(e.lockClass)})))}function f(){const e=t.params.pagination;if(d())return;let s=t.pagination.el;s&&(s=o(s),s.forEach((s=>{s.classList.remove(e.hiddenClass),s.classList.remove(e.modifierClass+e.type),s.classList.remove(t.isHorizontal()?e.horizontalClass:e.verticalClass),e.clickable&&(s.classList.remove(...(e.clickableClass||"").split(" ")),s.removeEventListener("click",p))}))),t.pagination.bullets&&t.pagination.bullets.forEach((t=>t.classList.remove(...e.bulletActiveClass.split(" "))))}a("changeDirection",(()=>{if(!t.pagination||!t.pagination.el)return;const e=t.params.pagination;let{el:s}=t.pagination;s=o(s),s.forEach((s=>{s.classList.remove(e.horizontalClass,e.verticalClass),s.classList.add(t.isHorizontal()?e.horizontalClass:e.verticalClass)}))})),a("init",(()=>{!1===t.params.pagination.enabled?g():(h(),m(),u())})),a("activeIndexChange",(()=>{void 0===t.snapIndex&&u()})),a("snapIndexChange",(()=>{u()})),a("snapGridLengthChange",(()=>{m(),u()})),a("destroy",(()=>{f()})),a("enable disable",(()=>{let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList[t.enabled?"remove":"add"](t.params.pagination.lockClass))))})),a("lock unlock",(()=>{u()})),a("click",((e,s)=>{const a=s.target,r=o(t.pagination.el);if(t.params.pagination.el&&t.params.pagination.hideOnClick&&r&&r.length>0&&!a.classList.contains(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&a===t.navigation.nextEl||t.navigation.prevEl&&a===t.navigation.prevEl))return;const e=r[0].classList.contains(t.params.pagination.hiddenClass);i(!0===e?"paginationShow":"paginationHide"),r.forEach((e=>e.classList.toggle(t.params.pagination.hiddenClass)))}}));const g=()=>{t.el.classList.add(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList.add(t.params.pagination.paginationDisabledClass)))),f()};Object.assign(t.pagination,{enable:()=>{t.el.classList.remove(t.params.pagination.paginationDisabledClass);let{el:e}=t.pagination;e&&(e=o(e),e.forEach((e=>e.classList.remove(t.params.pagination.paginationDisabledClass)))),h(),m(),u()},disable:g,render:m,update:u,init:h,destroy:f})},function(e){let{swiper:t,extendParams:s,on:i,emit:r}=e;const o=a();let d,c,p,u,m=!1,h=null,f=null;function g(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e,rtlTranslate:s}=t,{dragEl:a,el:i}=e,r=t.params.scrollbar,n=t.params.loop?t.progressLoop:t.progress;let l=c,o=(p-c)*n;s?(o=-o,o>0?(l=c-o,o=0):-o+c>p&&(l=p+o)):o<0?(l=c+o,o=0):o+c>p&&(l=p-o),t.isHorizontal()?(a.style.transform=`translate3d(${o}px, 0, 0)`,a.style.width=`${l}px`):(a.style.transform=`translate3d(0px, ${o}px, 0)`,a.style.height=`${l}px`),r.hide&&(clearTimeout(h),i.style.opacity=1,h=setTimeout((()=>{i.style.opacity=0,i.style.transitionDuration="400ms"}),1e3))}function b(){if(!t.params.scrollbar.el||!t.scrollbar.el)return;const{scrollbar:e}=t,{dragEl:s,el:a}=e;s.style.width="",s.style.height="",p=t.isHorizontal()?a.offsetWidth:a.offsetHeight,u=t.size/(t.virtualSize+t.params.slidesOffsetBefore-(t.params.centeredSlides?t.snapGrid[0]:0)),c="auto"===t.params.scrollbar.dragSize?p*u:parseInt(t.params.scrollbar.dragSize,10),t.isHorizontal()?s.style.width=`${c}px`:s.style.height=`${c}px`,a.style.display=u>=1?"none":"",t.params.scrollbar.hide&&(a.style.opacity=0),t.params.watchOverflow&&t.enabled&&e.el.classList[t.isLocked?"add":"remove"](t.params.scrollbar.lockClass)}function y(e){return t.isHorizontal()?e.clientX:e.clientY}function E(e){const{scrollbar:s,rtlTranslate:a}=t,{el:i}=s;let r;r=(y(e)-w(i)[t.isHorizontal()?"left":"top"]-(null!==d?d:c/2))/(p-c),r=Math.max(Math.min(r,1),0),a&&(r=1-r);const n=t.minTranslate()+(t.maxTranslate()-t.minTranslate())*r;t.updateProgress(n),t.setTranslate(n),t.updateActiveIndex(),t.updateSlidesClasses()}function x(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n,dragEl:l}=a;m=!0,d=e.target===l?y(e)-e.target.getBoundingClientRect()[t.isHorizontal()?"left":"top"]:null,e.preventDefault(),e.stopPropagation(),i.style.transitionDuration="100ms",l.style.transitionDuration="100ms",E(e),clearTimeout(f),n.style.transitionDuration="0ms",s.hide&&(n.style.opacity=1),t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="none"),r("scrollbarDragStart",e)}function S(e){const{scrollbar:s,wrapperEl:a}=t,{el:i,dragEl:n}=s;m&&(e.preventDefault?e.preventDefault():e.returnValue=!1,E(e),a.style.transitionDuration="0ms",i.style.transitionDuration="0ms",n.style.transitionDuration="0ms",r("scrollbarDragMove",e))}function T(e){const s=t.params.scrollbar,{scrollbar:a,wrapperEl:i}=t,{el:n}=a;m&&(m=!1,t.params.cssMode&&(t.wrapperEl.style["scroll-snap-type"]="",i.style.transitionDuration=""),s.hide&&(clearTimeout(f),f=l((()=>{n.style.opacity=0,n.style.transitionDuration="400ms"}),1e3)),r("scrollbarDragEnd",e),s.snapOnRelease&&t.slideToClosest())}function M(e){const{scrollbar:s,params:a}=t,i=s.el;if(!i)return;const r=i,n=!!a.passiveListeners&&{passive:!1,capture:!1},l=!!a.passiveListeners&&{passive:!0,capture:!1};if(!r)return;const d="on"===e?"addEventListener":"removeEventListener";r[d]("pointerdown",x,n),o[d]("pointermove",S,n),o[d]("pointerup",T,l)}function C(){const{scrollbar:e,el:s}=t;t.params.scrollbar=te(t,t.originalParams.scrollbar,t.params.scrollbar,{el:"swiper-scrollbar"});const a=t.params.scrollbar;if(!a.el)return;let i,r;if("string"==typeof a.el&&t.isElement&&(i=t.el.querySelector(a.el)),i||"string"!=typeof a.el)i||(i=a.el);else if(i=o.querySelectorAll(a.el),!i.length)return;t.params.uniqueNavElements&&"string"==typeof a.el&&i.length>1&&1===s.querySelectorAll(a.el).length&&(i=s.querySelector(a.el)),i.length>0&&(i=i[0]),i.classList.add(t.isHorizontal()?a.horizontalClass:a.verticalClass),i&&(r=i.querySelector(se(t.params.scrollbar.dragClass)),r||(r=v("div",t.params.scrollbar.dragClass),i.append(r))),Object.assign(e,{el:i,dragEl:r}),a.draggable&&t.params.scrollbar.el&&t.scrollbar.el&&M("on"),i&&i.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))}function P(){const e=t.params.scrollbar,s=t.scrollbar.el;s&&s.classList.remove(...n(t.isHorizontal()?e.horizontalClass:e.verticalClass)),t.params.scrollbar.el&&t.scrollbar.el&&M("off")}s({scrollbar:{el:null,dragSize:"auto",hide:!1,draggable:!1,snapOnRelease:!0,lockClass:"swiper-scrollbar-lock",dragClass:"swiper-scrollbar-drag",scrollbarDisabledClass:"swiper-scrollbar-disabled",horizontalClass:"swiper-scrollbar-horizontal",verticalClass:"swiper-scrollbar-vertical"}}),t.scrollbar={el:null,dragEl:null},i("init",(()=>{!1===t.params.scrollbar.enabled?L():(C(),b(),g())})),i("update resize observerUpdate lock unlock",(()=>{b()})),i("setTranslate",(()=>{g()})),i("setTransition",((e,s)=>{!function(e){t.params.scrollbar.el&&t.scrollbar.el&&(t.scrollbar.dragEl.style.transitionDuration=`${e}ms`)}(s)})),i("enable disable",(()=>{const{el:e}=t.scrollbar;e&&e.classList[t.enabled?"remove":"add"](...n(t.params.scrollbar.lockClass))})),i("destroy",(()=>{P()}));const L=()=>{t.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.add(...n(t.params.scrollbar.scrollbarDisabledClass)),P()};Object.assign(t.scrollbar,{enable:()=>{t.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),t.scrollbar.el&&t.scrollbar.el.classList.remove(...n(t.params.scrollbar.scrollbarDisabledClass)),C(),b(),g()},disable:L,updateSize:b,setTranslate:g,init:C,destroy:P})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({parallax:{enabled:!1}});const i="[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]",r=(e,s)=>{const{rtl:a}=t,i=a?-1:1,r=e.getAttribute("data-swiper-parallax")||"0";let n=e.getAttribute("data-swiper-parallax-x"),l=e.getAttribute("data-swiper-parallax-y");const o=e.getAttribute("data-swiper-parallax-scale"),d=e.getAttribute("data-swiper-parallax-opacity"),c=e.getAttribute("data-swiper-parallax-rotate");if(n||l?(n=n||"0",l=l||"0"):t.isHorizontal()?(n=r,l="0"):(l=r,n="0"),n=n.indexOf("%")>=0?parseInt(n,10)*s*i+"%":n*s*i+"px",l=l.indexOf("%")>=0?parseInt(l,10)*s+"%":l*s+"px",null!=d){const t=d-(d-1)*(1-Math.abs(s));e.style.opacity=t}let p=`translate3d(${n}, ${l}, 0px)`;if(null!=o){p+=` scale(${o-(o-1)*(1-Math.abs(s))})`}if(c&&null!=c){p+=` rotate(${c*s*-1}deg)`}e.style.transform=p},n=()=>{const{el:e,slides:s,progress:a,snapGrid:n,isElement:l}=t,o=f(e,i);t.isElement&&o.push(...f(t.hostEl,i)),o.forEach((e=>{r(e,a)})),s.forEach(((e,s)=>{let l=e.progress;t.params.slidesPerGroup>1&&"auto"!==t.params.slidesPerView&&(l+=Math.ceil(s/2)-a*(n.length-1)),l=Math.min(Math.max(l,-1),1),e.querySelectorAll(`${i}, [data-swiper-parallax-rotate]`).forEach((e=>{r(e,l)}))}))};a("beforeInit",(()=>{t.params.parallax.enabled&&(t.params.watchSlidesProgress=!0,t.originalParams.watchSlidesProgress=!0)})),a("init",(()=>{t.params.parallax.enabled&&n()})),a("setTranslate",(()=>{t.params.parallax.enabled&&n()})),a("setTransition",((e,s)=>{t.params.parallax.enabled&&function(e){void 0===e&&(e=t.params.speed);const{el:s,hostEl:a}=t,r=[...s.querySelectorAll(i)];t.isElement&&r.push(...a.querySelectorAll(i)),r.forEach((t=>{let s=parseInt(t.getAttribute("data-swiper-parallax-duration"),10)||e;0===e&&(s=0),t.style.transitionDuration=`${s}ms`}))}(s)}))},function(e){let{swiper:t,extendParams:s,on:a,emit:i}=e;const n=r();s({zoom:{enabled:!1,maxRatio:3,minRatio:1,toggle:!0,containerClass:"swiper-zoom-container",zoomedSlideClass:"swiper-slide-zoomed"}}),t.zoom={enabled:!1};let l,o,c=1,p=!1;const u=[],m={originX:0,originY:0,slideEl:void 0,slideWidth:void 0,slideHeight:void 0,imageEl:void 0,imageWrapEl:void 0,maxRatio:3},h={isTouched:void 0,isMoved:void 0,currentX:void 0,currentY:void 0,minX:void 0,minY:void 0,maxX:void 0,maxY:void 0,width:void 0,height:void 0,startX:void 0,startY:void 0,touchesStart:{},touchesCurrent:{}},g={x:void 0,y:void 0,prevPositionX:void 0,prevPositionY:void 0,prevTime:void 0};let v=1;function b(){if(u.length<2)return 1;const e=u[0].pageX,t=u[0].pageY,s=u[1].pageX,a=u[1].pageY;return Math.sqrt((s-e)**2+(a-t)**2)}function y(e){const s=t.isElement?"swiper-slide":`.${t.params.slideClass}`;return!!e.target.matches(s)||t.slides.filter((t=>t.contains(e.target))).length>0}function x(e){if("mouse"===e.pointerType&&u.splice(0,u.length),!y(e))return;const s=t.params.zoom;if(l=!1,o=!1,u.push(e),!(u.length<2)){if(l=!0,m.scaleStart=b(),!m.slideEl){m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`),m.slideEl||(m.slideEl=t.slides[t.activeIndex]);let a=m.slideEl.querySelector(`.${s.containerClass}`);if(a&&(a=a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=a,m.imageWrapEl=a?E(m.imageEl,`.${s.containerClass}`)[0]:void 0,!m.imageWrapEl)return void(m.imageEl=void 0);m.maxRatio=m.imageWrapEl.getAttribute("data-swiper-zoom")||s.maxRatio}if(m.imageEl){const[e,t]=function(){if(u.length<2)return{x:null,y:null};const e=m.imageEl.getBoundingClientRect();return[(u[0].pageX+(u[1].pageX-u[0].pageX)/2-e.x-n.scrollX)/c,(u[0].pageY+(u[1].pageY-u[0].pageY)/2-e.y-n.scrollY)/c]}();m.originX=e,m.originY=t,m.imageEl.style.transitionDuration="0ms"}p=!0}}function S(e){if(!y(e))return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&(u[i]=e),u.length<2||(o=!0,m.scaleMove=b(),m.imageEl&&(a.scale=m.scaleMove/m.scaleStart*c,a.scale>m.maxRatio&&(a.scale=m.maxRatio-1+(a.scale-m.maxRatio+1)**.5),a.scale<s.minRatio&&(a.scale=s.minRatio+1-(s.minRatio-a.scale+1)**.5),m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`))}function T(e){if(!y(e))return;if("mouse"===e.pointerType&&"pointerout"===e.type)return;const s=t.params.zoom,a=t.zoom,i=u.findIndex((t=>t.pointerId===e.pointerId));i>=0&&u.splice(i,1),l&&o&&(l=!1,o=!1,m.imageEl&&(a.scale=Math.max(Math.min(a.scale,m.maxRatio),s.minRatio),m.imageEl.style.transitionDuration=`${t.params.speed}ms`,m.imageEl.style.transform=`translate3d(0,0,0) scale(${a.scale})`,c=a.scale,p=!1,a.scale>1&&m.slideEl?m.slideEl.classList.add(`${s.zoomedSlideClass}`):a.scale<=1&&m.slideEl&&m.slideEl.classList.remove(`${s.zoomedSlideClass}`),1===a.scale&&(m.originX=0,m.originY=0,m.slideEl=void 0)))}function M(e){if(!y(e)||!function(e){const s=`.${t.params.zoom.containerClass}`;return!!e.target.matches(s)||[...t.hostEl.querySelectorAll(s)].filter((t=>t.contains(e.target))).length>0}(e))return;const s=t.zoom;if(!m.imageEl)return;if(!h.isTouched||!m.slideEl)return;h.isMoved||(h.width=m.imageEl.offsetWidth,h.height=m.imageEl.offsetHeight,h.startX=d(m.imageWrapEl,"x")||0,h.startY=d(m.imageWrapEl,"y")||0,m.slideWidth=m.slideEl.offsetWidth,m.slideHeight=m.slideEl.offsetHeight,m.imageWrapEl.style.transitionDuration="0ms");const a=h.width*s.scale,i=h.height*s.scale;if(a<m.slideWidth&&i<m.slideHeight)return;h.minX=Math.min(m.slideWidth/2-a/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-i/2,0),h.maxY=-h.minY,h.touchesCurrent.x=u.length>0?u[0].pageX:e.pageX,h.touchesCurrent.y=u.length>0?u[0].pageY:e.pageY;if(Math.max(Math.abs(h.touchesCurrent.x-h.touchesStart.x),Math.abs(h.touchesCurrent.y-h.touchesStart.y))>5&&(t.allowClick=!1),!h.isMoved&&!p){if(t.isHorizontal()&&(Math.floor(h.minX)===Math.floor(h.startX)&&h.touchesCurrent.x<h.touchesStart.x||Math.floor(h.maxX)===Math.floor(h.startX)&&h.touchesCurrent.x>h.touchesStart.x))return void(h.isTouched=!1);if(!t.isHorizontal()&&(Math.floor(h.minY)===Math.floor(h.startY)&&h.touchesCurrent.y<h.touchesStart.y||Math.floor(h.maxY)===Math.floor(h.startY)&&h.touchesCurrent.y>h.touchesStart.y))return void(h.isTouched=!1)}e.cancelable&&e.preventDefault(),e.stopPropagation(),h.isMoved=!0;const r=(s.scale-c)/(m.maxRatio-t.params.zoom.minRatio),{originX:n,originY:l}=m;h.currentX=h.touchesCurrent.x-h.touchesStart.x+h.startX+r*(h.width-2*n),h.currentY=h.touchesCurrent.y-h.touchesStart.y+h.startY+r*(h.height-2*l),h.currentX<h.minX&&(h.currentX=h.minX+1-(h.minX-h.currentX+1)**.8),h.currentX>h.maxX&&(h.currentX=h.maxX-1+(h.currentX-h.maxX+1)**.8),h.currentY<h.minY&&(h.currentY=h.minY+1-(h.minY-h.currentY+1)**.8),h.currentY>h.maxY&&(h.currentY=h.maxY-1+(h.currentY-h.maxY+1)**.8),g.prevPositionX||(g.prevPositionX=h.touchesCurrent.x),g.prevPositionY||(g.prevPositionY=h.touchesCurrent.y),g.prevTime||(g.prevTime=Date.now()),g.x=(h.touchesCurrent.x-g.prevPositionX)/(Date.now()-g.prevTime)/2,g.y=(h.touchesCurrent.y-g.prevPositionY)/(Date.now()-g.prevTime)/2,Math.abs(h.touchesCurrent.x-g.prevPositionX)<2&&(g.x=0),Math.abs(h.touchesCurrent.y-g.prevPositionY)<2&&(g.y=0),g.prevPositionX=h.touchesCurrent.x,g.prevPositionY=h.touchesCurrent.y,g.prevTime=Date.now(),m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}function C(){const e=t.zoom;m.slideEl&&t.activeIndex!==t.slides.indexOf(m.slideEl)&&(m.imageEl&&(m.imageEl.style.transform="translate3d(0,0,0) scale(1)"),m.imageWrapEl&&(m.imageWrapEl.style.transform="translate3d(0,0,0)"),m.slideEl.classList.remove(`${t.params.zoom.zoomedSlideClass}`),e.scale=1,c=1,m.slideEl=void 0,m.imageEl=void 0,m.imageWrapEl=void 0,m.originX=0,m.originY=0)}function P(e){const s=t.zoom,a=t.params.zoom;if(!m.slideEl){e&&e.target&&(m.slideEl=e.target.closest(`.${t.params.slideClass}, swiper-slide`)),m.slideEl||(t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex]);let s=m.slideEl.querySelector(`.${a.containerClass}`);s&&(s=s.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=s,m.imageWrapEl=s?E(m.imageEl,`.${a.containerClass}`)[0]:void 0}if(!m.imageEl||!m.imageWrapEl)return;let i,r,l,o,d,p,u,g,v,b,y,x,S,T,M,C,P,L;t.params.cssMode&&(t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.touchAction="none"),m.slideEl.classList.add(`${a.zoomedSlideClass}`),void 0===h.touchesStart.x&&e?(i=e.pageX,r=e.pageY):(i=h.touchesStart.x,r=h.touchesStart.y);const A="number"==typeof e?e:null;1===c&&A&&(i=void 0,r=void 0),s.scale=A||m.imageWrapEl.getAttribute("data-swiper-zoom")||a.maxRatio,c=A||m.imageWrapEl.getAttribute("data-swiper-zoom")||a.maxRatio,!e||1===c&&A?(u=0,g=0):(P=m.slideEl.offsetWidth,L=m.slideEl.offsetHeight,l=w(m.slideEl).left+n.scrollX,o=w(m.slideEl).top+n.scrollY,d=l+P/2-i,p=o+L/2-r,v=m.imageEl.offsetWidth,b=m.imageEl.offsetHeight,y=v*s.scale,x=b*s.scale,S=Math.min(P/2-y/2,0),T=Math.min(L/2-x/2,0),M=-S,C=-T,u=d*s.scale,g=p*s.scale,u<S&&(u=S),u>M&&(u=M),g<T&&(g=T),g>C&&(g=C)),A&&1===s.scale&&(m.originX=0,m.originY=0),m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform=`translate3d(${u}px, ${g}px,0)`,m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform=`translate3d(0,0,0) scale(${s.scale})`}function L(){const e=t.zoom,s=t.params.zoom;if(!m.slideEl){t.params.virtual&&t.params.virtual.enabled&&t.virtual?m.slideEl=f(t.slidesEl,`.${t.params.slideActiveClass}`)[0]:m.slideEl=t.slides[t.activeIndex];let e=m.slideEl.querySelector(`.${s.containerClass}`);e&&(e=e.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]),m.imageEl=e,m.imageWrapEl=e?E(m.imageEl,`.${s.containerClass}`)[0]:void 0}m.imageEl&&m.imageWrapEl&&(t.params.cssMode&&(t.wrapperEl.style.overflow="",t.wrapperEl.style.touchAction=""),e.scale=1,c=1,m.imageWrapEl.style.transitionDuration="300ms",m.imageWrapEl.style.transform="translate3d(0,0,0)",m.imageEl.style.transitionDuration="300ms",m.imageEl.style.transform="translate3d(0,0,0) scale(1)",m.slideEl.classList.remove(`${s.zoomedSlideClass}`),m.slideEl=void 0,m.originX=0,m.originY=0)}function A(e){const s=t.zoom;s.scale&&1!==s.scale?L():P(e)}function I(){return{passiveListener:!!t.params.passiveListeners&&{passive:!0,capture:!1},activeListenerWithCapture:!t.params.passiveListeners||{passive:!1,capture:!0}}}function z(){const e=t.zoom;if(e.enabled)return;e.enabled=!0;const{passiveListener:s,activeListenerWithCapture:a}=I();t.wrapperEl.addEventListener("pointerdown",x,s),t.wrapperEl.addEventListener("pointermove",S,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.addEventListener(e,T,s)})),t.wrapperEl.addEventListener("pointermove",M,a)}function $(){const e=t.zoom;if(!e.enabled)return;e.enabled=!1;const{passiveListener:s,activeListenerWithCapture:a}=I();t.wrapperEl.removeEventListener("pointerdown",x,s),t.wrapperEl.removeEventListener("pointermove",S,a),["pointerup","pointercancel","pointerout"].forEach((e=>{t.wrapperEl.removeEventListener(e,T,s)})),t.wrapperEl.removeEventListener("pointermove",M,a)}Object.defineProperty(t.zoom,"scale",{get:()=>v,set(e){if(v!==e){const t=m.imageEl,s=m.slideEl;i("zoomChange",e,t,s)}v=e}}),a("init",(()=>{t.params.zoom.enabled&&z()})),a("destroy",(()=>{$()})),a("touchStart",((e,s)=>{t.zoom.enabled&&function(e){const s=t.device;if(!m.imageEl)return;if(h.isTouched)return;s.android&&e.cancelable&&e.preventDefault(),h.isTouched=!0;const a=u.length>0?u[0]:e;h.touchesStart.x=a.pageX,h.touchesStart.y=a.pageY}(s)})),a("touchEnd",((e,s)=>{t.zoom.enabled&&function(){const e=t.zoom;if(!m.imageEl)return;if(!h.isTouched||!h.isMoved)return h.isTouched=!1,void(h.isMoved=!1);h.isTouched=!1,h.isMoved=!1;let s=300,a=300;const i=g.x*s,r=h.currentX+i,n=g.y*a,l=h.currentY+n;0!==g.x&&(s=Math.abs((r-h.currentX)/g.x)),0!==g.y&&(a=Math.abs((l-h.currentY)/g.y));const o=Math.max(s,a);h.currentX=r,h.currentY=l;const d=h.width*e.scale,c=h.height*e.scale;h.minX=Math.min(m.slideWidth/2-d/2,0),h.maxX=-h.minX,h.minY=Math.min(m.slideHeight/2-c/2,0),h.maxY=-h.minY,h.currentX=Math.max(Math.min(h.currentX,h.maxX),h.minX),h.currentY=Math.max(Math.min(h.currentY,h.maxY),h.minY),m.imageWrapEl.style.transitionDuration=`${o}ms`,m.imageWrapEl.style.transform=`translate3d(${h.currentX}px, ${h.currentY}px,0)`}()})),a("doubleTap",((e,s)=>{!t.animating&&t.params.zoom.enabled&&t.zoom.enabled&&t.params.zoom.toggle&&A(s)})),a("transitionEnd",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&C()})),a("slideChange",(()=>{t.zoom.enabled&&t.params.zoom.enabled&&t.params.cssMode&&C()})),Object.assign(t.zoom,{enable:z,disable:$,in:P,out:L,toggle:A})},function(e){let{swiper:t,extendParams:s,on:a}=e;function i(e,t){const s=function(){let e,t,s;return(a,i)=>{for(t=-1,e=a.length;e-t>1;)s=e+t>>1,a[s]<=i?t=s:e=s;return e}}();let a,i;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(i=s(this.x,e),a=i-1,(e-this.x[a])*(this.y[i]-this.y[a])/(this.x[i]-this.x[a])+this.y[a]):0},this}function r(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},a("beforeInit",(()=>{if("undefined"!=typeof window&&("string"==typeof t.params.controller.control||t.params.controller.control instanceof HTMLElement)){const e=document.querySelector(t.params.controller.control);if(e&&e.swiper)t.controller.control=e.swiper;else if(e){const s=a=>{t.controller.control=a.detail[0],t.update(),e.removeEventListener("init",s)};e.addEventListener("init",s)}}else t.controller.control=t.params.controller.control})),a("update",(()=>{r()})),a("resize",(()=>{r()})),a("observerUpdate",(()=>{r()})),a("setTranslate",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTranslate(s,a)})),a("setTransition",((e,s,a)=>{t.controller.control&&!t.controller.control.destroyed&&t.controller.setTransition(s,a)})),Object.assign(t.controller,{setTranslate:function(e,s){const a=t.controller.control;let r,n;const l=t.constructor;function o(e){if(e.destroyed)return;const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline=t.params.loop?new i(t.slidesGrid,e.slidesGrid):new i(t.snapGrid,e.snapGrid)}(e),n=-t.controller.spline.interpolate(-s)),n&&"container"!==t.params.controller.by||(r=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),!Number.isNaN(r)&&Number.isFinite(r)||(r=1),n=(s-t.minTranslate())*r+e.minTranslate()),t.params.controller.inverse&&(n=e.maxTranslate()-n),e.updateProgress(n),e.setTranslate(n,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(a))for(let e=0;e<a.length;e+=1)a[e]!==s&&a[e]instanceof l&&o(a[e]);else a instanceof l&&s!==a&&o(a)},setTransition:function(e,s){const a=t.constructor,i=t.controller.control;let r;function n(s){s.destroyed||(s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&l((()=>{s.updateAutoHeight()})),x(s.wrapperEl,(()=>{i&&s.transitionEnd()}))))}if(Array.isArray(i))for(r=0;r<i.length;r+=1)i[r]!==s&&i[r]instanceof a&&n(i[r]);else i instanceof a&&s!==i&&n(i)}})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null}}),t.a11y={clicked:!1};let i=null;function r(e){const t=i;0!==t.length&&(t.innerHTML="",t.innerHTML=e)}const n=e=>(Array.isArray(e)?e:[e]).filter((e=>!!e));function l(e){(e=n(e)).forEach((e=>{e.setAttribute("tabIndex","0")}))}function o(e){(e=n(e)).forEach((e=>{e.setAttribute("tabIndex","-1")}))}function d(e,t){(e=n(e)).forEach((e=>{e.setAttribute("role",t)}))}function c(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-roledescription",t)}))}function p(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-label",t)}))}function u(e){(e=n(e)).forEach((e=>{e.setAttribute("aria-disabled",!0)}))}function m(e){(e=n(e)).forEach((e=>{e.setAttribute("aria-disabled",!1)}))}function h(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,a=e.target;t.pagination&&t.pagination.el&&(a===t.pagination.el||t.pagination.el.contains(e.target))&&!e.target.matches(se(t.params.pagination.bulletClass))||(t.navigation&&t.navigation.nextEl&&a===t.navigation.nextEl&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?r(s.lastSlideMessage):r(s.nextSlideMessage)),t.navigation&&t.navigation.prevEl&&a===t.navigation.prevEl&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?r(s.firstSlideMessage):r(s.prevSlideMessage)),t.pagination&&a.matches(se(t.params.pagination.bulletClass))&&a.click())}function f(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function g(){return f()&&t.params.pagination.clickable}const w=(e,t,s)=>{l(e),"BUTTON"!==e.tagName&&(d(e,"button"),e.addEventListener("keydown",h)),p(e,s),function(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-controls",t)}))}(e,t)},b=()=>{t.a11y.clicked=!0},E=()=>{requestAnimationFrame((()=>{requestAnimationFrame((()=>{t.destroyed||(t.a11y.clicked=!1)}))}))},x=e=>{if(t.a11y.clicked)return;const s=e.target.closest(`.${t.params.slideClass}, swiper-slide`);if(!s||!t.slides.includes(s))return;const a=t.slides.indexOf(s)===t.activeIndex,i=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);a||i||e.sourceCapabilities&&e.sourceCapabilities.firesTouchEvents||(t.isHorizontal()?t.el.scrollLeft=0:t.el.scrollTop=0,t.slideTo(t.slides.indexOf(s),0))},S=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&c(t.slides,e.itemRoleDescriptionMessage),e.slideRole&&d(t.slides,e.slideRole);const s=t.slides.length;e.slideLabelMessage&&t.slides.forEach(((a,i)=>{const r=t.params.loop?parseInt(a.getAttribute("data-swiper-slide-index"),10):i;p(a,e.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,s))}))},T=()=>{const e=t.params.a11y;t.el.append(i);const s=t.el;e.containerRoleDescriptionMessage&&c(s,e.containerRoleDescriptionMessage),e.containerMessage&&p(s,e.containerMessage);const a=t.wrapperEl,r=e.id||a.getAttribute("id")||`swiper-wrapper-${l=16,void 0===l&&(l=16),"x".repeat(l).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var l;const o=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var d;d=r,n(a).forEach((e=>{e.setAttribute("id",d)})),function(e,t){(e=n(e)).forEach((e=>{e.setAttribute("aria-live",t)}))}(a,o),S();let{nextEl:u,prevEl:m}=t.navigation?t.navigation:{};if(u=n(u),m=n(m),u&&u.forEach((t=>w(t,r,e.nextSlideMessage))),m&&m.forEach((t=>w(t,r,e.prevSlideMessage))),g()){n(t.pagination.el).forEach((e=>{e.addEventListener("keydown",h)}))}t.el.addEventListener("focus",x,!0),t.el.addEventListener("pointerdown",b,!0),t.el.addEventListener("pointerup",E,!0)};a("beforeInit",(()=>{i=v("span",t.params.a11y.notificationClass),i.setAttribute("aria-live","assertive"),i.setAttribute("aria-atomic","true")})),a("afterInit",(()=>{t.params.a11y.enabled&&T()})),a("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&S()})),a("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{nextEl:e,prevEl:s}=t.navigation;s&&(t.isBeginning?(u(s),o(s)):(m(s),l(s))),e&&(t.isEnd?(u(e),o(e)):(m(e),l(e)))}()})),a("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;f()&&t.pagination.bullets.forEach((s=>{t.params.pagination.clickable&&(l(s),t.params.pagination.renderBullet||(d(s,"button"),p(s,e.paginationBulletMessage.replace(/\{\{index\}\}/,y(s)+1)))),s.matches(se(t.params.pagination.bulletActiveClass))?s.setAttribute("aria-current","true"):s.removeAttribute("aria-current")}))}()})),a("destroy",(()=>{t.params.a11y.enabled&&function(){i&&i.remove();let{nextEl:e,prevEl:s}=t.navigation?t.navigation:{};e=n(e),s=n(s),e&&e.forEach((e=>e.removeEventListener("keydown",h))),s&&s.forEach((e=>e.removeEventListener("keydown",h))),g()&&n(t.pagination.el).forEach((e=>{e.removeEventListener("keydown",h)}));t.el.removeEventListener("focus",x,!0),t.el.removeEventListener("pointerdown",b,!0),t.el.removeEventListener("pointerup",E,!0)}()}))},function(e){let{swiper:t,extendParams:s,on:a}=e;s({history:{enabled:!1,root:"",replaceState:!1,key:"slides",keepQuery:!1}});let i=!1,n={};const l=e=>e.toString().replace(/\s+/g,"-").replace(/[^\w-]+/g,"").replace(/--+/g,"-").replace(/^-+/,"").replace(/-+$/,""),o=e=>{const t=r();let s;s=e?new URL(e):t.location;const a=s.pathname.slice(1).split("/").filter((e=>""!==e)),i=a.length;return{key:a[i-2],value:a[i-1]}},d=(e,s)=>{const a=r();if(!i||!t.params.history.enabled)return;let n;n=t.params.url?new URL(t.params.url):a.location;const o=t.slides[s];let d=l(o.getAttribute("data-history"));if(t.params.history.root.length>0){let s=t.params.history.root;"/"===s[s.length-1]&&(s=s.slice(0,s.length-1)),d=`${s}/${e?`${e}/`:""}${d}`}else n.pathname.includes(e)||(d=`${e?`${e}/`:""}${d}`);t.params.history.keepQuery&&(d+=n.search);const c=a.history.state;c&&c.value===d||(t.params.history.replaceState?a.history.replaceState({value:d},null,d):a.history.pushState({value:d},null,d))},c=(e,s,a)=>{if(s)for(let i=0,r=t.slides.length;i<r;i+=1){const r=t.slides[i];if(l(r.getAttribute("data-history"))===s){const s=t.getSlideIndex(r);t.slideTo(s,e,a)}}else t.slideTo(0,e,a)},p=()=>{n=o(t.params.url),c(t.params.speed,n.value,!1)};a("init",(()=>{t.params.history.enabled&&(()=>{const e=r();if(t.params.history){if(!e.history||!e.history.pushState)return t.params.history.enabled=!1,void(t.params.hashNavigation.enabled=!0);i=!0,n=o(t.params.url),n.key||n.value?(c(0,n.value,t.params.runCallbacksOnInit),t.params.history.replaceState||e.addEventListener("popstate",p)):t.params.history.replaceState||e.addEventListener("popstate",p)}})()})),a("destroy",(()=>{t.params.history.enabled&&(()=>{const e=r();t.params.history.replaceState||e.removeEventListener("popstate",p)})()})),a("transitionEnd _freeModeNoMomentumRelease",(()=>{i&&d(t.params.history.key,t.activeIndex)})),a("slideChange",(()=>{i&&t.params.cssMode&&d(t.params.history.key,t.activeIndex)}))},function(e){let{swiper:t,extendParams:s,emit:i,on:n}=e,l=!1;const o=a(),d=r();s({hashNavigation:{enabled:!1,replaceState:!1,watchState:!1,getSlideIndex(e,s){if(t.virtual&&t.params.virtual.enabled){const e=t.slides.filter((e=>e.getAttribute("data-hash")===s))[0];if(!e)return 0;return parseInt(e.getAttribute("data-swiper-slide-index"),10)}return t.getSlideIndex(f(t.slidesEl,`.${t.params.slideClass}[data-hash="${s}"], swiper-slide[data-hash="${s}"]`)[0])}}});const c=()=>{i("hashChange");const e=o.location.hash.replace("#",""),s=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex];if(e!==(s?s.getAttribute("data-hash"):"")){const s=t.params.hashNavigation.getSlideIndex(t,e);if(void 0===s||Number.isNaN(s))return;t.slideTo(s)}},p=()=>{if(!l||!t.params.hashNavigation.enabled)return;const e=t.virtual&&t.params.virtual.enabled?t.slidesEl.querySelector(`[data-swiper-slide-index="${t.activeIndex}"]`):t.slides[t.activeIndex],s=e?e.getAttribute("data-hash")||e.getAttribute("data-history"):"";t.params.hashNavigation.replaceState&&d.history&&d.history.replaceState?(d.history.replaceState(null,null,`#${s}`||""),i("hashSet")):(o.location.hash=s||"",i("hashSet"))};n("init",(()=>{t.params.hashNavigation.enabled&&(()=>{if(!t.params.hashNavigation.enabled||t.params.history&&t.params.history.enabled)return;l=!0;const e=o.location.hash.replace("#","");if(e){const s=0,a=t.params.hashNavigation.getSlideIndex(t,e);t.slideTo(a||0,s,t.params.runCallbacksOnInit,!0)}t.params.hashNavigation.watchState&&d.addEventListener("hashchange",c)})()})),n("destroy",(()=>{t.params.hashNavigation.enabled&&t.params.hashNavigation.watchState&&d.removeEventListener("hashchange",c)})),n("transitionEnd _freeModeNoMomentumRelease",(()=>{l&&p()})),n("slideChange",(()=>{l&&t.params.cssMode&&p()}))},function(e){let t,s,{swiper:i,extendParams:r,on:n,emit:l,params:o}=e;i.autoplay={running:!1,paused:!1,timeLeft:0},r({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!1,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}});let d,c,p,u,m,h,f,g,v=o&&o.autoplay?o.autoplay.delay:3e3,w=o&&o.autoplay?o.autoplay.delay:3e3,b=(new Date).getTime();function y(e){i&&!i.destroyed&&i.wrapperEl&&e.target===i.wrapperEl&&(i.wrapperEl.removeEventListener("transitionend",y),g||C())}const E=()=>{if(i.destroyed||!i.autoplay.running)return;i.autoplay.paused?c=!0:c&&(w=d,c=!1);const e=i.autoplay.paused?d:b+w-(new Date).getTime();i.autoplay.timeLeft=e,l("autoplayTimeLeft",e,e/v),s=requestAnimationFrame((()=>{E()}))},x=e=>{if(i.destroyed||!i.autoplay.running)return;cancelAnimationFrame(s),E();let a=void 0===e?i.params.autoplay.delay:e;v=i.params.autoplay.delay,w=i.params.autoplay.delay;const r=(()=>{let e;if(e=i.virtual&&i.params.virtual.enabled?i.slides.filter((e=>e.classList.contains("swiper-slide-active")))[0]:i.slides[i.activeIndex],!e)return;return parseInt(e.getAttribute("data-swiper-autoplay"),10)})();!Number.isNaN(r)&&r>0&&void 0===e&&(a=r,v=r,w=r),d=a;const n=i.params.speed,o=()=>{i&&!i.destroyed&&(i.params.autoplay.reverseDirection?!i.isBeginning||i.params.loop||i.params.rewind?(i.slidePrev(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(i.slides.length-1,n,!0,!0),l("autoplay")):!i.isEnd||i.params.loop||i.params.rewind?(i.slideNext(n,!0,!0),l("autoplay")):i.params.autoplay.stopOnLastSlide||(i.slideTo(0,n,!0,!0),l("autoplay")),i.params.cssMode&&(b=(new Date).getTime(),requestAnimationFrame((()=>{x()}))))};return a>0?(clearTimeout(t),t=setTimeout((()=>{o()}),a)):requestAnimationFrame((()=>{o()})),a},S=()=>{b=(new Date).getTime(),i.autoplay.running=!0,x(),l("autoplayStart")},T=()=>{i.autoplay.running=!1,clearTimeout(t),cancelAnimationFrame(s),l("autoplayStop")},M=(e,s)=>{if(i.destroyed||!i.autoplay.running)return;clearTimeout(t),e||(f=!0);const a=()=>{l("autoplayPause"),i.params.autoplay.waitForTransition?i.wrapperEl.addEventListener("transitionend",y):C()};if(i.autoplay.paused=!0,s)return h&&(d=i.params.autoplay.delay),h=!1,void a();const r=d||i.params.autoplay.delay;d=r-((new Date).getTime()-b),i.isEnd&&d<0&&!i.params.loop||(d<0&&(d=0),a())},C=()=>{i.isEnd&&d<0&&!i.params.loop||i.destroyed||!i.autoplay.running||(b=(new Date).getTime(),f?(f=!1,x(d)):x(),i.autoplay.paused=!1,l("autoplayResume"))},P=()=>{if(i.destroyed||!i.autoplay.running)return;const e=a();"hidden"===e.visibilityState&&(f=!0,M(!0)),"visible"===e.visibilityState&&C()},L=e=>{"mouse"===e.pointerType&&(f=!0,g=!0,i.animating||i.autoplay.paused||M(!0))},A=e=>{"mouse"===e.pointerType&&(g=!1,i.autoplay.paused&&C())};n("init",(()=>{i.params.autoplay.enabled&&(i.params.autoplay.pauseOnMouseEnter&&(i.el.addEventListener("pointerenter",L),i.el.addEventListener("pointerleave",A)),a().addEventListener("visibilitychange",P),S())})),n("destroy",(()=>{i.el.removeEventListener("pointerenter",L),i.el.removeEventListener("pointerleave",A),a().removeEventListener("visibilitychange",P),i.autoplay.running&&T()})),n("_freeModeStaticRelease",(()=>{(u||f)&&C()})),n("_freeModeNoMomentumRelease",(()=>{i.params.autoplay.disableOnInteraction?T():M(!0,!0)})),n("beforeTransitionStart",((e,t,s)=>{!i.destroyed&&i.autoplay.running&&(s||!i.params.autoplay.disableOnInteraction?M(!0,!0):T())})),n("sliderFirstMove",(()=>{!i.destroyed&&i.autoplay.running&&(i.params.autoplay.disableOnInteraction?T():(p=!0,u=!1,f=!1,m=setTimeout((()=>{f=!0,u=!0,M(!0)}),200)))})),n("touchEnd",(()=>{if(!i.destroyed&&i.autoplay.running&&p){if(clearTimeout(m),clearTimeout(t),i.params.autoplay.disableOnInteraction)return u=!1,void(p=!1);u&&i.params.cssMode&&C(),u=!1,p=!1}})),n("slideChange",(()=>{!i.destroyed&&i.autoplay.running&&(h=!0)})),Object.assign(i.autoplay,{start:S,stop:T,pause:M,resume:C})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({thumbs:{swiper:null,multipleActiveThumbs:!0,autoScrollOffset:0,slideThumbActiveClass:"swiper-slide-thumb-active",thumbsContainerClass:"swiper-thumbs"}});let r=!1,n=!1;function l(){const e=t.thumbs.swiper;if(!e||e.destroyed)return;const s=e.clickedIndex,a=e.clickedSlide;if(a&&a.classList.contains(t.params.thumbs.slideThumbActiveClass))return;if(null==s)return;let i;i=e.params.loop?parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"),10):s,t.params.loop?t.slideToLoop(i):t.slideTo(i)}function o(){const{thumbs:e}=t.params;if(r)return!1;r=!0;const s=t.constructor;if(e.swiper instanceof s)t.thumbs.swiper=e.swiper,Object.assign(t.thumbs.swiper.originalParams,{watchSlidesProgress:!0,slideToClickedSlide:!1}),Object.assign(t.thumbs.swiper.params,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper.update();else if(c(e.swiper)){const a=Object.assign({},e.swiper);Object.assign(a,{watchSlidesProgress:!0,slideToClickedSlide:!1}),t.thumbs.swiper=new s(a),n=!0}return t.thumbs.swiper.el.classList.add(t.params.thumbs.thumbsContainerClass),t.thumbs.swiper.on("tap",l),!0}function d(e){const s=t.thumbs.swiper;if(!s||s.destroyed)return;const a="auto"===s.params.slidesPerView?s.slidesPerViewDynamic():s.params.slidesPerView;let i=1;const r=t.params.thumbs.slideThumbActiveClass;if(t.params.slidesPerView>1&&!t.params.centeredSlides&&(i=t.params.slidesPerView),t.params.thumbs.multipleActiveThumbs||(i=1),i=Math.floor(i),s.slides.forEach((e=>e.classList.remove(r))),s.params.loop||s.params.virtual&&s.params.virtual.enabled)for(let e=0;e<i;e+=1)f(s.slidesEl,`[data-swiper-slide-index="${t.realIndex+e}"]`).forEach((e=>{e.classList.add(r)}));else for(let e=0;e<i;e+=1)s.slides[t.realIndex+e]&&s.slides[t.realIndex+e].classList.add(r);const n=t.params.thumbs.autoScrollOffset,l=n&&!s.params.loop;if(t.realIndex!==s.realIndex||l){const i=s.activeIndex;let r,o;if(s.params.loop){const e=s.slides.filter((e=>e.getAttribute("data-swiper-slide-index")===`${t.realIndex}`))[0];r=s.slides.indexOf(e),o=t.activeIndex>t.previousIndex?"next":"prev"}else r=t.realIndex,o=r>t.previousIndex?"next":"prev";l&&(r+="next"===o?n:-1*n),s.visibleSlidesIndexes&&s.visibleSlidesIndexes.indexOf(r)<0&&(s.params.centeredSlides?r=r>i?r-Math.floor(a/2)+1:r+Math.floor(a/2)-1:r>i&&s.params.slidesPerGroup,s.slideTo(r,e?0:void 0))}}t.thumbs={swiper:null},i("beforeInit",(()=>{const{thumbs:e}=t.params;if(e&&e.swiper)if("string"==typeof e.swiper||e.swiper instanceof HTMLElement){const s=a(),i=()=>{const a="string"==typeof e.swiper?s.querySelector(e.swiper):e.swiper;if(a&&a.swiper)e.swiper=a.swiper,o(),d(!0);else if(a){const s=i=>{e.swiper=i.detail[0],a.removeEventListener("init",s),o(),d(!0),e.swiper.update(),t.update()};a.addEventListener("init",s)}return a},r=()=>{if(t.destroyed)return;i()||requestAnimationFrame(r)};requestAnimationFrame(r)}else o(),d(!0)})),i("slideChange update resize observerUpdate",(()=>{d()})),i("setTransition",((e,s)=>{const a=t.thumbs.swiper;a&&!a.destroyed&&a.setTransition(s)})),i("beforeDestroy",(()=>{const e=t.thumbs.swiper;e&&!e.destroyed&&n&&e.destroy()})),Object.assign(t.thumbs,{init:o,update:d})},function(e){let{swiper:t,extendParams:s,emit:a,once:i}=e;s({freeMode:{enabled:!1,momentum:!0,momentumRatio:1,momentumBounce:!0,momentumBounceRatio:1,momentumVelocityRatio:1,sticky:!1,minimumVelocity:.02}}),Object.assign(t,{freeMode:{onTouchStart:function(){if(t.params.cssMode)return;const e=t.getTranslate();t.setTranslate(e),t.setTransition(0),t.touchEventsData.velocities.length=0,t.freeMode.onTouchEnd({currentPos:t.rtl?t.translate:-t.translate})},onTouchMove:function(){if(t.params.cssMode)return;const{touchEventsData:e,touches:s}=t;0===e.velocities.length&&e.velocities.push({position:s[t.isHorizontal()?"startX":"startY"],time:e.touchStartTime}),e.velocities.push({position:s[t.isHorizontal()?"currentX":"currentY"],time:o()})},onTouchEnd:function(e){let{currentPos:s}=e;if(t.params.cssMode)return;const{params:r,wrapperEl:n,rtlTranslate:l,snapGrid:d,touchEventsData:c}=t,p=o()-c.touchStartTime;if(s<-t.minTranslate())t.slideTo(t.activeIndex);else if(s>-t.maxTranslate())t.slides.length<d.length?t.slideTo(d.length-1):t.slideTo(t.slides.length-1);else{if(r.freeMode.momentum){if(c.velocities.length>1){const e=c.velocities.pop(),s=c.velocities.pop(),a=e.position-s.position,i=e.time-s.time;t.velocity=a/i,t.velocity/=2,Math.abs(t.velocity)<r.freeMode.minimumVelocity&&(t.velocity=0),(i>150||o()-e.time>300)&&(t.velocity=0)}else t.velocity=0;t.velocity*=r.freeMode.momentumVelocityRatio,c.velocities.length=0;let e=1e3*r.freeMode.momentumRatio;const s=t.velocity*e;let p=t.translate+s;l&&(p=-p);let u,m=!1;const h=20*Math.abs(t.velocity)*r.freeMode.momentumBounceRatio;let f;if(p<t.maxTranslate())r.freeMode.momentumBounce?(p+t.maxTranslate()<-h&&(p=t.maxTranslate()-h),u=t.maxTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.maxTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(p>t.minTranslate())r.freeMode.momentumBounce?(p-t.minTranslate()>h&&(p=t.minTranslate()+h),u=t.minTranslate(),m=!0,c.allowMomentumBounce=!0):p=t.minTranslate(),r.loop&&r.centeredSlides&&(f=!0);else if(r.freeMode.sticky){let e;for(let t=0;t<d.length;t+=1)if(d[t]>-p){e=t;break}p=Math.abs(d[e]-p)<Math.abs(d[e-1]-p)||"next"===t.swipeDirection?d[e]:d[e-1],p=-p}if(f&&i("transitionEnd",(()=>{t.loopFix()})),0!==t.velocity){if(e=l?Math.abs((-p-t.translate)/t.velocity):Math.abs((p-t.translate)/t.velocity),r.freeMode.sticky){const s=Math.abs((l?-p:p)-t.translate),a=t.slidesSizesGrid[t.activeIndex];e=s<a?r.speed:s<2*a?1.5*r.speed:2.5*r.speed}}else if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode.momentumBounce&&m?(t.updateProgress(u),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating=!0,x(n,(()=>{t&&!t.destroyed&&c.allowMomentumBounce&&(a("momentumBounce"),t.setTransition(r.speed),setTimeout((()=>{t.setTranslate(u),x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()}))}),0))}))):t.velocity?(a("_freeModeNoMomentumRelease"),t.updateProgress(p),t.setTransition(e),t.setTranslate(p),t.transitionStart(!0,t.swipeDirection),t.animating||(t.animating=!0,x(n,(()=>{t&&!t.destroyed&&t.transitionEnd()})))):t.updateProgress(p),t.updateActiveIndex(),t.updateSlidesClasses()}else{if(r.freeMode.sticky)return void t.slideToClosest();r.freeMode&&a("_freeModeNoMomentumRelease")}(!r.freeMode.momentum||p>=r.longSwipesMs)&&(a("_freeModeStaticRelease"),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses())}}}})},function(e){let t,s,a,i,{swiper:r,extendParams:n,on:l}=e;n({grid:{rows:1,fill:"column"}});const o=()=>{let e=r.params.spaceBetween;return"string"==typeof e&&e.indexOf("%")>=0?e=parseFloat(e.replace("%",""))/100*r.size:"string"==typeof e&&(e=parseFloat(e)),e};l("init",(()=>{i=r.params.grid&&r.params.grid.rows>1})),l("update",(()=>{const{params:e,el:t}=r,s=e.grid&&e.grid.rows>1;i&&!s?(t.classList.remove(`${e.containerModifierClass}grid`,`${e.containerModifierClass}grid-column`),a=1,r.emitContainerClasses()):!i&&s&&(t.classList.add(`${e.containerModifierClass}grid`),"column"===e.grid.fill&&t.classList.add(`${e.containerModifierClass}grid-column`),r.emitContainerClasses()),i=s})),r.grid={initSlides:e=>{const{slidesPerView:i}=r.params,{rows:n,fill:l}=r.params.grid,o=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:e.length;a=Math.floor(o/n),t=Math.floor(o/n)===o/n?o:Math.ceil(o/n)*n,"auto"!==i&&"row"===l&&(t=Math.max(t,i*n)),s=t/n},unsetSlides:()=>{r.slides&&r.slides.forEach((e=>{e.swiperSlideGridSet&&(e.style.height="",e.style[r.getDirectionLabel("margin-top")]="")}))},updateSlide:(e,i,n)=>{const{slidesPerGroup:l}=r.params,d=o(),{rows:c,fill:p}=r.params.grid,u=r.virtual&&r.params.virtual.enabled?r.virtual.slides.length:n.length;let m,h,f;if("row"===p&&l>1){const s=Math.floor(e/(l*c)),a=e-c*l*s,r=0===s?l:Math.min(Math.ceil((u-s*c*l)/c),l);f=Math.floor(a/r),h=a-f*r+s*l,m=h+f*t/c,i.style.order=m}else"column"===p?(h=Math.floor(e/c),f=e-h*c,(h>a||h===a&&f===c-1)&&(f+=1,f>=c&&(f=0,h+=1))):(f=Math.floor(e/s),h=e-f*s);i.row=f,i.column=h,i.style.height=`calc((100% - ${(c-1)*d}px) / ${c})`,i.style[r.getDirectionLabel("margin-top")]=0!==f?d&&`${d}px`:"",i.swiperSlideGridSet=!0},updateWrapperSize:(e,s)=>{const{centeredSlides:a,roundLengths:i}=r.params,n=o(),{rows:l}=r.params.grid;if(r.virtualSize=(e+n)*t,r.virtualSize=Math.ceil(r.virtualSize/l)-n,r.params.cssMode||(r.wrapperEl.style[r.getDirectionLabel("width")]=`${r.virtualSize+n}px`),a){const e=[];for(let t=0;t<s.length;t+=1){let a=s[t];i&&(a=Math.floor(a)),s[t]<r.virtualSize+s[0]&&e.push(a)}s.splice(0,s.length),s.push(...e)}}}},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:ae.bind(t),prependSlide:ie.bind(t),addSlide:re.bind(t),removeSlide:ne.bind(t),removeAllSlides:le.bind(t)})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({fadeEffect:{crossFade:!1}}),oe({effect:"fade",swiper:t,on:a,setTranslate:()=>{const{slides:e}=t;t.params.fadeEffect;for(let s=0;s<e.length;s+=1){const e=t.slides[s];let a=-e.swiperSlideOffset;t.params.virtualTranslate||(a-=t.translate);let i=0;t.isHorizontal()||(i=a,a=0);const r=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e.progress),0):1+Math.min(Math.max(e.progress,-1),0),n=de(0,e);n.style.opacity=r,n.style.transform=`translate3d(${a}px, ${i}px, 0px)`}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`})),ce({swiper:t,duration:e,transformElements:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cubeEffect:{slideShadows:!0,shadow:!0,shadowOffset:20,shadowScale:.94}});const i=(e,t,s)=>{let a=s?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=s?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"left":"top")).split(" ")),e.append(a)),i||(i=v("div",("swiper-slide-shadow-cube swiper-slide-shadow-"+(s?"right":"bottom")).split(" ")),e.append(i)),a&&(a.style.opacity=Math.max(-t,0)),i&&(i.style.opacity=Math.max(t,0))};oe({effect:"cube",swiper:t,on:a,setTranslate:()=>{const{el:e,wrapperEl:s,slides:a,width:r,height:n,rtlTranslate:l,size:o,browser:d}=t,c=t.params.cubeEffect,p=t.isHorizontal(),u=t.virtual&&t.params.virtual.enabled;let m,h=0;c.shadow&&(p?(m=t.wrapperEl.querySelector(".swiper-cube-shadow"),m||(m=v("div","swiper-cube-shadow"),t.wrapperEl.append(m)),m.style.height=`${r}px`):(m=e.querySelector(".swiper-cube-shadow"),m||(m=v("div","swiper-cube-shadow"),e.append(m))));for(let e=0;e<a.length;e+=1){const s=a[e];let r=e;u&&(r=parseInt(s.getAttribute("data-swiper-slide-index"),10));let n=90*r,d=Math.floor(n/360);l&&(n=-n,d=Math.floor(-n/360));const m=Math.max(Math.min(s.progress,1),-1);let f=0,g=0,v=0;r%4==0?(f=4*-d*o,v=0):(r-1)%4==0?(f=0,v=4*-d*o):(r-2)%4==0?(f=o+4*d*o,v=o):(r-3)%4==0&&(f=-o,v=3*o+4*o*d),l&&(f=-f),p||(g=f,f=0);const w=`rotateX(${p?0:-n}deg) rotateY(${p?n:0}deg) translate3d(${f}px, ${g}px, ${v}px)`;m<=1&&m>-1&&(h=90*r+90*m,l&&(h=90*-r-90*m),t.browser&&t.browser.isSafari&&Math.abs(h)/90%2==1&&(h+=.001)),s.style.transform=w,c.slideShadows&&i(s,m,p)}if(s.style.transformOrigin=`50% 50% -${o/2}px`,s.style["-webkit-transform-origin"]=`50% 50% -${o/2}px`,c.shadow)if(p)m.style.transform=`translate3d(0px, ${r/2+c.shadowOffset}px, ${-r/2}px) rotateX(89.99deg) rotateZ(0deg) scale(${c.shadowScale})`;else{const e=Math.abs(h)-90*Math.floor(Math.abs(h)/90),t=1.5-(Math.sin(2*e*Math.PI/360)/2+Math.cos(2*e*Math.PI/360)/2),s=c.shadowScale,a=c.shadowScale/t,i=c.shadowOffset;m.style.transform=`scale3d(${s}, 1, ${a}) translate3d(0px, ${n/2+i}px, ${-n/2/a}px) rotateX(-89.99deg)`}const f=(d.isSafari||d.isWebView)&&d.needPerspectiveFix?-o/2:0;s.style.transform=`translate3d(0px,0,${f}px) rotateX(${t.isHorizontal()?0:h}deg) rotateY(${t.isHorizontal()?-h:0}deg)`,s.style.setProperty("--swiper-cube-translate-z",`${f}px`)},setTransition:e=>{const{el:s,slides:a}=t;if(a.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),t.params.cubeEffect.shadow&&!t.isHorizontal()){const t=s.querySelector(".swiper-cube-shadow");t&&(t.style.transitionDuration=`${e}ms`)}},recreateShadows:()=>{const e=t.isHorizontal();t.slides.forEach((t=>{const s=Math.max(Math.min(t.progress,1),-1);i(t,s,e)}))},getEffectParams:()=>t.params.cubeEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,resistanceRatio:0,spaceBetween:0,centeredSlides:!1,virtualTranslate:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({flipEffect:{slideShadows:!0,limitRotation:!0}});const i=(e,s)=>{let a=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-left"):e.querySelector(".swiper-slide-shadow-top"),i=t.isHorizontal()?e.querySelector(".swiper-slide-shadow-right"):e.querySelector(".swiper-slide-shadow-bottom");a||(a=pe("flip",e,t.isHorizontal()?"left":"top")),i||(i=pe("flip",e,t.isHorizontal()?"right":"bottom")),a&&(a.style.opacity=Math.max(-s,0)),i&&(i.style.opacity=Math.max(s,0))};oe({effect:"flip",swiper:t,on:a,setTranslate:()=>{const{slides:e,rtlTranslate:s}=t,a=t.params.flipEffect;for(let r=0;r<e.length;r+=1){const n=e[r];let l=n.progress;t.params.flipEffect.limitRotation&&(l=Math.max(Math.min(n.progress,1),-1));const o=n.swiperSlideOffset;let d=-180*l,c=0,p=t.params.cssMode?-o-t.translate:-o,u=0;t.isHorizontal()?s&&(d=-d):(u=p,p=0,c=-d,d=0),t.browser&&t.browser.isSafari&&(Math.abs(d)/90%2==1&&(d+=.001),Math.abs(c)/90%2==1&&(c+=.001)),n.style.zIndex=-Math.abs(Math.round(l))+e.length,a.slideShadows&&i(n,l);const m=`translate3d(${p}px, ${u}px, 0px) rotateX(${c}deg) rotateY(${d}deg)`;de(0,n).style.transform=m}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),ce({swiper:t,duration:e,transformElements:s})},recreateShadows:()=>{t.params.flipEffect,t.slides.forEach((e=>{let s=e.progress;t.params.flipEffect.limitRotation&&(s=Math.max(Math.min(e.progress,1),-1)),i(e,s)}))},getEffectParams:()=>t.params.flipEffect,perspective:()=>!0,overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({coverflowEffect:{rotate:50,stretch:0,depth:100,scale:1,modifier:1,slideShadows:!0}}),oe({effect:"coverflow",swiper:t,on:a,setTranslate:()=>{const{width:e,height:s,slides:a,slidesSizesGrid:i}=t,r=t.params.coverflowEffect,n=t.isHorizontal(),l=t.translate,o=n?e/2-l:s/2-l,d=n?r.rotate:-r.rotate,c=r.depth;for(let e=0,s=a.length;e<s;e+=1){const s=a[e],l=i[e],p=(o-s.swiperSlideOffset-l/2)/l,u="function"==typeof r.modifier?r.modifier(p):p*r.modifier;let m=n?d*u:0,h=n?0:d*u,f=-c*Math.abs(u),g=r.stretch;"string"==typeof g&&-1!==g.indexOf("%")&&(g=parseFloat(r.stretch)/100*l);let v=n?0:g*u,w=n?g*u:0,b=1-(1-r.scale)*Math.abs(u);Math.abs(w)<.001&&(w=0),Math.abs(v)<.001&&(v=0),Math.abs(f)<.001&&(f=0),Math.abs(m)<.001&&(m=0),Math.abs(h)<.001&&(h=0),Math.abs(b)<.001&&(b=0),t.browser&&t.browser.isSafari&&(Math.abs(m)/90%2==1&&(m+=.001),Math.abs(h)/90%2==1&&(h+=.001));const y=`translate3d(${w}px,${v}px,${f}px)  rotateX(${h}deg) rotateY(${m}deg) scale(${b})`;if(de(0,s).style.transform=y,s.style.zIndex=1-Math.abs(Math.round(u)),r.slideShadows){let e=n?s.querySelector(".swiper-slide-shadow-left"):s.querySelector(".swiper-slide-shadow-top"),t=n?s.querySelector(".swiper-slide-shadow-right"):s.querySelector(".swiper-slide-shadow-bottom");e||(e=pe("coverflow",s,n?"left":"top")),t||(t=pe("coverflow",s,n?"right":"bottom")),e&&(e.style.opacity=u>0?u:0),t&&(t.style.opacity=-u>0?-u:0)}}},setTransition:e=>{t.slides.map((e=>h(e))).forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((t=>{t.style.transitionDuration=`${e}ms`}))}))},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({creativeEffect:{limitProgress:1,shadowPerProgress:!1,progressMultiplier:1,perspective:!0,prev:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1},next:{translate:[0,0,0],rotate:[0,0,0],opacity:1,scale:1}}});const i=e=>"string"==typeof e?e:`${e}px`;oe({effect:"creative",swiper:t,on:a,setTranslate:()=>{const{slides:e,wrapperEl:s,slidesSizesGrid:a}=t,r=t.params.creativeEffect,{progressMultiplier:n}=r,l=t.params.centeredSlides;if(l){const e=a[0]/2-t.params.slidesOffsetBefore||0;s.style.transform=`translateX(calc(50% - ${e}px))`}for(let s=0;s<e.length;s+=1){const a=e[s],o=a.progress,d=Math.min(Math.max(a.progress,-r.limitProgress),r.limitProgress);let c=d;l||(c=Math.min(Math.max(a.originalProgress,-r.limitProgress),r.limitProgress));const p=a.swiperSlideOffset,u=[t.params.cssMode?-p-t.translate:-p,0,0],m=[0,0,0];let h=!1;t.isHorizontal()||(u[1]=u[0],u[0]=0);let f={translate:[0,0,0],rotate:[0,0,0],scale:1,opacity:1};d<0?(f=r.next,h=!0):d>0&&(f=r.prev,h=!0),u.forEach(((e,t)=>{u[t]=`calc(${e}px + (${i(f.translate[t])} * ${Math.abs(d*n)}))`})),m.forEach(((e,s)=>{let a=f.rotate[s]*Math.abs(d*n);t.browser&&t.browser.isSafari&&Math.abs(a)/90%2==1&&(a+=.001),m[s]=a})),a.style.zIndex=-Math.abs(Math.round(o))+e.length;const g=u.join(", "),v=`rotateX(${m[0]}deg) rotateY(${m[1]}deg) rotateZ(${m[2]}deg)`,w=c<0?`scale(${1+(1-f.scale)*c*n})`:`scale(${1-(1-f.scale)*c*n})`,b=c<0?1+(1-f.opacity)*c*n:1-(1-f.opacity)*c*n,y=`translate3d(${g}) ${v} ${w}`;if(h&&f.shadow||!h){let e=a.querySelector(".swiper-slide-shadow");if(!e&&f.shadow&&(e=pe("creative",a)),e){const t=r.shadowPerProgress?d*(1/r.limitProgress):d;e.style.opacity=Math.min(Math.max(Math.abs(t),0),1)}}const E=de(0,a);E.style.transform=y,E.style.opacity=b,f.origin&&(E.style.transformOrigin=f.origin)}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),ce({swiper:t,duration:e,transformElements:s,allSlides:!0})},perspective:()=>t.params.creativeEffect.perspective,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})},function(e){let{swiper:t,extendParams:s,on:a}=e;s({cardsEffect:{slideShadows:!0,rotate:!0,perSlideRotate:2,perSlideOffset:8}}),oe({effect:"cards",swiper:t,on:a,setTranslate:()=>{const{slides:e,activeIndex:s,rtlTranslate:a}=t,i=t.params.cardsEffect,{startTranslate:r,isTouched:n}=t.touchEventsData,l=a?-t.translate:t.translate;for(let o=0;o<e.length;o+=1){const d=e[o],c=d.progress,p=Math.min(Math.max(c,-4),4);let u=d.swiperSlideOffset;t.params.centeredSlides&&!t.params.cssMode&&(t.wrapperEl.style.transform=`translateX(${t.minTranslate()}px)`),t.params.centeredSlides&&t.params.cssMode&&(u-=e[0].swiperSlideOffset);let m=t.params.cssMode?-u-t.translate:-u,h=0;const f=-100*Math.abs(p);let g=1,v=-i.perSlideRotate*p,w=i.perSlideOffset-.75*Math.abs(p);const b=t.virtual&&t.params.virtual.enabled?t.virtual.from+o:o,y=(b===s||b===s-1)&&p>0&&p<1&&(n||t.params.cssMode)&&l<r,E=(b===s||b===s+1)&&p<0&&p>-1&&(n||t.params.cssMode)&&l>r;if(y||E){const e=(1-Math.abs((Math.abs(p)-.5)/.5))**.5;v+=-28*p*e,g+=-.5*e,w+=96*e,h=-25*e*Math.abs(p)+"%"}if(m=p<0?`calc(${m}px ${a?"-":"+"} (${w*Math.abs(p)}%))`:p>0?`calc(${m}px ${a?"-":"+"} (-${w*Math.abs(p)}%))`:`${m}px`,!t.isHorizontal()){const e=h;h=m,m=e}const x=p<0?""+(1+(1-g)*p):""+(1-(1-g)*p),S=`\n        translate3d(${m}, ${h}, ${f}px)\n        rotateZ(${i.rotate?a?-v:v:0}deg)\n        scale(${x})\n      `;if(i.slideShadows){let e=d.querySelector(".swiper-slide-shadow");e||(e=pe("cards",d)),e&&(e.style.opacity=Math.min(Math.max((Math.abs(p)-.5)/.5,0),1))}d.style.zIndex=-Math.abs(Math.round(c))+e.length;de(0,d).style.transform=S}},setTransition:e=>{const s=t.slides.map((e=>h(e)));s.forEach((t=>{t.style.transitionDuration=`${e}ms`,t.querySelectorAll(".swiper-slide-shadow").forEach((t=>{t.style.transitionDuration=`${e}ms`}))})),ce({swiper:t,duration:e,transformElements:s})},perspective:()=>!0,overwriteParams:()=>({watchSlidesProgress:!0,virtualTranslate:!t.params.cssMode})})}];return ee.use(ue),ee}();
 //# sourceMappingURL=swiper-bundle.min.js.map
 

(function(window,undefined){
  '$:nomunge'; // Used by YUI compressor.

  // Since jQuery really isn't required for this plugin, use `jQuery` as the
  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
  // creating it if necessary.
  var $ = window.jQuery || window.Cowboy || ( window.Cowboy = {} ),

    // Internal method reference.
    jq_throttle;

  // Method: jQuery.throttle
  //
  // Throttle execution of a function. Especially useful for rate limiting
  // execution of handlers on events like resize and scroll. If you want to
  // rate-limit execution of a function to a single time, see the
  // <jQuery.debounce> method.
  //
  // In this visualization, | is a throttled-function call and X is the actual
  // callback execution:
  //
  // > Throttled with `no_trailing` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X    X        X    X    X    X    X    X
  // >
  // > Throttled with `no_trailing` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X             X    X    X    X    X
  //
  // Usage:
  //
  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', throttled );
  // > jQuery('selector').unbind( 'someevent', throttled );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
  //    true, callback will only execute every `delay` milliseconds while the
  //    throttled-function is being called. If no_trailing is false or
  //    unspecified, callback will be executed one final time after the last
  //    throttled-function call. (After the throttled-function has not been
  //    called for `delay` milliseconds, the internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the throttled-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, throttled, function.

  $.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
    // After wrapper has stopped being called, this timeout ensures that
    // `callback` is executed at the proper times in `throttle` and `end`
    // debounce modes.
    var timeout_id,

      // Keep track of the last time `callback` was executed.
      last_exec = 0;

    // `no_trailing` defaults to falsy.
    if ( typeof no_trailing !== 'boolean' ) {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }

    // The `wrapper` function encapsulates all of the throttling / debouncing
    // functionality and when executed will limit the rate at which `callback`
    // is executed.
    function wrapper() {
      var that = this,
        elapsed = +new Date() - last_exec,
        args = arguments;

      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = +new Date();
        callback.apply( that, args );
      };

      // If `debounce_mode` is true (at_begin) this is used to clear the flag
      // to allow future `callback` executions.
      function clear() {
        timeout_id = undefined;
      };

      if ( debounce_mode && !timeout_id ) {
        // Since `wrapper` is being called for the first time and
        // `debounce_mode` is true (at_begin), execute `callback`.
        exec();
      }

      // Clear any existing timeout.
      timeout_id && clearTimeout( timeout_id );

      if ( debounce_mode === undefined && elapsed > delay ) {
        // In throttle mode, if `delay` time has been exceeded, execute
        // `callback`.
        exec();

      } else if ( no_trailing !== true ) {
        // In trailing throttle mode, since `delay` time has not been
        // exceeded, schedule `callback` to execute `delay` ms after most
        // recent execution.
        //
        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
        // after `delay` ms.
        //
        // If `debounce_mode` is false (at end), schedule `callback` to
        // execute after `delay` ms.
        timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
      }
    };

    // Set the guid of `wrapper` function to the same of original callback, so
    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
    // callback as a reference.
    if ( $.guid ) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }

    // Return the wrapper function.
    return wrapper;
  };

  // Method: jQuery.debounce
  //
  // Debounce execution of a function. Debouncing, unlike throttling,
  // guarantees that a function is only executed a single time, either at the
  // very beginning of a series of calls, or at the very end. If you want to
  // simply rate-limit execution of a function, see the <jQuery.throttle>
  // method.
  //
  // In this visualization, | is a debounced-function call and X is the actual
  // callback execution:
  //
  // > Debounced with `at_begin` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // >                          X                                 X
  // >
  // > Debounced with `at_begin` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X                                 X
  //
  // Usage:
  //
  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', debounced );
  // > jQuery('selector').unbind( 'someevent', debounced );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
  //    unspecified, callback will only be executed `delay` milliseconds after
  //    the last debounced-function call. If at_begin is true, callback will be
  //    executed only at the first debounced-function call. (After the
  //    throttled-function has not been called for `delay` milliseconds, the
  //    internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the debounced-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, debounced, function.

  $.debounce = function( delay, at_begin, callback ) {
    return callback === undefined
      ? jq_throttle( delay, at_begin, false )
      : jq_throttle( delay, callback, at_begin !== false );
  };

})(this);

/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/*
 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"}),null!==a.$dots&&(a.$dots.find("button").removeAttr("aria-current"),a.$dots.find("li.slick-active button").attr("aria-current","true"))},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.removeAttr("role"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).removeAttr("role").attr({"aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&(b.$dots.removeAttr("role"),b.$dots.find("li").each(function(c){a(this).removeAttr("role").removeAttr("aria-selected").removeAttr("aria-controls").attr("id","slick-slide"+b.instanceUid+c)}),b.$dots.find("button").each(function(){var c=a(this).text();a(this).attr("aria-label",c?"Go to slide "+c:"Carousel slide")}),b.$dots.parent().removeAttr("role")),b.$slider.attr({"role":"region","aria-roledescription":"carousel","aria-label":"Carousel"}),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});

/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});

/*!
* parallax.js v2.0.0 (http://pixelcog.github.io/parallax.js/)
* @copyright 2017 PixelCog, Inc.
* @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
*/
!function(t){function e(i){if(o[i])return o[i].exports;var r=o[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var o={};e.m=t,e.c=o,e.d=function(t,o,i){e.o(t,o)||Object.defineProperty(t,o,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var o=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(o,"a",o),o},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=1)}([function(t,e){t.exports=jQuery},function(t,e,o){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var n=function(){function t(t,e){for(var o=0;o<e.length;o++){var i=e[o];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,o,i){return o&&t(e.prototype,o),i&&t(e,i),e}}(),s=o(0),a=i(s),f=o(2),l=i(f),d=function(){function t(e,o){function i(t,e,i){var r=parseInt(o[t]);isNaN(r)?o[t]!==e&&o[t]!==i&&(o.pos+=(o[t]="center")+" "):o.pos+=(o[t]=r)+"px "}r(this,t);var n=(0,a.default)(e);if(o.pos="",i("posX","left","right"),i("posY","top","bottom"),navigator.userAgent.match(o.excludeAgents))o.src&&!n.is("img")&&n.css("background",'url("'+o.src+'") '+o.pos+"/cover");else{o.scrollingSelector&&(t.scrollingElement=(0,a.default)(o.scrollingSelector)[0]),t.isSet||t.init(),t.iList.push(this);var s=(0,a.default)("<div>").addClass("parallax-mirror").css({visibility:"hidden",zIndex:o.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}).prependTo((0,a.default)(o.mirrorSelector)),f=n.find(o.sliderSelector);0===f.length?f=(0,a.default)("<img>").attr("src",o.src):(o.formerParent=f.parent(),o.formerStyles=f.prop("style")),f.addClass("parallax-slider").prependTo(s),f.children("img").add(f).on("load",function(){t.update(!0)}),this.$s=f,this.$m=s}this.$w=n,this.o=o,"function"==typeof o.afterSetup&&o.afterSetup(this)}return n(t,[{key:"refresh",value:function(){var e=this.$w,o=this.o;o.dH=t.dH,o.dW=t.dW;var i=o.scrollingElement;if(i&&i!==document&&(o.dH=i.scrollHeight,o.dW=i.scrollWidth),o){o.aspectRatio||function(t,e){var o=0,i=0,r=0,n=0;if(0===t.children().each(function(){var t=(0,a.default)(this),e=t.offset(),s=e.top+t.outerHeight(),f=e.left+t.outerWidth();o=e.top<o?e.top:o,r=e.left<r?e.left:r,i=s>i?s:i,n=f>n?f:n}).length)e.aspectRatio=t[0].naturalWidth/(t[0].naturalHeight||1);else{var s=t.offset(),f=i-Math.max(o,s.top),l=n-Math.max(r,s.left);e.aspectRatio=l/(f||1)}}(this.$s,o);var r=o.aspectRatio||1;o.boxWidth=e.outerWidth(),o.boxHeight=e.outerHeight()+2*o.bleed,o.boxOffsetTop=e.offset().top-o.bleed,o.boxOffsetLeft=e.offset().left,o.boxOffsetBottom=o.boxOffsetTop+o.boxHeight;var n=t.wH,s=t.dH,f=Math.min(o.boxOffsetTop,s-n),l=Math.max(o.boxOffsetTop+o.boxHeight-n,0),d=o.boxHeight+(f-l)*(1-o.speed)|0,u=(o.boxOffsetTop-f)*(1-o.speed)|0,p=void 0;o.boxWidth<d*r?(o.imageWidth=d*r|0,o.imageHeight=d,o.offsetBaseTop=u,p=o.imageWidth-o.boxWidth,"left"===o.posX?o.offsetLeft=0:"right"===o.posX?o.offsetLeft=-p:isNaN(o.posX)?o.offsetLeft=-p/2|0:o.offsetLeft=Math.max(o.posX,-p)):(o.imageWidth=o.boxWidth,o.imageHeight=o.boxWidth/r|0,o.offsetLeft=0,p=o.imageHeight-d,"top"===o.posY?o.offsetBaseTop=u:"bottom"===o.posY?o.offsetBaseTop=u-p:isNaN(o.posY)?o.offsetBaseTop=u-p/2|0:o.offsetBaseTop=u+Math.max(o.posY,-p)),"function"==typeof o.afterRefresh&&o.afterRefresh(this)}}},{key:"render",value:function(){var e=this.o,o=t.sT,i=t.sL,r=e.overScrollFix?t.overScroll:0,n=o+t.wH;e.boxOffsetBottom>o&&e.boxOffsetTop<=n?(e.visibility="visible",e.mirrorTop=e.boxOffsetTop-o,e.mirrorLeft=e.boxOffsetLeft-i,e.offsetTop=e.offsetBaseTop-e.mirrorTop*(1-e.speed)):e.visibility="hidden",this.$m.css({transform:"translate3d("+e.mirrorLeft+"px, "+(e.mirrorTop-r)+"px, 0px)",visibility:e.visibility,height:e.boxHeight,width:e.boxWidth}),this.$s.css({transform:"translate3d("+e.offsetLeft+"px, "+e.offsetTop+"px, 0px)",position:"absolute",height:e.imageHeight,width:e.imageWidth,maxWidth:"none"}),"function"==typeof e.afterRender&&e.afterRender(this)}},{key:"destroy",value:function(){if(this.$m&&this.$m.remove(),this.$s){for(var e=0;e<t.iList.length;e++)t.iList[e]===this&&t.iList.splice(e,1);this.o.formerParent&&(this.$s.prop("style",this.o.formerStyles),this.o.formerParent.append(this.$s))}0===t.iList.length&&((0,a.default)(window).off("scroll.px.parallax resize.px.parallax load.px.parallax"),t.isSet=!1),"function"==typeof this.o.afterDestroy&&this.o.afterDestroy(this)}}],[{key:"init",value:function(){function e(){t.wH=r.height(),t.wW=r.width(),t.dH=i[0].scrollHeight||i.height(),t.dW=i[0].scrollWidth||i.width()}function o(){var e=n.scrollTop(),o=t.dH-t.wH,i=t.dW-t.wW;t.sT=Math.max(0,Math.min(o,e)),t.sL=Math.max(0,Math.min(i,n.scrollLeft())),t.overScroll=Math.max(e-o,Math.min(e,0))}if(!t.isSet){var i=(0,a.default)(t.scrollingElement||document),r=(0,a.default)(window),n=(0,a.default)(t.scrollingElement||window);r.on("resize.px.parallax load.px.parallax",function(){e(),t.update(!0)}),e(),t.isSet=!0;var s=-1;!function e(){var i=n.scrollTop();s!==i&&(s=i,o(),t.update()),window.requestAnimationFrame(e)}()}}},{key:"update",value:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&a.default.each(t.iList,function(){this.refresh()}),a.default.each(t.iList,function(){this.render()})}}]),t}();d.DEFAULTS={src:null,speed:.2,bleed:0,zIndex:-100,posX:"center",posY:"center",overScrollFix:!1,excludeAgents:/(iPod|iPhone|iPad|Android)/,aspectRatio:null,sliderSelector:">.parallax-slider",mirrorSelector:"body",scrollingSelector:null,afterRefresh:null,afterRender:null,afterSetup:null,afterDestroy:null},d.AUTOINIT=!0,d.sT=0,d.sL=0,d.wH=0,d.wW=0,d.dH=1<<30,d.dW=1<<30,d.iList=[],d.isSet=!1,(0,a.default)(function(){d.AUTOINIT&&(0,a.default)("[data-parallax]").parallax()}),(0,l.default)("parallax",d)},function(t,e,o){"use strict";function i(t,e){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i="__"+t,n=s.default.fn[t];s.default.fn[t]=function(t){return this.each(function(){var o=(0,s.default)(this),n=o.data(i);if(n||"destroy"===t)"function"==typeof n.configure&&n.configure(options);else{var a=s.default.extend({},e.DEFAULTS,o.data(),"object"===(void 0===t?"undefined":r(t))&&t);o.data(i,n=new e(this,a))}"string"==typeof t&&("destroy"===t?(n.destroy(),o.data(i,!1)):n[t]())})},o&&(s.default[t]=function(e){return(0,s.default)({})[t](e)}),s.default.fn[t].noConflict=function(){return s.default.fn[t]=n}}Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=i;var n=o(0),s=function(t){return t&&t.__esModule?t:{default:t}}(n)}]);

/*!
handlebars v1.3.0
Copyright (C) 2011 by Yehuda Katz
MIT Licence
*/
var Handlebars=function(){var e=function(){"use strict";function t(e){this.string=e}var e;t.prototype.toString=function(){return""+this.string};e=t;return e}();var t=function(e){"use strict";function o(e){return r[e]||"&"}function u(e,t){for(var n in t){if(Object.prototype.hasOwnProperty.call(t,n)){e[n]=t[n]}}}function c(e){if(e instanceof n){return e.toString()}else if(!e&&e!==0){return""}e=""+e;if(!s.test(e)){return e}return e.replace(i,o)}function h(e){if(!e&&e!==0){return true}else if(l(e)&&e.length===0){return true}else{return false}}var t={};var n=e;var r={"&":"&","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};var i=/[&<>"'`]/g;var s=/[&<>"'`]/;t.extend=u;var a=Object.prototype.toString;t.toString=a;var f=function(e){return typeof e==="function"};if(f(/x/)){f=function(e){return typeof e==="function"&&a.call(e)==="[object Function]"}}var f;t.isFunction=f;var l=Array.isArray||function(e){return e&&typeof e==="object"?a.call(e)==="[object Array]":false};t.isArray=l;t.escapeExpression=c;t.isEmpty=h;return t}(e);var n=function(){"use strict";function n(e,n){var r;if(n&&n.firstLine){r=n.firstLine;e+=" - "+r+":"+n.firstColumn}var i=Error.prototype.constructor.call(this,e);for(var s=0;s<t.length;s++){this[t[s]]=i[t[s]]}if(r){this.lineNumber=r;this.column=n.firstColumn}}var e;var t=["description","fileName","lineNumber","message","name","number","stack"];n.prototype=new Error;e=n;return e}();var r=function(e,t){"use strict";function h(e,t){this.helpers=e||{};this.partials=t||{};p(this)}function p(e){e.registerHelper("helperMissing",function(e){if(arguments.length===2){return undefined}else{throw new i("Missing helper: '"+e+"'")}});e.registerHelper("blockHelperMissing",function(t,n){var r=n.inverse||function(){},i=n.fn;if(f(t)){t=t.call(this)}if(t===true){return i(this)}else if(t===false||t==null){return r(this)}else if(a(t)){if(t.length>0){return e.helpers.each(t,n)}else{return r(this)}}else{return i(t)}});e.registerHelper("each",function(e,t){var n=t.fn,r=t.inverse;var i=0,s="",o;if(f(e)){e=e.call(this)}if(t.data){o=m(t.data)}if(e&&typeof e==="object"){if(a(e)){for(var u=e.length;i<u;i++){if(o){o.index=i;o.first=i===0;o.last=i===e.length-1}s=s+n(e[i],{data:o})}}else{for(var l in e){if(e.hasOwnProperty(l)){if(o){o.key=l;o.index=i;o.first=i===0}s=s+n(e[l],{data:o});i++}}}}if(i===0){s=r(this)}return s});e.registerHelper("if",function(e,t){if(f(e)){e=e.call(this)}if(!t.hash.includeZero&&!e||r.isEmpty(e)){return t.inverse(this)}else{return t.fn(this)}});e.registerHelper("unless",function(t,n){return e.helpers["if"].call(this,t,{fn:n.inverse,inverse:n.fn,hash:n.hash})});e.registerHelper("with",function(e,t){if(f(e)){e=e.call(this)}if(!r.isEmpty(e))return t.fn(e)});e.registerHelper("log",function(t,n){var r=n.data&&n.data.level!=null?parseInt(n.data.level,10):1;e.log(r,t)})}function v(e,t){d.log(e,t)}var n={};var r=e;var i=t;var s="1.3.0";n.VERSION=s;var o=4;n.COMPILER_REVISION=o;var u={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:">= 1.0.0"};n.REVISION_CHANGES=u;var a=r.isArray,f=r.isFunction,l=r.toString,c="[object Object]";n.HandlebarsEnvironment=h;h.prototype={constructor:h,logger:d,log:v,registerHelper:function(e,t,n){if(l.call(e)===c){if(n||t){throw new i("Arg not supported with multiple helpers")}r.extend(this.helpers,e)}else{if(n){t.not=n}this.helpers[e]=t}},registerPartial:function(e,t){if(l.call(e)===c){r.extend(this.partials,e)}else{this.partials[e]=t}}};var d={methodMap:{0:"debug",1:"info",2:"warn",3:"error"},DEBUG:0,INFO:1,WARN:2,ERROR:3,level:3,log:function(e,t){if(d.level<=e){var n=d.methodMap[e];if(typeof console!=="undefined"&&console[n]){console[n].call(console,t)}}}};n.logger=d;n.log=v;var m=function(e){var t={};r.extend(t,e);return t};n.createFrame=m;return n}(t,n);var i=function(e,t,n){"use strict";function a(e){var t=e&&e[0]||1,n=o;if(t!==n){if(t<n){var r=u[n],i=u[t];throw new s("Template was precompiled with an older version of Handlebars than the current runtime. "+"Please update your precompiler to a newer version ("+r+") or downgrade your runtime to an older version ("+i+").")}else{throw new s("Template was precompiled with a newer version of Handlebars than the current runtime. "+"Please update your runtime to a newer version ("+e[1]+").")}}}function f(e,t){if(!t){throw new s("No environment passed to template")}var n=function(e,n,r,i,o,u){var a=t.VM.invokePartial.apply(this,arguments);if(a!=null){return a}if(t.compile){var f={helpers:i,partials:o,data:u};o[n]=t.compile(e,{data:u!==undefined},t);return o[n](r,f)}else{throw new s("The partial "+n+" could not be compiled when running in runtime-only mode")}};var r={escapeExpression:i.escapeExpression,invokePartial:n,programs:[],program:function(e,t,n){var r=this.programs[e];if(n){r=c(e,t,n)}else if(!r){r=this.programs[e]=c(e,t)}return r},merge:function(e,t){var n=e||t;if(e&&t&&e!==t){n={};i.extend(n,t);i.extend(n,e)}return n},programWithDepth:t.VM.programWithDepth,noop:t.VM.noop,compilerInfo:null};return function(n,i){i=i||{};var s=i.partial?i:t,o,u;if(!i.partial){o=i.helpers;u=i.partials}var a=e.call(r,s,n,o,u,i.data);if(!i.partial){t.VM.checkRevision(r.compilerInfo)}return a}}function l(e,t,n){var r=Array.prototype.slice.call(arguments,3);var i=function(e,i){i=i||{};return t.apply(this,[e,i.data||n].concat(r))};i.program=e;i.depth=r.length;return i}function c(e,t,n){var r=function(e,r){r=r||{};return t(e,r.data||n)};r.program=e;r.depth=0;return r}function h(e,t,n,r,i,o){var u={partial:true,helpers:r,partials:i,data:o};if(e===undefined){throw new s("The partial "+t+" could not be found")}else if(e instanceof Function){return e(n,u)}}function p(){return""}var r={};var i=e;var s=t;var o=n.COMPILER_REVISION;var u=n.REVISION_CHANGES;r.checkRevision=a;r.template=f;r.programWithDepth=l;r.program=c;r.invokePartial=h;r.noop=p;return r}(t,n,r);var s=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n;var f=r;var l=i;var c=function(){var e=new o.HandlebarsEnvironment;f.extend(e,o);e.SafeString=u;e.Exception=a;e.Utils=f;e.VM=l;e.template=function(t){return l.template(t,e)};return e};var h=c();h.create=c;s=h;return s}(r,e,n,t,i);var o=function(e){"use strict";function r(e){e=e||{};this.firstLine=e.first_line;this.firstColumn=e.first_column;this.lastColumn=e.last_column;this.lastLine=e.last_line}var t;var n=e;var i={ProgramNode:function(e,t,n,s){var o,u;if(arguments.length===3){s=n;n=null}else if(arguments.length===2){s=t;t=null}r.call(this,s);this.type="program";this.statements=e;this.strip={};if(n){u=n[0];if(u){o={first_line:u.firstLine,last_line:u.lastLine,last_column:u.lastColumn,first_column:u.firstColumn};this.inverse=new i.ProgramNode(n,t,o)}else{this.inverse=new i.ProgramNode(n,t)}this.strip.right=t.left}else if(t){this.strip.left=t.right}},MustacheNode:function(e,t,n,s,o){r.call(this,o);this.type="mustache";this.strip=s;if(n!=null&&n.charAt){var u=n.charAt(3)||n.charAt(2);this.escaped=u!=="{"&&u!=="&"}else{this.escaped=!!n}if(e instanceof i.SexprNode){this.sexpr=e}else{this.sexpr=new i.SexprNode(e,t)}this.sexpr.isRoot=true;this.id=this.sexpr.id;this.params=this.sexpr.params;this.hash=this.sexpr.hash;this.eligibleHelper=this.sexpr.eligibleHelper;this.isHelper=this.sexpr.isHelper},SexprNode:function(e,t,n){r.call(this,n);this.type="sexpr";this.hash=t;var i=this.id=e[0];var s=this.params=e.slice(1);var o=this.eligibleHelper=i.isSimple;this.isHelper=o&&(s.length||t)},PartialNode:function(e,t,n,i){r.call(this,i);this.type="partial";this.partialName=e;this.context=t;this.strip=n},BlockNode:function(e,t,i,s,o){r.call(this,o);if(e.sexpr.id.original!==s.path.original){throw new n(e.sexpr.id.original+" doesn't match "+s.path.original,this)}this.type="block";this.mustache=e;this.program=t;this.inverse=i;this.strip={left:e.strip.left,right:s.strip.right};(t||i).strip.left=e.strip.right;(i||t).strip.right=s.strip.left;if(i&&!t){this.isInverse=true}},ContentNode:function(e,t){r.call(this,t);this.type="content";this.string=e},HashNode:function(e,t){r.call(this,t);this.type="hash";this.pairs=e},IdNode:function(e,t){r.call(this,t);this.type="ID";var i="",s=[],o=0;for(var u=0,a=e.length;u<a;u++){var f=e[u].part;i+=(e[u].separator||"")+f;if(f===".."||f==="."||f==="this"){if(s.length>0){throw new n("Invalid path: "+i,this)}else if(f===".."){o++}else{this.isScoped=true}}else{s.push(f)}}this.original=i;this.parts=s;this.string=s.join(".");this.depth=o;this.isSimple=e.length===1&&!this.isScoped&&o===0;this.stringModeValue=this.string},PartialNameNode:function(e,t){r.call(this,t);this.type="PARTIAL_NAME";this.name=e.original},DataNode:function(e,t){r.call(this,t);this.type="DATA";this.id=e},StringNode:function(e,t){r.call(this,t);this.type="STRING";this.original=this.string=this.stringModeValue=e},IntegerNode:function(e,t){r.call(this,t);this.type="INTEGER";this.original=this.integer=e;this.stringModeValue=Number(e)},BooleanNode:function(e,t){r.call(this,t);this.type="BOOLEAN";this.bool=e;this.stringModeValue=e==="true"},CommentNode:function(e,t){r.call(this,t);this.type="comment";this.comment=e}};t=i;return t}(n);var u=function(){"use strict";var e;var t=function(){function t(e,t){return{left:e.charAt(2)==="~",right:t.charAt(0)==="~"||t.charAt(1)==="~"}}function r(){this.yy={}}var e={trace:function(){},yy:{},symbols_:{error:2,root:3,statements:4,EOF:5,program:6,simpleInverse:7,statement:8,openInverse:9,closeBlock:10,openBlock:11,mustache:12,partial:13,CONTENT:14,COMMENT:15,OPEN_BLOCK:16,sexpr:17,CLOSE:18,OPEN_INVERSE:19,OPEN_ENDBLOCK:20,path:21,OPEN:22,OPEN_UNESCAPED:23,CLOSE_UNESCAPED:24,OPEN_PARTIAL:25,partialName:26,partial_option0:27,sexpr_repetition0:28,sexpr_option0:29,dataName:30,param:31,STRING:32,INTEGER:33,BOOLEAN:34,OPEN_SEXPR:35,CLOSE_SEXPR:36,hash:37,hash_repetition_plus0:38,hashSegment:39,ID:40,EQUALS:41,DATA:42,pathSegments:43,SEP:44,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"CLOSE_UNESCAPED",25:"OPEN_PARTIAL",32:"STRING",33:"INTEGER",34:"BOOLEAN",35:"OPEN_SEXPR",36:"CLOSE_SEXPR",40:"ID",41:"EQUALS",42:"DATA",44:"SEP"},productions_:[0,[3,2],[3,1],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[31,3],[37,1],[39,3],[26,1],[26,1],[26,1],[30,2],[21,1],[43,3],[43,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[38,1],[38,2]],performAction:function(n,r,i,s,o,u,a){var f=u.length-1;switch(o){case 1:return new s.ProgramNode(u[f-1],this._$);break;case 2:return new s.ProgramNode([],this._$);break;case 3:this.$=new s.ProgramNode([],u[f-1],u[f],this._$);break;case 4:this.$=new s.ProgramNode(u[f-2],u[f-1],u[f],this._$);break;case 5:this.$=new s.ProgramNode(u[f-1],u[f],[],this._$);break;case 6:this.$=new s.ProgramNode(u[f],this._$);break;case 7:this.$=new s.ProgramNode([],this._$);break;case 8:this.$=new s.ProgramNode([],this._$);break;case 9:this.$=[u[f]];break;case 10:u[f-1].push(u[f]);this.$=u[f-1];break;case 11:this.$=new s.BlockNode(u[f-2],u[f-1].inverse,u[f-1],u[f],this._$);break;case 12:this.$=new s.BlockNode(u[f-2],u[f-1],u[f-1].inverse,u[f],this._$);break;case 13:this.$=u[f];break;case 14:this.$=u[f];break;case 15:this.$=new s.ContentNode(u[f],this._$);break;case 16:this.$=new s.CommentNode(u[f],this._$);break;case 17:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 18:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 19:this.$={path:u[f-1],strip:t(u[f-2],u[f])};break;case 20:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 21:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 22:this.$=new s.PartialNode(u[f-2],u[f-1],t(u[f-3],u[f]),this._$);break;case 23:this.$=t(u[f-1],u[f]);break;case 24:this.$=new s.SexprNode([u[f-2]].concat(u[f-1]),u[f],this._$);break;case 25:this.$=new s.SexprNode([u[f]],null,this._$);break;case 26:this.$=u[f];break;case 27:this.$=new s.StringNode(u[f],this._$);break;case 28:this.$=new s.IntegerNode(u[f],this._$);break;case 29:this.$=new s.BooleanNode(u[f],this._$);break;case 30:this.$=u[f];break;case 31:u[f-1].isHelper=true;this.$=u[f-1];break;case 32:this.$=new s.HashNode(u[f],this._$);break;case 33:this.$=[u[f-2],u[f]];break;case 34:this.$=new s.PartialNameNode(u[f],this._$);break;case 35:this.$=new s.PartialNameNode(new s.StringNode(u[f],this._$),this._$);break;case 36:this.$=new s.PartialNameNode(new s.IntegerNode(u[f],this._$));break;case 37:this.$=new s.DataNode(u[f],this._$);break;case 38:this.$=new s.IdNode(u[f],this._$);break;case 39:u[f-2].push({part:u[f],separator:u[f-1]});this.$=u[f-2];break;case 40:this.$=[{part:u[f]}];break;case 43:this.$=[];break;case 44:u[f-1].push(u[f]);break;case 47:this.$=[u[f]];break;case 48:u[f-1].push(u[f]);break}},table:[{3:1,4:2,5:[1,3],8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[3]},{5:[1,16],8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[2,2]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{4:20,6:18,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{4:20,6:22,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{5:[2,16],14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{17:23,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:29,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:30,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:31,21:24,30:25,40:[1,28],42:[1,27],43:26},{21:33,26:32,32:[1,34],33:[1,35],40:[1,28],43:26},{1:[2,1]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{10:36,20:[1,37]},{4:38,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,7],22:[1,13],23:[1,14],25:[1,15]},{7:39,8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,6],22:[1,13],23:[1,14],25:[1,15]},{17:23,18:[1,40],21:24,30:25,40:[1,28],42:[1,27],43:26},{10:41,20:[1,37]},{18:[1,42]},{18:[2,43],24:[2,43],28:43,32:[2,43],33:[2,43],34:[2,43],35:[2,43],36:[2,43],40:[2,43],42:[2,43]},{18:[2,25],24:[2,25],36:[2,25]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],35:[2,38],36:[2,38],40:[2,38],42:[2,38],44:[1,44]},{21:45,40:[1,28],43:26},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],42:[2,40],44:[2,40]},{18:[1,46]},{18:[1,47]},{24:[1,48]},{18:[2,41],21:50,27:49,40:[1,28],43:26},{18:[2,34],40:[2,34]},{18:[2,35],40:[2,35]},{18:[2,36],40:[2,36]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{21:51,40:[1,28],43:26},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,3],22:[1,13],23:[1,14],25:[1,15]},{4:52,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,5],22:[1,13],23:[1,14],25:[1,15]},{14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],25:[2,23]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,45],21:56,24:[2,45],29:53,30:60,31:54,32:[1,57],33:[1,58],34:[1,59],35:[1,61],36:[2,45],37:55,38:62,39:63,40:[1,64],42:[1,27],43:26},{40:[1,65]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],35:[2,37],36:[2,37],40:[2,37],42:[2,37]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{18:[1,66]},{18:[2,42]},{18:[1,67]},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,4],22:[1,13],23:[1,14],25:[1,15]},{18:[2,24],24:[2,24],36:[2,24]},{18:[2,44],24:[2,44],32:[2,44],33:[2,44],34:[2,44],35:[2,44],36:[2,44],40:[2,44],42:[2,44]},{18:[2,46],24:[2,46],36:[2,46]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],35:[2,26],36:[2,26],40:[2,26],42:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],35:[2,27],36:[2,27],40:[2,27],42:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],35:[2,28],36:[2,28],40:[2,28],42:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],35:[2,29],36:[2,29],40:[2,29],42:[2,29]},{18:[2,30],24:[2,30],32:[2,30],33:[2,30],34:[2,30],35:[2,30],36:[2,30],40:[2,30],42:[2,30]},{17:68,21:24,30:25,40:[1,28],42:[1,27],43:26},{18:[2,32],24:[2,32],36:[2,32],39:69,40:[1,70]},{18:[2,47],24:[2,47],36:[2,47],40:[2,47]},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],41:[1,71],42:[2,40],44:[2,40]},{18:[2,39],24:[2,39],32:[2,39],33:[2,39],34:[2,39],35:[2,39],36:[2,39],40:[2,39],42:[2,39],44:[2,39]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{36:[1,72]},{18:[2,48],24:[2,48],36:[2,48],40:[2,48]},{41:[1,71]},{21:56,30:60,31:73,32:[1,57],33:[1,58],34:[1,59],35:[1,61],40:[1,28],42:[1,27],43:26},{18:[2,31],24:[2,31],32:[2,31],33:[2,31],34:[2,31],35:[2,31],36:[2,31],40:[2,31],42:[2,31]},{18:[2,33],24:[2,33],36:[2,33],40:[2,33]}],defaultActions:{3:[2,2],16:[2,1],50:[2,42]},parseError:function(t,n){throw new Error(t)},parse:function(t){function v(e){r.length=r.length-2*e;i.length=i.length-e;s.length=s.length-e}function m(){var e;e=n.lexer.lex()||1;if(typeof e!=="number"){e=n.symbols_[e]||e}return e}var n=this,r=[0],i=[null],s=[],o=this.table,u="",a=0,f=0,l=0,c=2,h=1;this.lexer.setInput(t);this.lexer.yy=this.yy;this.yy.lexer=this.lexer;this.yy.parser=this;if(typeof this.lexer.yylloc=="undefined")this.lexer.yylloc={};var p=this.lexer.yylloc;s.push(p);var d=this.lexer.options&&this.lexer.options.ranges;if(typeof this.yy.parseError==="function")this.parseError=this.yy.parseError;var g,y,b,w,E,S,x={},T,N,C,k;while(true){b=r[r.length-1];if(this.defaultActions[b]){w=this.defaultActions[b]}else{if(g===null||typeof g=="undefined"){g=m()}w=o[b]&&o[b][g]}if(typeof w==="undefined"||!w.length||!w[0]){var L="";if(!l){k=[];for(T in o[b])if(this.terminals_[T]&&T>2){k.push("'"+this.terminals_[T]+"'")}if(this.lexer.showPosition){L="Parse error on line "+(a+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+k.join(", ")+", got '"+(this.terminals_[g]||g)+"'"}else{L="Parse error on line "+(a+1)+": Unexpected "+(g==1?"end of input":"'"+(this.terminals_[g]||g)+"'")}this.parseError(L,{text:this.lexer.match,token:this.terminals_[g]||g,line:this.lexer.yylineno,loc:p,expected:k})}}if(w[0]instanceof Array&&w.length>1){throw new Error("Parse Error: multiple actions possible at state: "+b+", token: "+g)}switch(w[0]){case 1:r.push(g);i.push(this.lexer.yytext);s.push(this.lexer.yylloc);r.push(w[1]);g=null;if(!y){f=this.lexer.yyleng;u=this.lexer.yytext;a=this.lexer.yylineno;p=this.lexer.yylloc;if(l>0)l--}else{g=y;y=null}break;case 2:N=this.productions_[w[1]][1];x.$=i[i.length-N];x._$={first_line:s[s.length-(N||1)].first_line,last_line:s[s.length-1].last_line,first_column:s[s.length-(N||1)].first_column,last_column:s[s.length-1].last_column};if(d){x._$.range=[s[s.length-(N||1)].range[0],s[s.length-1].range[1]]}S=this.performAction.call(x,u,f,a,this.yy,w[1],i,s);if(typeof S!=="undefined"){return S}if(N){r=r.slice(0,-1*N*2);i=i.slice(0,-1*N);s=s.slice(0,-1*N)}r.push(this.productions_[w[1]][0]);i.push(x.$);s.push(x._$);C=o[r[r.length-2]][r[r.length-1]];r.push(C);break;case 3:return true}}return true}};var n=function(){var e={EOF:1,parseError:function(t,n){if(this.yy.parser){this.yy.parser.parseError(t,n)}else{throw new Error(t)}},setInput:function(e){this._input=e;this._more=this._less=this.done=false;this.yylineno=this.yyleng=0;this.yytext=this.matched=this.match="";this.conditionStack=["INITIAL"];this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0};if(this.options.ranges)this.yylloc.range=[0,0];this.offset=0;return this},input:function(){var e=this._input[0];this.yytext+=e;this.yyleng++;this.offset++;this.match+=e;this.matched+=e;var t=e.match(/(?:\r\n?|\n).*/g);if(t){this.yylineno++;this.yylloc.last_line++}else{this.yylloc.last_column++}if(this.options.ranges)this.yylloc.range[1]++;this._input=this._input.slice(1);return e},unput:function(e){var t=e.length;var n=e.split(/(?:\r\n?|\n)/g);this._input=e+this._input;this.yytext=this.yytext.substr(0,this.yytext.length-t-1);this.offset-=t;var r=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1);this.matched=this.matched.substr(0,this.matched.length-1);if(n.length-1)this.yylineno-=n.length-1;var i=this.yylloc.range;this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:n?(n.length===r.length?this.yylloc.first_column:0)+r[r.length-n.length].length-n[0].length:this.yylloc.first_column-t};if(this.options.ranges){this.yylloc.range=[i[0],i[0]+this.yyleng-t]}return this},more:function(){this._more=true;return this},less:function(e){this.unput(this.match.slice(e))},pastInput:function(){var e=this.matched.substr(0,this.matched.length-this.match.length);return(e.length>20?"...":"")+e.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var e=this.match;if(e.length<20){e+=this._input.substr(0,20-e.length)}return(e.substr(0,20)+(e.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var e=this.pastInput();var t=(new Array(e.length+1)).join("-");return e+this.upcomingInput()+"\n"+t+"^"},next:function(){if(this.done){return this.EOF}if(!this._input)this.done=true;var e,t,n,r,i,s;if(!this._more){this.yytext="";this.match=""}var o=this._currentRules();for(var u=0;u<o.length;u++){n=this._input.match(this.rules[o[u]]);if(n&&(!t||n[0].length>t[0].length)){t=n;r=u;if(!this.options.flex)break}}if(t){s=t[0].match(/(?:\r\n?|\n).*/g);if(s)this.yylineno+=s.length;this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:s?s[s.length-1].length-s[s.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+t[0].length};this.yytext+=t[0];this.match+=t[0];this.matches=t;this.yyleng=this.yytext.length;if(this.options.ranges){this.yylloc.range=[this.offset,this.offset+=this.yyleng]}this._more=false;this._input=this._input.slice(t[0].length);this.matched+=t[0];e=this.performAction.call(this,this.yy,this,o[r],this.conditionStack[this.conditionStack.length-1]);if(this.done&&this._input)this.done=false;if(e)return e;else return}if(this._input===""){return this.EOF}else{return this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})}},lex:function(){var t=this.next();if(typeof t!=="undefined"){return t}else{return this.lex()}},begin:function(t){this.conditionStack.push(t)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(t){this.begin(t)}};e.options={};e.performAction=function(t,n,r,i){function s(e,t){return n.yytext=n.yytext.substr(e,n.yyleng-t)}var o=i;switch(r){case 0:if(n.yytext.slice(-2)==="\\\\"){s(0,1);this.begin("mu")}else if(n.yytext.slice(-1)==="\\"){s(0,1);this.begin("emu")}else{this.begin("mu")}if(n.yytext)return 14;break;case 1:return 14;break;case 2:this.popState();return 14;break;case 3:s(0,4);this.popState();return 15;break;case 4:return 35;break;case 5:return 36;break;case 6:return 25;break;case 7:return 16;break;case 8:return 20;break;case 9:return 19;break;case 10:return 19;break;case 11:return 23;break;case 12:return 22;break;case 13:this.popState();this.begin("com");break;case 14:s(3,5);this.popState();return 15;break;case 15:return 22;break;case 16:return 41;break;case 17:return 40;break;case 18:return 40;break;case 19:return 44;break;case 20:break;case 21:this.popState();return 24;break;case 22:this.popState();return 18;break;case 23:n.yytext=s(1,2).replace(/\\"/g,'"');return 32;break;case 24:n.yytext=s(1,2).replace(/\\'/g,"'");return 32;break;case 25:return 42;break;case 26:return 34;break;case 27:return 34;break;case 28:return 33;break;case 29:return 40;break;case 30:n.yytext=s(1,2);return 40;break;case 31:return"INVALID";break;case 32:return 5;break}};e.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];e.conditions={mu:{rules:[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],inclusive:false},emu:{rules:[2],inclusive:false},com:{rules:[3],inclusive:false},INITIAL:{rules:[0,1,32],inclusive:true}};return e}();e.lexer=n;r.prototype=e;e.Parser=r;return new r}();e=t;return e}();var a=function(e,t){"use strict";function s(e){if(e.constructor===i.ProgramNode){return e}r.yy=i;return r.parse(e)}var n={};var r=e;var i=t;n.parser=r;n.parse=s;return n}(u,o);var f=function(e){"use strict";function r(){}function i(e,t,r){if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i=r.parse(e);var s=(new r.Compiler).compile(i,t);return(new r.JavaScriptCompiler).compile(s,t)}function s(e,t,r){function s(){var n=r.parse(e);var i=(new r.Compiler).compile(n,t);var s=(new r.JavaScriptCompiler).compile(i,t,undefined,true);return r.template(s)}if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i;return function(e,t){if(!i){i=s()}return i.call(this,e,t)}}var t={};var n=e;t.Compiler=r;r.prototype={compiler:r,disassemble:function(){var e=this.opcodes,t,n=[],r,i;for(var s=0,o=e.length;s<o;s++){t=e[s];if(t.opcode==="DECLARE"){n.push("DECLARE "+t.name+"="+t.value)}else{r=[];for(var u=0;u<t.args.length;u++){i=t.args[u];if(typeof i==="string"){i='"'+i.replace("\n","\\n")+'"'}r.push(i)}n.push(t.opcode+" "+r.join(" "))}}return n.join("\n")},equals:function(e){var t=this.opcodes.length;if(e.opcodes.length!==t){return false}for(var n=0;n<t;n++){var r=this.opcodes[n],i=e.opcodes[n];if(r.opcode!==i.opcode||r.args.length!==i.args.length){return false}for(var s=0;s<r.args.length;s++){if(r.args[s]!==i.args[s]){return false}}}t=this.children.length;if(e.children.length!==t){return false}for(n=0;n<t;n++){if(!this.children[n].equals(e.children[n])){return false}}return true},guid:0,compile:function(e,t){this.opcodes=[];this.children=[];this.depths={list:[]};this.options=t;var n=this.options.knownHelpers;this.options.knownHelpers={helperMissing:true,blockHelperMissing:true,each:true,"if":true,unless:true,"with":true,log:true};if(n){for(var r in n){this.options.knownHelpers[r]=n[r]}}return this.accept(e)},accept:function(e){var t=e.strip||{},n;if(t.left){this.opcode("strip")}n=this[e.type](e);if(t.right){this.opcode("strip")}return n},program:function(e){var t=e.statements;for(var n=0,r=t.length;n<r;n++){this.accept(t[n])}this.isSimple=r===1;this.depths.list=this.depths.list.sort(function(e,t){return e-t});return this},compileProgram:function(e){var t=(new this.compiler).compile(e,this.options);var n=this.guid++,r;this.usePartial=this.usePartial||t.usePartial;this.children[n]=t;for(var i=0,s=t.depths.list.length;i<s;i++){r=t.depths.list[i];if(r<2){continue}else{this.addDepth(r-1)}}return n},block:function(e){var t=e.mustache,n=e.program,r=e.inverse;if(n){n=this.compileProgram(n)}if(r){r=this.compileProgram(r)}var i=t.sexpr;var s=this.classifySexpr(i);if(s==="helper"){this.helperSexpr(i,n,r)}else if(s==="simple"){this.simpleSexpr(i);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("blockValue")}else{this.ambiguousSexpr(i,n,r);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("ambiguousBlockValue")}this.opcode("append")},hash:function(e){var t=e.pairs,n,r;this.opcode("pushHash");for(var i=0,s=t.length;i<s;i++){n=t[i];r=n[1];if(this.options.stringParams){if(r.depth){this.addDepth(r.depth)}this.opcode("getContext",r.depth||0);this.opcode("pushStringParam",r.stringModeValue,r.type);if(r.type==="sexpr"){this.sexpr(r)}}else{this.accept(r)}this.opcode("assignToHash",n[0])}this.opcode("popHash")},partial:function(e){var t=e.partialName;this.usePartial=true;if(e.context){this.ID(e.context)}else{this.opcode("push","depth0")}this.opcode("invokePartial",t.name);this.opcode("append")},content:function(e){this.opcode("appendContent",e.string)},mustache:function(e){this.sexpr(e.sexpr);if(e.escaped&&!this.options.noEscape){this.opcode("appendEscaped")}else{this.opcode("append")}},ambiguousSexpr:function(e,t,n){var r=e.id,i=r.parts[0],s=t!=null||n!=null;this.opcode("getContext",r.depth);this.opcode("pushProgram",t);this.opcode("pushProgram",n);this.opcode("invokeAmbiguous",i,s)},simpleSexpr:function(e){var t=e.id;if(t.type==="DATA"){this.DATA(t)}else if(t.parts.length){this.ID(t)}else{this.addDepth(t.depth);this.opcode("getContext",t.depth);this.opcode("pushContext")}this.opcode("resolvePossibleLambda")},helperSexpr:function(e,t,r){var i=this.setupFullMustacheParams(e,t,r),s=e.id.parts[0];if(this.options.knownHelpers[s]){this.opcode("invokeKnownHelper",i.length,s)}else if(this.options.knownHelpersOnly){throw new n("You specified knownHelpersOnly, but used the unknown helper "+s,e)}else{this.opcode("invokeHelper",i.length,s,e.isRoot)}},sexpr:function(e){var t=this.classifySexpr(e);if(t==="simple"){this.simpleSexpr(e)}else if(t==="helper"){this.helperSexpr(e)}else{this.ambiguousSexpr(e)}},ID:function(e){this.addDepth(e.depth);this.opcode("getContext",e.depth);var t=e.parts[0];if(!t){this.opcode("pushContext")}else{this.opcode("lookupOnContext",e.parts[0])}for(var n=1,r=e.parts.length;n<r;n++){this.opcode("lookup",e.parts[n])}},DATA:function(e){this.options.data=true;if(e.id.isScoped||e.id.depth){throw new n("Scoped data references are not supported: "+e.original,e)}this.opcode("lookupData");var t=e.id.parts;for(var r=0,i=t.length;r<i;r++){this.opcode("lookup",t[r])}},STRING:function(e){this.opcode("pushString",e.string)},INTEGER:function(e){this.opcode("pushLiteral",e.integer)},BOOLEAN:function(e){this.opcode("pushLiteral",e.bool)},comment:function(){},opcode:function(e){this.opcodes.push({opcode:e,args:[].slice.call(arguments,1)})},declare:function(e,t){this.opcodes.push({opcode:"DECLARE",name:e,value:t})},addDepth:function(e){if(e===0){return}if(!this.depths[e]){this.depths[e]=true;this.depths.list.push(e)}},classifySexpr:function(e){var t=e.isHelper;var n=e.eligibleHelper;var r=this.options;if(n&&!t){var i=e.id.parts[0];if(r.knownHelpers[i]){t=true}else if(r.knownHelpersOnly){n=false}}if(t){return"helper"}else if(n){return"ambiguous"}else{return"simple"}},pushParams:function(e){var t=e.length,n;while(t--){n=e[t];if(this.options.stringParams){if(n.depth){this.addDepth(n.depth)}this.opcode("getContext",n.depth||0);this.opcode("pushStringParam",n.stringModeValue,n.type);if(n.type==="sexpr"){this.sexpr(n)}}else{this[n.type](n)}}},setupFullMustacheParams:function(e,t,n){var r=e.params;this.pushParams(r);this.opcode("pushProgram",t);this.opcode("pushProgram",n);if(e.hash){this.hash(e.hash)}else{this.opcode("emptyHash")}return r}};t.precompile=i;t.compile=s;return t}(n);var l=function(e,t){"use strict";function u(e){this.value=e}function a(){}var n;var r=e.COMPILER_REVISION;var i=e.REVISION_CHANGES;var s=e.log;var o=t;a.prototype={nameLookup:function(e,t){var n,r;if(e.indexOf("depth")===0){n=true}if(/^[0-9]+$/.test(t)){r=e+"["+t+"]"}else if(a.isValidJavaScriptVariableName(t)){r=e+"."+t}else{r=e+"['"+t+"']"}if(n){return"("+e+" && "+r+")"}else{return r}},compilerInfo:function(){var e=r,t=i[e];return"this.compilerInfo = ["+e+",'"+t+"'];\n"},appendToBuffer:function(e){if(this.environment.isSimple){return"return "+e+";"}else{return{appendToBuffer:true,content:e,toString:function(){return"buffer += "+e+";"}}}},initializeBuffer:function(){return this.quotedString("")},namespace:"Handlebars",compile:function(e,t,n,r){this.environment=e;this.options=t||{};s("debug",this.environment.disassemble()+"\n\n");this.name=this.environment.name;this.isChild=!!n;this.context=n||{programs:[],environments:[],aliases:{}};this.preamble();this.stackSlot=0;this.stackVars=[];this.registers={list:[]};this.hashes=[];this.compileStack=[];this.inlineStack=[];this.compileChildren(e,t);var i=e.opcodes,u;this.i=0;for(var a=i.length;this.i<a;this.i++){u=i[this.i];if(u.opcode==="DECLARE"){this[u.name]=u.value}else{this[u.opcode].apply(this,u.args)}if(u.opcode!==this.stripNext){this.stripNext=false}}this.pushSource("");if(this.stackSlot||this.inlineStack.length||this.compileStack.length){throw new o("Compile completed with content left on stack")}return this.createFunctionContext(r)},preamble:function(){var e=[];if(!this.isChild){var t=this.namespace;var n="helpers = this.merge(helpers, "+t+".helpers);";if(this.environment.usePartial){n=n+" partials = this.merge(partials, "+t+".partials);"}if(this.options.data){n=n+" data = data || {};"}e.push(n)}else{e.push("")}if(!this.environment.isSimple){e.push(", buffer = "+this.initializeBuffer())}else{e.push("")}this.lastContext=0;this.source=e},createFunctionContext:function(e){var t=this.stackVars.concat(this.registers.list);if(t.length>0){this.source[1]=this.source[1]+", "+t.join(", ")}if(!this.isChild){for(var n in this.context.aliases){if(this.context.aliases.hasOwnProperty(n)){this.source[1]=this.source[1]+", "+n+"="+this.context.aliases[n]}}}if(this.source[1]){this.source[1]="var "+this.source[1].substring(2)+";"}if(!this.isChild){this.source[1]+="\n"+this.context.programs.join("\n")+"\n"}if(!this.environment.isSimple){this.pushSource("return buffer;")}var r=this.isChild?["depth0","data"]:["Handlebars","depth0","helpers","partials","data"];for(var i=0,o=this.environment.depths.list.length;i<o;i++){r.push("depth"+this.environment.depths.list[i])}var u=this.mergeSource();if(!this.isChild){u=this.compilerInfo()+u}if(e){r.push(u);return Function.apply(this,r)}else{var a="function "+(this.name||"")+"("+r.join(",")+") {\n  "+u+"}";s("debug",a+"\n\n");return a}},mergeSource:function(){var e="",t;for(var n=0,r=this.source.length;n<r;n++){var i=this.source[n];if(i.appendToBuffer){if(t){t=t+"\n    + "+i.content}else{t=i.content}}else{if(t){e+="buffer += "+t+";\n  ";t=undefined}e+=i+"\n  "}}return e},blockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);this.replaceStack(function(t){e.splice(1,0,t);return"blockHelperMissing.call("+e.join(", ")+")"})},ambiguousBlockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);var t=this.topStack();e.splice(1,0,t);this.pushSource("if (!"+this.lastHelper+") { "+t+" = blockHelperMissing.call("+e.join(", ")+"); }")},appendContent:function(e){if(this.pendingContent){e=this.pendingContent+e}if(this.stripNext){e=e.replace(/^\s+/,"")}this.pendingContent=e},strip:function(){if(this.pendingContent){this.pendingContent=this.pendingContent.replace(/\s+$/,"")}this.stripNext="strip"},append:function(){this.flushInline();var e=this.popStack();this.pushSource("if("+e+" || "+e+" === 0) { "+this.appendToBuffer(e)+" }");if(this.environment.isSimple){this.pushSource("else { "+this.appendToBuffer("''")+" }")}},appendEscaped:function(){this.context.aliases.escapeExpression="this.escapeExpression";this.pushSource(this.appendToBuffer("escapeExpression("+this.popStack()+")"))},getContext:function(e){if(this.lastContext!==e){this.lastContext=e}},lookupOnContext:function(e){this.push(this.nameLookup("depth"+this.lastContext,e,"context"))},pushContext:function(){this.pushStackLiteral("depth"+this.lastContext)},resolvePossibleLambda:function(){this.context.aliases.functionType='"function"';this.replaceStack(function(e){return"typeof "+e+" === functionType ? "+e+".apply(depth0) : "+e})},lookup:function(e){this.replaceStack(function(t){return t+" == null || "+t+" === false ? "+t+" : "+this.nameLookup(t,e,"context")})},lookupData:function(){this.pushStackLiteral("data")},pushStringParam:function(e,t){this.pushStackLiteral("depth"+this.lastContext);this.pushString(t);if(t!=="sexpr"){if(typeof e==="string"){this.pushString(e)}else{this.pushStackLiteral(e)}}},emptyHash:function(){this.pushStackLiteral("{}");if(this.options.stringParams){this.push("{}");this.push("{}")}},pushHash:function(){if(this.hash){this.hashes.push(this.hash)}this.hash={values:[],types:[],contexts:[]}},popHash:function(){var e=this.hash;this.hash=this.hashes.pop();if(this.options.stringParams){this.push("{"+e.contexts.join(",")+"}");this.push("{"+e.types.join(",")+"}")}this.push("{\n    "+e.values.join(",\n    ")+"\n  }")},pushString:function(e){this.pushStackLiteral(this.quotedString(e))},push:function(e){this.inlineStack.push(e);return e},pushLiteral:function(e){this.pushStackLiteral(e)},pushProgram:function(e){if(e!=null){this.pushStackLiteral(this.programExpression(e))}else{this.pushStackLiteral(null)}},invokeHelper:function(e,t,n){this.context.aliases.helperMissing="helpers.helperMissing";this.useRegister("helper");var r=this.lastHelper=this.setupHelper(e,t,true);var i=this.nameLookup("depth"+this.lastContext,t,"context");var s="helper = "+r.name+" || "+i;if(r.paramsInit){s+=","+r.paramsInit}this.push("("+s+",helper "+"? helper.call("+r.callParams+") "+": helperMissing.call("+r.helperMissingParams+"))");if(!n){this.flushInline()}},invokeKnownHelper:function(e,t){var n=this.setupHelper(e,t);this.push(n.name+".call("+n.callParams+")")},invokeAmbiguous:function(e,t){this.context.aliases.functionType='"function"';this.useRegister("helper");this.emptyHash();var n=this.setupHelper(0,e,t);var r=this.lastHelper=this.nameLookup("helpers",e,"helper");var i=this.nameLookup("depth"+this.lastContext,e,"context");var s=this.nextStack();if(n.paramsInit){this.pushSource(n.paramsInit)}this.pushSource("if (helper = "+r+") { "+s+" = helper.call("+n.callParams+"); }");this.pushSource("else { helper = "+i+"; "+s+" = typeof helper === functionType ? helper.call("+n.callParams+") : helper; }")},invokePartial:function(e){var t=[this.nameLookup("partials",e,"partial"),"'"+e+"'",this.popStack(),"helpers","partials"];if(this.options.data){t.push("data")}this.context.aliases.self="this";this.push("self.invokePartial("+t.join(", ")+")")},assignToHash:function(e){var t=this.popStack(),n,r;if(this.options.stringParams){r=this.popStack();n=this.popStack()}var i=this.hash;if(n){i.contexts.push("'"+e+"': "+n)}if(r){i.types.push("'"+e+"': "+r)}i.values.push("'"+e+"': ("+t+")")},compiler:a,compileChildren:function(e,t){var n=e.children,r,i;for(var s=0,o=n.length;s<o;s++){r=n[s];i=new this.compiler;var u=this.matchExistingProgram(r);if(u==null){this.context.programs.push("");u=this.context.programs.length;r.index=u;r.name="program"+u;this.context.programs[u]=i.compile(r,t,this.context);this.context.environments[u]=r}else{r.index=u;r.name="program"+u}}},matchExistingProgram:function(e){for(var t=0,n=this.context.environments.length;t<n;t++){var r=this.context.environments[t];if(r&&r.equals(e)){return t}}},programExpression:function(e){this.context.aliases.self="this";if(e==null){return"self.noop"}var t=this.environment.children[e],n=t.depths.list,r;var i=[t.index,t.name,"data"];for(var s=0,o=n.length;s<o;s++){r=n[s];if(r===1){i.push("depth0")}else{i.push("depth"+(r-1))}}return(n.length===0?"self.program(":"self.programWithDepth(")+i.join(", ")+")"},register:function(e,t){this.useRegister(e);this.pushSource(e+" = "+t+";")},useRegister:function(e){if(!this.registers[e]){this.registers[e]=true;this.registers.list.push(e)}},pushStackLiteral:function(e){return this.push(new u(e))},pushSource:function(e){if(this.pendingContent){this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));this.pendingContent=undefined}if(e){this.source.push(e)}},pushStack:function(e){this.flushInline();var t=this.incrStack();if(e){this.pushSource(t+" = "+e+";")}this.compileStack.push(t);return t},replaceStack:function(e){var t="",n=this.isInline(),r,i,s;if(n){var o=this.popStack(true);if(o instanceof u){r=o.value;s=true}else{i=!this.stackSlot;var a=!i?this.topStackName():this.incrStack();t="("+this.push(a)+" = "+o+"),";r=this.topStack()}}else{r=this.topStack()}var f=e.call(this,r);if(n){if(!s){this.popStack()}if(i){this.stackSlot--}this.push("("+t+f+")")}else{if(!/^stack/.test(r)){r=this.nextStack()}this.pushSource(r+" = ("+t+f+");")}return r},nextStack:function(){return this.pushStack()},incrStack:function(){this.stackSlot++;if(this.stackSlot>this.stackVars.length){this.stackVars.push("stack"+this.stackSlot)}return this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var e=this.inlineStack;if(e.length){this.inlineStack=[];for(var t=0,n=e.length;t<n;t++){var r=e[t];if(r instanceof u){this.compileStack.push(r)}else{this.pushStack(r)}}}},isInline:function(){return this.inlineStack.length},popStack:function(e){var t=this.isInline(),n=(t?this.inlineStack:this.compileStack).pop();if(!e&&n instanceof u){return n.value}else{if(!t){if(!this.stackSlot){throw new o("Invalid stack pop")}this.stackSlot--}return n}},topStack:function(e){var t=this.isInline()?this.inlineStack:this.compileStack,n=t[t.length-1];if(!e&&n instanceof u){return n.value}else{return n}},quotedString:function(e){return'"'+e.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},setupHelper:function(e,t,n){var r=[],i=this.setupParams(e,r,n);var s=this.nameLookup("helpers",t,"helper");return{params:r,paramsInit:i,name:s,callParams:["depth0"].concat(r).join(", "),helperMissingParams:n&&["depth0",this.quotedString(t)].concat(r).join(", ")}},setupOptions:function(e,t){var n=[],r=[],i=[],s,o,u;n.push("hash:"+this.popStack());if(this.options.stringParams){n.push("hashTypes:"+this.popStack());n.push("hashContexts:"+this.popStack())}o=this.popStack();u=this.popStack();if(u||o){if(!u){this.context.aliases.self="this";u="self.noop"}if(!o){this.context.aliases.self="this";o="self.noop"}n.push("inverse:"+o);n.push("fn:"+u)}for(var a=0;a<e;a++){s=this.popStack();t.push(s);if(this.options.stringParams){i.push(this.popStack());r.push(this.popStack())}}if(this.options.stringParams){n.push("contexts:["+r.join(",")+"]");n.push("types:["+i.join(",")+"]")}if(this.options.data){n.push("data:data")}return n},setupParams:function(e,t,n){var r="{"+this.setupOptions(e,t).join(",")+"}";if(n){this.useRegister("options");t.push("options");return"options="+r}else{t.push(r);return""}}};var f=("break else new var"+" case finally return void"+" catch for switch while"+" continue function this with"+" default if throw"+" delete in try"+" do instanceof typeof"+" abstract enum int short"+" boolean export interface static"+" byte extends long super"+" char final native synchronized"+" class float package throws"+" const goto private transient"+" debugger implements protected volatile"+" double import public let yield").split(" ");var l=a.RESERVED_WORDS={};for(var c=0,h=f.length;c<h;c++){l[f[c]]=true}a.isValidJavaScriptVariableName=function(e){if(!a.RESERVED_WORDS[e]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)){return true}return false};n=a;return n}(r,n);var c=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n.parser;var f=n.parse;var l=r.Compiler;var c=r.compile;var h=r.precompile;var p=i;var d=o.create;var v=function(){var e=d();e.compile=function(t,n){return c(t,n,e)};e.precompile=function(t,n){return h(t,n,e)};e.AST=u;e.Compiler=l;e.JavaScriptCompiler=p;e.Parser=a;e.parse=f;return e};o=v();o.create=v;s=o;return s}(s,o,a,f,l);return c}();

/*!
* imagesLoaded PACKAGED v4.1.1
* JavaScript is all like "You images are done yet or what?"
* MIT License
*/
!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});

!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x=document.all&&!window.atob,j={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded"},O=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,j),(0,b.default)(w,j.once),w},S=function(){w=(0,h.default)(),O()},_=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},E=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},z=function(e){return j=i(j,e),w=(0,h.default)(),E(j.disable)||x?_():(document.querySelector("body").setAttribute("data-aos-easing",j.easing),document.querySelector("body").setAttribute("data-aos-duration",j.duration),document.querySelector("body").setAttribute("data-aos-delay",j.delay),"DOMContentLoaded"===j.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?O(!0):"load"===j.startEvent?window.addEventListener(j.startEvent,function(){O(!0)}):document.addEventListener(j.startEvent,function(){O(!0)}),window.addEventListener("resize",(0,f.default)(O,50,!0)),window.addEventListener("orientationchange",(0,f.default)(O,50,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,j.once)},99)),document.addEventListener("DOMNodeRemoved",function(e){var t=e.target;t&&1===t.nodeType&&t.hasAttribute&&t.hasAttribute("data-aos")&&(0,f.default)(S,50,!0)}),(0,d.default)("[data-aos]",S),w)};e.exports={init:z,refresh:O,refreshHard:S}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),S?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return _?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,E&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(S=!!n.leading,_="maxWait"in n,y=_?x(u(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),S?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return _?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,E&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(S=!!n.leading,_="maxWait"in n,y=_?k(a(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){a.push({selector:e,fn:t}),!u&&r&&(u=new r(o),u.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})),o()}function o(){for(var e,t,n=0,o=a.length;n<o;n++){e=a[n],t=i.querySelectorAll(e.selector);for(var r,u=0,c=t.length;u<c;u++)r=t[u],r.ready||(r.ready=!0,e.fn.call(r,r))}}Object.defineProperty(t,"__esModule",{value:!0});var i=window.document,r=window.MutationObserver||window.WebKitMutationObserver,a=[],u=void 0;t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){e=e||document.querySelectorAll("[data-aos]");var t=[];return[].forEach.call(e,function(e,n){t.push({node:e})}),t};t.default=n}])});
//# sourceMappingURL=aos.js.map


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },

  // from https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
  handleize: function (str) {
    str = str.toLowerCase();

    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    str = str.replace(/\W+/g, "-");

    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str
  },

  /**
   * https://davidwalsh.name/javascript-debounce-function
   *
   * Returns a function, that, as long as it continues to be invoked, will not
   * be triggered. The function will be called after it stops being called for
   * N milliseconds. If `immediate` is passed, trigger the function on the
   * leading edge, instead of the trailing.
   */
  debounce: function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $images = $('.rte img:not(.dewrap)');
    var $videos = $('.rte video');
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $images.each(function() {
      $(this).wrap('<div class="rte__image-wrapper"></div>');
    });

    $videos.each(function() {
      $(this).wrap('<div class="rte__mp4-video-wrapper"></div>');
    });

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      if (!found) {
        let foundSingleOption = false;
        variants.forEach(function(variant) {
          selectedValues.forEach(function(option) {
            if (option.value === variant[option.index]) {
              foundSingleOption = option.value;
            }
          });
        });

        let optionChangeVal = false;
        let optionToChange = false;
        variants.forEach(function(variant) {
          if (variant.option1 === foundSingleOption || variant.option2 === foundSingleOption) {
            found = variant;
            optionChangeVal = variant.option1 === foundSingleOption ? variant.option2 : variant.option1;
            optionToChange = variant.option1 === foundSingleOption ? 'option2' : 'option1';
          }
        });

        if (this.$container.data('section-type') == 'product-grid-item') {
          this.$container.find(`[data-value="${optionChangeVal}"]`).click()
        } else {

          const labelSelector = '[data-swatch-label-value]';
          let labelValue = $(labelSelector).html();
          $('[data-swatch-label-value]').html(labelValue);
          $('select[id^="SingleOptionSelector"][id$="--cloned"]').val(optionChangeVal).trigger('change');
          $('select[id^="SingleOptionSelector"][id$="--cloned"]').niceSelect('update');
        }
      }
      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      if (window.shopUS || window.shopCA) {
        $('input#shop-pay-input, input[name="product-id"]').val(variant.id);
        $('shopify-payment-terms').attr('variant-id', variant.id);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      if (window.location.href.split(variant.id)[1] && window.location.href.split(variant.id)[1].length > 0) {
        window.utm = window.utm.length != 0 ? window.utm : window.location.href.split(variant.id)[1];
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id + window.utm;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      if (!$(this.originalSelectorId, this.$container)[0]) {
        $(this.originalSelectorId)[0].value = variant.id;
      } else {
        $(this.originalSelectorId, this.$container)[0].value = variant.id;
      }
    }
  });

  return Variants;
})();

/*======== Custom Helper Functions ===========*/

const medium = 768;
function mediumDown() {
  return $(window).width() < medium;
}
const large = 990;
function largeDown() {
  return $(window).width() < large;
}
function headerHeight() {
  return mediumDown() ? Math.round($('.header-wrapper').outerHeight()) : Math.round($('.header-wrapper').outerHeight()) - 1;
}
/*================ Templates ================*/


theme.equalHeight = function() {
  var $columns = $('.equalHeightColumn');
  $columns.height('initial');
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

theme.navClick = function() {
  $('.nav--mobile .accessibleNav .grandparent > a, .nav--mobile .accessibleNav .parent > a.nav__caret, .nav--mobile .accessibleNav .grandparent > a[href="#"], .nav--mobile .accessibleNav .parent > a[href="#"]').on('click', function(event){
    event.preventDefault();
    var $mainMenu = $(this).closest('.main-menu');
    var $dropdownLi = $(this).closest('li');
    var $dropdownCarat = $dropdownLi.children( '.nav__caret' );
    var $currentExpandedLi = $('.nav--mobile .main-menu>li.nav__item.main-menu--expanded');
    var $currentDropDownCarat = $currentExpandedLi.children( '.nav__caret' );
    if ($currentExpandedLi.length && !$dropdownLi.hasClass('main-menu--expanded')) {
      $currentExpandedLi.removeClass('main-menu--expanded');
      $currentDropDownCarat.attr('aria-expanded', $dropdownCarat.attr('aria-expanded')=='false' ? 'true' : 'false');
    } else {
      $mainMenu.toggleClass('sub-menu--expanded');
    }
    //$mainMenu.toggleClass('sub-menu--expanded');
    $dropdownLi.toggleClass('main-menu--expanded');
    $dropdownCarat.attr('aria-expanded', $dropdownCarat.attr('aria-expanded')=='false' ? 'true' : 'false');
  });
  $('.menuToggle').on('click', function(event){
    event.preventDefault();
    $('.header-menu').toggleClass('main-menu--expanded');
    $('.header-search').toggleClass('main-menu--expanded');
    $('.header-wrapper').toggleClass('main-menu--expanded');
    var $toggle = $(this);
    $toggle.attr('aria-expanded', $toggle.attr('aria-expanded')=='false' ? 'true' : 'false');
    theme.updateMobileNavAriaHidden();
  });
};

theme.delayNav = function() {
  var hoverTimeout;
  var $agingGrandparent;
  $('.nav--desktop .grandparent').hover(function() {
    if(typeof $agingGrandparent != 'undefined') {
      $agingGrandparent.removeClass('hover');
      $agingGrandparent.find( ' > .nav__link' ).attr('aria-expanded','false');
    }
    window.clearTimeout(hoverTimeout);
    var $grandparent = $(this);
    $grandparent.addClass('hover');
    $grandparent.find( ' > .nav__link' ).attr('aria-expanded','true');
    theme.updateMobileNavAriaHidden();

  },function() {
    $agingGrandparent = $(this);
    hoverTimeout = window.setTimeout(function() {
      $agingGrandparent.removeClass('hover');
      $agingGrandparent.find( ' > .nav__link' ).attr('aria-expanded','false');
      theme.updateMobileNavAriaHidden();
    },250);
  });
};

theme.ariaHover = function() {
  $('.nav--desktop .parent').hover(
    function() {
      $(this).children('.nav__link').attr('aria-expanded','true');
      theme.updateMobileNavAriaHidden();
    },
    function() {
      $(this).children('.nav__link').attr('aria-expanded','false');
      theme.updateMobileNavAriaHidden();
    }
  );
};

theme.lazyImage = function() {
  document.addEventListener('lazyloaded', function(e){
    $(e.target).parent('.lazy-image').css( "background-image", "none" );
  });
};

theme.tabletMenu = function() {
  if (Modernizr.touch){
    $('.nav--desktop .grandparent > a.nav__link, .nav--desktop .main-menu > .parent > a.nav__link').on( 'click', function(event){
      if ( $(this).parent().hasClass('hover') ){
        $(this).parent().removeClass('hover');
        $(this).attr('aria-expanded','false');
      } else{
        event.preventDefault();
        $('.grandparent, .parent').removeClass('hover');
        $(this).parent().addClass('hover');
        $(this).attr('aria-expanded','true');
      }
      theme.updateMobileNavAriaHidden();
    });
  }
};

theme.smoothScroll = function() {
  const noScrollElements = '.grid__link, .js-toggle-compare-modal';
  $(`a[href*="#"]:not([href="#"]):not(${noScrollElements})`).click(function(event) {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
       if (target.length) {
         event.preventDefault();
         var offset = target.attr('data-scroll-offset') ? Number(target.attr('data-scroll-offset')) : 0;
         $('html,body').animate({
          scrollTop: target.offset().top + offset
        }, 1000);
      }
    }
  });
};
const navBreakpoint = window.shopUS || window.shopCA ? 1340 : 1200;
theme.detectNav = function(){
  /*
  var navWidth = $('.nav--desktop .main-menu').outerWidth();
  var logoWidth = $('.logo-wrapper').outerWidth();
  var widthLimit = $('.site-header .wrapper').width();
  var totalWidth = navWidth + logoWidth;

  if ( totalWidth < widthLimit || navBreakpoint && window.innerWidth > navBreakpoint ){
    $('.header-wrapper, .site-header, .info-bar').addClass('showDesktop');
    $('.header-wrapper, .site-header, .info-bar').removeClass('showMobile');
  }
  else {
    navBreakpoint = window.innerWidth;
    console.log(navBreakpoint)
    $('.header-wrapper, .site-header, .info-bar').addClass('showMobile');
    $('.header-wrapper, .site-header, .info-bar').removeClass('showDesktop');
  }
  */

  if ( window.innerWidth > navBreakpoint ) {
    $('.header-wrapper, .site-header, .info-bar').addClass('showDesktop');
    $('.header-wrapper, .site-header, .info-bar').removeClass('showMobile');
  } else {
    $('.header-wrapper, .site-header, .info-bar').addClass('showMobile');
    $('.header-wrapper, .site-header, .info-bar').removeClass('showDesktop');
  }

  theme.updateMobileNavAriaHidden();
};

/**
 * When the mobile drawer nav is open, or a desktop nav mega-menu / dropdown is
 * open, hide main content and footer from the accessibility tree so screen
 * readers do not traverse page content behind the overlay.
 */
theme.updateMobileNavAriaHidden = function () {
  var $main = $('main.main-content');
  var $footer = $('footer.footer');
  var $beforeMain = $main.prev('[id^="shopify-section-"]');
  if (!$main.length && !$footer.length && !$beforeMain.length) {
    return;
  }

  var mobileMenuOpen =
    $('.header-wrapper').hasClass('main-menu--expanded') &&
    $('.header-wrapper').hasClass('showMobile');

  var desktopDropdownOpen =
    $('.header-wrapper').hasClass('showDesktop') &&
    $('.nav--desktop .nav__link[aria-expanded="true"]').length > 0;

  var overlayOpen = mobileMenuOpen || desktopDropdownOpen;

  if (overlayOpen) {
    $main.attr('aria-hidden', 'true');
    $footer.attr('aria-hidden', 'true');
    $beforeMain.attr('aria-hidden', 'true');

    if (mobileMenuOpen) {
      var active = document.activeElement;
      if (
        active &&
        (($main.length && $main.has(active).length) ||
          ($footer.length && $footer.has(active).length) ||
          ($beforeMain.length && $beforeMain.has(active).length))
      ) {
        $('.nav--mobile .menuToggle.header-hamburger').first().focus();
      }
    }
  } else {
    $main.removeAttr('aria-hidden');
    $footer.removeAttr('aria-hidden');
    $beforeMain.removeAttr('aria-hidden');
  }
};

theme.updateShopifyAccountVars = function() {
  var $header = $('.header-wrapper');
  var $accounts = $header.find('shopify-account');
  if (!$accounts.length) return;

  var isInverse = $header.hasClass('inverse') &&
    !$header.hasClass('scrolled') &&
    !$header.hasClass('main-menu--expanded') &&
    !$header.hasClass('header-hover');

  var inverseVars = {
    '--shopify-account-signed-in-avatar-color-background': '#5433eb',
    '--shopify-account-signed-in-avatar-color-text': 'white',
    '--shopify-account-color-accent': 'white',
    '--shopify-account-color-accent-text': 'white',
    '--shopify-account-color-shadow': 'rgb(255 255 255 / 1)'
  };
  var defaultVars = {
    '--shopify-account-signed-in-avatar-color-background': '#5433eb',
    '--shopify-account-signed-in-avatar-color-text': 'white',
    '--shopify-account-color-accent': 'white',
    '--shopify-account-color-accent-text': 'white',
    '--shopify-account-color-shadow': 'rgb(255 255 255 / 1)'
  };

  var vars = isInverse ? inverseVars : defaultVars;
  $accounts.each(function() {
    var el = this;
    Object.keys(vars).forEach(function(key) {
      el.style.setProperty(key, vars[key]);
    });
  });
};

theme.fullHeight = function(){
  var windowHeight = $(window).height();
  var navHeight = ($('.header-wrapper').height());
  var heroHeight = windowHeight;
  if( !$('.header-wrapper').hasClass('fixed') ) {
    heroHeight -= navHeight;
  }
  $('.index-sections > .shopify-section:first-child > .use_screen_full').height(heroHeight).css('min-height', 'initial');
  $('.index-sections > .shopify-section:first-child > .use_screen_full.homepage-slideshow .slideshow__slide').height(heroHeight);
  $('.index-sections > .shopify-section:first-child > .use_screen_full.homepage-double .double__block').height(heroHeight);
};

theme.contentOverflow = function(){
  $('.preventOverflow').css('min-height', function() {
    var contentHeight = $(this).find('.preventOverflowContent').height();
    return (contentHeight + 30);
  });
};

theme.heightOverride = function(){
  if ((/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
    $( '.use_screen_full, .use_screen_three_quarters, .use_screen_two_thirds, .use_screen_one_half, .use_screen_one_third, .use_screen_one_fifth').css('height', function() {
      return $(this).css('height');
    }, 'important');
    $( '.use_screen_full .slideshow__slide, .use_screen_three_quarters .slideshow__slide, .use_screen_two_thirds .slideshow__slide, .use_screen_one_half .slideshow__slide, .use_screen_one_third .slideshow__slide').css('height', function() {
      return $(this).css('height');
    }, 'important');

    $( '.use_screen_full .double__block, .use_screen_three_quarters .double__block, .use_screen_two_thirds .double__block, .use_screen_one_half .double__block, .use_screen_one_third .double__block, .use_screen_one_fifth .double__block').css('height', function() {
      return $(this).css('height');
    }, 'important');
  }
};

theme.matchHeight = function(){
  $('.equalOverflowHeight').css('min-height', function() {
    var blockHeights = $('.preventOverflowContent', $(this) ).map(function() {
      return $(this).height();
    }).get();
    var tallest = Math.max.apply(null, blockHeights);
    return (tallest + 30);
  });
};

theme.productModal = function() {

  Shopify.productModal = {
    open: function( id ) {
      let $modal = $(id),
          $modalToggle = $(`[product-modal-toggle][data-toggle="${id}"]`),
          $slide = $modalToggle.closest('.slick-slide'),
          $slider = $modalToggle.closest('.slick-slider');
      if( $slide.length && !$slide.hasClass(`slick-current`) ) {
        let slickIndex = parseInt( $slide.attr('data-slick-index') );
        $slider.slick('goTo', slickIndex);
      }
      if( $modal.length ) {
        $modal.addClass('in');
      }
      if( $modalToggle.length ) {
        $modalToggle.removeClass('collapsed');
      }
    },
    close: function( id ) {
      if( id === undefined ) {
        $('[product-modal]').removeClass('in');
        $('[product-modal-toggle]').addClass('collapsed');
      }
      var $modal = $(id),
          $modalToggle = $('[product-modal-toggle][data-toggle="' + id + '"]');
      if( $modal.length ) {
        $modal.removeClass('in');
      }
      if( $modalToggle.length ) {
        $modalToggle.addClass('collapsed');
      }
    },
    toggle: function( id ) {
      var $modal = $(id);
      if( !$modal.length ) {
        return;
      }
      if( $modal.hasClass('in') ) {
        Shopify.productModal.close( id );
      } else {
        Shopify.productModal.open( id );
      }
    }
  };

  $('body').on('click', '[product-modal-toggle]', function(e){
    e.preventDefault();
    var modalSelector = $(this).attr('data-toggle');
    Shopify.productModal.toggle(modalSelector);
  });
};

theme.klaviyoForm = function() {
  var selectors = {
    form: '[klaviyo-form]',
    inputs: '[klaviyo-form-inputs]',
    success: '[klaviyo-form-success]',
    error: '[klaviyo-form-error]'
  };

  $.getScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js', function() {
    KlaviyoSubscribe.attachToForms(selectors.form, {
      hide_form_on_success: true,
      custom_success_message: true
    });
  });

  $(document).on('klaviyo.subscribe.success', selectors.form, function() {
    var $form = $(this),
        eventLabel = $form.attr('data-event-label');

    if( typeof( gtag ) !== 'undefined' ) {
      gtag(
        'event', 'Complete Registration', {
        'event_category': 'Klaviyo Form Subscription',
        'event_label': eventLabel,
        'value': 1
      });
    }

    $form.find( selectors.inputs ).hide();
    $form.find( selectors.success ).show();
  });

  $(document).on('klaviyo.subscribe.error', selectors.form, function() {
    var $form = $(this);
    $form.find( selectors.inputs ).hide();
    $form.find( selectors.error ).show();
  });
};

theme.currencySelector = function() {
  var $currencySelect = $('[data-currency-selector] select');

  var updateCurrent = function( $select ) {
    var val = $select.val(),
        $container = $select.closest('[data-currency-selector]');
    $container.find('.nice-select > .current').attr('data-value', val);
  };

  $currencySelect.on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });

  if( $().niceSelect !== undefined ) {
    $currencySelect.each(function(){
      $(this)
        .niceSelect()
        .on('change', function(){
          updateCurrent( $(this) );
        });

      var $container = $(this).closest('[data-currency-selector]');
      $container.addClass('in');
    });

    updateCurrent( $currencySelect );
  }
};

theme.getCartItemCount = function(cart) {
  if( cart === undefined ) {
    return 0;
  }
  var cartItemCount = cart.item_count;

  for ( var i=0 ; i<cart.items.length ; i ++ ) {
    var item = cart.items[i];
    if( item.sku == 'nested_Product' ) {
      cartItemCount -= item.quantity;
    }
  }
  return cartItemCount;
};

theme.countdownTimer = function() {
  $(`[countdown-timer]`).each(function(){
    let $countdownTimer = $(this),
        timestamp = $countdownTimer.attr(`data-timestamp`),
        compareDate = new Date(timestamp * 1000);

    setInterval(function(){
      var currentDate = new Date(),
          diffSecs = Math.floor((compareDate - (currentDate))/1000),
          diffMins = Math.floor(diffSecs/60),
          diffHrs = Math.floor(diffMins/60),
          diffDays = Math.floor(diffHrs/24);
          // counterStringHours = (diffHrs<10) ? '0'+diffHrs : diffHrs;

    console.log({
      'diffSecs': diffSecs
    });

    if( diffSecs < 0 ) {
      $countdownTimer.removeClass('in');
      return;
    }

    $countdownTimer.addClass('in');
      diffHrs = diffHrs-(diffDays*24);
      diffMins = diffMins-(diffDays*24*60)-(diffHrs*60);
      diffSecs = diffSecs-(diffDays*24*60*60)-(diffHrs*60*60)-(diffMins*60);

      let counterStrinDays = (diffDays<10) ? '0'+diffDays : diffDays,
          counterStringHours = (diffHrs<10) ? '0'+diffHrs : diffHrs,
          counterStringMins = (diffMins<10) ? '0'+diffMins : diffMins,
          counterStringSecs = (diffSecs<10) ? '0'+diffSecs : diffSecs;

      $countdownTimer.find(`[countdown-timer-days] [countdown-timer-value]`).html( counterStrinDays );
      $countdownTimer.find(`[countdown-timer-hrs] [countdown-timer-value]`).html( counterStringHours );
      $countdownTimer.find(`[countdown-timer-mins] [countdown-timer-value]`).html( counterStringMins );
      $countdownTimer.find(`[countdown-timer-secs] [countdown-timer-value]`).html( counterStringSecs );
    }, 1000);
  })
};


theme.init = function () {
  theme.ariaHover();
  theme.lazyImage();
  theme.equalHeight();
  theme.matchHeight();
  theme.navClick();
  theme.delayNav();
  theme.smoothScroll();
  theme.detectNav();
  theme.tabletMenu();
  theme.fullHeight();
  theme.contentOverflow();
  theme.heightOverride();
  theme.productModal();
  theme.klaviyoForm();
  theme.currencySelector();
  theme.countdownTimer();
};

$(window).resize(function() {
  theme.detectNav();
  theme.contentOverflow();
  theme.equalHeight();
  theme.matchHeight();
  theme.fullHeight();
  theme.heightOverride();
}).resize();

$('.logo-image').imagesLoaded(function() {
  $(window).resize();
});

$(window).on("load", function () {
  $(window).resize();
});


$(theme.init);

/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains code for the Customer Addresses template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddAddress');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains code for the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {

    var emailValue = $('#CustomerEmail').val();
    $('#RecoverEmail').val(emailValue);
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Password Page
 * ------------------------------------------------------------------------------
 * Login modal for the password page
 *
 */


theme.passwordPage = (function() {
  $('.js-toggle-login-modal').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    closeOnBgClick: false,
    closeBtnInside: false,
    closeOnContentClick: false,
    tClose: 'x',
    removalDelay: 500,
    callbacks: {
      open: function() {
        window.setTimeout( function() { document.getElementById('password').focus(); }, 50 );
      },
      close: function() {
        window.setTimeout( function() { document.getElementById('email').focus(); }, 50 );
      }
    }
  });
  if ( $('.storefront-password-form .errors').length ) {
    $('.js-toggle-login-modal').click();
  }
})();


/*================ Sections ================*/
theme.Accordion = (function() {
  function Accordion(container) {
    var $container = this.$container = $(container);

    $container.find('[accordion-toggle]').click(function() {
      var $accordionItem = $(this).closest('[accordion-item]'),
          $accordionContent = $accordionItem.find('[accordion-content]'),
          $accordionIcon = $accordionItem.find('[accordion-icon]');

      if( $accordionContent.is(':visible') ){
        $accordionContent.slideUp('fast');
        $accordionItem.removeClass('in');
        $accordionIcon.removeClass('icon-minus').addClass('icon-plus');
      } else {
        $accordionContent.slideDown('fast');
        $accordionItem.addClass('in');
        $accordionIcon.removeClass('icon-plus').addClass('icon-minus');
      }
    });
  }

  Accordion.prototype = _.assignIn({}, Accordion.prototype, {});

  return Accordion;
})();
function roundPrices() {
  const priceSelector = `data-line-item-price`;
  if( Shopify.currency.active !== 'CAD' ) {
    $container.find(`[${priceSelector}]`).addClass('in');
    return;
  }

  $container.find(`[${priceSelector}]`).each(function(){
    const value = parseInt( $(this).attr(priceSelector)/100 );
    $(this).html(`$${value}`).addClass('in');
  });
}
function motivator(cart, trigger) {
  var $progress = $container.find('.cart__motivator--progress-bar-active');
  var subTotal = cart.total_price / 100;
  var threshold = motivator_threshold;
  var remaining = Math.round(threshold - subTotal);
  var motivatorMsg = motivator_msg;
  var motivatorUnlocked = motivator_unlocked;
  var $motivatorText = $('.cart__motivator--text');
  var percentage = 100 - (remaining / threshold * 100);
  var displayMsg;
  var giftAdded = cart ? cart.attributes['Gift Added'] : null;
  var giftID = motivator_gift_id;
  var hasGift = false;
  if (cart) {
    cart.items.forEach(() => {
      if (this.id == giftID && this.final_line_price == 0) {
        hasGift = true;
      }
    });
  }
  if (remaining > 0) {
    displayMsg = motivatorMsg.replace('[currency]', window.defaultCurrencySymbol).replace('[quantity]', remaining);
    $progress.css('width', `${percentage}%`);
    if (giftAdded != 'false') {
      $.ajax ({
        url: window.nonEnglish ? `/${window.langCode}/cart/update.js` : '/cart/update.js',
        dataType:'json',
        data: { attributes: { 'Gift Added': 'false' } },
        complete: function(){
          if (trigger == 'upsell' || trigger == 'qty') $container.trigger('refresh');
        }
      });
    } else {
      if (trigger == 'upsell' || trigger == 'qty') $container.trigger('refresh');
    }
  } else {
    displayMsg = motivatorUnlocked;
    $progress.css('width', '100%');
    // Add Gift Item
    if (!hasGift && giftAdded != 'true') {
      var formObject = {};
      var items = [];
      items.push({quantity: 1, id: giftID});
      formObject = {
        items: items,
        attributes: { 'Gift Added': 'true' }
      }
      $.ajax({
        type: 'POST',
        url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
        dataType: 'json',
        data: formObject,
        complete: function(){
          $container.trigger('refresh');
        }
      });
    } else {
      $container.trigger('refresh');
    }
  }
  $motivatorText.text(displayMsg);
}
theme.CartMotivator = (function() {
  var $container = $('[data-section-type="cart-motivator"]');
  if (!$container.length) return;
  $(document).on('update_motivator', function(event, data) {
    updateMotivator(data);
    if (!$('.cart__motivator--section').hasClass('hide-on-cart')) {
    $('.cart--page').find('.cart__body').before($('.cart__motivator--section').clone());
    $('.section-cart-motivator').addClass('hide');
    $('.cart--page .cart__motivator--section').addClass('in');
    } else {
      $('.cart--page .cart__motivator--section').removeClass('in');
    }
  });
  updateMotivator();
  if ($('body').hasClass('template-cart')) {
    if (!$('.cart__motivator--section').hasClass('hide-on-cart')) {
      $('.cart--page').find('.cart__body').before($container.clone());
      if (cart.items.length) {
        $('.cart--page [data-section-type="cart-motivator"]').addClass('in');
      } else {
        $('.cart--page [data-section-type="cart-motivator"]').addClass('hide');
      }
    } else {
      $container.removeClass('in');
    }
  } else {
    $container.addClass('in');
  }
  function updateMotivator(data) {
    var motivatorData = JSON.parse($container.find('[data-motivator]').html()),
        tier1Amount = motivatorData.tier_1_amount * 100,
        tier2Amount = motivatorData.tier_2_amount * 100,
        midFraction = motivatorData.mid_fraction,
        $msgEl = $container.find('[data-motivator-msg]'),
        cartTotal = data?.subTotal ? data.subTotal : cart.total_price,
        cartDifferenceTier1 = tier1Amount - cartTotal,
        cartDifferenceTier2 = tier2Amount - cartTotal,
        cartDiffPercentage = cartTotal / tier2Amount * 100,
        $barActive = $container.find('.cart__motivator--progress-bar-active'),
        $midNotch = $container.find('.cart__motivator--tier-mid-notch'),
        $endNotch = $container.find('.cart__motivator--tier-end-notch'),
        $btn = $container.find('.cart__motivator--btn'),
        $midText = $container.find('.cart__motivator--tier-mid'),
        $midAmt = $container.find('.cart__motivator--tier-mid-amt'),
        $endAmt = $container.find('.cart__motivator--tier-end-amt'),
        $endText = $container.find('.cart__motivator--tier-end'),
        giftAdded = data?.freeItem ? data.freeItem : cart?.items.find(item => item.discounted_price == 0) && cart;

    $midAmt.html(slate.Currency.formatMoney(tier1Amount, theme.moneyFormat));
    $endAmt.html(slate.Currency.formatMoney(tier2Amount, theme.moneyFormat));

    $midAmt.css('left', `${midFraction}%`);
    $midText.css('left', `${midFraction}%`);
    cartDifferenceTier1 < 0 ? midAddClass() : midRemoveClass();
    cartDifferenceTier2 < 0 ? endAddClass() : endRemoveClass();
    $barActive.css('width', (cartDifferenceTier2 < 0 ? 100 : cartDiffPercentage) + '%');

    if (cartDifferenceTier1 > 0) {
      $msgEl.html(motivatorData.motivator_message_1.replace('[amount]', slate.Currency.formatMoney(cartDifferenceTier1, theme.moneyFormat)));
      $btn.attr('href', motivatorData.tier_1_btn_link);
    } else if (cartDifferenceTier2 > 0) {
      $msgEl.html(motivatorData.motivator_message_2.replace('[amount]', slate.Currency.formatMoney(cartDifferenceTier2, theme.moneyFormat)));
      $btn.attr('href', motivatorData.tier_1_btn_link);
    } else {
      $msgEl.html(motivatorData.motivator_message_3);
      $btn.attr('href', motivatorData.tier_2_btn_link);
    }

    if (giftAdded && cartTotal > tier1Amount) {
      $btn.text(motivatorData.gift_added_btn_text);
      $btn.addClass('gift-added');
    } else {
      $btn.text(motivatorData.default_btn_text);
    }

    function midAddClass() {
      $midNotch.addClass('active');
      $midAmt.addClass('active');
      $midText.addClass('active');
    }
    function midRemoveClass() {
      $midNotch.removeClass('active');
      $midAmt.removeClass('active');
      $midText.removeClass('active');
    }
    function endAddClass() {
      $endNotch.addClass('active');
      $endAmt.addClass('active');
      $endText.addClass('active');
    }
    function endRemoveClass() {
      $endNotch.removeClass('active');
      $endAmt.removeClass('active');
      $endText.removeClass('active');
    }
  }
})();
theme.Cart = (function() {
  function Cart(container) {
    var $container = this.$container = $(container),
        instance = this,
        id = this.id = $container.attr('data-section-id');

    this.init();
    this.upsell();
    this.lineItemPriceRounding();
    //this.shippingInsurance();
    if (motivator_gift_id != 0) {
      $(window).on('load', function(){ motivator(cart) });
    }
    let scope = this;
    $container
      .on('refresh', function(){
        $.get('/cart?view=ajax')
         .done(function(data) {
          // data-cart-additional -- we move the section-settings generated
          // markup around because it cannot be included in our ajax request
          let cartContent = $(data).find(`[data-ajax-cart-wrapper]`).html();
          $('[data-ajax-cart-wrapper]').empty().html(cartContent);
          // $('[data-ajax-cart-wrapper]').empty().html(data);
          $container.find('[data-cart-update]').hide();
          $container.trigger('updateBodyHeight');
          $container.trigger('initUpsell');
          if ($('.cart__motivator--section').length) {
            var cartData = {
              subTotal : $(data).find('[data-cart-subtotal]').data('subtotal'),
              freeItem : $(data).find('[data-line-item-price="0"]').length
            }
            $(document).trigger('update_motivator', cartData);
          }
          // $container.trigger('shippingInsurance.updatePrice');
          // $container.trigger('shippingInsurance.adjustCart');
          // $container.trigger('shippingInsurance.update');
          // document.dispatchEvent(new CustomEvent('cart:rerendered'));
          roundPrices();
        });
      })
      .on('click', '.js-qty__adjust', function(){
        var $element = $(this),
            $quantitySelector = $element.closest('.js-qty'),
            $quantityInput = $quantitySelector.find('.js-qty__num'),
            quantity = parseInt( $quantityInput.val() );

        if ($element.hasClass('js-qty__adjust--plus')){
          quantity += 1;
        } else {
          quantity = ( quantity<=1 ) ? 0 : quantity-1;
          if ($element.closest('.cart__item').hasClass('js-stickers-at-min')) {
            var $item = $element.closest('js-stickers-at-min');

            $item.addClass('disabled loading');

            var stickersItemKeys = [];

            $('.js-stickers-at-min').each(function(){
              stickersItemKeys.push($(this).data('id'));
            });

            var updateItems = {};
            stickersItemKeys.map(x => 
              updateItems[x] = 0
            );
            instance.changeQuantity('/cart/update.js', { updates: updateItems });
            return;
          }
        }
        $quantityInput.val(quantity).change();
      })
      .on('change', '.js-qty__num', $.debounce(500, function(){
        var $element = $(this),
            $item = $element.closest('.cart__item'),
            quantity = parseInt( $element.val() ),
            itemKey = $element.data('line-key');
        $item.addClass('disabled loading');
        instance.changeQuantity('/cart/change.js', quantity, itemKey);
      }));

    if( window.location.search.indexOf('devMode=1') !== -1 ) {
      $(`.cart__item--hidden`).show();
      console.log(`devMode`)
    }
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    init: function() {
      $container = this.$container;
      $container.on('click', '[data-cart-update]', function(){
        $container.find('[type="submit"][name="update"]').click();
      });
      $container.find('[data-cart-update]').hide();
    },

    changeQuantity: function(endpoint, quantity, id) {
      var instance = this;
      var data = endpoint == '/cart/update.js' ? quantity : {
        quantity: quantity,
        id: id
      }
      var params = {
        type: 'POST',
        url: endpoint,
        data: data,
        dataType: 'json',
        error: function(XMLHttpRequest, textStatus) {
          var $errors = $('[data-form-errors]');
          $errors.slideUp('fast');
          $errors.empty().html(XMLHttpRequest.responseJSON.description).slideDown('fast');
        },
        complete: function(jqxhr, text) {
          if (motivator_gift_id == 0) instance.$container.trigger('refresh');

          $.getJSON('/cart.js')
           .done(function(cart) {
            var cartItemCount  = theme.getCartItemCount(cart);

            if( cartItemCount == 0 ) {
              $('.cartCount').html(cartItemCount).addClass('hidden-count');
            } else {
              $('.cartCount').html(cartItemCount).removeClass('hidden-count');
            }
            if (motivator_gift_id != 0) motivator(cart, 'qty');
          });
        }
      }
      jQuery.ajax(params);
    },

    lineItemPriceRounding: function(){
      roundPrices();
    },
    upsell: function() {
      var $container = this.$container,
          selectors = {
            wrapper: '.swatch-wrapper',
            swatchList: '[data-swatch-list]',
            swatchItem: '[data-swatch-item]',
            swatchLink: '[data-swatch-link]',
            swatchValue: '[data-swatch-label-value]'
          };
      // Init swatch click handle
      $('body')
        .on('click', '[data-cart-form] ' + selectors.swatchLink, function(e){
          e.preventDefault();

          var val = $(this).data('value'),
              $upsellItem = $(this).closest('[data-upsell-item]'),
              $upsellThumb = $upsellItem.find('[data-upsell-thumb]'),
              $swatchWrapper = $(this).closest( selectors.wrapper ),
              $productSwatch = $swatchWrapper.find( selectors.swatchItem ),
              productObject = false,
              productVariantTitle = '',
              productId = $upsellItem.attr('data-product-id'),
              variant = false;

          // Update swatch label
          $swatchWrapper.find( selectors.swatchValue ).html(val);

          // Update swatch state
          $productSwatch.removeClass('active');
          $(this).closest( selectors.swatchItem ).addClass('active');


          if( !$upsellItem.find('[data-product-json][data-product-id="' + productId + '"]').length ) {
            return;
          }

          productObject = JSON.parse( $upsellItem.find('[data-product-json][data-product-id="' + productId + '"]').html() );

          $upsellItem.find('.swatch-wrapper').each(function(){
            var optionValue = $(this).find('[data-swatch-item].active > a').attr('data-value');
            if( typeof(optionValue) === 'undefined' ) {
              optionValue = $(this).find('[data-swatch-item]').first().find('> a').attr('data-value');
            }
            if( productVariantTitle != '' ) {
              productVariantTitle += ' / ';
            }
            productVariantTitle += optionValue;
          });

          for( var i=0 ; i<productObject.variants.length ; i++ ) {
            var v = productObject.variants[i];
            if( v.title == productVariantTitle ) {
              variant = v;
            }
          }

          if( variant ) {
            $upsellItem.attr('data-variant-id', variant.id);

            let featuredImage = productObject.featured_image;

            if( variant.featured_image && typeof( variant.featured_image.src ) !== 'undefined' ) {
              featuredImage = variant.featured_image.src;
            }
            let alt = variant.title ? productObject.title + ' - ' + variant.title : productObject.title;
            $upsellThumb
              .removeClass('loaded')
              .html('<img alt="'+ alt + '" src="' + featuredImage.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png').replace('.gif', '_120x.gif') + '" />')
              .find('img').imagesLoaded(function(){
                $upsellThumb.addClass('loaded');
              });
          }
        })
        .on('click', '[data-cart-form] [data-upsell-add]', function(e){
          e.preventDefault();
          e.stopPropagation();
          // if swatch is clicked, stop adding
          if( $(e.target).attr('data-swatch-link') !== undefined ||
              $(e.target).closest('[data-swatch-link]').length ) {
            return;
          }
          
          var $upsellItem = $(this).closest('[data-upsell-item]'),
              variantId = $upsellItem.attr('data-variant-id'),
              properties = {},
              data = {
                quantity: 1,
                id: variantId
              };
              properties['_cart upsell'] = variantId;
          if( $upsellItem.find('[data-upsell-variant-metafields]').length ) {
            var upsellVariantMetafields = JSON.parse( $upsellItem.find('[data-upsell-variant-metafields]').html() )

            if( upsellVariantMetafields &&
                typeof( upsellVariantMetafields[variantId] ) !== undefined &&
                typeof( upsellVariantMetafields[variantId]['preorder_ship_date'] ) !== undefined ) {

              if ( upsellVariantMetafields[variantId].inventory_quantity == 'none' &&
                   upsellVariantMetafields[variantId].inventory_policy == 'continue' ) {
                    properties['Estimated delivery'] = upsellVariantMetafields[variantId]['preorder_ship_date'];
              }
            }
          }

          if( properties != false ){
            data.properties = properties;
          }

          $.ajax({
            type: 'POST',
            url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
            dataType: 'json',
            data: data,
            error: function(){
              //console.log('error')
            },
            success: function(){
              // console.log('success')
            },
            complete: function(jqxhr, text) {
              if (motivator_gift_id == 0) $container.trigger('refresh');
              $.getJSON('/cart.js')
               .done(function(cart) {
                
                var cartItemCount  = theme.getCartItemCount(cart);
    
                if( cartItemCount == 0 ) {
                  $('.cartCount').html(cartItemCount).addClass('hidden-count');
                } else {
                  $('.cartCount').html(cartItemCount).removeClass('hidden-count');
                }
                if (motivator_gift_id != 0) motivator(cart, 'upsell');
              });
            }
          });
        });

      $container.on('initUpsell', function(){
        $container.find('[data-upsell-item]').each(function(){
          var $item = $(this),
              variantId = $item.attr('data-default-variant-id');
          if( $item.find('[data-swatch-link][data-variant-id="' + variantId + '"]').length ) {
            //$item.find('[data-swatch-item]').removeClass('active');
            $item.find('[data-swatch-link][data-variant-id="' + variantId + '"]').click();
          } else {
            $item.filter('.active').each(function(){
              $(this).find(' > [data-swatch-link]').click();
            })
          }
          $item.addClass('in');
        });
        $container.find('[data-product-grid-value="Size"]').each(function(){
          let swatchValue = $(this).find('span').html();
          let code = sizeSwatchCodes.find(element => element.value.toLowerCase() == swatchValue.toLowerCase())?.code;
          $(this).find('span').html(code);
        });
      });

      $(window).on('load', function(){
        $container.trigger('initUpsell');
      });
    }
  });

  return Cart;
})();

function loadYoutubeAPI(){
  if(!window.YoutubeAPILoading){
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    document.getElementsByTagName('head')[0].appendChild(tag);
    window.YoutubeAPILoading = true;
  }
}
function onYouTubeIframeAPIReady() {
  window.YoutubeAPILoaded = true;
  $('body').trigger('YoutubeAPILoaded');
}

theme.Video = (function() {
  function Video(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var $featuredImage = this.$featuredImage = $('#FeaturedImage-'+id);
    var featuredImageSelector = this.featuredImageSelector = '#FeaturedImage-'+id;
    var parallaxSliderSelector = this.parallaxSliderSelector = '#FeaturedImage-'+id + " .parallax-slider";
    var $autoplay = this.$autoplay = this.$container.find('[data-video-autoplay]');
    var $youtubeWrapper = this.$youtubeWrapper = this.$container.find('[data-youtube-wrapper]');
    var playerID = this.playerID = $youtubeWrapper.attr('id');
    theme.playersArray = [];


    function LoadYoutubeVideo(){
      theme.playersArray[playerID] = new YT.Player(playerID, {
        videoId: videoID,
        playerVars: {
          cc_load_policy: 0,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          autohide: 0,
          controls: 0,
          branding: 0,
          showinfo: 0,
          rel: 0,
          fs: 0,
          wmode: 'opaque'
        },
        events: {
          'onReady': onVideoReady,
          'onStateChange': onVideoStateChange
        }
      });
    }

    function onVideoReady(e) {
      e.target.mute();
      e.target.playVideo();
      $($currentVideo).on('mfpOpen', function() {
          e.target.pauseVideo();
      });
      $($currentVideo).on('mfpClose', function() {
          e.target.playVideo();
      });
    }

    function onVideoStateChange(e) {
      if (e.data == 0) {
        // video is over, replay
        e.target.playVideo();
      }
      if (e.data == 1) {
        // video is playing
        $autoplay.css('opacity', '1');
      }
    }

    if ( $autoplay.length ) {
      var videoID = $autoplay.attr('data-video-id');
      var videoType = $autoplay.attr('data-video-type');

      if ( videoType == 'vimeo'){
        var oembed_url = 'https://vimeo.com/api/oembed.json'
        var vimeo_url = 'https://vimeo.com/' + videoID;

        var params = {
          url: vimeo_url,
          background: true,
          muted: true,
          autoplay: true
        }
        $.getJSON(oembed_url, params, function(data) {
          $autoplay.html(data.html);
        })
      }
      else if ( videoType == 'youtube'){
        $autoplay.css('opacity', '0');
        loadYoutubeAPI();

        var player;
        if(window.YoutubeAPILoaded){
          LoadYoutubeVideo()
        }
        else{
          $('body').on('YoutubeAPILoaded', LoadYoutubeVideo)
        }
      }
    }

    if ($featuredImage.attr('data-parallax-src')) {
      $featuredImage.parallax({
        src: $featuredImage.data('parallax-src'),
        parallax: 'scroll',
        excludeAgents: /(none)/,
        mirrorSelector: featuredImageSelector
      });
      $.each( $(featuredImageSelector).data(), function(key,val){
        if (key == 'widths' ){
         val = "[" + val + "]"
        }
        var kebabKey = "data-" + key;
        kebabKey = kebabKey.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
        $(parallaxSliderSelector).attr( kebabKey,val);
      });
      $(parallaxSliderSelector).addClass('lazyload');

      var loadCount = 0;
      $(parallaxSliderSelector).on('load', function(){
        loadCount++;
        if (loadCount > 1){
          $featuredImage.css("background-image", '');
        }
      });
      setTimeout(function() {
        $featuredImage.css("background-image", '');
      }, 5000);
    }
  }


  Video.prototype = _.assignIn({}, Video.prototype, {
    onUnload: function() {
      if (this.$container.attr('data-img-src')) {
        this.$container.parallax('destroy');
      }
      var magnificObject = this.$container.find('.popupVideo')
      magnificObject.off('click.magnificpopup');
      magnificObject.removeData('magnificPopup');

      theme.playersArray[this.playerID].destroy();
    }
  });

  return Video;
})();

theme.Parallax = (function() {
  function Parallax(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var $featuredImage = this.$featuredImage = $('#FeaturedImage-'+id);
    var featuredImageSelector = this.featuredImageSelector = '#FeaturedImage-'+id;
    var parallaxSliderSelector = this.parallaxSliderSelector = '#FeaturedImage-'+id + " .parallax-slider";
    if ($container.hasClass('inverse-header') && !$('.header-wrapper').hasClass('inverse')) {
      $('.header-wrapper').addClass('inverse');
      theme.updateShopifyAccountVars();
    }
    if ($featuredImage.attr('data-parallax-src')) {
      $featuredImage.parallax({
        src: $featuredImage.data('parallax-src'),
        parallax: 'scroll',
        excludeAgents: /(none)/,
        mirrorSelector: featuredImageSelector
      });

      $.each( $(featuredImageSelector).data(), function(key,val){
        if (key == 'widths' ){
         val = "[" + val + "]"
        }
        var kebabKey = "data-" + key;
        kebabKey = kebabKey.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
        $(parallaxSliderSelector).attr( kebabKey,val);
      });

      $(parallaxSliderSelector).addClass('lazyload');

      var loadCount = 0;
      $(parallaxSliderSelector).on('load', function(){
        loadCount++;
        if (loadCount > 1){
          $featuredImage.css("background-image", '');
        }
      });

      setTimeout(function() {
        $featuredImage.css("background-image", '');
      }, 5000);
    }
    $featuredImage.each(function(){
      var alt = $(this).attr('alt');
      $featuredImage.find('.parallax-slider').attr('alt', alt);
    });
    // var defaultSrc = $(parallaxSliderSelector).attr( 'src' ),
    //     defaultSrcset = $(parallaxSliderSelector).attr( 'srcset' );
    // $(parallaxSliderSelector).attr('desktop-src', defaultSrc);
    // $(parallaxSliderSelector).attr('desktop-srcsrc', defaultSrcset);

    // // Responsive
    // $(window).resize(slate.utils.debounce(function(){
    //   console.log('resize debounce');

    //   var srcset = $(container).find('.background-size-cover.small-down--hide').attr('data-bgset');
    //   if( $(window).width() < 768 ) {
    //     srcset = $(container).find('.background-size-cover.medium--hide.medium-up--hide').attr('data-bgset');
    //   }

    //   $(parallaxSliderSelector)
    //     .attr('srcset', srcset);

    // }, 500));
  }

  Parallax.prototype = _.assignIn({}, Parallax.prototype, {
    onUnload: function() {
      if (this.$featuredImage.attr('data-img-src')) {
        this.$featuredImage.parallax('destroy');
      }
    }
  });

  return Parallax;
})();

theme.Header = (function() {
  function Header(container) {
    var $container = this.$container = $(container),
        id = this.id = $container.attr('data-section-id'),
        lastScrollTop = this.lastScrollTop = 0;

    this.init();
    this.scrollDetect();
    this.extendMenuToggle();
    this.initLogoAnimation();
    this.overlayClickHandle();
    this.search();

  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    init: function() {
    },
    scrollDetect: function() {
      var $container = this.$container;

      $(window).scroll(function(){
        if( $(window).scrollTop() > 1 ) {
          $container.addClass('scrolled');
        } else {
          $container.removeClass('scrolled');
        }
      });
    },
    extendMenuToggle:function() {
      var $container = this.$container,
          $navMobile = $container.find('.nav--mobile');

      $container.find('.menuToggle').on('click', function(event){
        $target = $(event.target);

        var expanded = ($target.attr('aria-expanded') == 'true'),
            windowHeight = window.innerHeight ? window.innerHeight : $(window).height(),
            menuMaxHeight = windowHeight - $navMobile.find('.mobile-wrapper').outerHeight();

        //console.log('expanded = ' + expanded);

        if( expanded ) {
          $navMobile.find('.header-menu').css('max-height', menuMaxHeight);
        } else {
          $navMobile.find('.header-menu').css('max-height', '');
        }

      });
    },
    initLogoAnimation: function() {
      var lastScrollTop = this.lastScrollTop;
      var $headerLogo = $('.header-logo');

      $(window).scroll(function() {
        // https://stackoverflow.com/questions/4326845/how-can-i-determine-the-direction-of-a-jquery-scroll-event
        var scrollTop = $(window).scrollTop();

        if ( scrollTop == lastScrollTop ) {
          return;
        }

        // prevent iOS bottom bouning
        if ( scrollTop >= ($('body').outerHeight() - $(window).height() - 120)) {
          return;
        }

        if ( scrollTop > lastScrollTop ){
          $headerLogo.addClass('header-logo--simplified')
        } else {
          $headerLogo.removeClass('header-logo--simplified');
        }

        if ( scrollTop <= 0 ) {
          $headerLogo.removeClass('header-logo--simplified');
        }

        lastScrollTop = scrollTop;
      });
    },
    overlayClickHandle: function() {
      var $container = this.$container;
      $container.find('.header__overlay').click(function(){
        $container.find('.menuToggle').click();
      });
    },
    search: function () {
      var $container = this.$container;
      $('body').on('click', function(e) {
        if (!$('body').hasClass('search-open') || $(e.target).closest('a').attr('href') == '/search' || $(e.target).closest('a').attr('href') == `/${window.langCode}/search`) return;
        var $target = $(e.target);
        if (!$target.closest('.search--wrapper, .search__dropdown, .aa-Panel, .aa-DetachedContainer').length || $target.hasClass('aa-DetachedCancelButton')) {
          $container.find('.search__dropdown, .search--wrapper').removeClass('active');
          $('body').removeClass('search-open');
        }
      });
      $container.find('a[href*="/search"]').click(function(e){
        e.preventDefault();
        var searchOpen = $container.find('.search__dropdown').hasClass('active');
        if (searchOpen) {
          $container.find('.search__dropdown, .search--wrapper').removeClass('active');
          $('body').removeClass('search-open');
        } else {
          $container.find('.search__dropdown, .search--wrapper').addClass('active');
          $('body').addClass('search-open');
          var gate = window.monosAlgoliaSearchGate;
          if (gate) {
            gate.activate().then(function () {
              return gate.waitUntilAutocompleteReady();
            }).then(function (elements) {
              if (elements.button) {
                elements.button.click();
              }
              if (elements.input) {
                elements.input.focus();
              } else {
                $('.search-open input.aa-Input').trigger('focus');
              }
            });
          } else {
            $('.search-open input.aa-Input').trigger('focus');
            $('.search-open .aa-DetachedSearchButton').trigger('click');
          }
        }
      });
      $(window).on('resize', function(){
        if (!$('body').hasClass('search-open')) {
          $('.aa-DetachedCancelButton').trigger('click');
        }
      });
    }
  });

  return Header;
})();

theme.Collection = (function() {
  function Collection(container) {
    var $container = this.$container = $(container),
        templateSuffix = $container.attr('data-template-suffix') || '';

    if( templateSuffix == 'color' ) {
      this.initColorCollection();
    }
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    initColorCollection: function(){
      var $container = this.$container,
          $productGridItem = $container.find('.product-grid-item');
      $(window).on("load", function () {
        $container.css('opacity', '');
      })
    }
  });

  return Collection;
})();

theme.Slideshow = (function() {
  function Slideshow(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#slideshow-'+sectionId;
    var $slideshow = this.$slideshow = $(this.slideshow);

    this.init();
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    init: function() {
      this.$slideshow.on('init', function(event, slick){
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        slick.$prevArrow.addClass($currentSlide.data("color"));
        slick.$nextArrow.addClass($currentSlide.data("color"));
      })
      this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

        slick.$prevArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$prevArrow.addClass($nextSlide.data("color"));

        slick.$nextArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$nextArrow.addClass($nextSlide.data("color"));
      });
      this.$slideshow.slick({
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed'),
        adaptiveHeight: false,
        dots: false
      });
    },
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });
  return Slideshow;
})();


theme.Product = (function() {
  function Product(container) {
    let $container = this.$container = $(container),
        sectionType = this.sectionType = $container.attr('data-section-type'),
        sectionId = this.sectionId = $container.attr('data-section-id');
    window.selectedStickers = window.alphabetStickers ? [] : null;

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: true,
      namespace: '.product-single',
      stickyLayout: ($container.attr('data-sticky-layout') == 'true' )
    }

    this.selectors = {
      productJson: '[data-product-json]',
      productSection: '#ProductSection-'+sectionId,
      productSlider: '[data-product-slider]',
      productThumbs: '[data-product-thumbs]',
      productImage: '[data-product-image]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      variantDropdown: '#ProductSelect-'+sectionId,
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      productPrice: '[data-product-price]',
      comparePrice: '[data-product-compare-at-price]',
      quantityInput:    '#Quantity-'+sectionId+' .QuantityInput',
      sticky: {
        selector: '.product__slides-wrap, .product__info',
        parent: '.product-single--sticky'
      }
    }

    if( sectionType == 'product-grid-item' ) {
      this.selectors.productJson = '[data-product-grid-json]';
      this.settings.namespace = '.grid__wrap';
      this.settings.enableHistoryState = false;
    }
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if ( !this.$container.find( this.selectors.productJson ).html()) {
      return;
    }

    this.productSingleObject = JSON.parse( this.$container.find( this.selectors.productJson ).html() );
    this.zoomEnable = $container.data('image-zoom-enable');

    this.variantMetafields = false;
    if(  this.$container.find('[data-variant-metafields]').length ) {
      this.variantMetafields = JSON.parse( this.$container.find('[data-variant-metafields]').html() )
    }

    if( sectionType == 'product-bundle' || sectionType == 'product-bundle-item' ) {
      this.settings.enableHistoryState = false;
    }

    if( sectionType == 'product-bundle-item' ) {
      this.settings.namespace = '.product-bundle-item';
    }

    if( sectionType == 'product-bundle' ) {
      this.initBundle();
      this.tabs();
      this.accordion();
      this.tabsSpaceCheck();
      this.initVariantSizeSelector();

      let instance = this;
      $(window).resize($.throttle(400, function(){
        instance.tabsSpaceCheck();
        if( instance.settings.stickyLayout ) {
          if( $(window).width() > 768 ) {
            instance.initStickyLayout();
          } else {
            instance.destroyStickyLayout();
          }
        }
      }));
      return;
    }

    this.initProductVariant();
    this.initProductSwatches();
    this.initAdd();
    if ( sectionType !== 'product-bundle-curated' && sectionType !== 'product-bundle-item' && sectionType !== 'product-grid-item' ) {
      const $okendoReviewSummary = $container.find('.okendo-reviews-summary-secondary');
      const productID = $okendoReviewSummary.data('product-id');
      const okendoID = $okendoReviewSummary.data('okendo-id');
      const okendoURL = `https://api.okendo.io/v1/stores/${okendoID}/products/shopify-${productID}/reviews_summary`;
      if (productID && okendoID) {
        $.getJSON(okendoURL).done(function(data) {
          if (data && data.reviewsSummary?.body) {
            const reviewsSummary = data.reviewsSummary.body;
            const reviewCount = data.reviewsSummary.contributingReviewCount;
            const dateGenerated = data.reviewsSummary.dateGenerated;
            // only calculate time if dateGenerated is present
            let timeAgo = '';
            if (dateGenerated && reviewCount) {
              const date = new Date(dateGenerated);
              const now = new Date();
              const diffTime = Math.abs(now - date);
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              const diffWeeks = Math.floor(diffDays / 7);
              const diffMonths = Math.floor(diffDays / 30);
              if (diffWeeks < 2) {
                timeAgo = `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
              } else if (diffWeeks < 4) {
                timeAgo = `${diffWeeks} week${diffWeeks > 1 ? 's' : ''} ago`;
              } else {
                timeAgo = `${diffMonths} month${diffMonths > 1 ? 's' : ''} ago`;
              }
            }
            const summaryProcess = reviewCount && dateGenerated ? `Generated by AI from ${reviewCount} most recent customer reviews updated ${timeAgo}` : 'Generated by AI from customer reviews';
            $okendoReviewSummary.find('.tooltiptext').html(summaryProcess);
            $okendoReviewSummary.find('.okendo-reviews-summary-trunc, .okendo-reviews-summary').html(`<p>${reviewsSummary}</p>`);
            $okendoReviewSummary.removeClass('hide');
          }
        });
      }
      if (window.referer) {
        $container.find('input[name="properties[Estimated delivery]"]').after(`<input type="hidden" name="properties[_referer]" value="${window.referer}">`);
      }
    }
    if( sectionType == 'product-bundle-item' || sectionType == 'product-grid-item' ) {
      return;
    }
    if( sectionType == 'product-bundle-curated' ) {
      $(bundleFeaturedVariants.products).each(function(){
        var itemHandle = this.handle;
        var itemVariantHandle = this.variantTitle.includes(' / ') && singleVariantWithSlash.indexOf(itemHandle) == -1 ? this.variantTitle.split(' / ')[1] : this.variantTitle;
        $(`.bundle-product-item[data-product-handle="${itemHandle}"]`).find(`.swatch__item .swatch__link[data-value="${itemVariantHandle}"]`).click();
      });

      $container.find('.swatch__item > .swatch__link').on('click', function(e){
        e.preventDefault();
        if ($(e.target).closest('[data-section-type="product-grid-item"]').hasClass('product-grid-item')) return;
        var handle = $(this).closest('.bundle-product-item').attr('data-product-handle');
        var featuredVar = bundleFeaturedVariants.products.find(obj => obj.handle == handle);

        // Use featured Variant to set value of first option ie. 'Large' in 'Large / Carbon Black'
        var variant = featuredVar.variantTitle.includes(' / ') && singleVariantWithSlash.indexOf(handle) == -1 ? featuredVar.variantTitle.split(' / ')[0] + ' / ' + $(this).data('value') : $(this).data('value');

        var variantID = featuredVar.variantTitle.includes(' / ') && singleVariantWithSlash.indexOf(handle) == -1 && bundleProductImages.products.find(obj => obj.handle == handle) ? bundleProductImages.products.find(obj => obj.handle == handle).variants.find(obj => obj.title == variant).id : $(this).data('variant-id');
        $(this).closest('.bundle-product-item').attr('data-variant-id', variantID);
        var updatedPrice = 0;

        /*
        var variant = multipleOptionVariants.length > 0 ? (multipleOptionVariants.find(obj => obj.handle === handle)).variantTitle.split(' / ')[0] + ' / ' + $(this).data('value') : $(this).data('value');
        if (multipleOptionVariants.length > 0) {
          console.log(multipleOptionVariants.find(obj => obj.handle === handle)
        } else {
          variant = $(this).data('value');
        }*/

        $(`.bundles-featured-image .image-wrapper[data-product-handle="${handle}"]`).addClass('hide');
        $(`.bundles-featured-image .image-wrapper[data-product-handle="${handle}"][data-variant-title="${variant}"]`).removeClass('hide');
        $(bundleProductImages.products).each(function(){
          if (this.handle == handle) {
            var variants = this.variants;
            $(variants).each(function(){
              if (this.title == variant) {
                var img = this.featured;
                var imgThumb = this.mainImage
                var imageEl = `<img class="fade-in lazypreload lazyautosizes lazyloaded" src="${img}"></img>`;
                var thumbEl = `<img class="fade-in lazypreload lazyautosizes lazyloaded bundle-img-thumb" src="${imgThumb}"></img>`;
                var index = $(`.bundles-featured-image .image-wrapper[data-product-handle="${handle}"]`).data('index');
                $(`.product__slides__item[aria-describedby="slick-slide${index}"] .image-wrapper`).html(imageEl);
                if (!mediumDown()) $(`.product__thumbs #slick-slide${index}`).html(thumbEl);
              }
            })
          }
        });
        var bundlesData = JSON.parse($container.find('[data-bundle-product-items]').html());
        if (bundlesData.length > 0) {
          var freeGift = $container.find('[data-free-gift]').length ? $container.find('[data-free-gift]').data('free-gift') : false;
          var variantSetAvailable = true;
          $(`[data-bundle-product-item]:not([data-product-handle="${freeGift}"])`).map((index, element) => {
            const itemPrice = bundlesData?.find(
              obj => obj.product_handle == $(element).data('product-handle')).variants?.find(
                obj => obj.variant_id == $(element).find('.swatch__item.active .swatch__link').data('variant-id'))?.variant_price;
            updatedPrice += itemPrice;
          });
          $(`[data-bundle-product-item]:not([data-product-handle="${freeGift}"])`).map((index, element) => {
            const itemAvailable = bundlesData?.find(
              obj => obj.product_handle == $(element).data('product-handle')).variants?.find(
                obj => obj.variant_id == $(element).find('.swatch__item.active .swatch__link').data('variant-id'))?.variant_available;
            if (!itemAvailable) {
              variantSetAvailable = false;
            }
          });
          if (!variantSetAvailable) {
            $('#AddToCart-product-bundles').addClass('disabled');
            $('#AddToCart-product-bundles').attr('disabled', true);
            $('#AddToCart-product-bundles').html(theme.strings.outOfStock);
          } else {
            $('#AddToCart-product-bundles').removeClass('disabled');
            $('#AddToCart-product-bundles').attr('disabled', false);
            $('#AddToCart-product-bundles').html('Add to Cart');
          }
          var mainProduct = JSON.parse($container.find('[data-product-json]').html());
          var bundleDiscount = mainProduct?.compare_at_price > mainProduct?.price ? mainProduct?.compare_at_price - mainProduct?.price : 0;
          updatedPrice = freeGift ? updatedPrice : updatedPrice - bundleDiscount;
          $('[data-product-price][class*="bundle"] .money').html(slate.Currency.formatMoney(updatedPrice, theme.moneyFormat));
          $('[data-product-compare-at-price][class*="bundle"] .money').html(slate.Currency.formatMoney(updatedPrice + bundleDiscount, theme.moneyFormat));
        }
      });
    }
    this.compareSizesModal();
    this.promoModal();
    this.quantitySelectors();
    this.initSlider();
    this.tabs();
    this.accordion();
    this.tabsSpaceCheck();
    this.initProductSizeSelector();
    this.initVariantSizeSelector();
    this.initProductUpsell();
    this.klaviyoPixels();
    this.initWarrantyModal();
      
    var searchOpen = false;
    $('.search__dropdown').hasClass('active') ? searchOpen = true : searchOpen = false;

    if (this.zoomEnable && !searchOpen) {
      this.productImageZoom();
    }
    if ( sectionType != 'product-bundle-curated' ) {
      let instance = this;
      $(window).resize($.throttle(400, function(){
        instance.tabsSpaceCheck();
        if( instance.settings.stickyLayout ) {
          if( $(window).width() > 768 ) {
            instance.initStickyLayout();
          } else {
            instance.destroyStickyLayout();
          }
        }
      }));
    }
  }
  Product.prototype = _.assignIn({}, Product.prototype, {
    initAdd: function() {
      let $container = this.$container,
          $addToCartWrapper = $container.find('.add-to-cart-wrapper'),
          $addToCartError = $container.find('.add-to-cart-error');

      $container
        .find('[data-add-to-cart]:not(#AddToCart-product-bundles)').on('click', function(e) {
          e.preventDefault();
          var productType = getProductObject($container, '[data-product-json]').type;
          var productHandle = getProductObject($container, '[data-product-json]').handle;

          if( $(this).hasClass('disabled') ||
              !$(this).closest('form').length ) {
            return;
          }
          if (window.alphabetStickers) {
            var items = [];
            $.map(window.selectedStickers, function(val, i){
              var vID = $(`.swatch__link[data-value="${val}"]`).data('variant-id');
              items.push({quantity: 1, id: vID});
            });

            formObject = {
              items: addStoreAttributionToCart(items)
            }
            ajaxAddItem(formObject);
          } else {
            var form = $(this).closest('form'),
              formSerialized = form.serializeArray();

            if (form.find('[type="file"]').length){
              return;
            }

            var formObject = {};
              $.map(formSerialized, function(val, i){
              formObject[val.name] = val.value;
            });

            if (productType == 'Luggage' && !window.preventLTWModal) {
              magnificOpen('#lifetime-warranty-plus-modal', 'mfp-fade', ltwModal, ltwOnCloseModal);
              function ltwModal() {
                window.currentFormData = {
                  id: formObject.id,
                  quantity: formObject['quantity'] || 1,
                  properties: {
                    'Estimated delivery': formObject['properties[Estimated delivery]'] || '',
                    '_referer': window.referer || '',
                  }
                };
                window.formObject = formObject;
                items = [];
                
                $('button[id^="Add-lifetime-warranty-plus-add-"]').on('click', function(e) {
                  e.preventDefault();
                  var ltwID = $(this).data('variant');
                  var ltwObj = singleItemCartObject(ltwID, 1, {'_pdp ltw': true});
                  items.push(ltwObj, window.currentFormData);
                  cartAdd({items}, error, success, () => {});
                  function error(xhr, status, error) {
                    console.error('Error adding Lifetime Warranty Plus to cart:', error);
                  }
                  function success(data) {
                    updateHeaderCartTotal();
                    windowRedirect('/cart');
                  }
                });
                $('.lifetime-warranty-plus-modal a').on('click', function(e) {
                  e.preventDefault();
                  let redirectUrl = $(this).attr('href') ? $(this).attr('href') : '/cart';
                  items.push(window.currentFormData);
                  cartAdd({items}, error, success, () => {});
                  function error(xhr, status, error) {
                    console.error('Error adding Lifetime Warranty Plus to cart:', error);
                  }
                  function success(data) {
                    updateHeaderCartTotal();
                    windowRedirect(redirectUrl);
                  }
                });
              }
              function ltwOnCloseModal() {
                  items.push(window.currentFormData);
                  cartAdd({items}, error, success, () => {});
                  function error(xhr, status, error) {
                    console.error('Error while adding item to cart:', error);
                  }
                  function success(data) {
                    updateHeaderCartTotal();
                    windowRedirect('/cart');
                  }
              }
            } else {
              ajaxAddItem(addStoreAttributionToCart(formObject));
            }
          }
        });
      $container.find('#AddToCart-product-bundles').on('click', function(e){
        e.preventDefault();
        var items = [];
        var bundleItem = $(e.target).closest('[data-product-form]').data('product-handle');
        $(e.target).closest('form').find('[data-bundle-product-item]').each(function(){
          var vID = $(this).data('variant-id');
          var properties = {
            '_curated bundle': bundleItem,
          };
          items.push({
            quantity: 1, 
            id: vID,
            properties: properties,
          });
        });
        items = items.reverse();
        formObject = {
          items: items
        }
        ajaxAddItem(formObject);
        
      });

      let ajaxAddItem = function(data, redirect) {
        $addToCartWrapper.addClass('loading');
        $.ajax({
          type: 'POST',
          url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
          dataType: 'json',
          data: data,
          error: addError,
          success: addSuccess,
          complete: updateHeaderTotal
        });
      }

      let updateHeaderTotal = function() {
        //console.log('updateHeaderTotal')
        $.getJSON('/cart.js')
         .done(function(cart) {
           $('.cartCount').html(cart.item_count).removeClass('hidden-count');
           $('.header-cart .cartIcon').addClass('nav__icon--filled');
           if (motivator_gift_id != 0) motivator(cart);
        });
      }

      let addError = function(object, status) {
        $addToCartError.html(object.responseJSON.description).removeClass('hide');
        $addToCartWrapper.removeClass('loading');
      }

      let addSuccess = function() {

        $addToCartWrapper.removeClass('loading');
        $addToCartError.html('').removeClass('hide');
        var redirectUrl = window.nonEnglish ? `/${window.langCode}/cart` : '/cart';
        if( $container.attr('data-grid-type') == "upsell-grid-item" ) {
          $('[data-section-type="product"]').trigger('refreshPromoModal');
        } else if( $container.attr('data-upsell-modal-after-add-to-cart') === 'true' ) {
          let $promoModalTrigger = $container.find('[data-product-promo-popup-trigger]');
          if( $promoModalTrigger.length ) {
            let $promoModal = $( $promoModalTrigger.attr('data-mfp-src') );

            $container.trigger('refreshPromoModal', function(){
              if( $promoModal.find('[data-grid-type="upsell-grid-item"][data-in-cart="false"]').length ) {
                $promoModalTrigger.click();
              } else {
                window.location.href = redirectUrl;
              }
            });
          }
        } else {
          window.location.href = redirectUrl;
        }
      }
    },
    initBundle: function(){
      this.settings['bundleDiscountAmount'] = parseInt( this.$container.attr('data-bundle-discount-amount') ) || 0;
      this.settings['bundleDiscountCode'] = this.$container.attr('data-bundle-discount-code') || false;

      if( Shopify.currency && Shopify.currency.rate ) {
        this.settings['bundleDiscountAmount'] *= Shopify.currency.rate;
      }

      if( typeof(sections)==='undefined' ) {
        let sections = new slate.Sections();
        sections.register('product-bundle-item', theme.Product);
      } else {
        sections.register('product-bundle-item', theme.Product);
      }

      let $container = this.$container,
          selectors = this.selectors,
          scope = this;

      // Alter UI
      $container.find(`[size-selector]`).remove();
      $container.find(`[type="submit"]`).hide();
      $(`<button class="btn btn--large btn--full uppercase" data-add-bundle-to-cart>Add to Cart</button>`).insertAfter('.product-bundle-item:last-of-type')
      $(`<div class="product__bundle-summary">
          <div class="grid">
             <div class="grid__item medium-up--seven-twelfths text-center medium-up--text-left">
               <p class="subtitle" data-bundle-saving></p>
             </div>
             <div class="grid__item medium-up--five-twelfths text-center medium-up--text-right">
              <h5 class="product__price title">
                <span class="money"><span data-product-price></span></span>
                <p class="product__compare-at-price small compare-at title" style="display: none">
                  <span class="screen-reader-only">Original price: </span>
                  <span class="money"><span data-product-compare-at-price></span></span>
                </p>
              </h5>
             </div>
           </div>
         </div>`).insertAfter('.product-bundle-item:last-of-type')

      // Variant change handle
      $container.find(`[data-section-type="product-bundle-item"]`).on('variantChange.product-bundle-item', function(){

        // Update bundle price
        let bundlePrice = 0,
            bundleCompareAtPrice = 0;
        $container.find('.product-bundle-item').each(function(){
          bundlePrice += parseInt( $(this).attr('data-price') ),
          bundleCompareAtPrice += parseInt( $(this).attr('data-compare-at-price') );
        });

        let bundleDiscountAmount = scope.settings.bundleDiscountAmount;
        bundlePrice -= bundleDiscountAmount;

        // console.log({
        //   'bundlePrice': bundlePrice,
        //   'bundleCompareAtPrice': bundleCompareAtPrice
        // });

        // Regardless of stock, update the product price
        $container.find(selectors.productPrice).html("<span class='money'>" + slate.Currency.formatMoney(bundlePrice, moneyFormat) + "</span>").attr('data-product-price', bundlePrice);

        // Also update and show the product's compare price if necessary
        if (bundleCompareAtPrice > bundlePrice) {
          $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(bundleCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', bundleCompareAtPrice);
          $container.find(selectors.comparePrice).closest('.compare-at').show();
          $container.find(selectors.productPrice).closest('.product__price').addClass('on-sale');
          $container.find(`[data-bundle-saving]`).show().html("Buy together and save <span class='money'>" + slate.Currency.formatMoney(bundleCompareAtPrice-bundlePrice, moneyFormat) + "</span>" );
        } else {
          $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(bundleCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', bundleCompareAtPrice);
          $container.find(selectors.comparePrice).closest('.compare-at').hide();
          $container.find(selectors.productPrice).closest('.product__price').removeClass('on-sale');
          $container.find(`[data-bundle-saving]`).hide().html("");
        }

        // Update slider
        var $productSlider = $container.find(selectors.productSlider),
            productSlideItemsHtml = $container.find('[data-product-slides-object]').html(),
            $productSlideItems = $(productSlideItemsHtml);

        scope.destroySlider();

        // Clear slider html
        $productSlider.html('');

        let imageKeys = {};
        $container.find(`[data-section-type="product-bundle-item"]`).each(function(){
          let productHandle = $(this).attr('data-section-id'),
              imageVariantTitle = $(this).attr('data-variant-title')
              imageKeys[productHandle] = imageVariantTitle;
        });

        $productSlideItems.find('.product__slides__item').each(function(){
          let $slideItem = $(this),
              imageVariantTitle = $slideItem.attr('data-variant-title'),
              productHandle = $slideItem.attr('data-product-handle');
          if( imageVariantTitle == 'All' ) {
            $productSlider.append( $slideItem );
            return;
          }
          for (let k in imageKeys) {
            if (imageKeys.hasOwnProperty(k) && productHandle == k && imageVariantTitle == imageKeys[k] ) {
              $productSlider.append( $slideItem );
              break;
            }
          }
        });

        scope.initSlider();

        if ( $container.data('image-zoom-enable') ) {
          scope.productImageZoom();
        }

        let $productSlides = $container.find('.product__slides'),
            currentProductHandle = $(this).attr('data-section-id'),
            firstSlideIndex = $container.find('.product__slides__item').filter(`[data-product-handle="${currentProductHandle}"]`).first().attr('data-slick-index');
        if( $productSlides.hasClass('show-first') ) {
          $productSlides.removeClass('show-first');
          return;
        }
        $productSlides.slick('goTo', firstSlideIndex);
      });

      // Add to cart handle
      $container.find(`[data-add-bundle-to-cart]`).click(function(evt) {
        evt.preventDefault();
        console.log(`add bundle to cart`);

        let bundleDiscountCode = scope.settings.bundleDiscountCode;
        let items = [];
        $container.find('.product-bundle-item').each(function(){
          let item = {'quantity': 1},
              $form = $(this).find('form'),
              formSerialized = $form.serializeArray();

          for( let i=0 ; i<formSerialized.length ; i++ ) {
            let formItem = formSerialized[i];
            if( formItem.name == 'id' ) {
              item.id = formItem.value;
              continue;
            }
            if( formItem.name.indexOf('properties[') !== -1 ) {
              let propertyKey = formItem.name.replace('properties[', '').replace(']', ''),
                  propertyVal = formItem.value;
              item.properties = {};
              item.properties[propertyKey] = propertyVal
            }
          }
          items.push(item);
        });

        let formData = { 'items': items };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          if( bundleDiscountCode ) {
            window.location.href = `/checkout?discount=${bundleDiscountCode}`;
          } else {
            if (window.nonEnglish) {
              window.location.href = `/${window.langCode}/cart`;
            } else {
              window.location.href = "/cart";
            }
          }
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });

      // ensure slider will stay at first slide
      $container.find('.product__slides').addClass('show-first');

      // trigger to init price and slider
      $container.find(`[data-section-type="product-bundle-item"]`).first().find('.swatch__item > .swatch__link').first().click()
    },
    initProductVariant: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      }
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateAllVariants.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateSlider.bind(this));

      if( this.sectionType == 'product-grid-item' ) {
        let currentVariantId = parseInt( this.$container.attr('data-current-variant-id') );
        for( let i=0 ; i<this.productSingleObject.variants.length; i++ ) {
          let variant = this.productSingleObject.variants[i];
          if( variant.id == currentVariantId ) {
            this.variants.currentVariant = variant;
            break;
          }
        }
      }

      this.updateAllVariants({variant: this.variants.currentVariant});
    },
    initProductSwatches: function(){
      var $container = this.$container,
          selectors = {
            swatchWrapper: '[data-swatch-wrapper]',
            swatchList: '[data-swatch-list]',
            swatchItem: '[data-swatch-item]',
            swatchLink: '[data-swatch-link]',
            swatchValue: '[data-swatch-label-value]'
          },
          $singleOptionSelectors = $(this.selectors.singleOptionSelector);

      // Init swatch click handle
      if (window.alphabetStickers) {
        $container.find('input[data-swatch-label-value]').on('input change keyup paste', function(){
          var currentValue = $(this).val();
          var uppercaseValue = currentValue.toUpperCase();
          $(this).val(uppercaseValue);
          window.selectedStickers = $(this).val().split('');
          var last = window.selectedStickers.length ? window.selectedStickers[window.selectedStickers.length - 1] : 'A';
          var slideIndex = $container.find('.product__slides').find(`[data-variant-title="${last}"]`).index();
          $container.find('.product__slides').slick('slickGoTo', slideIndex);
          if (window.selectedStickers.length > 1) {
            $('[data-add-to-cart]').removeClass('disabled').prop('disabled', false);
          } else {
            $('[data-add-to-cart]').addClass('disabled').prop('disabled', true);
          }
          updateVariantPrice(window.selectedStickers);
        });
        $container.find( selectors.swatchWrapper ).find( selectors.swatchLink ).mouseenter(function(e){
          var value = $(e.target).closest(selectors.swatchItem).find(selectors.swatchLink).data('value');
          var slideIndex = $container.find('.product__slides').find(`[data-variant-title="${value}"]`).index();
          $container.find('.product__slides').slick('slickGoTo', slideIndex);
          updateVariantPrice(window.selectedStickers);
        });
        $container.find( selectors.swatchWrapper ).find( selectors.swatchLink ).click(function(e){
          e.preventDefault();
          var val = $(this).data('value'),
            $swatchWrapper = $(this).closest( selectors.swatchWrapper ),
            index = $swatchWrapper.find( selectors.swatchList ).data('index'),
            $productSwatch = $swatchWrapper.find( selectors.swatchItem );

            // Update swatch state
            if (!window.selectedStickers) window.selectedStickers = [];
            window.selectedStickers.push(val);
            $('[data-swatch-label-value]').val(window.selectedStickers.toString().replaceAll(',',''));
            // Update swatch label
            $swatchWrapper.find( selectors.swatchValue ).html(window.selectedStickers);

            if (window.selectedStickers.length > 1) {
              $('[data-add-to-cart]').removeClass('disabled').prop('disabled', false);
            }
            var last = window.selectedStickers.length ? window.selectedStickers[window.selectedStickers.length - 1] : 'A';
            var slideIndex = $('.product__slides').find(`[data-variant-title="${val}"]`).index();
            $('.product__slides').slick('slickGoTo', slideIndex);

            if( $productSwatch.closest('[data-upsell]').length ) {
              return;
            }
            updateVariantPrice(window.selectedStickers);
        });
        function updateVariantPrice(stickers) {
          var $price = $('.product__price');
          var variantPrice = $price.data('price');
          variantPrice = stickers && stickers.length > 1 ? stickers.length * variantPrice : variantPrice;
          $price.html("<span class='money'>" + slate.Currency.formatMoney(variantPrice, moneyFormat) + "</span>").attr('data-product-price', variantPrice);
        }
      } else {
        $container.find( selectors.swatchWrapper ).find( selectors.swatchLink ).click(function(e){
          e.preventDefault();
          var val = $(this).data('value'),
            $swatchWrapper = $(this).closest( selectors.swatchWrapper ),
            index = $swatchWrapper.find( selectors.swatchList ).data('index'),
            $productSwatch = $swatchWrapper.find( selectors.swatchItem );

            // Update swatch label
            const productHandle = getProductObject($container, '[data-product-json]').handle;
            let swatchValueText = $swatchWrapper.find( selectors.swatchValue ).html();

            swatchValueText = val;
            $swatchWrapper.find( selectors.swatchValue ).html(swatchValueText);

            // Update swatch state
            $productSwatch.removeClass('active');
            $(this).closest( selectors.swatchItem ).addClass('active');

            if( $productSwatch.closest('[data-upsell]').length ) {
              return;
            }
            // Update selector
            $singleOptionSelectors.filter('[data-index="' + index + '"]').val(val).change();
        });
        if( $container.find( selectors.swatchList ).length && this.sectionType == 'product' ) {
          $container.find( selectors.swatchList ).find( selectors.swatchItem ).filter('.active').find(' > a').click();
        }
      }
    },
    updateAllVariants: function(evt) {
      let $container = this.$container,
          selectors = this.selectors,
          sectionType = this.sectionType,
          variant = evt.variant,
          moneyFormat = theme.moneyFormat,
          variantPrice = variant.price,
          variantCompareAtPrice = variant.compare_at_price;

      // console.log(`updateAllVariants() - ${this.productSingleObject.title} - ${variant.title}`);

      if( variantCompareAtPrice === null || variantCompareAtPrice < variantPrice ){
        variantCompareAtPrice = variantPrice;
      }

      if (variant) {
        // Select a valid variant if available
        $container.attr('data-variant-title', variant.title);
        if (window.nonEnglish) {
          if (variant.title.includes(' / ')) {
            $container.attr('data-variant-title', translate(variant.title.split(' / ')[0], window.lang) + ' / ' + translate(variant.title.split(' / ')[1], window.lang));
          } else {
            $container.attr('data-variant-title', translate(variant.title, window.lang));
          }
        }
        if (this.sectionType !== 'product-bundle-curated') {
          if (variant.available) {
            // Available, enable the submit button, change text, show quantity elements
            $container.find(selectors.addToCart).removeClass('disabled').prop('disabled', false);
            $container.find(selectors.addToCartText).html(theme.strings.addToCart);
            $container.removeClass( "variant--soldout variant--unavailabe" );
          } else {
            // Sold out, disable the submit button, change text, hide quantity elements
            $container.find(selectors.addToCart).addClass('disabled').prop('disabled', true);
            $container.find(selectors.addToCartText).html(theme.strings.soldOut);
            $container.removeClass( "variant--unavailabe" ).addClass( "variant--soldout" );
          }
        }
        $container.find('.product__price').attr('data-price', variantPrice)
        if (window.alphabetStickers) {
          variantPrice = window.selectedStickers.length > 1 ? window.selectedStickers.length * variantPrice : variantPrice;
        }
        // Regardless of stock, update the product price
        $container.find(selectors.productPrice).html("<span class='money'>" + slate.Currency.formatMoney(variantPrice, moneyFormat) + "</span>").attr('data-product-price', variantPrice);
        if (window.displayPercentage && sectionType !== 'product-bundle-curated') {
          var discountedPrice = variant.price - variant.price * window.displayPercentage / 100;
          $container.find(selectors.productPrice).closest('.product__price').find(`.product__price--percentage-discounted`).html(slate.Currency.formatMoney(discountedPrice, moneyFormat));
          $container.find(selectors.productPrice).closest('.product__price').find('.money').addClass('hide');
        }
        if( this.sectionType == 'product-bundle-item' ) {
          $container.attr({
            'data-price': variantPrice,
            'data-compare-at-price': variantCompareAtPrice,
            'data-variant-title': variant.title,
            'data-variant-id': variant.id,
            'data-available': variant.available
          });
        }

        // Also update and show the product's compare price if necessary
        if (variantCompareAtPrice > variantPrice) {
          $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', variantCompareAtPrice);
          $container.find(selectors.comparePrice).closest('.compare-at').show();
          $container.find(selectors.productPrice).closest('.product__price').addClass('on-sale');
        } else {
          if (window.displayPercentage && sectionType !== 'product-bundle-curated') {
            $container.find(selectors.productPrice).closest('.product__price').addClass('show-discount-code-price');
            $container.find(selectors.comparePrice).closest('.product__compare-at-price').find('.product__price--percentage-discounted--original').html(slate.Currency.formatMoney(variantPrice, moneyFormat));
            $container.find(selectors.comparePrice).closest('.compare-at').show();
            if ($container.hasClass('grid__item')) {
              $container.find(selectors.productPrice + ' .money').html(slate.Currency.formatMoney(variantPrice - variantPrice * window.displayPercentage / 100, moneyFormat));
              $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(variantPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', variantPrice);
            } else {
              $container.find(selectors.productPrice + ' .money').addClass('hide');
            }
          } else {
            $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', variantCompareAtPrice);
            $container.find(selectors.comparePrice).closest('.compare-at').hide();
            $container.find(selectors.productPrice).closest('.product__price').removeClass('on-sale');
          }
        }

        if( sectionType == 'product-grid-item' ) {
          if (variantCompareAtPrice > variantPrice || window.displayPercentage) {
            $container.find('.grid__price').addClass('on-sale');
            $container.find('.sticker--sale').show();
          } else {
            $container.find('.grid__price').removeClass('on-sale');
            $container.find('.sticker--sale').hide();
          }
        }

        // Update based on metafields
        if( this.variantMetafields === false ) {
          return;
        }
        var productType = $('[data-product-type]').data('product-type');
        var variantMetafields = this.variantMetafields[ variant.id ];
        // Update product message
        var productMessage = $container.find('[data-product-message]').attr('data-product-preorder-message');
        if( typeof(productMessage) !== 'undefined' ) {
          if ( variantMetafields.inventory_quantity == 'none' && variantMetafields.inventory_policy == 'continue' ) {
            var preOrderText = translate('Add to Cart (Pre-Order)', window.lang);
            var preOrderMsg = preOrderText;
            $container.find(selectors.addToCartText).html(preOrderMsg);
            if( variantMetafields.preorder_message !== null ) {
              productMessage = variantMetafields.preorder_message;
            }

            if( variantMetafields.preorder_ship_date !== null ) {
              $container.find('[name="properties[Estimated delivery]"]').val( variantMetafields.preorder_ship_date );
            } else {
              $container.find('[name="properties[Estimated delivery]"]').val( '' );
            }
          } else {
            let shippingMessage = $container.find('[data-product-message]').attr('data-product-shipping-message'),
                alteredQuantity = variantMetafields.alteredQuantity;
            alteredQuantity = ( alteredQuantity == 0 ) ? 10 : alteredQuantity;
            let lowstockMessage = $container.find('[data-product-message]').attr('data-product-lowstock-message');
            const outOfStockMessage = $container.find('[data-product-message]').attr('data-product-outofstock-message');
            if (!variant.available) {
              productMessage = outOfStockMessage;
              } else {
            if( alteredQuantity > 3 ) {
              productMessage = shippingMessage.replace('[quantity]', alteredQuantity)
            } else {
              productMessage = lowstockMessage;
            }
            $container.find('[name="properties[Estimated delivery]"]').val( '' );
          }
        }
          $container.find('[data-product-message]').html(productMessage);
        }

        // Update additional description
        var additionalDescription = '',
            additionalFeatures = '',
            additionalDescHeading = variantMetafields.additional_desc_heading,
            additionalDescContent = variantMetafields.additional_desc_content,
            additionalFeatHeading = variantMetafields.additional_feat_heading,
            additionalFeatContent = variantMetafields.additional_feat_content;

        if( additionalDescHeading !== null ) {
          additionalDescription += '<h4 class="uppercase">' + additionalDescHeading + '</h4>';
        }

        if( additionalDescContent !== null ) {
          if( additionalDescContent.indexOf('<p>') === -1 ) {
            additionalDescription += `<p>${additionalDescContent}</p>` ;
          } else {
            additionalDescription += `${additionalDescContent}` ;
          }
        }
        if( additionalFeatHeading !== null ) {
          additionalFeatures += '<h4 class="uppercase">' + additionalFeatHeading + '</h4>';
        }
        if( additionalFeatContent !== null ) {
          additionalFeatures += `${additionalFeatContent}`;
        }
        if( additionalFeatures !== '' ) {
          $container.find('[data-product-additional-features]').html(additionalFeatures).show();
        } else {
          $container.find('[data-product-additional-features]').html('').hide();
        }

        if( additionalDescription !== '' ) {
          $container.find('[data-product-additional-description]').html(additionalDescription).show();
        } else {
          $container.find('[data-product-additional-description]').html('').hide();
        }
        if( this.$container.find('[data-inventory-metafields]').length ) {
          $container.find('.inventory:not(.hide)').addClass('hide');
          $container.find(`.inventory.variant-id--${variant.id}`).removeClass('hide');
        }
      } else {
        // The variant doesn't exist, disable submit button.
        // This may be an error or notice that a specific variant is not available.
        // To only show available variants, implement linked product options:
        //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
        $container.find(selectors.addToCart).addClass('disabled').prop('disabled', true);
        $container.find(selectors.addToCartText).html(theme.strings.unavailable);
        $container.removeClass( "variant--soldout" ).addClass( "variant--unavailabe" );
      }
      if (window.alphabetStickers && window.selectedStickers.length < 2) {
        $container.find(selectors.addToCart).addClass('disabled').prop('disabled', true);
      }
    },
    quantitySelectors: function() {
      // Setup listeners to add/subtract from the input
      this.$container.find('.js-qty__adjust').off().on('click', function() {
        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, '')),
            submit = qtySelector.data('submit');

              // Make sure we have a valid integer
              if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
                // We have a number!
              } else {
                // Not a number. Default to 1.
                qty = 1;
              }


        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty).trigger('change');
        if(submit){
          qtySelector.parents('form').submit();
        }
      });
    },
    initSlider: function() {
      var $container = this.$container,
          selectors = this.selectors,
          $slider = $container.find(selectors.productSlider),
          swipeEnable = true,
          searchOpen = false,
          productBundlesCurated = $container.attr('id') ? $container.attr('id').includes('product-bundle') : null;

      if( $slider.hasClass('slick-initialized') ) {
        return;
      }
      $('.search__dropdown').hasClass('active') ? searchOpen = true : searchOpen = false;

      if ( this.zoomEnable && !Modernizr.touch ){ swipeEnable = false; }
      const responsive = productBundlesCurated ? [
        {
          breakpoint: 769,
          settings: {
            draggable: true,
            fade: false,
            customPaging: function(slider, i) {
              return '<button type="button" data-role="none" role="button" tabindex="0">' + i + '</button>';
            }
          }
        }
      ] : false;
      $slider.slick({
        adaptiveHeight: false,
        fade: true,
        dots: true,
        speed: 200,
        swipe: swipeEnable,
        appendDots: $container.find(selectors.productThumbs),
        touchThreshold: 10,
        customPaging: function(slider, i) {
          var $slide = $(slider.$slides[i]),
              isVideo = ( $slide.hasClass('product__slides__item--video') ) ? true : false,
              thumb = $slide.data('thumb'),
              imageId = $slide.data('image-id'),
              alt = $slide.find('img').attr('alt');
          if( isVideo ) {
            return '<span class="product__thumbs__video" data-image-id="' + imageId + '"><img src="' + thumb + '"><span class="btn btn--play"></span></span>';
          }
          return `<img src="${thumb}" alt="${alt + ' (thumbnail)'}">`;
        },
        responsive: responsive
      });
      if (!productBundlesCurated) {
        $slider.find('.product__slides__item').each(function(index, slide) {
          var $slide = $(slide),
          thumb = $slide.data('thumb').replace('_small_cropped', '_200x200_cropped'),
          imageId = $slide.data('image-id'),
          alt = $slide.find('img').attr('alt');

          if (thumb) {
            $('.product__thumbs--mobile').append(
              `<div class="product__thumbs__mobile-item" data-image-id="${imageId}">
                <img src="${thumb}" alt="${alt + ' (thumbnail)'}">
              </div>`
            );
          }
        });
        if ($container.find('.product__thumbs__mobile-item').length > 3) {
          $container.find('.product__thumbs--mobile').removeClass('inline-flex');
          $container.find('.product__thumbs--mobile').slick({
            dots: false,
            arrows: false,
            slidesToShow: 4,
            infinite: false,
            adaptiveHeight: false,
            asNavFor: selectors.productSlider,
            focusOnSelect: true,
            draggable: true,
            swipe: true,
            touchThreshold: 100,
            touchMove: true,
            swipeToSlide: true
          });
          $slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
            $('.product__thumbs--mobile').slick('slickGoTo', currentSlide);
          });
        } else {
          $container.find('.product__thumbs--mobile, .product__thumbs__mobile-item').addClass('inline-flex');
          $container.find('.product__thumbs__mobile-item').on('click', function(e){
            e.preventDefault();
            var imageId = $(this).data('image-id');
            $slider.slick('slickGoTo', $slider.find(`.product__slides__item[data-image-id="${imageId}"]`).data('slick-index'));
          });
        }
      }
      if ( productBundlesCurated ) {
        $slider.on('afterChange', function(event, slick, currentSlide){
          if (currentSlide != 0) {
            $('.bundles-featured-image').addClass('hide');
          } else {
            $('.bundles-featured-image').removeClass('hide');
          }
        });
      }

      $slider.find(selectors.productImage).imagesLoaded(function(){
        if( !$slider.hasClass('slick-initialized') ) {
          return;
        }
        $slider.slick('setPosition');
      });

      // update vertical scroller state
      if( $container.find('.vertical-scroll-container > *').length ) {
        $container.find('.vertical-scroll-container > *').trigger('scroll');
      }
      if (window.alphabetStickers) {

        alphabetStickersSlider('init');
        $(window).on('resize', function(){
          var win = $(this);
          if (win.width() >= 769) { 
            window.desktop = true;
          } else {
            window.desktop = false;
          }
          if (window.desktop) {
            alphabetStickersSlider('slider-desktop');
          } else {
            alphabetStickersSlider('slider-mobile');
          }
        });
        function alphabetStickersSlider(operation) {
          $slider.find('.product__slides__item').each(function(){
            let $slideItem = $(this),
                imageVariantTitle = $slideItem.attr('data-variant-title');
            if( imageVariantTitle != 'All' ) {
              var slideID = $(this).attr('aria-describedby');
              $(`.product__thumbs li#${slideID}`).addClass('hide');
            }
          });
        }
        $slider.on('swipe', function(event, slick, direction) {
          setTimeout(
            function() {
              var currentSlide = $slider.slick('slickCurrentSlide');
              var slideFormatted = '0' + currentSlide.toLocaleString();
              var $thumbsVisible = $(`.product__thumbs .slick-dots li:not(.hide)`);

              if ($(`.product__thumbs .slick-dots li#slick-slide${slideFormatted}`).hasClass('hide')) {
                if (direction == 'left') {
                  $slider.slick('slickGoTo', returnVisibleDotIndex($thumbsVisible, 0), 0);
                } else {
                  $slider.slick('slickGoTo', returnVisibleDotIndex($thumbsVisible, -1), 0);
                }
              }
              function returnVisibleDotIndex ($elements, index) {
                return parseInt($elements.eq(index).attr('id').replace('slick-slide', ''));
              }
          }
            , 200)
          
        });
      }
      if (productBundlesCurated) {
        var $bundlesFeaturedImgs = $('.bundles-featured-image .image-wrapper');
        setTimeout(function(){
          $bundlesFeaturedImgs.each(function() {
            $(this).css({
            "position" : "absolute",
            "opacity": 1
          });
         })
        }, 500)
      }
    },
    initProductSizeSelector: function() {
      var $container = this.$container,
          $sizeSelector = $container.find('[size-selector]');

      if( !$sizeSelector.length ) {
        return;
      }

      $sizeSelector.change(function(){
        var val = $(this).val();
        if( val == window.location.pathname ) {
          return;
        }
        window.location = val;
      });

      if( $().niceSelect !== undefined ) {
        $sizeSelector.niceSelect();
      }
    },
    initVariantSizeSelector: function(){
      let $container = this.$container,
          sectionType = this.sectionType,
          $sizeSwatches = $container.find('.product__options .swatch-wrapper--size'),
          $sizeSelectorWrapper = $sizeSwatches.find('+ .selector-wrapper'),
          $sizeSelect = $sizeSelectorWrapper.find('select'),
          enableSizeDropdown = false,
          productHandle = this.productSingleObject.handle,
          sizeDropdownProductHandles = ['packing-cubes', 'luggage-cover', 'washable-luggage-cover', 'kiyo-uvc-water-bottle', 'metro-toiletry-case', 'metro-laptop-sleeve', 'garment-sleeve', 'reformation-packing-cubes'];

      if( sectionType == 'product-bundle' ) {
        enableSizeDropdown = true;
      }
      if( sizeDropdownProductHandles.includes(productHandle) && $sizeSwatches.length ) {
        enableSizeDropdown = true;
      }
      
      if( !enableSizeDropdown ) {
        return;
      }

      $sizeSwatches
        .remove();

      $sizeSelectorWrapper
        .find('label')
        .hide();

      $sizeSelect
        .hide()
        .clone()
        .attr('id', $sizeSelect.attr('id') + '--cloned' )
        .attr('class', '')
        .attr('data-index', '')
        .attr('data-section', '')
        .attr('data-nice-select', '')
        .insertAfter( $sizeSelectorWrapper );

      var $sizeSelectCloned = $container.find( '#' + $sizeSelect.attr('id') + '--cloned' );

      if( $().niceSelect !== undefined ) {
        $sizeSelectCloned
          .attr('size-selector', '')
          .niceSelect();
      }

      $sizeSelectCloned.change(function(){
        var val = $(this).val();
        if (val == '/products/packing-cubes') {
          window.location = '/products/packing-cubes';
          return;
        }
        $sizeSelect.val(val).change();
      });
      $('.nice-select').on('click', function(){
        $(this).closest('.product-page').toggleClass('nice-select-open');
      });
    },
    destroySlider: function() {
      var $slider = this.$container.find(this.selectors.productSlider),
      productBundlesCurated = this.$container.attr('id') ? this.$container.attr('id').includes('product-bundle') : null;

      // unslick it and remove thumbnails html if it's a slick slider
      if( $slider.hasClass('slick-initialized') ) {
        $slider.slick('unslick');
        if (!productBundlesCurated) {
          if (this.$container.find('.product__thumbs--mobile').hasClass('slick-initialized')) {
            this.$container.find('.product__thumbs--mobile').slick('unslick');
          }
          this.$container.find('.product__thumbs--mobile').html('');
        }
        $slider.find(this.selectors.productThumbs).html('');
      }
    },
    updateSlider: function(evt) {
      // Dynamic slider
      var $container = this.$container,
          selectors = this.selectors,
          variant = evt.variant,
          values = [],
          $productSlider = this.$container.find(this.selectors.productSlider),
          productSlideItemsHtml = this.$container.find('[data-product-slides-object]').html(),
          $productSlideItems = $(productSlideItemsHtml);

      if( variant.title !== null ) {
        values.push(variant.title);
        if (window.nonEnglish) {
          if (variant.title.includes(' / ') && singleVariantWithSlash.indexOf(slate.utils.handleize(variant.name.split(' - ')[0])) == -1) {
            const [firstPart, secondPart] = variant.title.split(' / ');
            values.push(translate(firstPart, 'english') + ' / ' + secondPart);
            values.push(translate(firstPart, 'english') + ' / ' + translate(secondPart, 'english'));
            values.push(firstPart + ' / ' + translate(secondPart, 'english'));
          } else {
            values.push(translate(variant.title, 'english'));
          }
        }
      }
      if( variant.option1 !== null ) {
        values.push(variant.option1)
        if (window.nonEnglish) values.push(translate(variant.option1, 'english'));
      }
      if( variant.option2 !== null ) {
        values.push(variant.option2)
        if (window.nonEnglish) values.push(translate(variant.option2, 'english'));
      }
      if( variant.option3 !== null ) {
        values.push(variant.option3)
        if (window.nonEnglish) values.push(translate(variant.option3, 'english'));
      }

      if( typeof( $productSlider.attr('data-current-values')) !== 'undefined' ) {
        if( slate.utils.handleize($productSlider.attr('data-current-values')) === slate.utils.handleize(variant.title) ) {
          return;
        }
      }

      this.destroySlider();

      $productSlider.attr('data-current-values', slate.utils.handleize(variant.title));

      if( values.length > 1 ) {
        // Clear slider html
        $productSlider.html('');

        $productSlideItems.find('.product__slides__item').each(function(){
          let $slideItem = $(this),
              imageVariantTitle = $slideItem.attr('data-variant-title');
              if (imageVariantTitle.includes(' / ')) {
                imageVariantTitle = window.nonEnglish ? translate(imageVariantTitle.split(' / ')[0], window.lang) + ' / ' + imageVariantTitle.split(' / ')[1] : imageVariantTitle;
              } else {
                imageVariantTitle = window.nonEnglish ? translate(imageVariantTitle, window.lang) : imageVariantTitle;
              }
          if( values.indexOf(imageVariantTitle) !== -1 || imageVariantTitle == 'All' ) {
            $productSlider.append( $slideItem );
          }
        });
      } else {
        // Build the slider html with all slides if this is a simple product
        $productSlider.html( $productSlideItems.find('.product__slides__item') );
      }

      this.initSlider();

      if ( this.$container.data('image-zoom-enable') ) {
        this.productImageZoom();
      }
    },
    productImageZoom: function() {
      if (Modernizr.touch) {
        return;
      }

      this.$container.find(this.selectors.productImage).magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade mfp-product',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tLoading: '',
        removalDelay: 200
      });
    },
    compareSizesModal: function(){
      this.$container.find('[data-compare-sizes-modal-trigger]').magnificPopup({
        type: 'ajax',
        mainClass: 'modal modal--compare-sizes',
        alignTop: true,
        overflowY: 'scroll', // as we know that popup content is tall we set scroll overflow by default to avoid jump
        callbacks: {
          ajaxContentAdded: function() {
            $(window).trigger('resize');

            let sections = new slate.Sections();
            sections.register('compare', theme.Compare);
          }
        }
      });

      $('body').on('click', '.compare__item__link[href="' + location.pathname + '"]', function(e){
        e.preventDefault();
        $.magnificPopup.close();
      })
    },
    promoModal: function(){
      let $container = this.$container,
          modalTriggerSelector = '[data-product-promo-popup-trigger]';

      if( !$container.find(modalTriggerSelector).length ) {
        return;
      }

      let $modalTrigger = $container.find(modalTriggerSelector),
          modalId = $modalTrigger.attr('data-mfp-src');

      $container.on('refreshPromoModal', function(evt, refreshPromoModalCallback){
        if( !$(modalId).length ) {
          return;
        }

        let $upsellModal = $(modalId),
            $upsellModalWrap = $upsellModal.closest('.modal--upsell');
        $upsellModalWrap.addClass('loading');

        $.getJSON('/cart.js')
         .done(function(cart) {

          let itemCount = {
            'luggage': 0,
            'packing-cubes': 0,
            'luggage-cover': 0,
          };
          for( let i=0 ; i<cart.items.length ; i++ ) {
            let cartItem = cart.items[i];
            if( itemCount[cartItem.handle] ){
              itemCount[cartItem.handle] += cartItem.quantity;
            } else {
              itemCount[cartItem.handle] = cartItem.quantity;
            }
            if( cartItem.product_type == 'Luggage' ) {
              itemCount.luggage++;
            }
          }

          let $upsellGrid = {
            'all': $upsellModal.find(`[data-grid-type="upsell-grid-item"]`)
          };
          $upsellGrid['all'].attr('data-in-cart', false);
          $upsellGrid['luggage-cover'] = $upsellGrid['all'].filter(`[data-product-handle="luggage-cover"]`);
          $upsellGrid['packing-cubes'] = $upsellGrid['all'].filter(`[data-product-handle="packing-cubes"]`);

          /*
          if( $upsellGrid['luggage-cover'].length && $upsellGrid['packing-cubes'].length ) {

            switch( itemCount['luggage'] > 0 ) {
              case true:

                if( itemCount['packing-cubes'] > 0 && itemCount['luggage-cover'] > 0 ) {

                  console.log('condition has luggage / has packing cubes / has luggage cover')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('15% discount applied.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('15% discount applied.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                } else if( itemCount['packing-cubes'] > 0 ) {

                  console.log('condition has luggage / has packing cubes')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('15% discount applied.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', false)

                } else if( itemCount['luggage-cover'] > 0 ) {

                  console.log('condition has luggage / has luggage cover')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', false)

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('15% discount applied.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                } else {
                  console.log('nothing added')
                }
                break;

              case false:
                if( itemCount['packing-cubes'] > 0 && itemCount['luggage-cover'] > 0 ) {

                  console.log('condition no luggage / has packing cubes / has luggage cover')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('Order with a suitcase to unlock your 15% discount.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('Order with a suitcase to unlock your 15% discount.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                } else if( itemCount['packing-cubes'] > 0 ) {

                  console.log('condition no luggage / has packing cubes')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('Order with a suitcase to unlock your 15% discount.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', false)

                } else if( itemCount['luggage-cover'] > 0 ) {

                  console.log('condition no luggage / has luggage cover')
                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', false)

                  $upsellGrid['luggage-cover']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('Order with a suitcase to unlock your 15% discount.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                } else {
                  console.log('unknown condition')
                }
                break;

              default:
            }

          } else if( $upsellGrid['packing-cubes'].length ) {

            switch( itemCount['luggage'] > 0 ) {
              case true:
                if( itemCount['packing-cubes'] > 0 ) {

                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('15% discount applied.').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                }
                break;

              case false:
                if( itemCount['packing-cubes'] > 0 ) {

                  $upsellGrid['packing-cubes']
                    .attr('data-discount-percentage', 85).attr('data-in-cart', true)
                    .find('[data-upsell-message]').html('Order with a suitcase to unlock your 15% discount').show().end()
                    .find('.add-to-cart-wrapper').css('visibility', 'hidden')

                }
                break;

              default:
            }

          }
          */
          // Update price
          $upsellGrid['all'].each(function(){
            $upsellGridItem = $(this);
            if( $upsellGridItem.find('[data-swatch-item].active').length ) {
              $upsellGridItem.find('[data-swatch-item].active').first()
                .removeClass('active').find('[data-swatch-link]').click();
            }
          });

          if( typeof(refreshPromoModalCallback) === 'function' ) {
            refreshPromoModalCallback();
          }

          setTimeout(function(){
            $upsellModalWrap.removeClass('loading');
          }, 500);
        });
      });

      $modalTrigger.each(function(){
        let modalClass = $(this).attr('data-modal-class');
        $(this).magnificPopup({
          type: 'inline',
          mainClass: modalClass,
          closeOnBgClick: true,
          closeBtnInside: true,
          closeOnContentClick: false,
          tClose: 'x',
          removalDelay: 500,
          callbacks: {
            open: function() {
              $container.trigger('refreshPromoModal');
              cycleThroughElements('#ProductPromoModal *', window.lang);
            },
            close: function() {
              // Will fire when popup is closed
            }
          }
        });
      });
    },
    tabs: function(){
      let selectors = this.selectors;
      $(selectors.productSection + ' .tabs__content--0').addClass('current');
      $(selectors.productSection + ' .tabs__item--0').addClass('current');

      $(selectors.productSection + ' ul.tabs > li').click(function(){
        let $tabs = $(this).closest(`[product-tabs]`),
            tabId = $(this).attr('data-tab');
        $tabs.find('ul.tabs > li').removeClass('current');
        $tabs.find('.tabs__content').removeClass('current');
        $(this).addClass('current');
        $tabs.find('.tabs__content--' + tabId).addClass('current');

        $( selectors.sticky.selector ).trigger("sticky_kit:recalc");
      })
    },
    accordion: function(){
      var selectors = this.selectors;
      // mobile accordion for tabs content
      $(selectors.productSection + ' .accordion__toggle').click(function() {
        if($(this).next('div').is(':visible')){
          $(this).next('div').slideUp('fast');
          $(this).find('i').removeClass('icon-minus');
          $(this).find('i').addClass('icon-plus');
        } else {
          $(this).next('div').slideDown('fast');
          $(this).find('i').removeClass('icon-plus');
          $(this).find('i').addClass('icon-minus');
        }

        setTimeout(function(){
          $( selectors.sticky.selector ).trigger("sticky_kit:recalc");
        }, 200);
      });
    },
    tabsSpaceCheck: function(){
      var tabsHeight = $(this.selectors.productSection + ' .tabs').outerHeight(),
          firstTabItemHeight = $(this.selectors.productSection + ' .tabs__item').first().outerHeight();

      $(this.selectors.productSection + ' .product-tabs').show();
      $(this.selectors.productSection + ' .product-accordion').hide();

      // if( (tabsHeight - firstTabItemHeight) > 10 ) {
      if( $(window).width() < 1100 ) {
        $(this.selectors.productSection + ' .product-tabs').hide();
        $(this.selectors.productSection + ' .product-accordion').show();
      }
    },
    initStickyLayout: function() {
      var $container = this.$container,
          stickySelector = this.selectors.sticky
          tabsSpaceCheck = this.tabsSpaceCheck;
      $( stickySelector.selector )
        .stick_in_parent({
          parent: stickySelector.parent
        });
    },
    initProductUpsell: function() {
      var $container = this.$container,
          selectors = this.selectors,
          currentVariant = this.variants.currentVariant,
          $btnPrice = $('.js-btn-price'),
          $btnStatic = $('.js-btn-static'),
          $upsellItem = $container.find('.upsell-item'),
          discount = $upsellItem.data('upsell-item-discount'),
          itemPrice = $upsellItem.data('upsell-item-price'),
          productPrice = $('.product__price').data('price');

      if (window.nonEnglish) $btnStatic.html(translate('Add Both &ndash; ', window.lang));

      if( !$container.find('[data-upsell]').length ) {
        return;
      }
      mainProductSoldOut(currentVariant);

      const itemTotal = itemPrice - discount;
      const upsellTotal = productPrice + itemTotal;
      $btnPrice.html(slate.Currency.formatMoney(upsellTotal, moneyFormatLight))

      const $upsellItems = $container.find('.product__upsell__list');

      var getSelectedUpsellProductObject = function($upsellItem){
        var item = JSON.parse( $upsellItem.find('[data-upsell-product-json]').html() );
        if (!item) {
          return false;
        }
        return item;
      };

      var getSelectedUpsellVariantObject = function($upsellItem){
        let upsellProduct = getSelectedUpsellProductObject($upsellItem),
            variantTitle = '';
        if( !upsellProduct ) {
          return false;
        }

        $upsellItem.find('[data-swatch-list]').each(function(){
          let value = $(this).find('[data-swatch-item].active').find('[data-swatch-link]').attr('data-value');
          if( typeof(value) !== 'undefined' ) {
            variantTitle += (variantTitle=='') ? value : ' / ' + value;
          }
        })

        var sizeSelected = $('.product__info .product__options .swatch__list--size .swatch__item.active a').data('value');
        if (!variantTitle.includes(' / ') && sizeSelected) {
          variantTitle += (' / ' +  sizeSelected);
        }

        let variant = upsellProduct.variants.find(variant => variant.title === variantTitle) ? upsellProduct.variants.find(variant => variant.title === variantTitle) : false;
        if ($container.find('.upsell-item').data('upsell-item-handle') == 'metro-toiletry-case' && variantTitle == 'Small / Cactus (Vegan Leather)') {
          $container.find('.swatch__link[data-value="Large"]').click();
          return;
        }
        return variant;
      };

      var addQueue = [];

      var addAlong = function() {
        // If we still have requests in the queue, let's process the next one.
        if( addQueue.length ) {
          var request = addQueue.shift();
          // pass the properties into the function as well
          addItemWithProperties(request.variantId, request.quantity, request.properties, addAlong);
        } else {
          // If the queue is empty, we will redirect to the cart page.
          // document.location.href = '/cart';
          if (window.nonEnglish) {
            $container.find(`[action="/${window.langCode}/cart/add"]`).submit();
          } else {
            $container.find(`[action="/cart/add"]`).submit();
          }
        }
      };

      var addItemWithProperties = function(id, quantity, properties, callback) {
        var params = {
          quantity: quantity,
          id: id
        };

        if( properties != false ){
          params.properties = properties;
        }

        $.ajax({
          type: 'POST',
          url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
          dataType: 'json',
          data: params,
          success: function(){
            if(typeof callback === 'function'){
              callback();
            }
          },
          error: function(){}
        });
      };

      var pushToAddQueue = function (variantId, quantity, properties) {
        addQueue.push({
          variantId: variantId,
          quantity: quantity,
          properties: properties
        });
      };

      var updateSelectedColor = function(variant) {
        $upsellItems.each(function(){
          let $item = $(this),
              $checkbox = $item.find('[data-upsell-item]'),
              $includedItemColorSwatch = $item.find('[data-swatch-link]').filter(`[data-value="${variant.option1}"]`);
          let selected = false;
          if( $checkbox.val() == 'Metro Folio Kit' ) {
            selected = false;
          }

          if( $includedItemColorSwatch.length && !selected ) {
            $includedItemColorSwatch.click();
          }
        });
      };

      var updatePrice = function() {
        var moneyFormat = theme.moneyFormat,
            productPrice = parseInt( $container.find('[data-product-price]:first-of-type').attr('data-product-price') ) || 0,
            productCompareAtPrice = parseInt( $container.find('[data-product-compare-at-price]').attr('data-product-compare-at-price') ) || 0,
            totalPrice = productPrice,
            totalCompareAtPrice = productCompareAtPrice,
            discountValue = parseInt( $container.find('[data-upsell]').attr('data-bundle-discount-value') ),
            minimumQuantityOfItems = parseInt( $container.find('[data-bundle-minimum-quantity-of-items]').attr('data-bundle-minimum-quantity-of-items') ) || 2,
            activatedDiscount = ($container.find('[data-upsell-item]').length >= (minimumQuantityOfItems-1) ),
            upsellDiscount = $container.find('[data-bundle-discount-value]').attr('data-bundle-discount-value') || 0;

        if( Shopify.currency.rate !== undefined ) {
          discountValue *= Shopify.currency.rate;
        }

        var $item = $upsellItems.find('[data-upsell-item]'),
            upsellVariant = getSelectedUpsellVariantObject($item);
        if ( !upsellVariant ) {
          return;
        }
        var discountedVariantPrice = upsellVariant.price - upsellDiscount;

        compareAtPrice = ( upsellVariant.price > upsellVariant.compare_at_price) ? upsellVariant.price : upsellVariant.compare_at_price;
        totalPrice += discountedVariantPrice;
        totalCompareAtPrice += compareAtPrice;

        if( totalCompareAtPrice == 0 ) {
          totalCompareAtPrice = totalPrice;
        }
        // Apply bundle pricing
        /*
        if( activatedDiscount ) {
          totalPrice -= discountValue;
        }*/

        $btnPrice.html(slate.Currency.formatMoney(displayPercentage(totalPrice, window.displayPercentage), moneyFormatLight));
        $upsellItem.find('.upsell-item__price').html(slate.Currency.formatMoney(displayPercentage(upsellVariant.price, window.displayPercentage), moneyFormatLight));
        $upsellItem.find('.upsell-item__price--compare-at').html(slate.Currency.formatMoney(displayPercentage(upsellVariant.price - discountValue, window.displayPercentage), moneyFormatLight));
        function displayPercentage (price, percentage ) {
          if (!price) return
          if (!percentage) {
            return price
          }
          return price - (percentage * price / 100 );
        }
      };

      $(document).ready(function(){
        $upsellItems.each(function(){
          var $item = $(this);
          if( $item.find('[data-swatch-item].active').hasClass('sold-out') ) {
            $item.find('[data-swatch-item]').not('.sold-out').first().find('> [data-swatch-link]').click();
          } else {
            $item.find('[data-swatch-item].active > [data-swatch-link]').click();
          }
        });
        updateSelectedColor(currentVariant);
        updatePrice();
      });

      $container.on('variantChange', function(evt) {
        let variant = evt.variant;
        mainProductSoldOut(variant)
        updateSelectedColor(variant);
        updatePrice();
      });

      $container.find('[data-upsell]').find('[data-swatch-link]').click(function(){
        let $upsellItem = $(this).closest('[data-upsell-item]'),
            $upsellThumb = $upsellItem.find('[data-upsell-thumb]'),
            upsellProduct = getSelectedUpsellProductObject( $upsellItem ),
            upsellVariant = getSelectedUpsellVariantObject( $upsellItem ),
            upsellMedia = JSON.parse($container.find('[data-upsell-media]').html()),
            upsellScaled = upsellMedia.images.find(image => image.alt.includes(upsellVariant.title + ' Scaled'));

        if ( upsellVariant ) {
          if( upsellVariant.featured_media ) {
            imgUrl = upsellScaled ? upsellScaled.src : upsellVariant.featured_media.preview_image.src;
            imgUrl = imgUrl
                      .replace('.jpg', '_600x.jpg')
                      .replace('.png', '_600x.png')
                      .replace('.gif', '_600x.gif'),
            imageAlt = upsellScaled ? upsellScaled.alt : upsellVariant.featured_media.preview_image.alt;
          }
          if (!upsellVariant.available) {
            $upsellItem.find('.js-pdp-upsell').addClass('disabled');
          } else {
            $upsellItem.find('.js-pdp-upsell').removeClass('disabled');
          }
          $upsellThumb
            .removeClass('loaded')
            .html(`<img src="${imgUrl}" alt="${imageAlt}"" />`)
            .find('img').imagesLoaded(function(){
              $upsellThumb.addClass('loaded');
            });
        }

        updatePrice();
      });

      $container.find('[data-upsell-item]').change(function(){
        updatePrice();
      });
      $container.find('.js-pdp-upsell').click(function(e){
        e.preventDefault();
          var $upsellItem = $(e.target).closest('[data-upsell-item]'),
              upsellVariant = getSelectedUpsellVariantObject($upsellItem),
              variantId = upsellVariant.id,
              quantity = 1,
              properties = {};
          if( $upsellItem.find('[data-upsell-variant-metafields]').length ) {
            var upsellVariantMetafields = JSON.parse( $upsellItem.find('[data-upsell-variant-metafields]').html() )

            if( upsellVariantMetafields &&
                typeof( upsellVariantMetafields[variantId] ) !== undefined &&
                typeof( upsellVariantMetafields[variantId]['preorder_ship_date'] ) !== undefined ) {

              if ( upsellVariantMetafields[variantId].inventory_quantity == 'none' &&
                    upsellVariantMetafields[variantId].inventory_policy == 'continue' ) {
                properties = {
                  'Estimated delivery': upsellVariantMetafields[variantId]['preorder_ship_date']
                };
              }
            }
          }
          properties['_pdp upsell'] = variantId;
          if (window.referer) {
            properties['_referer'] = window.referer;
          }
          pushToAddQueue(variantId, quantity, properties);
          addAlong();
      });
      function mainProductSoldOut(variant) {
        if (!variant.available) {
          $container.find('.js-pdp-upsell').addClass('main-product-sold-out');
        } else {
          $container.find('.js-pdp-upsell').removeClass('main-product-sold-out');
        }
      }
    },
    klaviyoPixels: function(){
      var $container = this.$container;

      $container.on( "variantChange", function(evt) {
        var variant = evt.variant;
        if( typeof item !== 'undefined' ) {
          item.VariantID = variant.id;
          item.VariantName = variant.title;
          item.ImageURL = (variant.featured_image != null ) ? variant.featured_image.src : false;
          item.Price = slate.Currency.formatMoney(variant.price, theme.moneyFormatLight);
          item.CompareAtPrice = slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormatLight);
        }

        if( typeof _learnq !== 'undefined' && typeof item !== 'undefined' ) {
          _learnq.push(['track', 'Viewed Product', item]);
        }
      });
    },
    destroyStickyLayout: function() {
      $( this.selectors.sticky.selector ).trigger("sticky_kit:detach");
    },
    onBlockSelect: function(evt) {
      $('*[data-block-id="' + evt.detail.blockId + '"]').click();
    },
    onBlockDeselect: function(evt) {
      $('*[data-block-id="' + evt.detail.blockId + '"]').click();
    },
    minPurchase: function () {
      
    },
    initWarrantyModal: function() {
      $('.ltw-trigger, [data-product-ltw-trigger]').on('click', function(){
        magnificOpen('#lifetime-warranty-plus-modal', 'mfp-fade', ltwModal, () => {});
        function ltwModal() {
          $('button[id^="Add-lifetime-warranty-plus-add-"]').on('click', function(e) {
            e.preventDefault();
            var items = [];
            var ltwID = $(this).data('variant');
            var ltwObj = singleItemCartObject(ltwID, 1, {'_pdp ltw': true});
            if (window.referer) {
              ltwObj['_referer'] = window.referer;
            }
            items.push(ltwObj);
            cartAdd({items}, error, success, () => {});
            function error(xhr, status, error) {
              console.error('Error adding Lifetime Warranty Plus to cart:', error);
            }
            function success(data) {
              updateHeaderCartTotal();
              $.magnificPopup.close();
            }
            window.preventLTWModal = true;
          });
          $('a[id="Add-lifetime-warranty-plus-decline"]').on('click', function(e) {
            e.preventDefault();
            window.preventLTWModal = true;
            $.magnificPopup.close();
          });
        }
      });
    }
  });

  return Product;
})();
theme.Blog = (function() {
  function Blog(container) {
    var $container = this.$container = $(container),
        id = this.id = $container.attr('data-section-id'),
        blogSections = this.blogSections = new slate.Sections();

    this.initItemHover();
    this.tagSelector();

    var scope = this;
    this.$container.find('.blog__tags__link, .pagination a').click(function(e){
      e.preventDefault();
      var url = $(this).attr('href');
      scope.ajaxLoad( url );
    });
  }

  Blog.prototype = _.assignIn({}, Blog.prototype, {
    initItemHover: function() {
      this.$container.find('[article-item-link]')
        .mouseenter(function() {
          $(this).find('[article-item-btn]').addClass('active');
        })
        .mouseleave(function() {
          $(this).find('[article-item-btn]').removeClass('active');
        });

    },
    tagSelector: function(){
      var $tagSelector = this.$container.find('[tag-selector]');
      if( ! $tagSelector.length ) {
        return;
      }
      $tagSelector.change(function(e){
        var val = $(this).val();
        if( val == window.location.pathname ) {
          return;
        }
        window.location = val;
      });


      if( $().niceSelect !== undefined ) {
        $('select[tag-selector]').niceSelect();
      }
    },
    ajaxLoad: function(url){
      var $container = this.$container,
          blogSections = this.blogSections,
          title = $container.attr('data-title');


      if( url.indexOf('?') !== -1 ) {
        url += `&section_id=main-blog&title=${title}`;
      } else {
        url += `?section_id=main-blog&title=${title}`;
      }

      console.log({
        "url": url
      })

      $container.addClass('loading');

      $.get(url, function(data){
        $container.closest('.shopify-section').html( $(data).html() ).removeClass('loading');

        // Update url state & page title if it's a blog page
        url = url
          .replace(`?section_id=main-blog`, '')
          .replace(`&section_id=main-blog`, '')
          .replace(`section_id=main-blog`, '')
          .replace(`?title=${title}`, '')
          .replace(`&title=${title}`, '')
          .replace(`title=${title}`, '');

        if( window.location.href.indexOf('/blogs/') !== -1 ) {
          window.history.pushState({},"", url );
          // var newTitle = $(data).find('[data-page-title]').attr('data-page-title');
          // if( typeof(newTitle) !== 'undefined' ) {
          //   document.title = newTitle;
          // }
        }

        // Reset previous instances
        blogSections.instances = [];
        blogSections.register('blog', theme.Blog);

        // Refresh AOS
        if( typeof( AOS ) !== 'undefined' ) {
          AOS.refresh();
        }
      });
    }
  });

  return Blog;
})();

theme.Press = (function() {
  function Press(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id'),
        $pressSlider = $container.find('.press__slider'),
        $pressNavLink = $container.find('.press__nav__link'),
        updateNavStatus = this.updateNavStatus,
        fade = (Modernizr.touch) ? false : true;

    $pressSlider
      .on('init', function(event, slick){
        $container.find('.press__nav__item').removeClass('active');
        $container.find('.press__nav__link').filter('[data-index="0"]').closest('.press__nav__item').addClass('active');
      })
      .on('afterChange', function(event, slick, currentSlide) {
        $container.find('.press__nav__item').removeClass('active');
        $container.find('.press__nav__link').filter('[data-index="' + currentSlide + '"]').closest('.press__nav__item').addClass('active');

        $(window).trigger('resize');
      })
      .slick({
        fade: fade,
        infinite: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });

    $pressNavLink.on('click', function(e){
      e.preventDefault();
      var index = $(this).data('index');
      if( index == undefined ) {
        return;
      }
      $pressSlider.slick('goTo', index);
    });
  }

  Press.prototype = _.assignIn({}, Press.prototype, {
  });

  return Press;
})();

theme.Gallery = (function() {
  function Gallery(container) {
    let $container = this.$container = $(container);
    let $slider = this.$slider = this.$container.find('[data-gallery-slider]');
    this.init();
  }

  Gallery.prototype = _.assignIn({}, Gallery.prototype, {
    initSlider: function() {
      let zoom = ( this.$container.attr('data-zoom') == 'true' );

      if( !this.$slider.length ) {
        return;
      }

      this.$slider
        .on('mousedown',  function (evt, slick, direction) {
          if( $(evt.target).closest('[product-modal-toggle]').length ) {
            return;
          }
          Shopify.productModal.close();
        })
        .on('beforeChange', function(e, slick, currentSlide, nextSlide) {
          Shopify.productModal.close();
        })
        .on('afterChange', function(e, slick, currentSlide) {
          $(window).trigger('resize');
        })
        .slick({
          infinite: true,
          adaptiveHeight: false,
          autoplay: false,
          speed: 200,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: true,
                dots: true
              }
            }
          ]
        })
        // .slick('slickPause');

      if( zoom ) {
        this.initZoom();
      }
    },
    destroySlider: function() {
      if( !this.$slider.length ) {
        return;
      }
      this.$slider.slick('unslick');
    },
    initZoom: function() {
      if (Modernizr.touch) {
        return;
      }
      this.$container.find('img').magnificPopup({
        type: 'image',
        mainClass: 'mfp-fade mfp-gallery',
        closeOnBgClick: true,
        closeBtnInside: false,
        closeOnContentClick: true,
        tLoading: '',
        removalDelay: 200
      });
    },
    init: function() {
      this.initSlider();
    },
    onUnload: function() {
      this.destroySlider();
    },
    onBlockSelect: function(evt) {
      // Ignore the cloned version
      let $slide = this.$slider.find(`.slick-slide:not(.slick-cloned)[data-block-id="${evt.detail.blockId}"]`),
          slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      this.$slider.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });

  return Gallery;
})();

theme.Compare = (function() {
  function Compare(container) {
    let $container = this.$container = $(container);
    this.init();
  }

  Compare.prototype = _.assignIn({}, Compare.prototype, {
    init: function() {
      this.$container.find('.tabs__item').click(function(){
        let productHandle = $(this).attr('data-tab'),
            $gridItem = $(this).closest('.grid__item');
        $(this).closest('ul').find('li').removeClass('current');
        $(this).addClass('current');
        $gridItem.find('.compare__item').addClass('hide').filter(`[data-product-handle="${productHandle}"]`).removeClass('hide');
      });
    }
  });

  return Compare;
})();

theme.ProductGridItem = (function() {
  function ProductGridItem(container) {
    let $container = this.$container = $(container),
        gridType = this.gridType = $container.attr('data-grid-type');


    this.settings = {
      namespace: '.grid__wrap',
    }

    this.selectors = {
      productJson: '[data-product-grid-json]',
      productPrice: '[data-product-price]',
      comparePrice: '[data-product-compare-at-price]',
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if ( !$container.find( this.selectors.productJson ).html()) {
      return;
    }
    this.productSingleObject = JSON.parse( $container.find( this.selectors.productJson ).html() );

    $container.find('[data-product-grid-value="Size"]').each(function(){
      let swatchValue = $(this).find('span').html();
      let code = sizeSwatchCodes.find(element => element.value.toLowerCase() == swatchValue.toLowerCase())?.code;
      $(this).find('span').html(code);
    });
    this.updateAllVariants();
    this.initUpsellGrid();
    this.bundleGrid();
    this.alphabetStickersGrid();

    if( Modernizr.touch ) {
      this.$container.find('.grid__form').click(function(e){
        let $sectionSlider = $(e.target).closest('.shopify-section').hasClass('section-product-slider');
        let $sectionCompare = $(e.target).closest('.shopify-section').hasClass('section-compare-sizes');
        if ($sectionSlider && mediumDown()) {
          let variantLink = $(e.target).closest('.grid__body').find('.grid__link').attr('href');
          if (variantLink) window.location.href = variantLink;
        } else {
          $(this).addClass('in');
        }
      });
    }
    /*
    if (window.nonEnglish) {
      $container.find('.active a').each(function(){
        $(this).trigger('click');
      });
    }*/

       
             const $image = this.$container.find('.grid__link');

             $image.on('mouseenter', function () {
             $(this).find('[data-grid-image], [data-grid-image-hover]').addClass('hover__hide');
             });

            $image.on('mouseleave', function () {
            $(this).find('[data-grid-image], [data-grid-image-hover]').removeClass('hover__hide');
            });

  }

  ProductGridItem.prototype = _.assignIn({}, ProductGridItem.prototype, {
    updateAllVariants: function(){
      let $container = this.$container,
          selectors = this.selectors,
          productSingleObject = this.productSingleObject;
      this.$container.on('variantChange' + this.settings.namespace, function(evt){
        let selectedVariant = '';
        let valueHidden = false;

        // Build selectedVariant string based on currently active swatches
        $(evt.target).find('.swatch__item.active .swatch__link').each(function(i){
          if ($(this).closest('.swatch-wrapper').hasClass('hide')) {
            valueHidden = true;
          } else {
            selectedVariant = !selectedVariant ? $(this).data('value') : selectedVariant + ' / ' + $(this).data('value');
          }
        });

        // Find the product object and then get the variant with title === selectedVariant
        let productObj = getProductObject($(evt.target), '[data-product-grid-json]');
        let variant = null;
        if (productObj && productObj.variants && selectedVariant) {
          variant = productObj.variants.find(v => v.title === selectedVariant);
        }

        let imgUrl = false,
            imgHoverUrl = false,
            imageAlt = '';

        if (variant && !valueHidden && selectedVariant) {
          // IMAGE LOGIC
          if (variant.featured_media) {
            imgUrl = variant.featured_media.preview_image.src
                        .replace('.jpg', '_600x.jpg')
                        .replace('.png', '_600x.png')
                        .replace('.gif', '_600x.gif');
            imageAlt = variant.featured_media.alt;
          }

          $container.find('[data-product-url]').each(function(){
            let productUrl = $(this).attr('data-product-url');
            $(this).attr('href', productUrl + '?variant=' + variant.id);
          });

          // IMAGE ALT / SCALED / HOVER LOGIC
          let variantScaledAlt = variant.title + ' Scaled',
              variantHoverAlt = variant.title + ' Hover',
              colorScaledAlt = false,
              colorHoverAlt = false,
              colorOptionIndex = productSingleObject.options.indexOf('Color');
          if (window.nonEnglish) {
            if (variant.title.includes(' / ')) {
              const [firstPart, secondPart] = variant.title.split(' / ');
              var firstPartMod = translate(firstPart, 'english') != firstPart ? translate(firstPart, 'english') : firstPart;
              var secondPartMod = translate(secondPart, 'english') != secondPart ? translate(secondPart, 'english') : secondPart;
              variantScaledAlt = firstPartMod + ' / ' + secondPartMod + ' Scaled';
            } else {
              variantScaledAlt = translate(variant.title, 'english') + ' Scaled';
            }
          }

          if (colorOptionIndex != -1) {
            colorScaledAlt = translate(variant.options[colorOptionIndex], 'english') + ' Scaled';
            colorHoverAlt = translate(variant.options[colorOptionIndex], 'english') + ' Hover';
          }

          if (colorScaledAlt) {
            for (let i=0 ; i<productSingleObject.media.length ; i++) {
              let mediaItem = productSingleObject.media[i],
                  mediaItemAlt = mediaItem.alt;
              if (mediaItemAlt !== null) {
                mediaItemAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[0] : mediaItem.alt;
                if (mediaItem.media_type == 'image' && mediaItemAlt == colorScaledAlt) {
                  imageAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[1] : mediaItem.alt;
                  imgUrl = mediaItem.src
                    .replace('.jpg', '_600x.jpg')
                    .replace('.png', '_600x.png')
                    .replace('.gif', '_600x.gif');
                }
              }
            }
          }
          if (colorHoverAlt) {
            for (let i=0 ; i<productSingleObject.media.length ; i++) {
              let mediaItem = productSingleObject.media[i],
                  mediaItemAlt = mediaItem.alt;
              if (mediaItemAlt !== null) {
                mediaItemAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[0] : mediaItem.alt;
                if (mediaItem.media_type == 'image' && mediaItemAlt == colorHoverAlt) {
                  imageAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[1] : mediaItem.alt;
                  imgHoverUrl = mediaItem.src
                    .replace('.jpg', '_600x.jpg')
                    .replace('.png', '_600x.png')
                    .replace('.gif', '_600x.gif');
                }
              }
            }
          }
          for (let i=0 ; i<productSingleObject.media.length ; i++) {
            let mediaItem = productSingleObject.media[i],
                mediaItemAlt = mediaItem.alt;
            if (mediaItemAlt !== null) {
              mediaItemAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[0] : mediaItem.alt;
              if (mediaItem.media_type == 'image' && mediaItemAlt == variantScaledAlt) {
                imageAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[1] : mediaItem.alt;
                imgUrl = mediaItem.src
                  .replace('.jpg', '_600x.jpg')
                  .replace('.png', '_600x.png')
                  .replace('.gif', '_600x.gif');
              }
            }
          }
          for (let i=0 ; i<productSingleObject.media.length ; i++) {
            let mediaItem = productSingleObject.media[i],
                mediaItemAlt = mediaItem.alt; 
            if (mediaItemAlt !== null) {
              mediaItemAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[0] : mediaItem.alt;
              if (mediaItem.media_type == 'image' && mediaItemAlt == variantHoverAlt) {
                imageAlt = (mediaItem.alt.indexOf(' | ') != -1) ? mediaItem.alt.split(' | ')[1] : mediaItem.alt;
                imgHoverUrl = mediaItem.src
                  .replace('.jpg', '_600x.jpg')
                  .replace('.png', '_600x.png')
                  .replace('.gif', '_600x.gif');
              }
            }
          }

          if (imgHoverUrl) {
            if (!$container.find('.grid__link').hasClass('secondary_image_true')) {
              $container.find('.grid__link').addClass('secondary_image_true');   
            }
          } else {
            $container.find('.grid__link').removeClass('secondary_image_true');
          }

          $container.find('[data-grid-image]')
            .attr('data-bgset', '')
            .attr('alt', imageAlt)
            .css('background-image', `url("${imgUrl}"`);
          $container.find('[data-grid-image-hover]')
            .attr('data-bgset', '')
            .attr('alt', imageAlt)
            .css('background-image', `url("${imgHoverUrl}"`);
          if (typeof($container.attr('data-discount-percentage')) === 'undefined') {
            return;
          }

          let moneyFormat = theme.moneyFormat,
              variantPrice = variant.price,
              variantCompareAtPrice = variant.compare_at_price,
              displayPercentage = window.displayPercentage,
              discountPercentage  = parseInt($container.attr('data-discount-percentage'));

          if (variantCompareAtPrice === null || variantCompareAtPrice < variantPrice) {
            variantCompareAtPrice = variantPrice;
          }

          // Regardless of stock, update the product price
          $container.find(selectors.productPrice).html("<span class='money'>" + slate.Currency.formatMoney(variantPrice, moneyFormat) + "</span>").attr('data-product-price', variantPrice);

          variantPrice *= (discountPercentage / 100);
          if (displayPercentage) variantPrice *= (displayPercentage / 100);

          // Regardless of stock, update the product price again (discounted value)
          $container.find(selectors.productPrice).html("<span class='money'>" + slate.Currency.formatMoney(variantPrice, moneyFormat) + "</span>").attr('data-product-price', variantPrice);

          // Also update and show the product's compare price if necessary
          if (variantCompareAtPrice > variantPrice) {
            $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', variantCompareAtPrice);
            $container.find(selectors.comparePrice).closest('.compare-at').show();
            $container.find(selectors.productPrice).closest('.product__price').addClass('on-sale');
          } else {
            $container.find(selectors.comparePrice).html("<span class='money'>" + slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) + "</span>").attr('data-product-compare-at-price', variantCompareAtPrice);
            $container.find(selectors.comparePrice).closest('.compare-at').hide();
            $container.find(selectors.productPrice).closest('.product__price').removeClass('on-sale');
          }

          if (variantCompareAtPrice > variantPrice) {
            $container.find('.grid__price').addClass('on-sale');
          } else {
            $container.find('.grid__price').removeClass('on-sale');
          }
        }
      });

    },
    initUpsellGrid: function(){
      let $container = this.$container,
          productSingleObject = this.productSingleObject;

      if( this.gridType == 'upsell-grid-item' ) {
        $(`<p class="grid__upsell-message h6" style="display:none;" data-upsell-message></p>`).insertAfter( $container.find('.add-to-cart-wrapper') );
      }

      if( productSingleObject.title == 'Luggage Cover' &&
          $container.attr('data-grid-type') == 'upsell-grid-item' &&
          $('[data-section-type="product"]').find('[data-product-json]').length ) {

        let mainProductTitle = JSON.parse( $('[data-section-type="product"]').find('[data-product-json]').html() ).title;

        switch(mainProductTitle) {
          case 'Carry-On':
            $container.find(`[data-swatch-link][title="Carry-On"]`).click();
            break;

          case 'Carry-On Plus':
            $container.find(`[data-swatch-link][title="Carry-On Plus"]`).click();
            break;

          case 'Check-In Medium':
            $container.find(`[data-swatch-link][title="Check-In Medium"]`).click();
            break;
          case 'Carry-On Pro':
            $container.find(`[data-swatch-link][title="Carry-On Pro"]`).click();
            break;
          case 'Carry-On Pro Plus':
            $container.find(`[data-swatch-link][title="Carry-On Pro Plus"]`).click();
            break;
          case 'Check-In Large':
            $container.find(`[data-swatch-link][title="Check-In Large"]`).click();
            break;
          case 'Hybrid Carry-On':
            $container.find(`[data-swatch-link][title="Hybrid Carry-On"]`).click();
            break;
          case 'Hybrid Carry-On Plus':
            $container.find(`[data-swatch-link][title="Hybrid Carry-On Plus"]`).click();
            break;
          case 'Hybrid Check-In Medium':
            $container.find(`[data-swatch-link][title="Hybrid Check-In Medium"]`).click();
            break;
          case 'Hybrid Check-In Large':
            $container.find(`[data-swatch-link][title="Hybrid Check-In Large"]`).click();
            break;
          case 'Hybrid Trunk':
            $container.find(`[data-swatch-link][title="Hybrid Trunk"]`).click();
            break;
          default:
        }
      }
    },
    bundleGrid: function(){
      if( Shopify.currency && Shopify.currency.rate ) {
        let $bundleStartingFromPrice = this.$container.find(`[data-product-bundle-starting-from-price]`),
            $bundleSaving = this.$container.find(`[data-product-bundle-saving]`);
        if( $bundleStartingFromPrice.length ) {
          let productPriceMin = parseInt( $bundleStartingFromPrice.attr('data-product-price-min') ) || 0,
              bundleDiscount = parseInt( $bundleStartingFromPrice.attr('data-bundle-discount') ) * Shopify.currency.rate || 0 ;
          $bundleStartingFromPrice.html( slate.Currency.formatMoney((productPriceMin - bundleDiscount), theme.moneyFormat) );
        }
        if( $bundleSaving.length ) {
          let savingMax = parseInt( $bundleSaving.attr('data-saving-max') ) * Shopify.currency.rate || 0;
          $bundleSaving.html( slate.Currency.formatMoney(savingMax, theme.moneyFormat) );
        }
      }
    },
    alphabetStickersGrid: function(){
      let $container = this.$container;
      let productHandle = $container.data('product-handle');
    }
  });

  return ProductGridItem;
})();

function getProductObject($container, jsonSelector) {
  return JSON.parse($container.find(jsonSelector).html());
}

theme.PageFaq = (function() {
  function PageFaq(container) {
    var $container = this.$container = $(container);
    // var stickySelector = this.stickySelector = '.faq__main, .faq__sidebar',
    //     parent = this.parent = '.faq__grid';

    var selectors = this.selectors = {
      sticky: {
        selector: '.faq__main, .faq__sidebar',
        parent: '.faq__grid',
      },
      nav: {
        item: '.faq__nav__item',
        link: '.faq__nav__link'
      }
    }

    // this.navClick();
    this.scrollSpy();

    var currentScope = this;
    $(window).resize(function() {
      if( $(window).width() >= 768 ) {
        currentScope.initStickyLayout();
      } else {
        currentScope.destroyStickyLayout();
      }
    }).resize();
  }

  PageFaq.prototype = _.assignIn({}, PageFaq.prototype, {
    navClick: function(){
      var $container = this.$container,
          navSelectors = this.selectors.nav;
      $container.find( navSelectors.link ).click(function(){
        var $items = $container.find( navSelectors.link ).removeClass('active');
        $(this).addClass('active');
      });
    },
    scrollSpy: function() {
      $('.faq__group').waypoint(function(direction) {
        var id = this.element.id;
        if( direction == 'down') {
          $('.faq__nav__link').removeClass('active');
          $('.faq__nav__link').filter('[href="#' + this.element.id + '"]').addClass('active');
        }
      }, {
        offset: '50%'
      });

      $('.faq__group').waypoint(function(direction) {
        var id = this.element.id;
        if( direction == 'up') {
          $('.faq__nav__link').removeClass('active');
          $('.faq__nav__link').filter('[href="#' + this.element.id + '"]').addClass('active');
        }
      }, {
        offset: '0%'
      });
    },
    initStickyLayout: function() {
      var stickySelector = this.selectors.sticky.selector,
          parent = this.selectors.sticky.parent;
      this.$container.find( stickySelector )
        .stick_in_parent({
          parent: parent
        });
    },
    destroyStickyLayout: function() {
      this.$container.find( this.selectors.sticky.selector ).trigger("sticky_kit:detach");
    }
  });

  return PageFaq;
})();

theme.Testimonials = (function() {
  $('.testimonials').slick({
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: true
        }
      }
    ]
  });
})();

theme.FeaturedProductSlider = (function() {
  $('.featured-product__slider').slick({
    slidesToShow: 3,
    infinite: true,
    variableWidth: true,
    centerMode: true,
    swipeToSlide: true,
    speed: 200,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 3,
          dots: true
        }
      }
    ]
  });

  $('.featured-product__set').on('click', function(e){
    const set = $(this).data('set');
    setActiveSlider(set);
    setActiveButton($(e.target));
    initSlide(set);
  });

  function setActiveButton($target) {
    $('.featured-product__set').removeClass('active');
    $target.closest('.featured-product__set').addClass('active');
  }
  function setActiveSlider(set) {
    $(`.featured-product__slider`).addClass('hide');
    $(`.featured-product__slider[data-set-slider="${set}"]`).removeClass('hide');
  }
  function initSlide(set) {
    $(`.featured-product__slider.slick-initialized[data-set-slider="${set}"]`).slick('slickGoTo', 0, true);
  }

  if (window.location.href.includes('#')) {
    var set = window.location.href.split('?')[0].split('#')[1];
    $('.featured-product__set').each(function(){
      var setHandleize = $(this).data('set').replace(/ /g, '-').toLowerCase();
      if (set == setHandleize) {
        $(this).trigger('click');
      }
    });
  }
})();


theme.CompareSizes = (function() {
  if (!($('.section-compare-sizes').length > 0)) return;
  let swiperCompare = null;
  let selectorClass = 'js-category';
  let dropDownClass = '.js-category-select'
  let $handles = $('[data-product-handles]');
  let productHandles = $handles.length ? $handles.data('product-handles').split(', ') : null;
  let currentSelection = $(`.${selectorClass}`).length ? $(`.${selectorClass}.active`).data('luggage') : $(dropDownClass).val();

  if ($(dropDownClass).length) $('[data-nice-select]').niceSelect();
  categorySelect(currentSelection);
  if (largeDown()) {
    sizeSelect();
    mobileSwiperInit();
  } else {
    sizeDeSelect();
  };
  updateCompareHeight();

  $('[data-luggage-size]').on('click', function(e){
    var size = $(e.target).data('luggage-size');
    $('[data-luggage-size]').removeClass('active');
    $(`[data-luggage-size="${size}"]`).addClass('active');
    sizeSelect();
    updateCompareHeight();
  });

  if ($('.js-category').length) {
    $('.js-category').on('click', function(e){
      var category = $(e.target).data('luggage');
      $('.js-category').removeClass('active');
      $(`[data-luggage="${category}"]`).addClass('active');
      categorySelect(category);
      updateCompareHeight();
      if (largeDown()) {
        switch(category) {
          case 'hybrid':
            defaultSize = 'hybrid-carry-on'
            break;
          case 'classic':
            defaultSize = 'carry-on'
            break;
          case 'expandable':
            defaultSize = 'expandable-carry-on'
            break;
          default:
            defaultSize = false;
        }
        if (defaultSize) {
          $(`[data-luggage-size="${defaultSize}"]`).trigger('click');
        }
      }
    });
  } else {
    $('select'+dropDownClass+'#select-desktop').on('change', function(e){
      const category = $(this).val();
      $('select'+dropDownClass+'#select-mobile').val(category).niceSelect('update');
      categorySelect(category);
      updateCompareHeight();
      //setTimeout(()=>{$(`.swiper-slide.${category}`).first().trigger('click')},100);
    });

    $('select'+dropDownClass+'#select-mobile').on('change', function(){
      const category = $(this).val();
      $('select'+dropDownClass+'#select-desktop').val(category).niceSelect('update');
      categorySelect(category);
      updateCompareHeight();
      setTimeout(()=>{$(`.swiper-slide.${category}`).first().trigger('click')},100);
      if ($('.section-compare-sizes .swiper').hasClass('swiper-initialized')) {
        swiperDestroy();
        mobileSwiperInit();
      } else {
        mobileSwiperInit();
      }
    });
  }

  function mobileSwiperInit() {
    swiperCompare = new Swiper('.section-compare-sizes .swiper', {
      spaceBetween: 0,
      slidesPerView: 'auto',
      loop: false,
      on: {
        init: function () {
        },
      },
    });
  }
  function swiperDestroy() {
    if ($('.section-compare-sizes .swiper').hasClass('swiper-initialized') && swiperCompare) {
      swiperCompare.destroy();
      swiperCompare = null;
    }
  }
  function sizeSelect() {
    var size = $('[data-luggage-size].active').data('luggage-size');
    productHandles.forEach(element => {
      $(`.${element}`).addClass('hide');
    });
    $(`.${size}`).removeClass('hide');
  }
  function sizeDeSelect() {
    if (!productHandles) return;
    productHandles.forEach(element => {
      $(`.${element}`).removeClass('hide');
    });
  }
  function categorySelect(luggage) {
    if (!luggage) return;
    let activeCategory = luggage;
    let hiddenCategories = [];
    if ($(selectorClass).length) {
      $(`.${selectorClass}:not(.active)`).each(function(){
        hiddenCategories.push($(this).data('luggage'));
      });
    } else {
      $(`${dropDownClass} .option:not(.selected)`).each(function(){
        hiddenCategories.push($(this).data('value'));
      });
    }
    hiddenCategories.map(function(item){
      $(`.${item}`).addClass('hide');
    });
    $(`.${activeCategory}`).removeClass('hide');
  }

  function updateCompareHeight() {
    var $container = $('#compare-luggage-products');
    if (!$container.length) return;

    if (largeDown()) {
      $container.css('height', '');
      return;
    }

    var $visibleItem = $container
      .find('.grid__item')
      .not('.grid__item--title')
      .filter(':visible')
      .first();

    if ($visibleItem.hasClass('large-up--one-eighth')) {
      $container.css('height', '300px');
    } else if ($visibleItem.hasClass('large-up--one-sixth')) {
      $container.css('height', '330px');
    } else if ($visibleItem.hasClass('large-up--one-fifth')) {
      $container.css('height', '370px');
    }
     else {
      $container.css('height', '');
    }
  }

  $('.compare-luggage__nav').css({ 'top': headerHeight() + 'px' })
  
  $(window).on('scroll', ()=>{
    var elements = document.getElementsByClassName('length-of-trip');
    var element = elements[0];
    if (!element) return;
    var rect = element.getBoundingClientRect();
    var threshold = largeDown() ? 870 : 175;
    var topDefault = largeDown() ? 28 : 99;
    var scrolling = rect.top < threshold;
    scrolling = true;
    if (scrolling) {
      $('.compare-luggage__nav').addClass('fixed');
      $('.compare-luggage__nav').css({ 'top': headerHeight() + 'px' })
      if (largeDown()) $('.product-section').addClass('scroll');
    } else {
      $('.compare-luggage__nav').removeClass('fixed');
      if (largeDown()) $('.product-section').removeClass('scroll');
      $('.compare-luggage__nav').css({ 'top': topDefault + 'px' });
    }
    if (!largeDown()) {
      sizeDeSelect();
      categorySelect($('select'+dropDownClass+'#select-desktop').val());
      updateCompareHeight();
    }
  });

  $(window).on('resize', function(){
    if (largeDown()) {
      sizeSelect();
      //setTimeout(()=>{$(`.swiper-slide.${$('select'+dropDownClass+'#select-desktop').val()}`).first().trigger('click')},100);
      mobileSwiperInit();
    } else {
      sizeDeSelect();
      categorySelect($('select'+dropDownClass+'#select-desktop').val());
    }
    updateCompareHeight();
  });
})();

theme.StickyNav = (function() {
  window.addEventListener('resize', stickyNavHandler);
  window.addEventListener('load', stickyNavHandler);

  function stickyNavHandler() {
    $('.section-sticky-nav').stick_in_parent({
      offset_top: headerHeight()
    })
    .on("sticky_kit:stick", function(e) {
        $(e.target).css({
          'top': `${headerHeight()}px`
      })
    .on("sticky_kit:unstick", function(e) {
        $(e.target).css({
          'top': `${headerHeight()}px`
        });
      });
    });
  
    const stickyNavMobile = new Swiper('.sticky-nav__wrapper .swiper', {
      spaceBetween: 0,
      loop: false,
      direction: 'horizontal',
      slidesPerView: 'auto',
      on: {
        init: function () {
        },
      },
    });
  }
})();

theme.Logo = (function() {
  const logoSwiper = new Swiper('.section-logo-swiper .swiper', {
    spaceBetween: 20,
    loop: true,
    loopAdditionalSlides: 4,
    slidesPerView: 2.5,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
      990: {
        slidesPerView: 5,
        spaceBetween: 0,
      }
    }
  });
})();

theme.FeaturedImageRow = (function() {
  const featuredImageSwiper = new Swiper('.section-featured-image-row .swiper', {
    spaceBetween: 0,
    loop: true,
    direction: 'horizontal',
    slidesPerView: 1.4,
    variableWidth: true,
    centeredSlides: true,
  });
})();

$(document).ready(function(){
  if ($('.discount-code__upsell').length && discountLinkTrigger) {
    var addToCartText = {
      default: 'Add to Cart',
      adding: 'Adding...',
      added: 'Added'
    }
    
    if (getCookie('discount_code') && getCookie('discount_code').includes(discountLinkTrigger) && getCookie('hide_discount_modal_upsell') != 'true') {
      $('.discount-code__upsell').addClass('in');

      var $container = $('body [data-section-type="discount-modal-upsell"]'),
          selectors = {
            wrapper: '.swatch-wrapper',
            swatchList: '[data-swatch-list]',
            swatchItem: '[data-swatch-item]',
            swatchLink: '[data-swatch-link]',
            swatchValue: '[data-swatch-label-value]'
          };
      $('body')
        .on('click', `[data-section-type="discount-modal-upsell"]` + ' ' + selectors.swatchLink, function(e){
          e.preventDefault();

          var val = $(this).data('value'),
              $upsellItem = $('[data-section-type="discount-modal-upsell"]'),
              $upsellThumb = $upsellItem.find('[data-upsell-thumb]'),
              $swatchWrapper = $(this).closest( selectors.wrapper ),
              $productSwatch = $swatchWrapper.find( selectors.swatchItem ),
              productObject = false,
              productVariantTitle = '',
              productId = $upsellItem.attr('data-product-id'),
              variant = false;

          // Update swatch label
          $swatchWrapper.find( selectors.swatchValue ).html(val);

          // Update swatch state
          $productSwatch.removeClass('active');
          $(this).closest( selectors.swatchItem ).addClass('active');

          /*
          if( !$upsellItem.find('[data-product-json][data-product-id="' + productId + '"]').length ) {
            return;
          }
          */
          productObject = discountModalProductObject;
          $upsellItem.find('.swatch-wrapper').each(function(){
            var optionValue = $(this).find('[data-swatch-item].active > a').attr('data-value');
            if( typeof(optionValue) === 'undefined' ) {
              optionValue = $(this).find('[data-swatch-item]').first().find('> a').attr('data-value');
            }
            if( productVariantTitle != '' ) {
              productVariantTitle += ' / ';
            }
            productVariantTitle += optionValue;
          });
          for( var i=0 ; i<productObject.variants.length ; i++ ) {
            var v = productObject.variants[i];
            if( v.title == productVariantTitle ) {
              variant = v;
            }
          }
          if( variant ) {
            $upsellItem.attr('data-variant-id', variant.id);

            let featuredImage = productObject.featured_image;

            if( variant.featured_image && typeof( variant.featured_image.src ) !== 'undefined' ) {
              featuredImage = variant.featured_image.src;
            }

            $upsellThumb
              .removeClass('loaded')
              .html('<img src="' + featuredImage.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png').replace('.gif', '_120x.gif') + '" />')
              .find('img').imagesLoaded(function(){
                $upsellThumb.addClass('loaded');
            });
          }
        })
        .on('click', `[data-section-type="discount-modal-upsell"]` + ' ' + '[data-upsell-add]', function(e){
          e.preventDefault();
          e.stopPropagation();
          $(this).text(addToCartText.adding);
          // if swatch is clicked, stop adding
          if( $(e.target).attr('data-swatch-link') !== undefined ||
              $(e.target).closest('[data-swatch-link]').length ) {
            return;
          }
          
          var $upsellItem = $('[data-section-type="discount-modal-upsell"]'),
              variantId = $upsellItem.attr('data-variant-id'),
              properties = {},
              data = {
                quantity: 1,
                id: variantId
              };
              properties['_modal upsell'] = variantId;
          if( discountModalVariantMetafields ) {
            var upsellVariantMetafields = discountModalVariantMetafields

            if( upsellVariantMetafields &&
                typeof( upsellVariantMetafields[variantId] ) !== undefined &&
                typeof( upsellVariantMetafields[variantId]['preorder_ship_date'] ) !== undefined ) {

              if ( upsellVariantMetafields[variantId].inventory_quantity == 'none' &&
                    upsellVariantMetafields[variantId].inventory_policy == 'continue' ) {
                    properties['Estimated delivery'] = upsellVariantMetafields[variantId]['preorder_ship_date'];
              }
            }
          }

          if( properties != false ){
            data.properties = properties;
          }

          $.ajax({
            type: 'POST',
            url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
            dataType: 'json',
            data: data,
            error: function(){
              // console.log('error')
            },
            success: function(){
              // console.log('success')
            },
            complete: function(jqxhr, text) {
              $(this).text(addToCartText.added);
              $.getJSON('/cart.js')
                .done(function(cart) {
                
                var cartItemCount  = theme.getCartItemCount(cart);

                if( cartItemCount == 0 ) {
                  $('.cartCount').html(cartItemCount).addClass('hidden-count');
                } else {
                  $('.cartCount').html(cartItemCount).removeClass('hidden-count');
                  $('.header-cart .cartIcon').addClass('nav__icon--filled');
                }
                $('.discount-code__upsell').removeClass('in');
                setCookie('hide_discount_modal_upsell', 'true', 7);
              });
            }
          });
        });
        var variantId = $container.attr('data-default-variant-id');
        if( $container.find('[data-swatch-link][data-variant-id="' + variantId + '"]').length ) {
          $container.find('[data-swatch-link][data-variant-id="' + variantId + '"]').click();
        } else {
          $container.filter('.active').each(function(){
            $(this).find(' > [data-swatch-link]').click();
          })
        }
        $('[data-section-type="discount-modal-upsell"] .close').on('click', function(){
          $('.discount-code__upsell').removeClass('in');
          setCookie('hide_discount_modal_upsell', 'true', 7);
        });
    }
  }
});

theme.RetailGuide = (function() {
    const headerLinkEl = '.retail__header--link';
    const headerLinkElDropdownEl = '.retail__header--link-dropdown';
    const retailProductModalSectionEl = '.retail__product-section';
    $(window).on('load', function(){
      if (window.location.href.includes('#')) {
        let type = window.location.href.split('#')[1];
        if (type.includes('airline-size-guide')) {
          $.magnificPopup.open({
            items: {
                src: '#airline-size-guide',
            },
            type: 'inline',
            mainClass: 'modal--airline-size-guide',
            midClick: true,
            callbacks: {
              open: function() {
                $('.modal--airline-size-guide').on('scroll', ()=>{
                  var element = document.getElementById('tableContainer');
                  var rect = element.getBoundingClientRect();
                  if (rect.top < 0) {
                    $('.header-row').addClass('fixed');
                    $('.first-row').addClass('scrolling');
                  } else {
                    $('.header-row').removeClass('fixed');
                    $('.first-row').removeClass('scrolling');
                  }
                });
              }
            }
        });
        } else {
          let category = false;

          $('.retail-guide__category').each(function(){
            if ($(this).attr('id') == type) {
              category = type;
              type = $(this).closest('.retail-guide__product-grid').data('grid-type');
            }
          });
          setTimeout(function(){
            $(`${headerLinkEl} a[data-type="${type}"]`).trigger('click');
            $(`${headerLinkEl} a[data-type="${type}"]`).closest(headerLinkEl).addClass('active');
            $(`${headerLinkElDropdownEl} a[data-type="${type}"]`).closest(headerLinkElDropdownEl).addClass('active');
            if (category) {
              setTimeout(function(){
                $(`a.faq__nav__link[href="#${category}"`).trigger('click');
              }, 500)
            }
          }, 500)
        }
      }
    });

    $(`${headerLinkEl}:not(.compare__link), ${headerLinkElDropdownEl}`).on('click', function(){
      const type = $(this).find('a').data('type');
      $(headerLinkEl).removeClass('active');
      $(headerLinkElDropdownEl).removeClass('active');
      $(`${headerLinkEl} a[data-type="${type}"]`).closest(headerLinkEl).addClass('active');
      $(`${headerLinkElDropdownEl} a[data-type="${type}"]`).closest(headerLinkElDropdownEl).addClass('active');

      $('.retail-guide__product-grid').addClass('hide');
      $(`.retail-guide__product-grid.${type}`).removeClass('hide');
      $('.retail-guide__sub-nav').addClass('hide');
      $(`.retail-guide__sub-nav.${type}:not(.always-hide)`).removeClass('hide');

      $('.faq__sidebar:not(.hide) .faq__nav__link').removeClass('active');
      $('.faq__sidebar:not(.hide) .faq__nav__link').first().addClass('active');
      $('.faq__sidebar:not(.hide)').trigger("sticky_kit:detach");
      $('.faq__sidebar:not(.hide)').stick_in_parent();
    });
    $(retailProductModalSectionEl).each(function(){
      let $container = $(this),
        $sizeSwatches = $container.find('.swatch-wrapper--size'),
        $sizeSelectorWrapper = $sizeSwatches.find('+ .selector-wrapper'),
        $sizeSelect = $sizeSelectorWrapper.find('select'),
        enableSizeDropdown = false,
        productHandle = $container.attr('id'),
        productData = JSON.parse($container.next('[data-product-grid-json]').html()),
        enableSizeDropdownHandles = ["packing-cubes","luggage-cover","kiyo-uvc-water-bottle","metro-toiletry-case","metro-laptop-sleeve","garment-sleeve","washable-luggage-cover","reformation-packing-cubes"];
      enableSizeDropdown = $sizeSwatches.length && enableSizeDropdownHandles.includes(productHandle) ? true : false;

      if (enableSizeDropdown) {
        $sizeSwatches.remove();
        $sizeSelectorWrapper.find('label').hide();
        $sizeSelect
          .hide()
          .clone()
          .attr('id', $sizeSelect.attr('id') + '--cloned' )
          .attr('class', '')
          .attr('data-index', '')
          .attr('data-section', '')
          .attr('data-nice-select', '')
          .insertAfter( $sizeSelectorWrapper );

        var $sizeSelectCloned = $container.find( '#' + $sizeSelect.attr('id') + '--cloned' );

        if( $().niceSelect !== undefined ) {
          $sizeSelectCloned
            .attr('size-selector', '')
            .niceSelect();
        }
        $sizeSelectCloned.change(function(){
          var val = $(this).val();
          $sizeSelect.val(val).change();
          let variantTitle = val;
          $container.find('[data-swatch-item].active').each(function(i){
            const option = $(this).find('a').data('value');
            variantTitle = variantTitle + ' / ' + option;
          });

          const price = productData.variants.find(variant => variant.title == variantTitle).price;
          const comparePrice = productData.variants.find(variant => variant.title == variantTitle).compare_at_price;
          $container.find('[data-product-price]').html(slate.Currency.formatMoney(price, theme.moneyFormat));
          $container.find('[data-product-compare-at-price]').html(slate.Currency.formatMoney(comparePrice, theme.moneyFormat));
  
          if ($container.find('.reduce_variant_images').length) variantTitle = variantTitle.split(' / ')[0];
          $container.find('.retail__product-slides img').addClass('hide');
          $container.find(`.retail__product-slides img[data-variant="${variantTitle}"]`).removeClass('hide');
        });
        $('.nice-select').on('click', function(){
          $(this).closest('.product-page').toggleClass('nice-select-open');
        });
      }

      $(this).find('a.swatch__link').on('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        const $container = $(this).closest(retailProductModalSectionEl);
        const $eventWrapper = $(this).closest('.swatch-wrapper');
        let variantTitle = $sizeSwatches.length ? $sizeSelect.val() : '';
        const value = $(this).data('value');
        $eventWrapper.find('[data-swatch-item].active').removeClass('active');
        $eventWrapper.find('[data-swatch-label-value]').html(value);
        $(this).closest('[data-swatch-item]').addClass('active');
        if (!$sizeSwatches.length) {
          $container.find('[data-swatch-item].active').each(function(i){
            const option = $(this).find('a').data('value');
            variantTitle = (i == 0) ? variantTitle + option : variantTitle + ' / ' + option;
          });
        } else {
          $container.find('[data-swatch-item].active').each(function(i){
            const option = $(this).find('a').data('value');
            variantTitle = variantTitle + ' / ' + option;
          });
        }
        if (variantTitle.includes('Small') && variantTitle.includes('Cactus') && productHandle == 'metro-toiletry-case') {
          variantTitle = variantTitle.replace('Small', 'Large');
          $container.find('select[id^="SingleOptionSelector"][id$="--cloned"]').val('Large').trigger('change');
          $container.find('select[id^="SingleOptionSelector"][id$="--cloned"]').niceSelect('update');
        }

        const price = productData.variants.find(variant => variant.title == variantTitle).price;
        const comparePrice = productData.variants.find(variant => variant.title == variantTitle).compare_at_price;
        $container.find('[data-product-price]').html(slate.Currency.formatMoney(price, theme.moneyFormat));
        $container.find('[data-product-compare-at-price]').html(slate.Currency.formatMoney(comparePrice, theme.moneyFormat));

        if ($container.find('.reduce_variant_images').length) variantTitle = variantTitle.split(' / ')[1];
      
        $container.find('.retail__product-slides img').addClass('hide');
        $container.find(`.retail__product-slides img[data-variant="${variantTitle}"]`).removeClass('hide');
      });

    });

    $(`${retailProductModalSectionEl} .compare__links a`).on('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      $.magnificPopup.close();
      const link = $(this).attr('href')
      const redirect = link.includes('/') ? link : false;
      if (redirect) {
        window.location.href = redirect;
      } else {
        $.magnificPopup.open({
            items: {
                src: '#airline-size-guide',
            },
            type: 'inline',
            mainClass: 'modal--airline-size-guide',
            midClick: true,
            callbacks: {
              open: function() {
                $('.modal--airline-size-guide').on('scroll', ()=>{
                  var element = document.getElementById('tableContainer');
                  var rect = element.getBoundingClientRect();
                  if (rect.top < 0) {
                    $('.header-row').addClass('fixed');
                    $('.first-row').addClass('scrolling');
                  } else {
                    $('.header-row').removeClass('fixed');
                    $('.first-row').removeClass('scrolling');
                  }
                });
              }
            }
        });
      }
    });

    $('.retail-guide__product-grid a').on('click', function(e){
      e.preventDefault();
      const src = $(this).attr('href');
      if (!src) return;
      const $gridItem = $(this).closest('.grid__item');
      const variantID = $gridItem.data('default-variant-id');
      const mainClass = 'modal--retail-quick-product ' + src.replace('#', '');
      magnificOpen(src, mainClass, modalCallBack, removeModalOpenClassBody);
      function modalCallBack() {
        closeMobileNav();
        if (variantID) {
          $(`.modal--retail-quick-product [data-variant-id="${variantID}"]`).trigger('click');
        }
        addModalOpenClassBody();
      }
    });

    $('.faq__sidebar:not(.hide)').stick_in_parent();

    $('.faq__nav__link').on('click', function(e){
      $('.faq__nav__link').removeClass('active');
      $(this).addClass('active');
    });

    $('.section-retail-quick-guide .menuToggle').on('click', function(){
      $('.retail__header-mobile--top-dropdown').toggleClass('open');
    });

    $('.faq__sidebar, .retail-guide__product-grid').on('click', function(){
      if ($('.retail__header-mobile--top-dropdown').hasClass('open')) {
        return closeMobileNav;
      }
    });

    function closeMobileNav() {
      $('.retail__header-mobile--top-dropdown').removeClass('open');
      $('.retail__header-mobile--top .menuToggle').attr('aria-expanded', false);
    }
})();

theme.BeforeAfter = (function() {
  const $container = $('.section-before-after-slider');
  $container.each(function(){
    $(this).find('.ba-slider').beforeAfter();
    $(this).find('.ba-slider-mobile').beforeAfter();
    $(this).find('img').addClass('in');
  });
})();
theme.StoreLocations = (function() {
  const $container = $('.section-store-locations');
  $container.find('.tab__link').on('click', function(e){
    e.preventDefault();
    const country = $(this).attr('href').replace('#','');
    $container.find('.tab__link').removeClass('active');
    $container.find('.tab__link[href="#' + country + '"]').addClass('active');
    if (country == 'all') {
      var resultsCount = $container.find('[data-country]').length;
      var resultsCountHtml = 'Showing ' + resultsCount + ' ' + (resultsCount == 1 ? 'result' : 'results');
      $container.find('.result__count').html(resultsCountHtml);
      $container.find('[data-country]').removeClass('hide');
    } else {
      var resultsCount = $container.find('[data-country="' + country + '"]').length;
      var resultsCountHtml = 'Showing ' + resultsCount + ' ' + (resultsCount == 1 ? 'result' : 'results');
      $container.find('.result__count').html(resultsCountHtml);
      $container.find('[data-country]').addClass('hide');
      $container.find('[data-country="' + country + '"]').removeClass('hide');
    }
  });
  $container.find('a[href="#all"]').trigger('click');
  $container.find('.store__list--item').on('click', function(){
    const store = $(this).data('location');
    $container.find('.store__image').addClass('out');
    $container.find(`.store__image[data-location="${store}"]`).removeClass('out');
  });
  $container.find('.store__details--hours-dropdown').on('click', function(){
    $(this).toggleClass('open');
  });
  $container.find('.stick-in-parent').data('sticky-offset', headerHeight()-1);
})();

theme.MiniNav = (function() {
  const $container = $('.mini-nav');
  $container.find('.nav-toggle--mini').on('click', function(e){
    const $navItem = $(e.target).closest('.nav-item');
    $navItem.find('ul').removeAttr('hidden');
  });
  $(document).on('click', function(e) {
    if (
      !$container.is(e.target) &&
      $container.has(e.target).length === 0 &&
      !$(e.target).closest('.nav-toggle--mini').length
    ) {
      $container.find('.nav-item ul').attr('hidden', true);
    }
  });
})();

theme.VideoShopping = (function() {
  var STREAMABLE_ORIGIN = 'https://streamable.com';
  var PLAYER_VERSION = '0.0.11';
  var PROGRESS_POLL_MS = 250;
  var INIT_POLL_MS = 250;
  var MAX_INIT_ATTEMPTS = 80;
  var IMMERSIVE_HASH = '#video-shopping';
  var instances = [];
  var hashRoutingInitialized = false;

  function formatTime(seconds) {
    if (seconds == null || isNaN(seconds)) return '0:00';
    var minutes = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return minutes + ':' + String(secs).padStart(2, '0');
  }

  function parsePayload(data) {
    if (!data) return null;
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (error) {
        return null;
      }
    }
    return data;
  }

  function isProbeMethod(method) {
    return method === 'getDuration' ||
      method === 'getPaused' ||
      method === 'getCurrentTime' ||
      method === 'getMuted' ||
      method === 'getVolume';
  }

  function VideoShopping(container) {
    this.container = container;
    this.$container = $(container);
    this.iframe = container.querySelector('[data-streamable-player]');
    this.controls = container.querySelector('[data-video-shopping-controls]');
    this.listenerId = 'video-shopping-' + container.getAttribute('data-section-id');

    if (!this.iframe || !this.controls) return;

    this.playBtn = this.controls.querySelector('[data-video-shopping-play]');
    this.progressBar = this.controls.querySelector('[data-video-shopping-progress]');
    this.progressFill = this.controls.querySelector('[data-video-shopping-progress-fill]');
    this.currentTimeEl = this.controls.querySelector('[data-video-shopping-current]');
    this.durationEl = this.controls.querySelector('[data-video-shopping-duration]');
    this.muteBtn = this.controls.querySelector('[data-video-shopping-mute]');
    this.volumeSlider = this.controls.querySelector('[data-video-shopping-volume]');
    this.$products = this.$container.find('[data-video-shopping-time]');
    this.$productDetails = this.$container.find('.product-details');
    this.productsSwiperEl = container.querySelector('[data-video-shopping-products]');
    this.fullscreenBtn = container.querySelector('[data-video-shopping-fullscreen]');
    this.backBtn = container.querySelector('[data-video-shopping-back]');
    this.sectionWrapper = document.getElementById('shopify-section-' + container.getAttribute('data-section-id'));
    this.isLinkedOnly = container.hasAttribute('data-section-is-linked');
    this.pendingLinkedPlay = false;
    this.activeProductTime = null;
    this.productsSwiper = null;
    this.isImmersive = false;
    this.savedScrollY = 0;
    this.isSyncingHash = false;

    if (this.isLinkedOnly && this.sectionWrapper) {
      this.sectionWrapper.id = 'video-shopping';
      this.container.removeAttribute('id');
      this.sectionWrapper.classList.remove('is-video-shopping-linked-visible');
    }

    instances.push(this);

    this.duration = 0;
    this.isMuted = true;
    this.savedVolume = 1;
    this.playerMuted = true;
    this.playerVolume = 0;
    this.isPaused = this.isLinkedOnly;
    this.isScrubbing = false;
    this.playerReady = false;
    this.listenersRegistered = false;
    this.commandQueue = [];
    this.progressInterval = null;
    this.initInterval = null;
    this.initAttempts = 0;

    this.onMessage = this.onMessage.bind(this);
    this.onIframeLoad = this.onIframeLoad.bind(this);
    this.onPlayClick = this.onPlayClick.bind(this);
    this.onProgressInput = this.onProgressInput.bind(this);
    this.onProgressChange = this.onProgressChange.bind(this);
    this.onMuteClick = this.onMuteClick.bind(this);
    this.onVolumeInput = this.onVolumeInput.bind(this);
    this.onProductDetailsClick = this.onProductDetailsClick.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onFullscreenClick = this.onFullscreenClick.bind(this);
    this.onFullscreenChange = this.onFullscreenChange.bind(this);
    this.onBackClick = this.onBackClick.bind(this);

    window.addEventListener('message', this.onMessage);
    this.iframe.addEventListener('load', this.onIframeLoad);
    this.playBtn.addEventListener('click', this.onPlayClick);
    this.progressBar.addEventListener('input', this.onProgressInput);
    this.progressBar.addEventListener('change', this.onProgressChange);
    this.muteBtn.addEventListener('click', this.onMuteClick);
    this.volumeSlider.addEventListener('input', this.onVolumeInput);
    this.$productDetails.on('click', this.onProductDetailsClick);

    if (this.fullscreenBtn) {
      this.fullscreenBtn.addEventListener('click', this.onFullscreenClick);
    }

    if (this.backBtn) {
      this.backBtn.addEventListener('click', this.onBackClick);
    }

    document.addEventListener('fullscreenchange', this.onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.onFullscreenChange);

    window.addEventListener('resize', this.onResize);
    var self = this;
    requestAnimationFrame(function() {
      self.initProductsSwiper();
    });
    if (this.isLinkedOnly) {
      this.container.classList.add('is-video-paused');
    }

    ensureHashRouting();
    this.beginPlayerInit();
    this.syncVolumeUiFromPlayer(true, 0);
  }

  function getHashTargetInstance() {
    var linkedInstance = null;
    var fallbackInstance = null;

    for (var i = 0; i < instances.length; i++) {
      var instance = instances[i];
      if (instance.isLinkedOnly) linkedInstance = instance;
      if (instance.isHashTarget()) fallbackInstance = instance;
    }

    return linkedInstance || fallbackInstance;
  }

  function ensureHashRouting() {
    if (hashRoutingInitialized) return;
    hashRoutingInitialized = true;

    function routeHash() {
      var instance = getHashTargetInstance();
      if (!instance || instance.isSyncingHash) return;
      instance.syncImmersiveFromHash();
    }

    window.addEventListener('hashchange', routeHash);

    document.addEventListener('click', function(evt) {
      var link = evt.target.closest('a[href="#video-shopping"], a[href$="#video-shopping"]');
      if (!link) return;

      var instance = getHashTargetInstance();
      if (!instance || !instance.isLinkedOnly) return;

      evt.preventDefault();
      instance.openFromHashLink();
    });

    routeHash();
  }

  VideoShopping.prototype.isHashTarget = function() {
    return this.container.id === 'video-shopping' ||
      (this.sectionWrapper && this.sectionWrapper.id === 'video-shopping');
  };

  VideoShopping.prototype.matchesImmersiveHash = function() {
    var hash = window.location.hash;
    return hash === IMMERSIVE_HASH || hash.indexOf(IMMERSIVE_HASH) === 0;
  };

  VideoShopping.prototype.openFromHashLink = function() {
    this.updateImmersiveHash(true);
    this.syncImmersiveFromHash();
  };

  VideoShopping.prototype.setLinkedSectionVisible = function(visible) {
    if (!this.isLinkedOnly || !this.sectionWrapper) return;
    this.sectionWrapper.classList.toggle('is-video-shopping-linked-visible', visible);
  };

  VideoShopping.prototype.isImmersiveHashTarget = function() {
    return this.matchesImmersiveHash();
  };

  VideoShopping.prototype.isHashTargetSection = function() {
    return this.isHashTarget();
  };

  VideoShopping.prototype.setImmersiveHash = function() {
    if (this.isImmersiveHashTarget()) return;

    var url = window.location.pathname + window.location.search + IMMERSIVE_HASH;

    if (history.replaceState) {
      history.replaceState(null, '', url);
    } else {
      window.location.hash = IMMERSIVE_HASH;
    }
  };

  VideoShopping.prototype.clearImmersiveHash = function() {
    if (!this.isImmersiveHashTarget()) return;

    var url = window.location.pathname + window.location.search;

    if (history.replaceState) {
      history.replaceState(null, '', url);
    } else {
      window.location.hash = '';
    }
  };

  VideoShopping.prototype.updateImmersiveHash = function(enable) {
    this.isSyncingHash = true;

    if (enable) {
      this.setImmersiveHash();
    } else {
      this.clearImmersiveHash();
    }

    this.isSyncingHash = false;
  };

  VideoShopping.prototype.syncImmersiveFromHash = function() {
    if (!this.isHashTargetSection()) return;

    if (this.isImmersiveHashTarget()) {
      if (!this.isImmersive) {
        this.enterImmersive({ fromHash: true });
      }
      return;
    }

    if (this.isImmersive) {
      this.exitImmersive({ fromHash: true });
    } else if (this.isLinkedOnly) {
      this.setLinkedSectionVisible(false);
    }
  };

  VideoShopping.prototype.getFullscreenElement = function() {
    return document.fullscreenElement || document.webkitFullscreenElement;
  };

  VideoShopping.prototype.isNativeFullscreenActive = function() {
    return this.sectionWrapper && this.getFullscreenElement() === this.sectionWrapper;
  };

  VideoShopping.prototype.requestNativeFullscreen = function() {
    if (!this.sectionWrapper) return Promise.reject();

    var request = this.sectionWrapper.requestFullscreen ||
      this.sectionWrapper.webkitRequestFullscreen ||
      this.sectionWrapper.webkitRequestFullScreen;

    if (!request) return Promise.reject();

    return Promise.resolve(request.call(this.sectionWrapper));
  };

  VideoShopping.prototype.exitNativeFullscreen = function() {
    var exit = document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.webkitCancelFullScreen;

    if (!exit || !this.getFullscreenElement()) return Promise.resolve();

    return Promise.resolve(exit.call(document));
  };

  VideoShopping.prototype.setImmersiveUi = function(isImmersive) {
    var wasImmersive = this.isImmersive;
    this.isImmersive = isImmersive;
    this.container.classList.toggle('is-immersive-fullscreen', isImmersive);
    document.body.classList.toggle('is-video-shopping-immersive', isImmersive);

    if (this.sectionWrapper) {
      this.sectionWrapper.classList.toggle('is-video-shopping-immersive-target', isImmersive);
    }

    if (this.isLinkedOnly) {
      this.setLinkedSectionVisible(isImmersive);

      if (isImmersive && !wasImmersive) {
        this.playLinkedVideo();
      } else if (!isImmersive && wasImmersive) {
        this.stopLinkedVideo();
      }
    }

    if (this.fullscreenBtn) {
      this.fullscreenBtn.setAttribute('data-state', isImmersive ? 'immersive' : 'normal');
      this.fullscreenBtn.setAttribute('aria-label', isImmersive ? 'Exit fullscreen' : 'Enter fullscreen');
    }
  };

  VideoShopping.prototype.playLinkedVideo = function() {
    if (!this.isLinkedOnly) return;

    if (!this.playerReady) {
      this.pendingLinkedPlay = true;
      return;
    }

    this.pendingLinkedPlay = false;
    this.send('play');
  };

  VideoShopping.prototype.stopLinkedVideo = function() {
    if (!this.isLinkedOnly) return;

    this.pendingLinkedPlay = false;
    this.send('pause');
    this.send('setCurrentTime', 0);
    this.setPlayState(true);
    this.renderProgress(0);
  };

  VideoShopping.prototype.onBackClick = function() {
    this.exitImmersive();
  };

  VideoShopping.prototype.enterImmersive = function(options) {
    options = options || {};
    if (this.isImmersive) return;

    this.savedScrollY = window.scrollY || window.pageYOffset;
    this.setImmersiveUi(true);
    window.scrollTo(0, 0);

    if (!options.fromHash) {
      this.updateImmersiveHash(true);
    }

    var self = this;
    this.requestNativeFullscreen().catch(function() {
      // CSS fallback already applied via setImmersiveUi
    }).finally(function() {
      if (self.productsSwiper) self.productsSwiper.update();
    });
  };

  VideoShopping.prototype.exitImmersive = function(options) {
    options = options || {};
    if (!this.isImmersive && !this.isNativeFullscreenActive()) return;

    if (this.isNativeFullscreenActive()) {
      this.exitNativeFullscreen();
      return;
    }

    this.setImmersiveUi(false);
    window.scrollTo(0, this.savedScrollY);

    if (!options.fromHash) {
      this.updateImmersiveHash(false);
    }

    if (this.productsSwiper) this.productsSwiper.update();
  };

  VideoShopping.prototype.onFullscreenClick = function() {
    if (this.isImmersive || this.isNativeFullscreenActive()) {
      this.exitImmersive();
    } else {
      this.enterImmersive();
    }
  };

  VideoShopping.prototype.onFullscreenChange = function() {
    var isNativeActive = this.isNativeFullscreenActive();

    if (isNativeActive && !this.isImmersive) {
      this.savedScrollY = window.scrollY || window.pageYOffset;
      this.setImmersiveUi(true);
      if (this.productsSwiper) this.productsSwiper.update();
      return;
    }

    if (!isNativeActive && this.isImmersive) {
      this.setImmersiveUi(false);
      window.scrollTo(0, this.savedScrollY);
      this.updateImmersiveHash(false);
      if (this.productsSwiper) this.productsSwiper.update();
    }
  };

  VideoShopping.prototype.initProductsSwiper = function() {
    if (this.productsSwiper || !this.productsSwiperEl) return;

    var self = this;
    this.productsSwiper = new Swiper(this.productsSwiperEl, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      variableWidth: true,
      centeredSlides: true,
      centerInsufficientSlides: true,
      spaceBetween: 12,
      slideToClickedSlide: true,
      speed: 350,
      watchSlidesProgress: true
    });

    this.productsSwiper.update();

    if (this.activeProductTime != null) {
      this.$products.each(function(index) {
        var time = parseInt(this.getAttribute('data-video-shopping-time'), 10);
        if (time === self.activeProductTime) {
          self.productsSwiper.slideTo(index, 0);
        }
      });
    } else if (this.$products.length) {
      this.productsSwiper.slideTo(0, 0);
    }
  };

  VideoShopping.prototype.destroyProductsSwiper = function() {
    if (!this.productsSwiper) return;
    this.productsSwiper.destroy(true, true);
    this.productsSwiper = null;
  };

  VideoShopping.prototype.onResize = function() {
    if (this.productsSwiper) {
      this.productsSwiper.update();
    } else {
      this.initProductsSwiper();
    }
  };

  VideoShopping.prototype.focusActiveProduct = function(activeProduct) {
    if (!activeProduct || !this.productsSwiper) return;

    var index = this.$products.index(activeProduct);
    if (index > -1) {
      this.productsSwiper.slideTo(index);
    }
  };

  VideoShopping.prototype.getIframeWindow = function() {
    return this.iframe && this.iframe.contentWindow;
  };

  VideoShopping.prototype.isIframeMessage = function(event) {
    var iframeWindow = this.getIframeWindow();
    return iframeWindow && event.source === iframeWindow;
  };

  VideoShopping.prototype.send = function(method, value, options) {
    options = options || {};
    var iframeWindow = this.getIframeWindow();
    if (!iframeWindow) return false;

    if (!this.playerReady && !options.force && !options.probe && !isProbeMethod(method)) {
      this.commandQueue.push({ method: method, value: value });
      this.beginPlayerInit();
      return false;
    }

    var message = {
      context: 'player.js',
      version: PLAYER_VERSION,
      method: method,
      listener: this.listenerId
    };

    if (value !== undefined) {
      message.value = value;
    }

    iframeWindow.postMessage(message, STREAMABLE_ORIGIN);
    return true;
  };

  VideoShopping.prototype.beginPlayerInit = function() {
    if (this.playerReady || this.initInterval) return;

    var self = this;
    this.initAttempts = 0;

    this.initInterval = window.setInterval(function() {
      if (self.playerReady) {
        self.stopPlayerInit();
        return;
      }

      self.initAttempts += 1;
      if (self.initAttempts > MAX_INIT_ATTEMPTS) {
        self.stopPlayerInit();
        return;
      }

      self.send('getDuration', undefined, { probe: true });
      self.send('getPaused', undefined, { probe: true });
    }, INIT_POLL_MS);

    this.send('getDuration', undefined, { probe: true });
    this.send('getPaused', undefined, { probe: true });
  };

  VideoShopping.prototype.stopPlayerInit = function() {
    if (!this.initInterval) return;
    window.clearInterval(this.initInterval);
    this.initInterval = null;
  };

  VideoShopping.prototype.onIframeLoad = function() {
    this.playerReady = false;
    this.listenersRegistered = false;
    this.commandQueue = [];
    this.playerMuted = true;
    this.playerVolume = 0;
    this.stopPlayerInit();
    this.stopProgressPolling();
    this.container.classList.remove('is-player-ready', 'is-video-paused', 'is-video-scrubbing');
    this.activeProductTime = null;
    this.renderProgress(0);
    this.syncVolumeUiFromPlayer(true, 0);
    this.beginPlayerInit();
  };

  VideoShopping.prototype.registerPlayerListeners = function() {
    if (this.listenersRegistered) return;

    this.listenersRegistered = true;
    this.send('addEventListener', 'timeupdate', { force: true });
    this.send('addEventListener', 'progress', { force: true });
    this.send('addEventListener', 'play', { force: true });
    this.send('addEventListener', 'pause', { force: true });
    this.send('addEventListener', 'ended', { force: true });
  };

  VideoShopping.prototype.flushCommandQueue = function() {
    var queue = this.commandQueue.slice();
    this.commandQueue = [];

    queue.forEach(function(item) {
      this.send(item.method, item.value, { force: true });
    }.bind(this));
  };

  VideoShopping.prototype.markPlayerReady = function() {
    if (this.playerReady) return;

    this.playerReady = true;
    this.stopPlayerInit();
    this.container.classList.add('is-player-ready');
    this.registerPlayerListeners();
    this.syncUi();
    this.flushCommandQueue();

    if (this.pendingLinkedPlay) {
      this.playLinkedVideo();
    }
  };

  VideoShopping.prototype.setDuration = function(duration) {
    if (duration == null || isNaN(duration) || duration <= 0) return;

    this.duration = duration;
    this.progressBar.max = duration;
    this.durationEl.textContent = formatTime(duration);
  };

  VideoShopping.prototype.renderProgress = function(currentTime) {
    if (currentTime == null || isNaN(currentTime)) return;

    this.progressBar.value = currentTime;
    this.currentTimeEl.textContent = formatTime(currentTime);

    if (this.progressFill) {
      var percent = this.duration > 0 ? (currentTime / this.duration) : 0;
      this.progressFill.style.transform = 'scaleX(' + percent + ')';
    }

    this.updateActiveProduct(currentTime);
  };

  VideoShopping.prototype.updateProgress = function(currentTime) {
    if (this.isScrubbing || currentTime == null || isNaN(currentTime)) return;
    this.renderProgress(currentTime);
  };

  VideoShopping.prototype.startProgressPolling = function() {
    if (this.progressInterval || !this.playerReady) return;

    var self = this;
    this.progressInterval = window.setInterval(function() {
      if (!self.isPaused && !self.isScrubbing) {
        self.send('getCurrentTime', undefined, { probe: true });
        if (!self.duration) {
          self.send('getDuration', undefined, { probe: true });
        }
      }
    }, PROGRESS_POLL_MS);
  };

  VideoShopping.prototype.stopProgressPolling = function() {
    if (!this.progressInterval) return;
    window.clearInterval(this.progressInterval);
    this.progressInterval = null;
  };

  VideoShopping.prototype.syncUi = function() {
    this.send('getPaused', undefined, { force: true });
    this.send('getMuted', undefined, { force: true });
    this.send('getVolume', undefined, { force: true });
    this.send('getDuration', undefined, { force: true });
    this.send('getCurrentTime', undefined, { force: true });
  };

  VideoShopping.prototype.setPlayState = function(isPaused) {
    this.isPaused = isPaused;
    this.playBtn.setAttribute('data-state', isPaused ? 'paused' : 'playing');
    this.playBtn.setAttribute('aria-label', isPaused ? 'Play' : 'Pause');
    this.container.classList.toggle('is-video-paused', isPaused);

    if (isPaused) {
      this.stopProgressPolling();
    } else {
      this.startProgressPolling();
    }
  };

  VideoShopping.prototype.setMuteState = function(isMuted) {
    this.isMuted = isMuted;
    this.muteBtn.setAttribute('data-state', isMuted ? 'muted' : 'unmuted');
    this.muteBtn.setAttribute('aria-label', isMuted ? 'Unmute' : 'Mute');
  };

  VideoShopping.prototype.syncVolumeUiFromPlayer = function(isMuted, volumePercent) {
    if (typeof isMuted === 'boolean') {
      this.playerMuted = isMuted;
    }

    if (typeof volumePercent === 'number' && !isNaN(volumePercent)) {
      this.playerVolume = volumePercent;
      if (volumePercent > 0) {
        this.savedVolume = volumePercent / 100;
      }
    }

    var muted = this.playerMuted || this.playerVolume === 0;
    this.setMuteState(muted);

    if (muted) {
      this.volumeSlider.value = 0;
      return;
    }

    var displayVolume = this.playerVolume > 0
      ? this.playerVolume / 100
      : (this.savedVolume > 0 ? this.savedVolume : 1);

    this.volumeSlider.value = displayVolume;
  };

  VideoShopping.prototype.applyPlayerVolume = function(volumePercent) {
    volumePercent = Math.max(0, Math.min(100, Math.round(volumePercent)));
    var sliderVolume = volumePercent / 100;

    this.playerMuted = volumePercent === 0;
    this.playerVolume = volumePercent;
    this.volumeSlider.value = sliderVolume;
    this.setMuteState(volumePercent === 0);

    if (volumePercent > 0) {
      this.savedVolume = sliderVolume;
      this.send('unmute');
      this.send('setVolume', volumePercent);
      return;
    }

    this.send('setVolume', 0);
    this.send('mute');
  };

  VideoShopping.prototype.updateActiveProduct = function(currentTime) {
    var activeProduct = null;
    var activeTime = -1;

    this.$products.each(function() {
      var time = parseInt(this.getAttribute('data-video-shopping-time'), 10);
      if (!isNaN(time) && time <= currentTime && time >= activeTime) {
        activeTime = time;
        activeProduct = this;
      }
    });

    this.$products.removeClass('is-active');
    if (activeProduct) {
      $(activeProduct).addClass('is-active');

      if (activeTime !== this.activeProductTime) {
        this.activeProductTime = activeTime;
        this.focusActiveProduct(activeProduct);
      }
    } else {
      this.activeProductTime = null;
    }
  };

  VideoShopping.prototype.handleTimePayload = function(value) {
    if (!value) return;

    if (typeof value === 'number') {
      this.updateProgress(value);
      return;
    }

    if (value.duration != null) {
      this.setDuration(Number(value.duration));
    }

    var currentTime = value.seconds != null ? Number(value.seconds) : Number(value.currentTime);
    if (!isNaN(currentTime)) {
      this.updateProgress(currentTime);
    }
  };

  VideoShopping.prototype.onMessage = function(event) {
    if (event.origin !== STREAMABLE_ORIGIN) return;
    if (!this.isIframeMessage(event)) return;

    var payload = parsePayload(event.data);
    if (!payload || payload.context !== 'player.js') return;

    var evt = payload.event;
    var value = payload.value;

    if (payload.listener && payload.listener !== this.listenerId && evt !== 'ready') return;

    switch (evt) {
      case 'ready':
        this.markPlayerReady();
        break;
      case 'getDuration':
        this.setDuration(Number(value));
        if (!this.playerReady) {
          this.markPlayerReady();
        }
        break;
      case 'getCurrentTime':
        this.updateProgress(Number(value));
        if (!this.playerReady) {
          this.markPlayerReady();
        }
        break;
      case 'getPaused':
        if (!this.playerReady) {
          this.markPlayerReady();
        }
        this.setPlayState(!!value);
        break;
      case 'getMuted':
        if (!this.playerReady) {
          this.markPlayerReady();
        }
        this.syncVolumeUiFromPlayer(!!value);
        break;
      case 'getVolume':
        if (!this.playerReady) {
          this.markPlayerReady();
        }
        if (typeof value === 'number') {
          this.syncVolumeUiFromPlayer(undefined, value);
        }
        break;
      case 'timeupdate':
      case 'progress':
        this.handleTimePayload(value);
        break;
      case 'play':
        this.setPlayState(false);
        break;
      case 'pause':
      case 'ended':
        this.setPlayState(true);
        break;
    }
  };

  VideoShopping.prototype.onPlayClick = function() {
    this.send(this.isPaused ? 'play' : 'pause');
  };

  VideoShopping.prototype.onProgressInput = function() {
    this.isScrubbing = true;
    this.container.classList.add('is-video-scrubbing');
    this.renderProgress(Number(this.progressBar.value));
  };

  VideoShopping.prototype.onProgressChange = function() {
    this.send('setCurrentTime', Number(this.progressBar.value));
    this.isScrubbing = false;
    this.container.classList.remove('is-video-scrubbing');
    this.renderProgress(Number(this.progressBar.value));
    this.send('getCurrentTime', undefined, { probe: true });
  };

  VideoShopping.prototype.onMuteClick = function() {
    var currentVolume = Number(this.volumeSlider.value);

    if (currentVolume === 0) {
      var restoreVolume = this.savedVolume > 0 ? this.savedVolume : 1;
      this.applyPlayerVolume(Math.round(restoreVolume * 100));
      return;
    }

    this.savedVolume = currentVolume;
    this.applyPlayerVolume(0);
  };

  VideoShopping.prototype.onVolumeInput = function() {
    this.applyPlayerVolume(Math.round(Number(this.volumeSlider.value) * 100));
  };

  VideoShopping.prototype.seekToProductTime = function(time) {
    if (time == null || isNaN(time)) return;
    this.container.classList.add('is-video-scrubbing');
    this.renderProgress(time);
    this.container.classList.remove('is-video-scrubbing');
    this.send('setCurrentTime', time);
    this.send('play');
  };

  VideoShopping.prototype.onProductDetailsClick = function(evt) {
    if ($(evt.target).closest('.product-shop-btn').length) return;

    var time = parseInt($(evt.currentTarget).closest('[data-video-shopping-time]').attr('data-video-shopping-time'), 10);
    evt.preventDefault();
    this.seekToProductTime(time);
  };

  VideoShopping.prototype.onUnload = function() {
    var index = instances.indexOf(this);
    if (index > -1) instances.splice(index, 1);

    this.stopPlayerInit();
    this.stopProgressPolling();
    this.destroyProductsSwiper();
    this.exitImmersive();
    document.removeEventListener('fullscreenchange', this.onFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('message', this.onMessage);
    this.iframe.removeEventListener('load', this.onIframeLoad);
    this.playBtn.removeEventListener('click', this.onPlayClick);
    this.progressBar.removeEventListener('input', this.onProgressInput);
    this.progressBar.removeEventListener('change', this.onProgressChange);
    this.muteBtn.removeEventListener('click', this.onMuteClick);
    this.volumeSlider.removeEventListener('input', this.onVolumeInput);
    this.$productDetails.off('click', this.onProductDetailsClick);

    if (this.fullscreenBtn) {
      this.fullscreenBtn.removeEventListener('click', this.onFullscreenClick);
    }

    if (this.backBtn) {
      this.backBtn.removeEventListener('click', this.onBackClick);
    }
  };

  return VideoShopping;
})();

$(document).on('shopify:section:load', theme.moveTags);

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('accordion', theme.Accordion);
  sections.register('cart-motivator', theme.CartMotivator);
  sections.register('cart', theme.Cart);
  sections.register('parallax', theme.Parallax);
  sections.register('parallax', theme.Video);
  sections.register('video', theme.Video);
  sections.register('product', theme.Product);
  sections.register('product-bundle', theme.Product);
  sections.register('header', theme.Header);
  sections.register('footer', theme.Footer);
  sections.register('collection', theme.Collection);
  sections.register('slideshow', theme.Slideshow);
  sections.register('blog', theme.Blog);
  sections.register('press', theme.Press);
  sections.register('compare', theme.Compare);
  sections.register('gallery', theme.Gallery);
  sections.register('product-grid-item', theme.Product);
  sections.register('product-grid-item', theme.ProductGridItem);
  sections.register('page-faq', theme.PageFaq);
  sections.register('testimonials', theme.Testimonials);
  sections.register('featured-product-slider', theme.FeaturedProductSlider);
  sections.register('product-bundle-curated', theme.Product);
  sections.register('compare-sizes', theme.CompareSizes);
  sections.register('compare-sizes-mini', theme.CompareSizesMini);
  sections.register('sticky-nav', theme.StickyNav);
  sections.register('logo', theme.Logo);
  sections.register('featured-image-row', theme.FeaturedImageRow);
  sections.register('product-lookbook', theme.ProductLookbook);
  sections.register('video-shopping', theme.VideoShopping);
  sections.register('rewards-list', theme.RewardsList);
  sections.register('retail-guide', theme.RetailGuide);
  sections.register('compare-table', theme.CompareTable);
  sections.register('before-after', theme.BeforeAfter);
  sections.register('store-locations', theme.StoreLocations);
  sections.register('mini-nav', theme.MiniNav);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  if ($('.section-banner-video .homepage-image').hasClass('inverse-header') && !$('.header-wrapper').hasClass('inverse')) {
    $('.header-wrapper').addClass('inverse');
  }

  theme.updateShopifyAccountVars();

  var $headerWrapper = $('.header-wrapper');
  if ($headerWrapper.length) {
    $headerWrapper.on('mouseenter', function() {
      $(this).addClass('header-hover');
    }).on('mouseleave', function() {
      $(this).removeClass('header-hover');
    });

    var headerEl = $headerWrapper[0];
    var accountVarObserver = new MutationObserver(function() {
      theme.updateShopifyAccountVars();
    });
    accountVarObserver.observe(headerEl, { attributes: true, attributeFilter: ['class'] });
  }

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }


  // Animate on scroll
  if( window.AOS ) {
    AOS.init({ once: false });
    $('body').addClass('aos-initialized');
  }

  if (window.shopUS && window.Shopify.currency.active) {
    $('body').addClass(`currency-${window.Shopify.currency.active}`);
  }
  stickInParentHandler();
});
/* commenting out for now, not using vimeo currently
if ($('.vimeo-wrapper').length) {
  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {

      if (entry.isIntersecting) {

        var frameID = $(entry.target).data('id');
        var frameSrc = $(entry.target).data('src');
        var content = `
        <iframe class="vimeo-iframe" id="${frameID}" src="${frameSrc}"
        frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
        `
        $(entry.target).append(content);

        observer.unobserve(entry.target);

        $(entry.target).find('.vimeo-iframe').each(function(){
          var $wrapper = $(this).closest('.background-size-cover');
          var player = new Vimeo.Player(this);
          player.on('play', function() {
            $wrapper.addClass('transparent');
          });
        });

      }
    });
  });

  // Start observing all target divs
  $('.vimeo-wrapper').each(function() {
    observer.observe(this);
  });
}
*/
var streamableEl = '.streamable-wrapper';
if ( $(streamableEl).length ) {
    var video = $("#video-test")[0];
    //console.log(video.duration);
    //getVideoDetails('video-test');
    video.play().then(function() {
      // if test video plays then reveal streamable video
      function checkIframeLoaded() {
        var $iframe = $(`${streamableEl} iframe`);
            $iframe.closest('.background-size-cover, .homepage-image-focus').addClass('transparent');
            setBgColor($iframe);
            clearInterval(iframeInterval);
      }
  
      var iframeInterval = setInterval(checkIframeLoaded, 100);

      function setBgColor($iframe) {
        const white = '#ffffff';
        const $section = $iframe.closest('section');
        const $prevSection = $section.closest('section.section-collection').length ? $section.prev('div.collection') : $section.prev('section');
        const topSection = $prevSection.length == 0;
        const bgDiv = $prevSection.is('section') && $prevSection.hasClass('section-collection') ? '.collection' : '.section-body';
        let prevBgColor = $prevSection.is('section') ? $prevSection.find(bgDiv).css('background-color') : $prevSection.css('background-color');
        if (topSection) {
          let nextBgColor = $section.next('section').find('.section-body').css('background-color');
          if (nextBgColor != white) {
            $section.css('background-color', nextBgColor);
          }
        } else {
          $section.css('background-color', prevBgColor);
        }
      }
  }).catch(function(error) {
      console.error("Video play error:", error);
  });
}

$('.popupVideo').each(function() {
  var $currentVideo = $(this);
  if ($currentVideo && $currentVideo.attr('href')) {
      if (!$currentVideo.attr('href').includes('streamable.com')) {
          $currentVideo.magnificPopup({
              type: 'iframe',
              mainClass: 'mfp-fade',
              removalDelay: 160,
              closeBtnInside: false,
              preloader: false,
              fixedContentPos: false,
              iframe: {
                  patterns: {
                      youtube: {
                          src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
                      }
                  }
              }
          });
      } else {
          let videoID = $currentVideo.attr('href').replace('https://streamable.com/', '');
          $currentVideo.magnificPopup({
              mainClass: 'mfp-fade mfp-streamable',
              items: {
                  src: $(`<div style="position:relative; width:100%; height:0px; padding-bottom:56.250%">
                             <iframe allow="fullscreen" allowfullscreen height="100%" 
                                     src="https://streamable.com/e/${videoID}?loop=0" 
                                     width="100%" 
                                     style="border:none; width:100%; height:100%; position:absolute; left:0px; top:0px; overflow:hidden;">
                             </iframe>
                           </div>`),
                  type: 'inline'
              }
          });
      }
  }
});

function getVideoDetails(videoID) {
  var video = document.getElementById(videoID);

  // Access video object properties
  var details = {
    currentSrc: video.currentSrc,           // Current video source URL
    videoWidth: video.videoWidth,           // Actual width of the video
    videoHeight: video.videoHeight,         // Actual height of the video
    duration: video.duration,               // Duration of the video in seconds
    currentTime: video.currentTime,         // Current playback position in seconds
    paused: video.paused,                   // Whether the video is paused
    ended: video.ended,                     // Whether the video has ended
    muted: video.muted,                     // Whether the video is muted
    volume: video.volume,                   // Current volume (0 to 1)
    playbackRate: video.playbackRate,       // Playback speed (1 is normal speed)
    buffered: video.buffered.length > 0 ? video.buffered.end(0) : 0,  // Amount of the video that is buffered
  };

  // Log details to the console
  console.log(details);
}
stickInParentHandler();

function stickInParentHandler(){
  $('.stick-in-parent').each(function() {
    let $element = $(this);
    let stickyOffset = $element.data('sticky-offset');
    $element.stick_in_parent({
      offset_top: stickyOffset,
      parent: '.stick-in-parent-wrapper'
    });
  });
}
function removeLastOccurrence(arr, value) {
  for (let i = arr.length - 1; i >= 0; i--) {
    if (arr[i] === value) {
      arr.splice(i, 1);
      break;
    }
  }
}
function countOccurrences(array, value) {
  let count = 0;
  for (let i = 0; i < array.length; i++) {
    if (array[i] === value) {
      count++;
    }
  }
  return count;
}


if (window.nonEnglish) {
  let lang = window.lang;
  cycleThroughElements('body *', lang);
  $('[data-swatch-tag]').each(function(){
    var tag = $(this).data('swatch-tag').replace(' Scaled', '');
    let translatedTag = '';
    if (tag.includes(' / ')) {
      const [firstPart, secondPart] = tag.split(' / ');
      var firstPartMod = translate(firstPart, 'english') != firstPart ? translate(firstPart, 'english') : firstPart;
      var secondPartMod = translate(secondPart, 'english') != secondPart ? translate(secondPart, 'english') : secondPart;
      translatedTag = firstPartMod + ' / ' + secondPartMod + ' Scaled';
    } else {
      translatedTag = translate(tag, 'english') != tag ? translate(tag, 'english') + ' Scaled' : tag + ' Scaled';
    }
    $(this).data('swatch-tag', translatedTag);
  });
}

var klaviyo = klaviyo || [];
if (!Array.isArray(klaviyo) && window.klaviyo_id) {
  klaviyo.init({
    account: window.klaviyo_id,
    platform: "shopify"
  });

  var product_page_text = "Notify Me When Available";
  var body_content = "Register to receive a notification when this item comes back in stock.";
  var subscription_success_label = "You're in! We'll let you know when it's back.";
  var email_field_label = "Email";
  var button_label = "Notify me when available";
  if (window.nonEnglish) {
    product_page_text = translate(product_page_text, window.lang);
    body_content = translate(body_content, window.lang);
    subscription_success_label = translate(subscription_success_label, window.lang);
    email_field_label = translate(email_field_label, window.lang);
    button_label = translate(button_label, window.lang);
  }
  klaviyo.enable("backinstock", {
    trigger: {
      product_page_text: product_page_text,
      product_page_class: "btn",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_anchor: false
    },
    modal: {
      headline: "{product_name}",
      body_content: body_content,
      email_field_label: email_field_label,
      button_label: button_label,
      subscription_success_label: subscription_success_label,
      footer_content: '',
      additional_styles: "@import url('https://fonts.googleapis.com/css?family=Cabin|Vollkorn');",
      drop_background_color: "#000",
      background_color: "#fff",
      text_color: "#222",
      button_text_color: "#fff",
      button_background_color: "#4d4d4d",
      close_button_color: "#ccc",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500"
    }
  });
}
function checkTranslationMatch(element, lang) {
  if (!window.translationSets) return;
  if (!Array.isArray(window.translationSets)) {
    console.error('window.translationSets is not defined or not an array');
    return null;
  }

  var elementHtml = element.innerHTML.trim().toLowerCase();

  var matchingTranslation = window.translationSets.find(function(translation) {
    return translation.french?.toLowerCase() === elementHtml || translation.english?.toLowerCase() === elementHtml || translation.deutsch?.toLowerCase() === elementHtml;
  });

  if (matchingTranslation) {
    var translatedText = translate(elementHtml, lang);
    return {
      element: element,
      translation: translatedText
    };
  } else {
    return null;
  }
}

function cycleThroughElements(selector, lang) {
  var elements = document.querySelectorAll(selector);
  elements.forEach(function(element) {
    var result = checkTranslationMatch(element, lang);
    if (result) {
      result.element.innerHTML = result.translation;
    }
  });
}
function translate(phrase, lang) {
  if (!window.translationSets) {
    return phrase;
  }
  var translationSets = window.translationSets;
  let translation = false;
  if (lang === 'french') {
    translation = translationSets.find(translation => translation.english?.toLowerCase() === phrase.toLowerCase());
    if (translation) return translation.french;
    return phrase
  } else if (lang === 'deutsch') {
    translation = translationSets.find(translation => translation.english?.toLowerCase() === phrase.toLowerCase());
    if (translation) return translation.deutsch;
    return phrase
  } else if (lang === 'english') {
    translation = translationSets.find(translation => translation.french?.toLowerCase() === phrase.toLowerCase() || translation.deutsch?.toLowerCase() === phrase.toLowerCase());
    if (translation) return translation.english;
    return phrase;
  }
  return phrase; // Return the original phrase if no translation is found
}

// resize document after ajax in complete to remove parallax errors
$(document).ajaxComplete(function() {
  $(window).resize();
});

$('a[href="#airline-size-guide"]:not(.retail__product-link)').magnificPopup({
  mainClass: 'modal--airline-size-guide',
  type:'inline',
  midClick: true,
  callbacks: {
    open: function() {
      $('.modal--airline-size-guide').on('scroll', ()=>{
        var element = document.getElementById('tableContainer');
        var rect = element.getBoundingClientRect();
        if (rect.top < 0) {
          $('.header-row').addClass('fixed');
          $('.first-row').addClass('scrolling');
        } else {
          $('.header-row').removeClass('fixed');
          $('.first-row').removeClass('scrolling');
        }
      });
    }
  }
});
// zowie trigger
$('a[href="#open-zowie"]').on('click',function(e){
  e.preventDefault();
  if (typeof Zowie === 'undefined' && typeof ZowieWidget === 'undefined') return;
  if (typeof Zowie !== 'undefined') return Zowie.open();
  if (typeof ZowieWidget !== 'undefined') return ZowieWidget.open();
});
if ($('#language-modal').length) {
    if (getCookie('languageModalShown') != 'true') {
    magnificOpen('#language-modal', 'mfp-fade mfp-language-modal', languageModalShown, ()=>{});
    function languageModalShown() {
      setCookie('languageModalShown', 'true', 30);
      $('#language-modal').find('a').on('click', function(e){
        e.preventDefault();
        const href = $(this).attr('href');
        if (href) {
          window.location.href = window.location.origin + href;
        }
      });
    }
  }
}
function magnificOpen(src, mainclass, callbackFunction, closeFunction, type) {
  $.magnificPopup.open({
    items: {
        src: src,
    },
    type: type || 'inline',
    mainClass: mainclass,
    midClick: true,
    fixedContentPos: true,
    callbacks: {
      open: function() {
        callbackFunction();
      },
      close: function() {
        closeFunction();
      }
    }
  });
}

var fitGuideScrollPosition = 0;

function lockFitGuideBodyScroll() {
  if (window.innerWidth > 767) return;
  fitGuideScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  $('body').addClass('fit-guide-modal-open').css({
    position: 'fixed',
    top: -fitGuideScrollPosition + 'px',
    left: 0,
    right: 0,
    width: '100%'
  });
}

function unlockFitGuideBodyScroll() {
  if (!$('body').hasClass('fit-guide-modal-open')) return;
  $('body').removeClass('fit-guide-modal-open').css({
    position: '',
    top: '',
    left: '',
    right: '',
    width: ''
  });
  window.scrollTo(0, fitGuideScrollPosition);
}

function fitGuideModalOpen() {
  var $modal = $('#fit-guide-modal');
  setTimeout(function() {
    $modal.find('[data-section-type="slideshow"]').each(function() {
      var $container = $(this);
      var sectionId = $container.attr('data-section-id');
      var $slideshow = $('#slideshow-' + sectionId);

      if (!$slideshow.length) return;

      if (!$slideshow.hasClass('slick-initialized') && typeof theme.Slideshow !== 'undefined') {
        new theme.Slideshow($container[0]);
      } else {
        $slideshow.slick('setPosition');
        $slideshow.slick('refresh');
      }
    });

    $(window).trigger('resize');
  }, 50);
}


$('[data-fit-guide-trigger]').on('click', function(e) {
  e.preventDefault();
  if (!$('#fit-guide-modal').length) return;
  magnificOpen(
    '#fit-guide-modal',
    'mfp-fade modal--fit-guide',
    function() {
      lockFitGuideBodyScroll();
      fitGuideModalOpen();
    },
    unlockFitGuideBodyScroll,
    'inline'
  );
});

// open external links in new tab
function externalLinks() {
  for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
    var b = c[a];
    b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank");
  }
}
externalLinks();
function hashOnlyLinks() {
  $('a[href=""]').on('click', function(e){
    e.preventDefault();
  });
}
hashOnlyLinks();


function scrollToAnchorWithOffset() {
  const hash = window.location.hash;

  if (hash) {
    const targetElement = document.querySelector(hash);
    if (targetElement) {
      const offset = targetElement.getAttribute('data-scroll-offset');
      if (offset) {
        const offsetValue = parseInt(offset, 10);
        if (!isNaN(offsetValue)) {
          const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementTop + offsetValue
          });
        }
      }
    }
  }
}
window.addEventListener('load', function() {
  setTimeout(function() {
    scrollToAnchorWithOffset();
  }, 500);
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
if ($('.store-sk-hours').length) {
  $('.store-sk-hours').each(function() {
    var $this = $(this);
    const feedId = $(this).data('feed-id');
    if (feedId) {
      $.getJSON(`https://data.accentapi.com/feed/${feedId}.json`).done(function(data) {
        var hours = data.content.week_day_text;
        if (hours.length > 0) {
          if (hours.length === 1) {
            var closedHtml = $this.closest('[data-section-type]').data('section-type') == 'store-locations'
              ? '<div class="one-half store__image--details-half vollkorn-16">Temporarily closed</div>'
              : '<div class="grid__item one-half days"><p>Temporarily closed</p></div>';
            $this.html(closedHtml);
            $this.removeClass('loading');
            return;
          }
          function formatHours(hoursStr) {
            return hoursStr.toLowerCase().replace(/\s+([ap]m)/g, '$1');
          }
          var scheduleData = [];
          hours.forEach(function(item) {
            if (item && typeof item === 'string' && !/<[^>]+>/.test(item)) {
              var match = item.match(/^(.+?):\s*(.+)$/);
              if (match) {
                scheduleData.push({
                  day: match[1].trim(),
                  hours: formatHours(match[2].trim())
                });
              }
            }
          });
          
          var dayOrder = {
            'Monday': 1, 'Tuesday': 2, 'Wednesday': 3, 'Thursday': 4,
            'Friday': 5, 'Saturday': 6, 'Sunday': 7
          };
          
          scheduleData.sort(function(a, b) {
            return (dayOrder[a.day] || 999) - (dayOrder[b.day] || 999);
          });
          
          var groups = [];
          var currentGroup = null;
          
          scheduleData.forEach(function(item) {
            var timeKey = item.hours.replace(/\s+/g, '');
            if (currentGroup && 
                currentGroup.timeKey === timeKey && 
                currentGroup.hours === item.hours) {
              var lastDayOrder = dayOrder[currentGroup.days[currentGroup.days.length - 1]] || 999;
              var currentDayOrder = dayOrder[item.day] || 999;
              
              // Check if consecutive
              if (currentDayOrder === lastDayOrder + 1) {
                currentGroup.days.push(item.day);
                return;
              }
            }

            if (currentGroup) {
              groups.push(currentGroup);
            }

            currentGroup = {
              timeKey: timeKey,
              hours: item.hours,
              days: [item.day]
            };
          });
          if (currentGroup) {
            groups.push(currentGroup);
          }
          function formatDayRange(days) {
            if (days.length === 1) {
              return days[0];
            }
            return days[0] + ' – ' + days[days.length - 1];
          }
          var daysHtml = '';
          var hoursHtml = '';
          if ($this.closest('[data-section-type]').data('section-type') == 'store-locations') {
                                   
            var storesPageClassL = !$this.closest('.store__details--hours-dropdown').length > 0 ? 'store__image--details-half vollkorn-16' : 'one-half store__details--half';
            var storesPageClassR = !$this.closest('.store__details--hours-dropdown').length > 0 ? 'store__image--details-half-right vollkorn-16' : 'one-half store__details--half-right pl-30';
            var html = '';
            groups.forEach(function(group) {
              html += `<div class="${storesPageClassL}">${formatDayRange(group.days)}</div><div class="${storesPageClassR}">${group.hours}</div>`;
            });
          } else {
            groups.forEach(function(group) {
              daysHtml += '<p>' + formatDayRange(group.days) + '</p>';
              hoursHtml += '<p>' + group.hours + '</p>';
            });
            var html = '<div class="grid__item one-half days">' + daysHtml + '</div>' +
                      '<div class="grid__item one-half hours">' + hoursHtml + '</div>';
  
          }
          $this.html(html);
          $this.removeClass('loading');
        } else {
          $this.removeClass('loading');
          $this.addClass('hide');
          $('.store-hours-liquid').removeClass('hide');
        }
      }).fail(function(jqxhr, text) {
        console.error('Error fetching store hours:', text);
        $this.removeClass('loading');
        $this.addClass('hide');
        $('.store-hours-liquid').removeClass('hide');
      });
    } else {
      $this.removeClass('loading');
      $this.addClass('hide');
      $('.store-hours-liquid').removeClass('hide');
    }
  });
}
theme.RewardsList = (function() {

  window.onload = function() {
    defaultActive();
  };

  function defaultActive() {
    const silverIds = document.querySelectorAll('.silver-id'); 
    const goldIds = document.querySelectorAll('.gold-id');     
    const blackIds = document.querySelectorAll('.black-id'); 
    const memberTiers = [...silverIds, ...goldIds, ...blackIds]; 
    
    memberTiers.forEach(function(tier) {
      if (tier && tier.classList.contains('active')) {
        tier.click(); 
      }
    });
  }

  function resetColors($section) {
    const allItems = $section.find('.gold, .silver, .black');
    allItems.each(function() {
      $(this).css('color', '');
    });
  }

  function resetImages($section) {
    const allImages = $section.find('.gold-tier, .silver-tier, .black-tier');
    allImages.each(function() {
      $(this).css('display', '');
    });
  }

  $(".silver-function").click(function() {
    const $section = $(this).closest('.rewards-list'); 
    resetColors($section);
    resetImages($section);
    const gold = $section.find('.gold');
    const black = $section.find('.black');
    const goldTier = $section.find('.gold-tier');
    const blackTier = $section.find('.black-tier');
    
    gold.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    black.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    goldTier.each(function() {
      $(this).css('display', 'none');
    });
    blackTier.each(function() {
      $(this).css('display', 'none');
    });
  });

  $(".gold-function").click(function() {
    const $section = $(this).closest('.rewards-list');
    resetColors($section);
    resetImages($section);
    const silver = $section.find('.silver');
    const black = $section.find('.black');
    const silverTier = $section.find('.silver-tier');
    const blackTier = $section.find('.black-tier');
    
    silver.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    black.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    silverTier.each(function() {
      $(this).css('display', 'none');
    });
    blackTier.each(function() {
      $(this).css('display', 'none');
    });
  });

  $(".black-function").click(function() {
    const $section = $(this).closest('.rewards-list');
    resetColors($section);
    resetImages($section);
    const silver = $section.find('.silver');
    const gold = $section.find('.gold');
    const silverTier = $section.find('.silver-tier');
    const goldTier = $section.find('.gold-tier');
    
    silver.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    gold.each(function() {
      $(this).css('color', '#b3b3b3');
    });
    silverTier.each(function() {
      $(this).css('display', 'none');
    });
    goldTier.each(function() {
      $(this).css('display', 'none');
    });
  });

});

$('.add-to-cart-link').on('click', function(e) {
  e.preventDefault();
  var $this = $(this);
  var productUrl = $this.attr('href');
  $.getJSON(`${productUrl}.js`)
    .done(function(product) {
      var variantId = product.variants[0].id;
      console.log('variantId', variantId);

      var data = {
        'id': variantId,
        'quantity': 1
      }
      $.ajax({
        type: 'POST',
        url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
        dataType: 'json',
        data: data,
        error: function(){
        },
        success: function(){
        },
        complete: function(jqxhr, text) {
          $.getJSON('/cart.js')
            .done(function(cart) {
            var cartItemCount  = theme.getCartItemCount(cart);
            if( cartItemCount == 0 ) {
              $('.cartCount').html(cartItemCount).addClass('hidden-count');
            } else {
              $('.cartCount').html(cartItemCount).removeClass('hidden-count');
              $('.header-cart .cartIcon').addClass('nav__icon--filled');
              window.location.href = "/cart";
            }
          });
        }
      });
    });
  });
  function addModalOpenClassBody() {
    if (!$('body').hasClass('modal-open')) {
      $('body').addClass('modal-open');
    }
  }
  function removeModalOpenClassBody() {
    if ($('body').hasClass('modal-open')) {
      $('body').removeClass('modal-open');
    }
  }
  function cartAdd(data, error, success, complete) {
    data.items = addStoreAttributionToCart(data.items);
    $.ajax({
      type: 'POST',
      url: window.nonEnglish ? `/${window.langCode}/cart/add.js` : '/cart/add.js',
      dataType: 'json',
      data: data,
      error: function(){
        error();
      },
      success: function(){
        success();
      },
      complete: function(jqxhr, text) {
        complete();
      }
    });
  }
  function updateHeaderCartTotal() {
    $.getJSON('/cart.js')
      .done(function(cart) {
        if (cart.item_count == 0) {
          $('.cartCount').html(cart.item_count).addClass('hidden-count');
          $('.header-cart .cartIcon').removeClass('nav__icon--filled');
          return;
        }
        $('.cartCount').html(cart.item_count).removeClass('hidden-count');
        $('.header-cart .cartIcon').addClass('nav__icon--filled');
    });
  }
  function windowRedirect(url) {
    return window.location.href = window.nonEnglish ? `/${window.langCode}${url}` : url;
  }
  function singleItemCartObject(variantId, quantity, properties) {
    return {
        'id': variantId,
        'quantity': quantity,
        'properties': properties || null
    };
  }
  updateHeaderCartTotal();
  theme.CompareTable = (function() {
    $('.js-toggle-compare-modal').magnificPopup({
      type: 'inline',
      mainClass: 'compare_table',
      closeOnBgClick: true,
      closeOnContentClick: false
    });
  })();
// search functions executed in search.liquid
function searchSwiper() {
  return new Swiper('.swiper--quick-access', {
    slidesPerView: 2,
    spaceBetween: 10,
  });
}
function searchAriaControlsParseIds(el, attr) {
  if (!el) return [];
  const raw = el.getAttribute(attr);
  if (!raw) return [];
  return raw
    .split(/\s+/)
    .map((id) => id.trim())
    .filter(Boolean);
}

function searchAriaControlsFallbackControlId(combobox) {
  var detached = combobox.closest('.aa-DetachedContainer');
  var panel =
    (detached && detached.querySelector('.aa-Panel[id]')) ||
    document.querySelector('.aa-Panel[id]');
  if (panel && panel.id && document.getElementById(panel.id)) {
    return panel.id;
  }
  var listboxScoped =
    (detached && detached.querySelector('.aa-Panel [role="listbox"][id]')) ||
    document.querySelector('.aa-Panel [role="listbox"][id]');
  if (listboxScoped && listboxScoped.id && document.getElementById(listboxScoped.id)) {
    return listboxScoped.id;
  }
  var listboxAny =
    (detached && detached.querySelector('[role="listbox"][id]')) ||
    document.querySelector('[role="listbox"][id]');
  if (listboxAny && listboxAny.id && document.getElementById(listboxAny.id)) {
    return listboxAny.id;
  }
  return null;
}

function searchAriaControlsSyncOne(combobox) {
  const input = combobox.querySelector('input.aa-Input');
  const seen = Object.create(null);
  ['aria-owns', 'aria-controls'].forEach((attr) => {
    searchAriaControlsParseIds(combobox, attr).forEach((id) => {
      seen[id] = true;
    });
    searchAriaControlsParseIds(input, attr).forEach((id) => {
      seen[id] = true;
    });
  });
  const ids = Object.keys(seen);
  let existing = ids.filter((id) => document.getElementById(id));

  var expanded = combobox.getAttribute('aria-expanded') === 'true';
  if (expanded && existing.length === 0) {
    var fallbackId = searchAriaControlsFallbackControlId(combobox);
    if (fallbackId) {
      existing = [fallbackId];
    }
  }

  const value = existing.length ? existing.join(' ') : '';

  if (value) {
    combobox.setAttribute('aria-controls', value);
    combobox.setAttribute('aria-owns', value);
    if (input) {
      input.setAttribute('aria-controls', value);
      input.setAttribute('aria-owns', value);
    }
  } else {
    combobox.removeAttribute('aria-controls');
    combobox.removeAttribute('aria-owns');
    if (input) {
      input.removeAttribute('aria-controls');
      input.removeAttribute('aria-owns');
    }
  }

  if (input) {
    var activeDesc = input.getAttribute('aria-activedescendant');
    if (activeDesc && document.getElementById(activeDesc)) {
      combobox.setAttribute('aria-activedescendant', activeDesc);
    } else {
      combobox.removeAttribute('aria-activedescendant');
    }
  } else {
    combobox.removeAttribute('aria-activedescendant');
  }

  if (!combobox._searchAriaObserved) {
    combobox._searchAriaObserved = true;
    let debounceTimer;
    const obs = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        searchAriaControlsSyncOne(combobox);
      }, 0);
    });
    obs.observe(combobox, {
      attributes: true,
      subtree: true,
      attributeFilter: [
        'aria-controls',
        'aria-owns',
        'aria-expanded',
        'aria-activedescendant',
      ],
    });
  }
}

function searchAriaControlsSyncImmediate() {
  document.querySelectorAll('.aa-Autocomplete[role="combobox"]').forEach((combobox) => {
    searchAriaControlsSyncOne(combobox);
  });
}

function searchAriaControls() {
  requestAnimationFrame(() => {
    requestAnimationFrame(searchAriaControlsSyncImmediate);
  });
}


function hideInstallmentsButton() {
  const allPaymentTerms = document.querySelectorAll('shopify-payment-terms');
  if (!allPaymentTerms.length) return false;

  allPaymentTerms.forEach(paymentTerms => {
    if (paymentTerms && paymentTerms.shadowRoot) {
      const btn = paymentTerms.shadowRoot.querySelector('#shopify-installments-cta');
      const p = paymentTerms.shadowRoot.querySelector('#shopify-installments p');
      const content = paymentTerms.shadowRoot.querySelector('#shopify-installments-content');
      const installments = paymentTerms.shadowRoot.querySelector('#shopify-installments');

      if (btn) {
        btn.style.setProperty('display', 'none', 'important');

        const shopPayDiv = paymentTerms.shadowRoot.querySelector('#shopify-installments-content div');

        if (shopPayDiv && !shopPayDiv.dataset.clickBound) {
          shopPayDiv.style.setProperty('cursor', 'pointer', 'important');
          shopPayDiv.addEventListener('click', () => btn.click());
          shopPayDiv.dataset.clickBound = 'true';
        }
      }

      const inProductPage = paymentTerms.closest('.product-page');
      if (!inProductPage) return;

      if (content) {
        content.style.setProperty('padding-right', '0', 'important');
        content.style.setProperty('font-family', 'Cabin', 'important');
        content.style.setProperty('font-size', '12px', 'important');
        content.style.setProperty('letter-spacing', '0.02em', 'important');
      }

      if (p) {
        if (window.innerWidth <= 1149) {
          p.style.setProperty('text-align', 'left', 'important');
          p.style.setProperty('margin-top', '0', 'important');
        } else {
          p.style.setProperty('text-align', 'right', 'important');
          p.style.setProperty('position', 'relative', 'important');
          p.style.setProperty('margin-top', '-20px', 'important');
        }
      }

      if (installments) {
        if (window.innerWidth <= 1149) {
          installments.style.setProperty('padding-top', '20px', 'important');
        } else {
          installments.style.setProperty('padding-top', '0', 'important');
        }
      }
    }
  });

  return true;
}

const observer = new MutationObserver(() => {
  hideInstallmentsButton();
});

observer.observe(document.body, { childList: true, subtree: true });
hideInstallmentsButton();

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(hideInstallmentsButton, 100);
});


function scrollToTabs(event) {
  event.preventDefault();
  const target = document.getElementById('product-tabs-section');
  if (!target) return;

  const tabs = target.querySelectorAll('.product-tabs .tabs__item');
  const contents = target.querySelectorAll('.product-tabs .tabs__content');
  if (tabs.length) {
    tabs.forEach(t => t.classList.remove('current'));
    contents.forEach(c => { c.classList.remove('current'); c.style.display = ''; });
    tabs[tabs.length - 1].classList.add('current');
    contents[contents.length - 1].classList.add('current');
  }

  const accordion = target.querySelector('.product-accordion .accordion__toggle:last-of-type');
  if (accordion) accordion.click();

  const offset = window.innerWidth >= 768 ? 30 : -65;
  const startY = window.pageYOffset;
  const distance = target.getBoundingClientRect().top - offset;
  const duration = 1200;
  let startTime;

  requestAnimationFrame(function step(now) {
    startTime = startTime || now;
    const t = Math.min((now - startTime) / duration, 1);
    const ease = t < 0.5 ? 4*t*t*t : 1 - Math.pow(-2*t + 2, 3) / 2;
    window.scrollTo(0, startY + distance * ease);
    if (t < 1) requestAnimationFrame(step);
  });
}
function setStoreAttribution() {
  let stores = ['vancouver', 'toronto', 'losangeles', 'chicago', 'dc', 'newyork', 'boston'];
  const hash = window.location.href.split('#')[1];
  if (stores.includes(hash)) {
    setCookie('store-id', hash, 15);
    return;
  }
}
setStoreAttribution();
function addStoreAttributionToCart(data) {
  const storeId = getCookie('store-id');
  if (!storeId || data == null) return data;

  if (Array.isArray(data)) {
    return data.map(function(item) {
      return addStoreAttributionToItem(item, storeId);
    });
  }

  return addStoreAttributionToItem(data, storeId);
}
function addStoreAttributionToItem(item, storeId) {
  if (!item) return item;

  if (item.id != null && !item.properties) {
    item['properties[_store-id]'] = storeId;
    return item;
  }

  item.properties = Object.assign({}, item.properties, { '_store-id': storeId });
  return item;
}
theme.ProductLookbook = (function() {
  const productLookbookSwiper = new Swiper('.section-product-lookbook .swiper', {
    spaceBetween: 0,
    loop: true,
    direction: 'horizontal',
    slidesPerView: 'auto',
    variableWidth: true,
    centeredSlides: true,
  });
})();

theme.CompareSizesMini = (function() {
  var $root = $('.section-compare-sizes-mini');
  if (!($root.length > 0)) return;
  let swiperCompareMini = null;
  let selectorClass = 'js-category';
  let dropDownClass = '.js-category-select'
  let $handles = $root.find('[data-product-handles]');
  let productHandles = $handles.length ? $handles.data('product-handles').split(', ') : null;
  let currentSelection = $root.find(`.${selectorClass}`).length ? $root.find(`.${selectorClass}.active`).data('luggage') : ($root.find(dropDownClass).val() || $root.find(`${dropDownClass} option`).first().val());

  function isMobileNav() {
    return window.innerWidth < 990;
  }

  if ($root.find(dropDownClass).length) $root.find('[data-nice-select]').niceSelect();
  if (isMobileNav()) {
    mobileSwiperInit();
  } else {
    sizeDeSelect();
  };
  categorySelect(currentSelection);
  if (isMobileNav()) {
    sizeSelect();
  }

  $root.find('[data-luggage-size]').on('click', function(e){
    var size = $(this).data('luggage-size');
    $root.find('[data-luggage-size]').removeClass('active');
    $root.find(`[data-luggage-size="${size}"]`).addClass('active');
    sizeSelect();
  });

  if ($root.find('.js-category').length) {
    $root.find('.js-category').on('click', function(e){
      var category = $(this).data('luggage');
      $root.find('.js-category').removeClass('active');
      $root.find(`[data-luggage="${category}"]`).addClass('active');
      categorySelect(category);
      if (isMobileNav()) {
        switch(category) {
          case 'hybrid':
            defaultSize = 'hybrid-carry-on'
            break;
          case 'classic':
            defaultSize = 'carry-on'
            break;
          case 'expandable':
            defaultSize = 'expandable-carry-on'
            break;
          default:
            defaultSize = false;
        }
        if (defaultSize) {
          $root.find(`[data-luggage-size="${defaultSize}"]`).trigger('click');
        }
      }
    });
  } else {
    $root.find('select'+dropDownClass+'#select-desktop').on('change', function(e){
      const category = $(this).val();
      $root.find('select'+dropDownClass+'#select-mobile').val(category).niceSelect('update');
      categorySelect(category);
      //setTimeout(()=>{$root.find(`.swiper-slide.${category}`).first().trigger('click')},100);
    });

    $root.find('select'+dropDownClass+'#select-mobile').on('change', function(){
      const category = $(this).val();
      $root.find('select'+dropDownClass+'#select-desktop').val(category).niceSelect('update');
      categorySelect(category);
      setTimeout(()=>{$root.find(`.swiper-slide.${category}`).first().trigger('click')},100);
      if ($root.find('.swiper').hasClass('swiper-initialized')) {
        swiperDestroy();
        mobileSwiperInit();
      } else {
        mobileSwiperInit();
      }
    });
  }

  function mobileSwiperInit() {
    swiperCompareMini = new Swiper('.section-compare-sizes-mini .swiper', {
      spaceBetween: 0,
      slidesPerView: 'auto',
      loop: false,
      on: {
        init: function () {
        },
      },
    });
  }
  function swiperDestroy() {
    if ($root.find('.swiper').hasClass('swiper-initialized') && swiperCompareMini) {
      swiperCompareMini.destroy();
      swiperCompareMini = null;
    }
  }
  function sizeSelect() {
    var size = $root.find('[data-luggage-size].active').data('luggage-size');
    productHandles.forEach(element => {
      $root.find(`.${element}`).addClass('hide');
    });
    $root.find(`.${size}`).removeClass('hide');
    if (swiperCompareMini) swiperCompareMini.update();
  }
  function sizeDeSelect() {
    if (!productHandles) return;
    productHandles.forEach(element => {
      $root.find(`.${element}`).removeClass('hide');
    });
  }
  function categorySelect(luggage) {
    if (!luggage) return;
    let activeCategory = luggage;
    let hiddenCategories = [];
    if ($root.find(`.${selectorClass}`).length) {
      $root.find(`.${selectorClass}:not(.active)`).each(function(){
        hiddenCategories.push($(this).data('luggage'));
      });
    } else {
      $root.find(`${dropDownClass} option`).each(function(){
        var value = $(this).val();
        if (value !== activeCategory) hiddenCategories.push(value);
      });
    }
    hiddenCategories.map(function(item){
      $root.find(`.${item}`).addClass('hide');
    });
    if (isMobileNav()) {
  $root.find(`.${activeCategory}`).removeClass('hide');
  var activeSize = $root.find('[data-luggage-size].active').data('luggage-size');
  if (activeSize) {
    $root.find(`.${activeSize}`).removeClass('hide');
  }
} else {
  $root.find(`.${activeCategory}`).removeClass('hide');
}
    if (swiperCompareMini) swiperCompareMini.update();
  }

  $root.find('.compare-sizes-mini__accordion [accordion-toggle]').on('click', function(){
    $(this).closest('.compare-sizes-mini__accordion').toggleClass('expanded');
  });

})();